var _slicedToArray = require("/app/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _toConsumableArray = require("/app/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/app/node_modules/@babel/runtime/helpers/defineProperty.js");

var _taggedTemplateLiteral = require("/app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

require("core-js/modules/esnext.global-this.js");

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@dasa-health/alma-tokens'), require('react'), require('styled-components'), require('@emotion/react'), require('@emotion/react/package.json'), require('styled-system'), require('theme-ui'), require('@dasa-health/alma-icons'), require('react-dom')) : typeof define === 'function' && define.amd ? define(['exports', '@dasa-health/alma-tokens', 'react', 'styled-components', '@emotion/react', '@emotion/react/package.json', 'styled-system', 'theme-ui', '@dasa-health/alma-icons', 'react-dom'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global["dasa-components"] = {}, global["UndefineddasaHealth/almaTokens"], global.React, global.StyledComponents, global["Undefinedemotion/react"], global.packageInfo, global.StyledSystem, global.ThemeUi, global["UndefineddasaHealth/almaIcons"], global.ReactDom));
})(this, function (exports, almaTokens, React, styled, react, packageInfo, styledSystem, themeUi, almaIcons, reactDom) {
  'use strict';

  function _interopDefaultLegacy(e) {
    return e && typeof e === 'object' && 'default' in e ? e : {
      'default': e
    };
  }

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);

    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function get() {
              return e[k];
            }
          });
        }
      });
    }

    n["default"] = e;
    return Object.freeze(n);
  }

  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

  var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

  var packageInfo__default = /*#__PURE__*/_interopDefaultLegacy(packageInfo);

  var styledSystem__namespace = /*#__PURE__*/_interopNamespace(styledSystem);

  function _extends$6() {
    _extends$6 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$6.apply(this, arguments);
  } // based on https://github.com/developit/dlv


  var get$4 = function get(obj, key, def, p, undef) {
    key = key && key.split ? key.split('.') : [key];

    for (p = 0; p < key.length; p++) {
      obj = obj ? obj[key[p]] : undef;
    }

    return obj === undef ? def : obj;
  };

  var defaultBreakpoints$3 = [40, 52, 64].map(function (n) {
    return n + 'em';
  });
  var defaultTheme$4 = {
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
    fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
  };
  var aliases$3 = {
    bg: 'backgroundColor',
    m: 'margin',
    mt: 'marginTop',
    mr: 'marginRight',
    mb: 'marginBottom',
    ml: 'marginLeft',
    mx: 'marginX',
    my: 'marginY',
    p: 'padding',
    pt: 'paddingTop',
    pr: 'paddingRight',
    pb: 'paddingBottom',
    pl: 'paddingLeft',
    px: 'paddingX',
    py: 'paddingY'
  };
  var multiples$3 = {
    marginX: ['marginLeft', 'marginRight'],
    marginY: ['marginTop', 'marginBottom'],
    paddingX: ['paddingLeft', 'paddingRight'],
    paddingY: ['paddingTop', 'paddingBottom'],
    size: ['width', 'height']
  };
  var scales$3 = {
    color: 'colors',
    backgroundColor: 'colors',
    borderColor: 'colors',
    margin: 'space',
    marginTop: 'space',
    marginRight: 'space',
    marginBottom: 'space',
    marginLeft: 'space',
    marginX: 'space',
    marginY: 'space',
    padding: 'space',
    paddingTop: 'space',
    paddingRight: 'space',
    paddingBottom: 'space',
    paddingLeft: 'space',
    paddingX: 'space',
    paddingY: 'space',
    top: 'space',
    right: 'space',
    bottom: 'space',
    left: 'space',
    gridGap: 'space',
    gridColumnGap: 'space',
    gridRowGap: 'space',
    gap: 'space',
    columnGap: 'space',
    rowGap: 'space',
    fontFamily: 'fonts',
    fontSize: 'fontSizes',
    fontWeight: 'fontWeights',
    lineHeight: 'lineHeights',
    letterSpacing: 'letterSpacings',
    border: 'borders',
    borderTop: 'borders',
    borderRight: 'borders',
    borderBottom: 'borders',
    borderLeft: 'borders',
    borderWidth: 'borderWidths',
    borderStyle: 'borderStyles',
    borderRadius: 'radii',
    borderTopRightRadius: 'radii',
    borderTopLeftRadius: 'radii',
    borderBottomRightRadius: 'radii',
    borderBottomLeftRadius: 'radii',
    borderTopWidth: 'borderWidths',
    borderTopColor: 'colors',
    borderTopStyle: 'borderStyles',
    borderBottomWidth: 'borderWidths',
    borderBottomColor: 'colors',
    borderBottomStyle: 'borderStyles',
    borderLeftWidth: 'borderWidths',
    borderLeftColor: 'colors',
    borderLeftStyle: 'borderStyles',
    borderRightWidth: 'borderWidths',
    borderRightColor: 'colors',
    borderRightStyle: 'borderStyles',
    outlineColor: 'colors',
    boxShadow: 'shadows',
    textShadow: 'shadows',
    zIndex: 'zIndices',
    width: 'sizes',
    minWidth: 'sizes',
    maxWidth: 'sizes',
    height: 'sizes',
    minHeight: 'sizes',
    maxHeight: 'sizes',
    flexBasis: 'sizes',
    size: 'sizes',
    // svg
    fill: 'colors',
    stroke: 'colors'
  };

  var positiveOrNegative$3 = function positiveOrNegative(scale, value) {
    if (typeof value !== 'number' || value >= 0) {
      return get$4(scale, value, value);
    }

    var absolute = Math.abs(value);
    var n = get$4(scale, absolute, absolute);
    if (typeof n === 'string') return '-' + n;
    return n * -1;
  };

  var transforms$3 = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
    var _extends2;

    return _extends$6({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative$3, _extends2));
  }, {});

  var responsive$3 = function responsive(styles) {
    return function (theme) {
      var next = {};
      var breakpoints = get$4(theme, 'breakpoints', defaultBreakpoints$3);
      var mediaQueries = [null].concat(breakpoints.map(function (n) {
        return "@media screen and (min-width: " + n + ")";
      }));

      for (var key in styles) {
        var value = typeof styles[key] === 'function' ? styles[key](theme) : styles[key];
        if (value == null) continue;

        if (!Array.isArray(value)) {
          next[key] = value;
          continue;
        }

        for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
          var media = mediaQueries[i];

          if (!media) {
            next[key] = value[i];
            continue;
          }

          next[media] = next[media] || {};
          if (value[i] == null) continue;
          next[media][key] = value[i];
        }
      }

      return next;
    };
  };

  var css$3 = function css(args) {
    return function (props) {
      if (props === void 0) {
        props = {};
      }

      var theme = _extends$6({}, defaultTheme$4, {}, props.theme || props);

      var result = {};
      var obj = typeof args === 'function' ? args(theme) : args;
      var styles = responsive$3(obj)(theme);

      for (var key in styles) {
        var x = styles[key];
        var val = typeof x === 'function' ? x(theme) : x;

        if (key === 'variant') {
          var variant = css(get$4(theme, val))(theme);
          result = _extends$6({}, result, {}, variant);
          continue;
        }

        if (val && typeof val === 'object') {
          result[key] = css(val)(theme);
          continue;
        }

        var prop = get$4(aliases$3, key, key);
        var scaleName = get$4(scales$3, prop);
        var scale = get$4(theme, scaleName, get$4(theme, prop, {}));
        var transform = get$4(transforms$3, prop, get$4);
        var value = transform(scale, val, val);

        if (multiples$3[prop]) {
          var dirs = multiples$3[prop];

          for (var i = 0; i < dirs.length; i++) {
            result[dirs[i]] = value;
          }
        } else {
          result[prop] = value;
        }
      }

      return result;
    };
  };

  var css$4 = css$3;

  var sx$1 = function sx$1(props) {
    return css$4(props.sx);
  };

  var tail$2 = function tail$2(arr) {
    return arr && arr.length ? arr[arr.length - 1] : void 0;
  };

  var head = function head(arr) {
    return arr && arr.length ? arr[0] : void 0;
  };

  var getStorybookArgVariant = function getStorybookArgVariant(options, defaultValue) {
    return {
      control: {
        type: options.length > 3 ? "select" : "radio"
      },
      description: "Varia\xE7\xE3o do componente.",
      name: "variant",
      options: options,
      table: {
        defaultValue: {
          summary: defaultValue
        },
        type: {
          summary: "string"
        }
      }
    };
  };

  var getStorybookArgVariantSize = function getStorybookArgVariantSize(options, defaultValue) {
    return {
      control: {
        type: options.length > 3 ? "select" : "radio"
      },
      description: "Varia\xE7\xE3o de tamanho do componente.",
      name: "variantSize",
      options: options,
      table: {
        defaultValue: {
          summary: defaultValue
        },
        type: {
          summary: "string"
        }
      }
    };
  };

  var getStorybookArgSize = function getStorybookArgSize(options, defaultValue) {
    return {
      control: {
        type: options.length > 3 ? "select" : "radio"
      },
      description: "Tamanho do componente.",
      name: "size",
      options: options,
      table: {
        defaultValue: {
          summary: defaultValue
        },
        type: {
          summary: "string"
        }
      }
    };
  };

  var getStorybookArgZIndex = function getStorybookArgZIndex() {
    var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return {
      control: {
        type: "number"
      },
      description: "Profundidade de sobreposi\xE7\xE3o que o componente ser\xE1 renderizado.",
      name: "zIndex",
      table: {
        defaultValue: {
          summary: defaultValue
        },
        type: {
          summary: "number"
        }
      }
    };
  };

  var storybookArgTypes = {
    actionButton: {
      control: {
        type: "object"
      },
      description: "Se recebido, habilita o bot\xE3o de a\xE7\xE3o do componente. O objeto deve ser no formato:\n\n{ label: string; onClick: () => void; }",
      name: "actionButton",
      table: {
        defaultValue: {
          summary: null
        },
        type: {
          summary: "string"
        }
      }
    },
    active: {
      control: {
        type: "boolean"
      },
      description: "Determina se o item \xE9 o ativo.",
      name: "active",
      table: {
        defaultValue: {
          summary: false
        },
        type: {
          summary: "boolean"
        }
      }
    },
    align: {
      control: {
        type: "select"
      },
      description: "Alinhamento vertical dos itens dentro do componente.",
      name: "align",
      options: ["stretch", "center", "flex-start", "flex-end", "baseline"],
      table: {
        defaultValue: {
          summary: "stretch"
        },
        type: {
          summary: "string"
        }
      }
    },
    brand: {
      control: {
        type: "boolean"
      },
      description: "Altera as cores do componente para modificar o contraste e se adequar ao contexto de fundo com a cor base da marca.",
      name: "brand",
      table: {
        defaultValue: {
          summary: false
        },
        type: {
          summary: "boolean"
        }
      }
    },
    direction: {
      control: {
        type: "select"
      },
      description: "Dire\xE7\xE3o dos itens dentro do componente.",
      name: "direction",
      options: ["column", "column-reverse", "row", "row-reverse"],
      table: {
        defaultValue: {
          summary: "row"
        },
        type: {
          summary: "string"
        }
      }
    },
    disabled: {
      control: {
        type: "boolean"
      },
      description: "Desabilita as intera\xE7\xF5es com o componente.",
      name: "disabled",
      table: {
        defaultValue: {
          summary: false
        },
        type: {
          summary: "boolean"
        }
      }
    },
    fullWidth: {
      control: {
        type: "boolean"
      },
      description: "Determina se o bot\xE3o ocupar\xE1 todo o cont\xEAiner horizontalmente.",
      name: "fullWidth",
      table: {
        defaultValue: {
          summary: false
        },
        type: {
          summary: "boolean"
        }
      }
    },
    iconColor: {
      control: {
        type: "text"
      },
      description: 'Altera a cor do \xEDcone principal, recebido pela propriedade "leadingIcon".',
      name: "iconColor",
      table: {
        defaultValue: {
          summary: null
        },
        type: {
          summary: "string"
        }
      }
    },
    imageSrc: {
      control: {
        type: "text"
      },
      description: "URL da imagem a ser usada.",
      name: "imageSrc",
      table: {
        defaultValue: {
          summary: ""
        },
        type: {
          summary: "string"
        }
      }
    },
    index: {
      control: {
        type: "number"
      },
      description: "N\xFAmero de \xEDndice do componente em rela\xE7\xE3o a uma lista.",
      name: "index",
      table: {
        defaultValue: {
          summary: null
        },
        type: {
          summary: "number"
        }
      }
    },
    isCurrentIndex: {
      control: {
        type: "boolean"
      },
      description: "Determina se o \xEDndice do componente \xE9 o selecionado dentro de uma lista.",
      name: "isCurrentIndex",
      table: {
        defaultValue: {
          summary: false
        },
        type: {
          summary: "boolean"
        }
      }
    },
    isLoading: {
      control: {
        type: "boolean"
      },
      description: 'Habilita/desabilita o estado de "Carregando" do componente.',
      name: "isLoading",
      table: {
        defaultValue: {
          summary: false
        },
        type: {
          summary: "boolean"
        }
      }
    },
    justify: {
      control: {
        type: "select"
      },
      description: "Alinhamento horizontal dos itens dentro do componente.",
      name: "justify",
      options: ["flex-start", "flex-end", "center", "space-between", "space-around", "space-evenly"],
      table: {
        defaultValue: {
          summary: "flex-start"
        },
        type: {
          summary: "string"
        }
      }
    },
    label: {
      control: {
        type: "text"
      },
      description: "Texto curto que ir\xE1 compor o r\xF3tulo do componente.",
      name: "label",
      table: {
        defaultValue: {
          summary: ""
        },
        type: {
          summary: "string"
        }
      }
    },
    leadingIcon: {
      control: {
        type: "React Element"
      },
      description: "\xCDcone de uso principal dentro do componente.",
      name: "leadingIcon",
      table: {
        defaultValue: {
          summary: null
        },
        type: {
          summary: "React Element"
        }
      }
    },
    message: {
      control: {
        type: "text"
      },
      description: "Mensagem principal que ser\xE1 passada pelo componente.",
      name: "message",
      table: {
        defaultValue: {
          summary: ""
        },
        type: {
          summary: "string"
        }
      }
    },
    name: {
      control: {
        type: "text"
      },
      description: "Nome de identifica\xE7\xE3o do componente.",
      name: "name",
      table: {
        defaultValue: {
          summary: ""
        },
        type: {
          summary: "string"
        }
      }
    },
    onClose: {
      control: {
        type: "function"
      },
      description: "Fun\xE7\xE3o que ser\xE1 executada ao clicar no bot\xE3o de fechar.",
      name: "onClose",
      table: {
        defaultValue: {
          summary: null
        },
        type: {
          summary: "function"
        }
      }
    },
    open: {
      control: {
        type: "boolean"
      },
      description: "Determina o estado de aberto/fechado do componente",
      name: "open",
      table: {
        defaultValue: {
          summary: false
        },
        type: {
          summary: "boolean"
        }
      }
    },
    selected: {
      control: {
        type: "boolean"
      },
      description: "Determina se o estado componente est\xE1 selecionado.",
      name: "selected",
      table: {
        defaultValue: {
          summary: false
        },
        type: {
          summary: "boolean"
        }
      }
    },
    spacing: {
      control: {
        type: "number"
      },
      description: "Espa\xE7o entre o conte\xFAdo do item e o divisor.",
      name: "spacing",
      table: {
        defaultValue: {
          summary: 10
        },
        type: {
          summary: "number"
        }
      }
    },
    supportIcon: {
      control: {
        type: "React Element"
      },
      description: "\xCDcone de suporte do componente.",
      name: "leadingIcon",
      table: {
        defaultValue: {
          summary: null
        },
        type: {
          summary: "React Element"
        }
      }
    },
    text: {
      control: {
        type: "text"
      },
      description: "Texto longo que ser\xE1 usado no componente.",
      name: "text",
      table: {
        defaultValue: {
          summary: ""
        },
        type: {
          summary: "string"
        }
      }
    },
    trailingIcon: {
      control: {
        type: "React Element"
      },
      description: "\xCDcone de uso a direita do componente.",
      name: "trailingIcon",
      table: {
        defaultValue: {
          summary: null
        },
        type: {
          summary: "React Element"
        }
      }
    },
    value: {
      control: {
        type: "text"
      },
      description: "Valor de refer\xEAncia do componente.",
      name: "value",
      table: {
        defaultValue: {
          summary: ""
        },
        type: {
          summary: "string"
        }
      }
    },
    wrap: {
      control: {
        type: "radio"
      },
      description: "Determina se o conte\xFAdo do componente deve passar pra pr\xF3xima linha quando chegar no limite do tamanho do cont\xEAiner.",
      name: "wrap",
      options: ["nowrap", "wrap", "wrap-reverse"],
      table: {
        defaultValue: {
          summary: "nowrap"
        },
        type: {
          summary: "string"
        }
      }
    }
  };
  var storybookArgSX = {
    bg: {
      control: {
        type: "text"
      },
      description: "Cor de fundo do componente.",
      name: "bg",
      table: {
        defaultValue: {
          summary: null
        },
        type: {
          summary: "string"
        }
      }
    },
    borderRadius: {
      control: {
        type: "text"
      },
      description: "Arredondamento da borda do componente.",
      name: "borderRadius",
      table: {
        defaultValue: {
          summary: null
        },
        type: {
          summary: ["number", "string"]
        }
      }
    },
    color: {
      control: {
        type: "text"
      },
      description: "Cor do texto dentro do componente.",
      name: "color",
      table: {
        defaultValue: {
          summary: null
        },
        type: {
          summary: "string"
        }
      }
    },
    height: {
      control: {
        type: "text"
      },
      description: "Altura do componente.",
      name: "height",
      table: {
        defaultValue: {
          summary: null
        },
        type: {
          summary: ["number", "string"]
        }
      }
    },
    href: {
      control: {
        type: "text"
      },
      description: "Especifica a URL da p\xE1gina para a qual o link vai. Se o atributo href n\xE3o estiver presente, o componente n\xE3o ser\xE1 um hiperlink",
      name: "href",
      table: {
        defaultValue: {
          summary: null
        },
        type: {
          summary: "string"
        }
      }
    },
    m: {
      control: {
        type: "number"
      },
      description: "Margem do componente.",
      name: "m",
      table: {
        defaultValue: {
          summary: null
        },
        type: {
          summary: ["number", "string"]
        }
      }
    },
    p: {
      control: {
        type: "number"
      },
      description: "Preenchimento do componente.",
      name: "p",
      table: {
        defaultValue: {
          summary: null
        },
        type: {
          summary: ["number", "string"]
        }
      }
    },
    placeholder: {
      control: {
        type: "text"
      },
      description: "Especifica uma pequena dica que descreve o valor esperado de um campo de entrada. ",
      name: "placeholder",
      table: {
        defaultValue: {
          summary: ""
        },
        type: {
          summary: "string"
        }
      }
    },
    target: {
      control: {
        type: "select"
      },
      description: "Especifica onde abrir a URL vinculada.",
      name: "target",
      options: ["_blank", "_self", "_parent", "_top", "framename"],
      table: {
        defaultValue: {
          summary: null
        },
        type: {
          summary: "string"
        }
      }
    },
    textAlign: {
      control: {
        type: "select"
      },
      description: "Especifica o alinhamento horizontal do texto em um elemento.",
      name: "textAlign",
      options: ["left", "right", "center", "justify"],
      table: {
        defaultValue: {
          summary: "left"
        },
        type: {
          summary: "string"
        }
      }
    },
    width: {
      control: {
        type: "text"
      },
      description: "Largura do componente.",
      name: "width",
      table: {
        defaultValue: {
          summary: null
        },
        type: {
          summary: ["number", "string"]
        }
      }
    }
  };
  var __defProp$11 = Object.defineProperty;
  var __defProps$F = Object.defineProperties;
  var __getOwnPropDescs$F = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$11 = Object.getOwnPropertySymbols;
  var __hasOwnProp$11 = Object.prototype.hasOwnProperty;
  var __propIsEnum$11 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$11 = function __defNormalProp$11(obj, key, value) {
    return key in obj ? __defProp$11(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$11 = function __spreadValues$11(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$11.call(b, prop)) __defNormalProp$11(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$11) {
      var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols$11(b)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var prop = _step.value;
          if (__propIsEnum$11.call(b, prop)) __defNormalProp$11(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    return a;
  };

  var __spreadProps$F = function __spreadProps$F(a, b) {
    return __defProps$F(a, __getOwnPropDescs$F(b));
  };

  var getThemedColorTokens = function getThemedColorTokens(newTokens) {
    var tokens = newTokens ? newTokens : almaTokens.almTokens;
    var palette = {
      black: tokens.ColorPaletteBlack,
      gray: {
        10: tokens.ColorPaletteGray10,
        20: tokens.ColorPaletteGray20,
        30: tokens.ColorPaletteGray30,
        40: tokens.ColorPaletteGray40,
        50: tokens.ColorPaletteGray50,
        60: tokens.ColorPaletteGray60,
        70: tokens.ColorPaletteGray70,
        80: tokens.ColorPaletteGray80
      },
      green: {
        10: tokens.ColorPaletteGreen10,
        20: tokens.ColorPaletteGreen20,
        30: tokens.ColorPaletteGreen30,
        40: tokens.ColorPaletteGreen40,
        50: tokens.ColorPaletteGreen50,
        60: tokens.ColorPaletteGreen60,
        70: tokens.ColorPaletteGreen70,
        80: tokens.ColorPaletteGreen80
      },
      purple: {
        10: tokens.ColorPalettePurple10,
        20: tokens.ColorPalettePurple20,
        30: tokens.ColorPalettePurple30,
        40: tokens.ColorPalettePurple40,
        50: tokens.ColorPalettePurple50,
        60: tokens.ColorPalettePurple60,
        70: tokens.ColorPalettePurple70,
        80: tokens.ColorPalettePurple80
      },
      red: {
        10: tokens.ColorPaletteRed10,
        20: tokens.ColorPaletteRed20,
        30: tokens.ColorPaletteRed30,
        40: tokens.ColorPaletteRed40,
        50: tokens.ColorPaletteRed50,
        60: tokens.ColorPaletteRed60,
        70: tokens.ColorPaletteRed70,
        80: tokens.ColorPaletteRed80
      },
      white: tokens.ColorPaletteWhite,
      yellow: {
        10: tokens.ColorPaletteYellow10,
        20: tokens.ColorPaletteYellow20,
        30: tokens.ColorPaletteYellow30,
        40: tokens.ColorPaletteYellow40,
        50: tokens.ColorPaletteYellow50,
        60: tokens.ColorPaletteYellow60,
        70: tokens.ColorPaletteYellow70,
        80: tokens.ColorPaletteYellow80
      }
    };
    var colorTokens = {
      brand: {
        primary: {
          10: tokens.ColorBrandPrimary10,
          20: tokens.ColorBrandPrimary20,
          30: tokens.ColorBrandPrimary30,
          40: tokens.ColorBrandPrimary40,
          50: tokens.ColorBrandPrimary50,
          60: tokens.ColorBrandPrimary60,
          70: tokens.ColorBrandPrimary70,
          80: tokens.ColorBrandPrimary80
        }
      },
      dataviz: {
        inverse: {
          negative: {
            shape: {
              "01": tokens.ColorDatavizInverseNegativeShape01,
              "02": tokens.ColorDatavizInverseNegativeShape02,
              "03": tokens.ColorDatavizInverseNegativeShape03
            },
            text: tokens.ColorDatavizInverseNegativeText
          },
          positive: {
            shape: {
              "01": tokens.ColorDatavizInversePositiveShape01,
              "02": tokens.ColorDatavizInversePositiveShape02,
              "03": tokens.ColorDatavizInversePositiveShape03
            },
            text: tokens.ColorDatavizInversePositiveText
          }
        },
        negative: {
          "01": tokens.ColorDatavizNegativeShape01,
          "02": tokens.ColorDatavizNegativeShape02,
          "03": tokens.ColorDatavizNegativeShape03,
          text: tokens.ColorDatavizNegativeText
        },
        positive: {
          "01": tokens.ColorDatavizPositiveShape01,
          "02": tokens.ColorDatavizPositiveShape02,
          "03": tokens.ColorDatavizPositiveShape03,
          text: tokens.ColorDatavizPositiveText
        }
      },
      feedback: {
        error: {
          shape: tokens.ColorFeedbackErrorShape,
          text: tokens.ColorFeedbackErrorText
        },
        inverse: {
          error: {
            shape: tokens.ColorFeedbackInverseErrorShape,
            text: tokens.ColorFeedbackInverseErrorText
          },
          on: {
            brand: {
              error: {
                shape: tokens.ColorFeedbackInverseOnBrandErrorShape,
                text: tokens.ColorFeedbackInverseOnBrandErrorText
              },
              success: {
                shape: tokens.ColorFeedbackInverseOnBrandSuccessShape,
                text: tokens.ColorFeedbackInverseOnBrandSuccessText
              }
            }
          },
          success: {
            shape: tokens.ColorFeedbackInverseSuccessShape,
            text: tokens.ColorFeedbackInverseSuccessText
          }
        },
        on: {
          brand: {
            error: {
              shape: tokens.ColorFeedbackOnBrandErrorShape,
              text: tokens.ColorFeedbackOnBrandErrorText
            },
            success: {
              shape: tokens.ColorFeedbackOnBrandSuccessShape,
              text: tokens.ColorFeedbackOnBrandSuccessText
            }
          }
        },
        success: {
          shape: tokens.ColorFeedbackSuccessShape,
          text: tokens.ColorFeedbackSuccessText
        }
      },
      interaction: {
        accent: {
          "01": tokens.ColorInteractionAccent01,
          "02": tokens.ColorInteractionAccent02,
          "03": tokens.ColorInteractionAccent03
        },
        blend: {
          "01": tokens.ColorInteractionBlend01,
          "02": tokens.ColorInteractionBlend02,
          "03": tokens.ColorInteractionBlend03,
          "04": tokens.ColorInteractionBlend04,
          "05": tokens.ColorInteractionBlend05,
          "06": tokens.ColorInteractionBlend06,
          "07": tokens.ColorInteractionBlend07,
          "08": tokens.ColorInteractionBlend08
        },
        danger: {
          "01": tokens.ColorInteractionDanger01,
          "02": tokens.ColorInteractionDanger02,
          "03": tokens.ColorInteractionDanger03
        },
        inverse: {
          accent: {
            "01": tokens.ColorInteractionInverseAccent01,
            "02": tokens.ColorInteractionInverseAccent02,
            "03": tokens.ColorInteractionInverseAccent03
          },
          blend: {
            "01": tokens.ColorInteractionInverseBlend01,
            "02": tokens.ColorInteractionInverseBlend02,
            "03": tokens.ColorInteractionInverseBlend03,
            "04": tokens.ColorInteractionInverseBlend04,
            "05": tokens.ColorInteractionInverseBlend05,
            "06": tokens.ColorInteractionInverseBlend06,
            "07": tokens.ColorInteractionInverseBlend07,
            "08": tokens.ColorInteractionInverseBlend08
          },
          danger: {
            "01": tokens.ColorInteractionInverseDanger01,
            "02": tokens.ColorInteractionInverseDanger02,
            "03": tokens.ColorInteractionInverseDanger03
          },
          on: {
            brand: {
              accent: {
                "01": tokens.ColorInteractionInverseOnBrandAccent01,
                "02": tokens.ColorInteractionInverseOnBrandAccent02,
                "03": tokens.ColorInteractionInverseOnBrandAccent03
              },
              blend: {
                "01": tokens.ColorInteractionInverseOnBrandBlend01,
                "02": tokens.ColorInteractionInverseOnBrandBlend02,
                "03": tokens.ColorInteractionInverseOnBrandBlend03,
                "04": tokens.ColorInteractionInverseOnBrandBlend04,
                "05": tokens.ColorInteractionInverseOnBrandBlend05,
                "06": tokens.ColorInteractionInverseOnBrandBlend06,
                "07": tokens.ColorInteractionInverseOnBrandBlend07,
                "08": tokens.ColorInteractionInverseOnBrandBlend08
              },
              danger: {
                "01": tokens.ColorInteractionInverseOnBrandDanger01,
                "02": tokens.ColorInteractionInverseOnBrandDanger02,
                "03": tokens.ColorInteractionInverseOnBrandDanger03
              },
              select: {
                active: tokens.ColorInteractionInverseOnBrandSelectActive,
                default: tokens.ColorInteractionInverseOnBrandSelectDefault,
                focus: tokens.ColorInteractionInverseOnBrandSelectFocus
              },
              subtle: {
                "01": tokens.ColorInteractionInverseOnBrandSubtle01,
                "02": tokens.ColorInteractionInverseOnBrandSubtle02,
                "03": tokens.ColorInteractionInverseOnBrandSubtle03
              }
            }
          },
          select: {
            active: tokens.ColorInteractionInverseSelectActive,
            default: tokens.ColorInteractionInverseSelectDefault,
            focus: tokens.ColorInteractionInverseSelectFocus
          },
          subtle: {
            "01": tokens.ColorInteractionInverseSubtle01,
            "02": tokens.ColorInteractionInverseSubtle02,
            "03": tokens.ColorInteractionInverseSubtle03
          }
        },
        on: {
          brand: {
            accent: {
              "01": tokens.ColorInteractionOnBrandAccent01,
              "02": tokens.ColorInteractionOnBrandAccent02,
              "03": tokens.ColorInteractionOnBrandAccent03
            },
            blend: {
              "01": tokens.ColorInteractionOnBrandBlend01,
              "02": tokens.ColorInteractionOnBrandBlend02,
              "03": tokens.ColorInteractionOnBrandBlend03,
              "04": tokens.ColorInteractionOnBrandBlend04,
              "05": tokens.ColorInteractionOnBrandBlend05,
              "06": tokens.ColorInteractionOnBrandBlend06,
              "07": tokens.ColorInteractionOnBrandBlend07,
              "08": tokens.ColorInteractionOnBrandBlend08
            },
            danger: {
              "01": tokens.ColorInteractionOnBrandDanger01,
              "02": tokens.ColorInteractionOnBrandDanger02,
              "03": tokens.ColorInteractionOnBrandDanger03
            },
            select: {
              active: tokens.ColorInteractionOnBrandSelectActive,
              default: tokens.ColorInteractionOnBrandSelectDefault,
              focus: tokens.ColorInteractionOnBrandSelectFocus
            },
            subtle: {
              "01": tokens.ColorInteractionOnBrandSubtle01,
              "02": tokens.ColorInteractionOnBrandSubtle02,
              "03": tokens.ColorInteractionOnBrandSubtle03
            }
          }
        },
        select: {
          active: tokens.ColorInteractionSelectActive,
          default: tokens.ColorInteractionSelectDefault,
          focus: tokens.ColorInteractionSelectFocus
        },
        subtle: {
          "01": tokens.ColorInteractionSubtle01,
          "02": tokens.ColorInteractionSubtle02,
          "03": tokens.ColorInteractionSubtle03
        }
      },
      neutral: {
        "00": tokens.ColorNeutral00,
        10: tokens.ColorNeutral10,
        20: tokens.ColorNeutral20,
        30: tokens.ColorNeutral30,
        inverse: {
          "00": tokens.ColorNeutralInverse00,
          10: tokens.ColorNeutralInverse10,
          20: tokens.ColorNeutralInverse20,
          30: tokens.ColorNeutralInverse30,
          on: {
            brand: {
              "00": tokens.ColorNeutralInverseOnBrand00,
              10: tokens.ColorNeutralInverseOnBrand10,
              20: tokens.ColorNeutralInverseOnBrand20,
              30: tokens.ColorNeutralInverseOnBrand30
            }
          }
        },
        on: {
          brand: {
            "00": tokens.ColorNeutralOnBrand00,
            10: tokens.ColorNeutralOnBrand10,
            20: tokens.ColorNeutralOnBrand20,
            30: tokens.ColorNeutralOnBrand30
          }
        }
      },
      support: {
        "01": tokens.ColorSupport01,
        "02": tokens.ColorSupport02,
        inverse: {
          "01": tokens.ColorSupportInverse01,
          "02": tokens.ColorSupportInverse02,
          on: {
            brand: {
              "01": tokens.ColorSupportInverseOnBrand01,
              "02": tokens.ColorSupportInverseOnBrand02
            }
          }
        },
        on: {
          brand: {
            "01": tokens.ColorSupportOnBrand01,
            "02": tokens.ColorSupportOnBrand02
          }
        }
      },
      typeface: {
        inverse: {
          meld: tokens.ColorTypefaceInverseMeld,
          on: {
            brand: {
              meld: tokens.ColorTypefaceInverseOnBrandMeld,
              pure: tokens.ColorTypefaceInverseOnBrandPure,
              smooth: tokens.ColorTypefaceInverseOnBrandSmooth,
              strong: tokens.ColorTypefaceInverseOnBrandStrong
            }
          },
          pure: tokens.ColorTypefaceInversePure,
          smooth: tokens.ColorTypefaceInverseSmooth,
          strong: tokens.ColorTypefaceInverseStrong
        },
        meld: tokens.ColorTypefaceMeld,
        on: {
          brand: {
            meld: tokens.ColorTypefaceOnBrandMeld,
            pure: tokens.ColorTypefaceOnBrandPure,
            smooth: tokens.ColorTypefaceOnBrandSmooth,
            strong: tokens.ColorTypefaceOnBrandStrong
          }
        },
        pure: tokens.ColorTypefacePure,
        smooth: tokens.ColorTypefaceSmooth,
        strong: tokens.ColorTypefaceStrong
      }
    };
    return __spreadProps$F(__spreadValues$11({}, colorTokens), {
      accent: tokens.ColorSupport01,
      background: "inherit",
      muted: tokens.ColorPaletteGray50,
      palette: palette,
      primary: tokens.ColorBrandPrimary40,
      secondary: tokens.ColorInteractionAccent01,
      text: "inherit"
    });
  };

  var radii = {
    circle: almaTokens.almTokens.BorderRadiusCircle,
    lg: almaTokens.almTokens.BorderRadiusLg,
    md: almaTokens.almTokens.BorderRadiusMd,
    none: almaTokens.almTokens.BorderRadiusNone,
    pill: almaTokens.almTokens.BorderRadiusPill,
    sm: almaTokens.almTokens.BorderRadiusSm,
    xs: almaTokens.almTokens.BorderRadiusXs
  };
  var shadows = {
    "01": almaTokens.almTokens.Shadow01,
    "02": almaTokens.almTokens.Shadow02,
    "03": almaTokens.almTokens.Shadow03,
    "04": almaTokens.almTokens.Shadow04
  };
  var space$1 = {
    inline: {
      giant: almaTokens.almTokens.SpacingInlineGiant,
      huge: almaTokens.almTokens.SpacingInlineHuge,
      lg: almaTokens.almTokens.SpacingInlineLg,
      md: almaTokens.almTokens.SpacingInlineMd,
      nano: almaTokens.almTokens.SpacingInlineNano,
      quark: almaTokens.almTokens.SpacingInlineQuark,
      sm: almaTokens.almTokens.SpacingInlineSm,
      xl: almaTokens.almTokens.SpacingInlineXl,
      xs: almaTokens.almTokens.SpacingInlineXs,
      xxl: almaTokens.almTokens.SpacingInlineXxl,
      xxs: almaTokens.almTokens.SpacingInlineXxs,
      xxxl: almaTokens.almTokens.SpacingInlineXxxl,
      xxxs: almaTokens.almTokens.SpacingInlineXxxs
    },
    inset: {
      lg: almaTokens.almTokens.SpacingInsetLg,
      md: almaTokens.almTokens.SpacingInsetMd,
      nano: almaTokens.almTokens.SpacingInsetNano,
      quark: almaTokens.almTokens.SpacingInsetQuark,
      sm: almaTokens.almTokens.SpacingInsetSm,
      xs: almaTokens.almTokens.SpacingInsetXs
    },
    squish: {
      nano: almaTokens.almTokens.SpacingSquishNano,
      quark: almaTokens.almTokens.SpacingSquishQuark,
      sm: almaTokens.almTokens.SpacingSquishSm,
      xs: almaTokens.almTokens.SpacingSquishXs
    },
    stack: {
      giant: almaTokens.almTokens.SpacingStackGiant,
      huge: almaTokens.almTokens.SpacingStackHuge,
      lg: almaTokens.almTokens.SpacingStackLg,
      md: almaTokens.almTokens.SpacingStackMd,
      nano: almaTokens.almTokens.SpacingStackNano,
      quark: almaTokens.almTokens.SpacingStackQuark,
      sm: almaTokens.almTokens.SpacingStackSm,
      xl: almaTokens.almTokens.SpacingStackXl,
      xs: almaTokens.almTokens.SpacingStackXs,
      xxl: almaTokens.almTokens.SpacingStackXxl,
      xxs: almaTokens.almTokens.SpacingStackXxs,
      xxxl: almaTokens.almTokens.SpacingStackXxxl,
      xxxs: almaTokens.almTokens.SpacingStackXxxs
    }
  };
  var borderWidths = {
    hairline: almaTokens.almTokens.BorderWidthHairline,
    heavy: almaTokens.almTokens.BorderWidthHeavy,
    none: almaTokens.almTokens.BorderWidthNone,
    thick: almaTokens.almTokens.BorderWidthThick,
    thin: almaTokens.almTokens.BorderWidthThin
  };
  var typography = {
    fontSizes: {
      display: almaTokens.almTokens.FontSizeDisplay,
      giant: almaTokens.almTokens.FontSizeGiant,
      lg: almaTokens.almTokens.FontSizeLg,
      md: almaTokens.almTokens.FontSizeMd,
      sm: almaTokens.almTokens.FontSizeSm,
      xl: almaTokens.almTokens.FontSizeXl,
      xs: almaTokens.almTokens.FontSizeXs,
      xxl: almaTokens.almTokens.FontSizeXxl,
      xxs: almaTokens.almTokens.FontSizeXxs,
      xxxl: almaTokens.almTokens.FontSizeXxxl,
      xxxs: almaTokens.almTokens.FontSizeXxxs
    },
    letterSpacings: {
      medium: almaTokens.almTokens.LetterSpacingMedium,
      small: almaTokens.almTokens.LetterSpacingSmall,
      standard: almaTokens.almTokens.LetterSpacingStandard
    },
    lineHeights: {
      distant: almaTokens.almTokens.LineHeightDistant,
      huge: almaTokens.almTokens.LineHeightHuge,
      large: almaTokens.almTokens.LineHeightLarge,
      medium: almaTokens.almTokens.LineHeightMedium,
      standard: almaTokens.almTokens.LineHeightStandard,
      superdistant: almaTokens.almTokens.LineHeightSuperdistant,
      tiny: almaTokens.almTokens.LineHeightTiny
    }
  };
  var fonts = {
    base: almaTokens.almTokens.FontFamilyBase
  };
  var fontWeights = {
    bold: almaTokens.almTokens.FontWeightBold,
    light: almaTokens.almTokens.FontWeightLight,
    medium: almaTokens.almTokens.FontWeightMedium,
    regular: almaTokens.almTokens.FontWeightRegular,
    semibold: almaTokens.almTokens.FontWeightSemibold
  };
  var breakpoints = ["37.5rem", "52.5rem", "64rem", "90rem"];
  var forms = {
    input: {
      "&:focus": {
        borderColor: "primary",
        borderWidth: 1,
        outline: "none"
      },
      borderColor: "grays.60",
      borderWidth: 1,
      fontFamily: "base",
      outline: "none"
    },
    label: {
      color: "grays.60",
      fontSize: 1,
      fontWeight: "normal",
      margin: 0,
      width: "auto"
    },
    select: {
      "&:focus": {
        borderColor: "primary",
        borderWidth: 1,
        outline: "none"
      },
      borderColor: "grays.60",
      fontFamily: "base"
    },
    slider: {
      bg: "muted"
    },
    textarea: {
      "&:focus": {
        borderColor: "primary",
        borderWidth: 1,
        outline: "none"
      },
      borderColor: "grays.60",
      fontFamily: "base"
    }
  };
  var text = {
    default: {
      color: "inherit"
    },
    h0: {
      fontSize: 7,
      fontWeight: "bold"
    },
    h1: {
      fontSize: 6,
      fontWeight: "bold"
    },
    h2: {
      fontSize: 5,
      fontWeight: "bold"
    },
    h3: {
      fontSize: 4,
      fontWeight: "bold"
    },
    h4: {
      fontSize: 3,
      fontWeight: "bold"
    },
    h5: {
      fontSize: 2,
      fontWeight: "bold"
    },
    h6: {
      fontSize: 1,
      fontWeight: "bold"
    }
  };
  var opacities = {
    "01": almaTokens.almTokens.Opacity01,
    "02": almaTokens.almTokens.Opacity02,
    "03": almaTokens.almTokens.Opacity03,
    "04": almaTokens.almTokens.Opacity04,
    "05": almaTokens.almTokens.Opacity05,
    "06": almaTokens.almTokens.Opacity06,
    "07": almaTokens.almTokens.Opacity07,
    "08": almaTokens.almTokens.Opacity08
  };
  var __defProp$10 = Object.defineProperty;
  var __defProps$E = Object.defineProperties;
  var __getOwnPropDescs$E = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$10 = Object.getOwnPropertySymbols;
  var __hasOwnProp$10 = Object.prototype.hasOwnProperty;
  var __propIsEnum$10 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$10 = function __defNormalProp$10(obj, key, value) {
    return key in obj ? __defProp$10(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$10 = function __spreadValues$10(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$10.call(b, prop)) __defNormalProp$10(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$10) {
      var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols$10(b)),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var prop = _step2.value;
          if (__propIsEnum$10.call(b, prop)) __defNormalProp$10(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    return a;
  };

  var __spreadProps$E = function __spreadProps$E(a, b) {
    return __defProps$E(a, __getOwnPropDescs$E(b));
  };

  var lineHeights = typography.lineHeights,
      fontSizes = typography.fontSizes,
      letterSpacings = typography.letterSpacings;

  var getCustomTheme = function getCustomTheme(defaultTokens, modes) {
    var getCustomModes = function getCustomModes() {
      if (modes && modes.length > 0) {
        var modesObject = {};
        modes.forEach(function (mode) {
          var name = mode.name,
              tokens = mode.tokens;
          return modesObject[name] = getThemedColorTokens(tokens);
        });
        return modesObject;
      }

      return {};
    };

    return {
      borderWidths: borderWidths,
      breakpoints: breakpoints,
      colors: __spreadProps$E(__spreadValues$10({}, getThemedColorTokens(defaultTokens)), {
        modes: getCustomModes()
      }),
      config: {
        initialColorModeName: "default",
        printColorModeName: "default",
        useColorSchemeMediaQuery: false,
        useLocalStorage: false
      },
      fontSizes: fontSizes,
      fontWeights: fontWeights,
      fonts: fonts,
      forms: forms,
      letterSpacings: letterSpacings,
      lineHeights: lineHeights,
      opacities: opacities,
      radii: radii,
      shadows: shadows,
      space: space$1,
      text: text
    };
  };

  var defaultColors = getThemedColorTokens();
  var defaultTheme$3 = getCustomTheme();

  var isMergeableObject = function isMergeableObject(value) {
    return isNonNullObject(value) && !isSpecial(value);
  };

  function isNonNullObject(value) {
    return !!value && typeof value === 'object';
  }

  function isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
  } // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25


  var canUseSymbol$1 = typeof Symbol === 'function' && Symbol.for;
  var REACT_ELEMENT_TYPE = canUseSymbol$1 ? Symbol.for('react.element') : 0xeac7;

  function isReactElement(value) {
    return value.$$typeof === REACT_ELEMENT_TYPE;
  }

  function emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
  }

  function cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
  }

  function defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function (element) {
      return cloneUnlessOtherwiseSpecified(element, options);
    });
  }

  function getMergeFunction(key, options) {
    if (!options.customMerge) {
      return deepmerge;
    }

    var customMerge = options.customMerge(key);
    return typeof customMerge === 'function' ? customMerge : deepmerge;
  }

  function getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function (symbol) {
      return target.propertyIsEnumerable(symbol);
    }) : [];
  }

  function getKeys(target) {
    return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
  }

  function propertyIsOnObject(object, property) {
    try {
      return property in object;
    } catch (_) {
      return false;
    }
  } // Protects from prototype poisoning and unexpected merging up the prototype chain.


  function propertyIsUnsafe(target, key) {
    return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
    && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
    && Object.propertyIsEnumerable.call(target, key)); // and also unsafe if they're nonenumerable.
  }

  function mergeObject(target, source, options) {
    var destination = {};

    if (options.isMergeableObject(target)) {
      getKeys(target).forEach(function (key) {
        destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
      });
    }

    getKeys(source).forEach(function (key) {
      if (propertyIsUnsafe(target, key)) {
        return;
      }

      if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
        destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
      } else {
        destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
      }
    });
    return destination;
  }

  function deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || isMergeableObject; // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.

    options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

    if (!sourceAndTargetTypesMatch) {
      return cloneUnlessOtherwiseSpecified(source, options);
    } else if (sourceIsArray) {
      return options.arrayMerge(target, source, options);
    } else {
      return mergeObject(target, source, options);
    }
  }

  deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) {
      throw new Error('first argument should be an array');
    }

    return array.reduce(function (prev, next) {
      return deepmerge(prev, next, options);
    }, {});
  };

  var deepmerge_1 = deepmerge;
  var cjs = deepmerge_1;

  function _extends$5() {
    _extends$5 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$5.apply(this, arguments);
  }
  /**
   * Allows for nested scales with shorthand values
   * @example
   * {
   *   colors: {
   *     primary: { __default: '#00f', light: '#33f' }
   *   }
   * }
   * css({ color: 'primary' }); // { color: '#00f' }
   * css({ color: 'primary.light' }) // { color: '#33f' }
   */


  var THEME_UI_DEFAULT_KEY$2 = '__default';

  var hasDefault$2 = function hasDefault(x) {
    return typeof x === 'object' && x !== null && THEME_UI_DEFAULT_KEY$2 in x;
  };
  /**
   * Extracts value under path from a deeply nested object.
   * Used for Themes, variants and Theme UI style objects.
   * Given a path to object with `__default` key, returns the value under that key.
   *
   * @param obj a theme, variant or style object
   * @param path path separated with dots (`.`)
   * @param fallback default value returned if get(obj, path) is not found
   */


  function get$3(obj, path, fallback, p, undef) {
    var pathArray = path && typeof path === 'string' ? path.split('.') : [path];

    for (p = 0; p < pathArray.length; p++) {
      obj = obj ? obj[pathArray[p]] : undef;
    }

    if (obj === undef) return fallback;
    return hasDefault$2(obj) ? obj[THEME_UI_DEFAULT_KEY$2] : obj;
  }

  var getObjectWithVariants$2 = function getObjectWithVariants(obj, theme) {
    if (obj && obj['variant']) {
      var result = {};

      for (var key in obj) {
        var x = obj[key];

        if (key === 'variant') {
          var val = typeof x === 'function' ? x(theme) : x;
          var variant = getObjectWithVariants(get$3(theme, val), theme);
          result = _extends$5({}, result, variant);
        } else {
          result[key] = x;
        }
      }

      return result;
    }

    return obj;
  };

  var defaultBreakpoints$2 = [40, 52, 64].map(function (n) {
    return n + 'em';
  });
  var defaultTheme$2 = {
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
    fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
  };
  var aliases$2 = {
    bg: 'backgroundColor',
    m: 'margin',
    mt: 'marginTop',
    mr: 'marginRight',
    mb: 'marginBottom',
    ml: 'marginLeft',
    mx: 'marginX',
    my: 'marginY',
    p: 'padding',
    pt: 'paddingTop',
    pr: 'paddingRight',
    pb: 'paddingBottom',
    pl: 'paddingLeft',
    px: 'paddingX',
    py: 'paddingY'
  };
  var multiples$2 = {
    marginX: ['marginLeft', 'marginRight'],
    marginY: ['marginTop', 'marginBottom'],
    paddingX: ['paddingLeft', 'paddingRight'],
    paddingY: ['paddingTop', 'paddingBottom'],
    scrollMarginX: ['scrollMarginLeft', 'scrollMarginRight'],
    scrollMarginY: ['scrollMarginTop', 'scrollMarginBottom'],
    scrollPaddingX: ['scrollPaddingLeft', 'scrollPaddingRight'],
    scrollPaddingY: ['scrollPaddingTop', 'scrollPaddingBottom'],
    size: ['width', 'height']
  };
  var scales$2 = {
    color: 'colors',
    backgroundColor: 'colors',
    borderColor: 'colors',
    caretColor: 'colors',
    columnRuleColor: 'colors',
    textDecorationColor: 'colors',
    opacity: 'opacities',
    transition: 'transitions',
    margin: 'space',
    marginTop: 'space',
    marginRight: 'space',
    marginBottom: 'space',
    marginLeft: 'space',
    marginX: 'space',
    marginY: 'space',
    marginBlock: 'space',
    marginBlockEnd: 'space',
    marginBlockStart: 'space',
    marginInline: 'space',
    marginInlineEnd: 'space',
    marginInlineStart: 'space',
    padding: 'space',
    paddingTop: 'space',
    paddingRight: 'space',
    paddingBottom: 'space',
    paddingLeft: 'space',
    paddingX: 'space',
    paddingY: 'space',
    paddingBlock: 'space',
    paddingBlockEnd: 'space',
    paddingBlockStart: 'space',
    paddingInline: 'space',
    paddingInlineEnd: 'space',
    paddingInlineStart: 'space',
    scrollMargin: 'space',
    scrollMarginTop: 'space',
    scrollMarginRight: 'space',
    scrollMarginBottom: 'space',
    scrollMarginLeft: 'space',
    scrollMarginX: 'space',
    scrollMarginY: 'space',
    scrollPadding: 'space',
    scrollPaddingTop: 'space',
    scrollPaddingRight: 'space',
    scrollPaddingBottom: 'space',
    scrollPaddingLeft: 'space',
    scrollPaddingX: 'space',
    scrollPaddingY: 'space',
    inset: 'space',
    insetBlock: 'space',
    insetBlockEnd: 'space',
    insetBlockStart: 'space',
    insetInline: 'space',
    insetInlineEnd: 'space',
    insetInlineStart: 'space',
    top: 'space',
    right: 'space',
    bottom: 'space',
    left: 'space',
    gridGap: 'space',
    gridColumnGap: 'space',
    gridRowGap: 'space',
    gap: 'space',
    columnGap: 'space',
    rowGap: 'space',
    fontFamily: 'fonts',
    fontSize: 'fontSizes',
    fontWeight: 'fontWeights',
    lineHeight: 'lineHeights',
    letterSpacing: 'letterSpacings',
    border: 'borders',
    borderTop: 'borders',
    borderRight: 'borders',
    borderBottom: 'borders',
    borderLeft: 'borders',
    borderWidth: 'borderWidths',
    borderStyle: 'borderStyles',
    borderRadius: 'radii',
    borderTopRightRadius: 'radii',
    borderTopLeftRadius: 'radii',
    borderBottomRightRadius: 'radii',
    borderBottomLeftRadius: 'radii',
    borderTopWidth: 'borderWidths',
    borderTopColor: 'colors',
    borderTopStyle: 'borderStyles',
    borderBottomWidth: 'borderWidths',
    borderBottomColor: 'colors',
    borderBottomStyle: 'borderStyles',
    borderLeftWidth: 'borderWidths',
    borderLeftColor: 'colors',
    borderLeftStyle: 'borderStyles',
    borderRightWidth: 'borderWidths',
    borderRightColor: 'colors',
    borderRightStyle: 'borderStyles',
    borderBlock: 'borders',
    borderBlockColor: 'colors',
    borderBlockEnd: 'borders',
    borderBlockEndColor: 'colors',
    borderBlockEndStyle: 'borderStyles',
    borderBlockEndWidth: 'borderWidths',
    borderBlockStart: 'borders',
    borderBlockStartColor: 'colors',
    borderBlockStartStyle: 'borderStyles',
    borderBlockStartWidth: 'borderWidths',
    borderBlockStyle: 'borderStyles',
    borderBlockWidth: 'borderWidths',
    borderEndEndRadius: 'radii',
    borderEndStartRadius: 'radii',
    borderInline: 'borders',
    borderInlineColor: 'colors',
    borderInlineEnd: 'borders',
    borderInlineEndColor: 'colors',
    borderInlineEndStyle: 'borderStyles',
    borderInlineEndWidth: 'borderWidths',
    borderInlineStart: 'borders',
    borderInlineStartColor: 'colors',
    borderInlineStartStyle: 'borderStyles',
    borderInlineStartWidth: 'borderWidths',
    borderInlineStyle: 'borderStyles',
    borderInlineWidth: 'borderWidths',
    borderStartEndRadius: 'radii',
    borderStartStartRadius: 'radii',
    columnRuleWidth: 'borderWidths',
    outlineColor: 'colors',
    boxShadow: 'shadows',
    textShadow: 'shadows',
    zIndex: 'zIndices',
    width: 'sizes',
    minWidth: 'sizes',
    maxWidth: 'sizes',
    height: 'sizes',
    minHeight: 'sizes',
    maxHeight: 'sizes',
    flexBasis: 'sizes',
    size: 'sizes',
    blockSize: 'sizes',
    inlineSize: 'sizes',
    maxBlockSize: 'sizes',
    maxInlineSize: 'sizes',
    minBlockSize: 'sizes',
    minInlineSize: 'sizes',
    columnWidth: 'sizes',
    // svg
    fill: 'colors',
    stroke: 'colors'
  };

  var positiveOrNegative$2 = function positiveOrNegative(scale, value) {
    if (typeof value !== 'number' || value >= 0) {
      if (typeof value === 'string' && value.startsWith('-')) {
        var valueWithoutMinus = value.substring(1);

        var _n = get$3(scale, valueWithoutMinus, valueWithoutMinus);

        if (typeof _n === 'number') {
          return _n * -1;
        }

        return "-" + _n;
      }

      return get$3(scale, value, value);
    }

    var absolute = Math.abs(value);
    var n = get$3(scale, absolute, absolute);
    if (typeof n === 'string') return '-' + n;
    return Number(n) * -1;
  };

  var transforms$2 = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginBlock', 'marginBlockEnd', 'marginBlockStart', 'marginInline', 'marginInlineEnd', 'marginInlineStart', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
    var _extends2;

    return _extends$5({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative$2, _extends2));
  }, {});

  var responsive$2 = function responsive(styles) {
    return function (theme) {
      var next = {};
      var breakpoints = theme && theme.breakpoints || defaultBreakpoints$2;
      var mediaQueries = [null].concat(breakpoints.map(function (n) {
        return n.includes('@media') ? n : "@media screen and (min-width: " + n + ")";
      }));

      for (var k in styles) {
        var key = k;
        var value = styles[key];

        if (typeof value === 'function') {
          value = value(theme || {});
        }

        if (value === false || value == null) {
          continue;
        }

        if (!Array.isArray(value)) {
          next[key] = value;
          continue;
        }

        for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
          var media = mediaQueries[i];

          if (!media) {
            next[key] = value[i];
            continue;
          }

          next[media] = next[media] || {};
          if (value[i] == null) continue;
          next[media][key] = value[i];
        }
      }

      return next;
    };
  };

  var css$2 = function css(args) {
    if (args === void 0) {
      args = {};
    }

    return function (props) {
      if (props === void 0) {
        props = {};
      }

      var theme = _extends$5({}, defaultTheme$2, 'theme' in props ? props.theme : props); // insert variant props before responsive styles, so they can be merged
      // we need to maintain order of the style props, so if a variant is place in the middle
      // of other props, it will extends its props at that same location order.


      var obj = getObjectWithVariants$2(typeof args === 'function' ? args(theme) : args, theme);
      var styles = responsive$2(obj)(theme);
      var result = {};

      for (var key in styles) {
        var x = styles[key];
        var val = typeof x === 'function' ? x(theme) : x;

        if (val && typeof val === 'object') {
          if (hasDefault$2(val)) {
            result[key] = val[THEME_UI_DEFAULT_KEY$2];
            continue;
          } // On type level, val can also be an array here,
          // but we transform all arrays in `responsive` function.


          result[key] = css(val)(theme);
          continue;
        }

        var prop = key in aliases$2 ? aliases$2[key] : key;
        var scaleName = prop in scales$2 ? scales$2[prop] : undefined;
        var scale = scaleName ? theme == null ? void 0 : theme[scaleName] : get$3(theme, prop, {});
        var transform = get$3(transforms$2, prop, get$3);
        var value = transform(scale, val, val);

        if (prop in multiples$2) {
          var dirs = multiples$2[prop];

          for (var i = 0; i < dirs.length; i++) {
            result[dirs[i]] = value;
          }
        } else {
          result[prop] = value;
        }
      }

      return result;
    };
  };

  var getCSS = function getCSS(props) {
    return function (theme) {
      var styles = css$2(props.sx)(theme);
      var raw = typeof props.css === 'function' ? props.css(theme) : props.css;
      return [styles, raw];
    };
  };

  var parseProps = function parseProps(props) {
    if (!props || !props.sx && !props.css) return props;
    var next = {};

    for (var key in props) {
      if (key === 'sx') continue;
      next[key] = props[key];
    }

    next.css = getCSS(props);
    return next;
  };

  var parseProps$1 = parseProps;

  function _extends$4() {
    _extends$4 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$4.apply(this, arguments);
  }

  var __EMOTION_VERSION__ = packageInfo__default["default"].version;

  var jsx = function jsx(type, props) {
    for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      children[_key - 2] = arguments[_key];
    }

    return react.jsx.apply(void 0, [type, parseProps$1(props)].concat(children));
  };
  /**
   * @internal
   */


  var __themeUiDefaultContextValue = {
    __EMOTION_VERSION__: __EMOTION_VERSION__,
    theme: {}
  };
  /**
   * @internal
   */

  var __ThemeUIContext = /*#__PURE__*/React.createContext(__themeUiDefaultContextValue);

  var useThemeUI = function useThemeUI() {
    return React.useContext(__ThemeUIContext);
  };

  var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
  var REACT_ELEMENT = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
  var FORWARD_REF = canUseSymbol ? Symbol.for('react.forward_ref') : 0xeac7;
  var deepmergeOptions = {
    isMergeableObject: function isMergeableObject(n) {
      return !!n && typeof n === 'object' && n.$$typeof !== REACT_ELEMENT && n.$$typeof !== FORWARD_REF;
    },
    arrayMerge: function arrayMerge(_leftArray, rightArray) {
      return rightArray;
    }
  };
  /**
   * Deeply merge themes
   */

  var merge$1 = function merge(a, b) {
    return cjs(a, b, deepmergeOptions);
  };

  function mergeAll() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return cjs.all(args, deepmergeOptions);
  }

  merge$1.all = mergeAll;
  /**
   * @internal
   */

  var __ThemeUIInternalBaseThemeProvider = function __ThemeUIInternalBaseThemeProvider(_ref) {
    var context = _ref.context,
        children = _ref.children;
    return jsx(react.ThemeContext.Provider, {
      value: context.theme
    }, jsx(__ThemeUIContext.Provider, {
      value: context,
      children: children
    }));
  };

  function ThemeProvider$1(_ref2) {
    var theme = _ref2.theme,
        children = _ref2.children;
    var outer = useThemeUI();

    if (process.env.NODE_ENV !== 'production') {
      if (outer.__EMOTION_VERSION__ !== __EMOTION_VERSION__) {
        console.warn('Multiple versions of Emotion detected,', 'and theming might not work as expected.', 'Please ensure there is only one copy of @emotion/react installed in your application.');
      }
    }

    var context = typeof theme === 'function' ? _extends$4({}, outer, {
      theme: theme(outer.theme)
    }) : merge$1.all({}, outer, {
      theme: theme
    });
    return jsx(__ThemeUIInternalBaseThemeProvider, {
      context: context,
      children: children
    });
  }

  var css_248z$1 = ".tippy-box[data-animation=fade][data-state=hidden]{opacity:0}[data-tippy-root]{max-width:calc(100vw - 10px)}.tippy-box{position:relative;background-color:#333;color:#fff;border-radius:4px;font-size:14px;line-height:1.4;white-space:normal;outline:0;transition-property:transform,visibility,opacity}.tippy-box[data-placement^=top]>.tippy-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-arrow:before{bottom:-7px;left:0;border-width:8px 8px 0;border-top-color:initial;transform-origin:center top}.tippy-box[data-placement^=bottom]>.tippy-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-arrow:before{top:-7px;left:0;border-width:0 8px 8px;border-bottom-color:initial;transform-origin:center bottom}.tippy-box[data-placement^=left]>.tippy-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-arrow:before{border-width:8px 0 8px 8px;border-left-color:initial;right:-7px;transform-origin:center left}.tippy-box[data-placement^=right]>.tippy-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-arrow:before{left:-7px;border-width:8px 8px 8px 0;border-right-color:initial;transform-origin:center right}.tippy-box[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-arrow{width:16px;height:16px;color:#333}.tippy-arrow:before{content:\"\";position:absolute;border-color:transparent;border-style:solid}.tippy-content{position:relative;padding:5px 9px;z-index:1}";
  var css_248z = ".tippy-box[data-placement^=top]>.tippy-svg-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-svg-arrow:after,.tippy-box[data-placement^=top]>.tippy-svg-arrow>svg{top:16px;transform:rotate(180deg)}.tippy-box[data-placement^=bottom]>.tippy-svg-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-svg-arrow>svg{bottom:16px}.tippy-box[data-placement^=left]>.tippy-svg-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-svg-arrow:after,.tippy-box[data-placement^=left]>.tippy-svg-arrow>svg{transform:rotate(90deg);top:calc(50% - 3px);left:11px}.tippy-box[data-placement^=right]>.tippy-svg-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-svg-arrow:after,.tippy-box[data-placement^=right]>.tippy-svg-arrow>svg{transform:rotate(-90deg);top:calc(50% - 3px);right:11px}.tippy-svg-arrow{width:16px;height:16px;fill:#333;text-align:initial}.tippy-svg-arrow,.tippy-svg-arrow>svg{position:absolute}";
  var GlobalStyles = styled.createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    * {\n        margin: 0;\n        padding: 0;\n        border: 0;\n        font-size: 100%;\n        font: inherit;\n        vertical-align: baseline;\n    }\n    *:focus {\n        outline: none;\n    }\n    /* HTML5 display-role reset for older browsers */\n    article, aside, details, figcaption, figure,\n    footer, header, hgroup, menu, nav, section {\n        display: block;\n    }\n    body {\n        line-height: 1;\n    }\n    ol, ul {\n        list-style: none;\n    }\n    blockquote, q {\n        quotes: none;\n    }\n    blockquote:before, blockquote:after,\n    q:before, q:after {\n        content: '';\n        content: none;\n    }\n    table {\n        border-collapse: collapse;\n        border-spacing: 0;\n    }\n\n    @font-face {\n        font-family: 'Dasa Sans';\n        src: url('https://almadshmltry1.dasaexp.io/fonts/eot/DasaSans-Bold.eot');\n        src: url('https://almadshmltry1.dasaexp.io/fonts/eot/DasaSans-Bold.eot?#iefix') format('embedded-opentype'),\n            url('https://almadshmltry1.dasaexp.io/fonts/woff/DasaSans-Bold.woff') format('woff'),\n            url('https://almadshmltry1.dasaexp.io/fonts/woff2/DasaSans-Bold.woff2') format('woff2');\n        font-weight: 700;\n    }\n    @font-face {\n        font-family: 'Dasa Sans';\n        src: url('https://almadshmltry1.dasaexp.io/fonts/eot/DasaSans-Semibold.eot');\n        src: url('https://almadshmltry1.dasaexp.io/fonts/eot/DasaSans-Semibold.eot?#iefix') format('embedded-opentype'),\n            url('https://almadshmltry1.dasaexp.io/fonts/woff/DasaSans-Semibold.woff') format('woff'),\n            url('https://almadshmltry1.dasaexp.io/fonts/woff2/DasaSans-Semibold.woff2') format('woff2');\n        font-weight: 600;\n    }\n    @font-face {\n        font-family: 'Dasa Sans';\n        src: url('https://almadshmltry1.dasaexp.io/fonts/eot/DasaSans-Medium.eot');\n        src: url('https://almadshmltry1.dasaexp.io/fonts/eot/DasaSans-Medium.eot?#iefix') format('embedded-opentype'),\n            url('https://almadshmltry1.dasaexp.io/fonts/woff/DasaSans-Medium.woff') format('woff'),\n            url('https://almadshmltry1.dasaexp.io/fonts/woff2/DasaSans-Medium.woff2') format('woff2');\n        font-weight: 500;\n    }\n    @font-face {\n        font-family: 'Dasa Sans';\n        src: url('https://almadshmltry1.dasaexp.io/fonts/eot/DasaSans-Regular.eot');\n        src: url('https://almadshmltry1.dasaexp.io/fonts/eot/DasaSans-Regular.eot?#iefix') format('embedded-opentype'),\n            url('https://almadshmltry1.dasaexp.io/fonts/woff/DasaSans-Regular.woff') format('woff'),\n            url('https://almadshmltry1.dasaexp.io/fonts/woff2/DasaSans-Regular.woff2') format('woff2');\n        font-weight: 400;\n    }\n    @font-face {\n        font-family: 'Dasa Sans';\n        src: url('https://almadshmltry1.dasaexp.io/fonts/eot/DasaSans-Light.eot');\n        src: url('https://almadshmltry1.dasaexp.io/fonts/eot/DasaSans-Light.eot?#iefix') format('embedded-opentype'),\n            url('https://almadshmltry1.dasaexp.io/fonts/woff/DasaSans-Light.woff') format('woff'),\n            url('https://almadshmltry1.dasaexp.io/fonts/woff2/DasaSans-Light.woff2') format('woff2');\n        font-weight: 300;\n    }\n\n    ", "\n    ", "\n"])), css_248z$1, css_248z);

  function _extends$3() {
    _extends$3 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$3.apply(this, arguments);
  }
  /**
   * Allows for nested scales with shorthand values
   * @example
   * {
   *   colors: {
   *     primary: { __default: '#00f', light: '#33f' }
   *   }
   * }
   * css({ color: 'primary' }); // { color: '#00f' }
   * css({ color: 'primary.light' }) // { color: '#33f' }
   */


  var THEME_UI_DEFAULT_KEY$1 = '__default';

  var hasDefault$1 = function hasDefault(x) {
    return typeof x === 'object' && x !== null && THEME_UI_DEFAULT_KEY$1 in x;
  };
  /**
   * Extracts value under path from a deeply nested object.
   * Used for Themes, variants and Theme UI style objects.
   * Given a path to object with `__default` key, returns the value under that key.
   *
   * @param obj a theme, variant or style object
   * @param path path separated with dots (`.`)
   * @param fallback default value returned if get(obj, path) is not found
   */


  function get$2(obj, path, fallback, p, undef) {
    var pathArray = path && typeof path === 'string' ? path.split('.') : [path];

    for (p = 0; p < pathArray.length; p++) {
      obj = obj ? obj[pathArray[p]] : undef;
    }

    if (obj === undef) return fallback;
    return hasDefault$1(obj) ? obj[THEME_UI_DEFAULT_KEY$1] : obj;
  }

  var getObjectWithVariants$1 = function getObjectWithVariants(obj, theme) {
    if (obj && obj['variant']) {
      var result = {};

      for (var key in obj) {
        var x = obj[key];

        if (key === 'variant') {
          var val = typeof x === 'function' ? x(theme) : x;
          var variant = getObjectWithVariants(get$2(theme, val), theme);
          result = _extends$3({}, result, variant);
        } else {
          result[key] = x;
        }
      }

      return result;
    }

    return obj;
  };

  var defaultBreakpoints$1 = [40, 52, 64].map(function (n) {
    return n + 'em';
  });
  var defaultTheme$1 = {
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
    fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
  };
  var aliases$1 = {
    bg: 'backgroundColor',
    m: 'margin',
    mt: 'marginTop',
    mr: 'marginRight',
    mb: 'marginBottom',
    ml: 'marginLeft',
    mx: 'marginX',
    my: 'marginY',
    p: 'padding',
    pt: 'paddingTop',
    pr: 'paddingRight',
    pb: 'paddingBottom',
    pl: 'paddingLeft',
    px: 'paddingX',
    py: 'paddingY'
  };
  var multiples$1 = {
    marginX: ['marginLeft', 'marginRight'],
    marginY: ['marginTop', 'marginBottom'],
    paddingX: ['paddingLeft', 'paddingRight'],
    paddingY: ['paddingTop', 'paddingBottom'],
    scrollMarginX: ['scrollMarginLeft', 'scrollMarginRight'],
    scrollMarginY: ['scrollMarginTop', 'scrollMarginBottom'],
    scrollPaddingX: ['scrollPaddingLeft', 'scrollPaddingRight'],
    scrollPaddingY: ['scrollPaddingTop', 'scrollPaddingBottom'],
    size: ['width', 'height']
  };
  var scales$1 = {
    color: 'colors',
    backgroundColor: 'colors',
    borderColor: 'colors',
    caretColor: 'colors',
    columnRuleColor: 'colors',
    textDecorationColor: 'colors',
    opacity: 'opacities',
    transition: 'transitions',
    margin: 'space',
    marginTop: 'space',
    marginRight: 'space',
    marginBottom: 'space',
    marginLeft: 'space',
    marginX: 'space',
    marginY: 'space',
    marginBlock: 'space',
    marginBlockEnd: 'space',
    marginBlockStart: 'space',
    marginInline: 'space',
    marginInlineEnd: 'space',
    marginInlineStart: 'space',
    padding: 'space',
    paddingTop: 'space',
    paddingRight: 'space',
    paddingBottom: 'space',
    paddingLeft: 'space',
    paddingX: 'space',
    paddingY: 'space',
    paddingBlock: 'space',
    paddingBlockEnd: 'space',
    paddingBlockStart: 'space',
    paddingInline: 'space',
    paddingInlineEnd: 'space',
    paddingInlineStart: 'space',
    scrollMargin: 'space',
    scrollMarginTop: 'space',
    scrollMarginRight: 'space',
    scrollMarginBottom: 'space',
    scrollMarginLeft: 'space',
    scrollMarginX: 'space',
    scrollMarginY: 'space',
    scrollPadding: 'space',
    scrollPaddingTop: 'space',
    scrollPaddingRight: 'space',
    scrollPaddingBottom: 'space',
    scrollPaddingLeft: 'space',
    scrollPaddingX: 'space',
    scrollPaddingY: 'space',
    inset: 'space',
    insetBlock: 'space',
    insetBlockEnd: 'space',
    insetBlockStart: 'space',
    insetInline: 'space',
    insetInlineEnd: 'space',
    insetInlineStart: 'space',
    top: 'space',
    right: 'space',
    bottom: 'space',
    left: 'space',
    gridGap: 'space',
    gridColumnGap: 'space',
    gridRowGap: 'space',
    gap: 'space',
    columnGap: 'space',
    rowGap: 'space',
    fontFamily: 'fonts',
    fontSize: 'fontSizes',
    fontWeight: 'fontWeights',
    lineHeight: 'lineHeights',
    letterSpacing: 'letterSpacings',
    border: 'borders',
    borderTop: 'borders',
    borderRight: 'borders',
    borderBottom: 'borders',
    borderLeft: 'borders',
    borderWidth: 'borderWidths',
    borderStyle: 'borderStyles',
    borderRadius: 'radii',
    borderTopRightRadius: 'radii',
    borderTopLeftRadius: 'radii',
    borderBottomRightRadius: 'radii',
    borderBottomLeftRadius: 'radii',
    borderTopWidth: 'borderWidths',
    borderTopColor: 'colors',
    borderTopStyle: 'borderStyles',
    borderBottomWidth: 'borderWidths',
    borderBottomColor: 'colors',
    borderBottomStyle: 'borderStyles',
    borderLeftWidth: 'borderWidths',
    borderLeftColor: 'colors',
    borderLeftStyle: 'borderStyles',
    borderRightWidth: 'borderWidths',
    borderRightColor: 'colors',
    borderRightStyle: 'borderStyles',
    borderBlock: 'borders',
    borderBlockColor: 'colors',
    borderBlockEnd: 'borders',
    borderBlockEndColor: 'colors',
    borderBlockEndStyle: 'borderStyles',
    borderBlockEndWidth: 'borderWidths',
    borderBlockStart: 'borders',
    borderBlockStartColor: 'colors',
    borderBlockStartStyle: 'borderStyles',
    borderBlockStartWidth: 'borderWidths',
    borderBlockStyle: 'borderStyles',
    borderBlockWidth: 'borderWidths',
    borderEndEndRadius: 'radii',
    borderEndStartRadius: 'radii',
    borderInline: 'borders',
    borderInlineColor: 'colors',
    borderInlineEnd: 'borders',
    borderInlineEndColor: 'colors',
    borderInlineEndStyle: 'borderStyles',
    borderInlineEndWidth: 'borderWidths',
    borderInlineStart: 'borders',
    borderInlineStartColor: 'colors',
    borderInlineStartStyle: 'borderStyles',
    borderInlineStartWidth: 'borderWidths',
    borderInlineStyle: 'borderStyles',
    borderInlineWidth: 'borderWidths',
    borderStartEndRadius: 'radii',
    borderStartStartRadius: 'radii',
    columnRuleWidth: 'borderWidths',
    outlineColor: 'colors',
    boxShadow: 'shadows',
    textShadow: 'shadows',
    zIndex: 'zIndices',
    width: 'sizes',
    minWidth: 'sizes',
    maxWidth: 'sizes',
    height: 'sizes',
    minHeight: 'sizes',
    maxHeight: 'sizes',
    flexBasis: 'sizes',
    size: 'sizes',
    blockSize: 'sizes',
    inlineSize: 'sizes',
    maxBlockSize: 'sizes',
    maxInlineSize: 'sizes',
    minBlockSize: 'sizes',
    minInlineSize: 'sizes',
    columnWidth: 'sizes',
    // svg
    fill: 'colors',
    stroke: 'colors'
  };

  var positiveOrNegative$1 = function positiveOrNegative(scale, value) {
    if (typeof value !== 'number' || value >= 0) {
      if (typeof value === 'string' && value.startsWith('-')) {
        var valueWithoutMinus = value.substring(1);

        var _n = get$2(scale, valueWithoutMinus, valueWithoutMinus);

        if (typeof _n === 'number') {
          return _n * -1;
        }

        return "-" + _n;
      }

      return get$2(scale, value, value);
    }

    var absolute = Math.abs(value);
    var n = get$2(scale, absolute, absolute);
    if (typeof n === 'string') return '-' + n;
    return Number(n) * -1;
  };

  var transforms$1 = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginBlock', 'marginBlockEnd', 'marginBlockStart', 'marginInline', 'marginInlineEnd', 'marginInlineStart', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
    var _extends2;

    return _extends$3({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative$1, _extends2));
  }, {});

  var responsive$1 = function responsive(styles) {
    return function (theme) {
      var next = {};
      var breakpoints = theme && theme.breakpoints || defaultBreakpoints$1;
      var mediaQueries = [null].concat(breakpoints.map(function (n) {
        return n.includes('@media') ? n : "@media screen and (min-width: " + n + ")";
      }));

      for (var k in styles) {
        var key = k;
        var value = styles[key];

        if (typeof value === 'function') {
          value = value(theme || {});
        }

        if (value === false || value == null) {
          continue;
        }

        if (!Array.isArray(value)) {
          next[key] = value;
          continue;
        }

        for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
          var media = mediaQueries[i];

          if (!media) {
            next[key] = value[i];
            continue;
          }

          next[media] = next[media] || {};
          if (value[i] == null) continue;
          next[media][key] = value[i];
        }
      }

      return next;
    };
  };

  var css$1 = function css(args) {
    if (args === void 0) {
      args = {};
    }

    return function (props) {
      if (props === void 0) {
        props = {};
      }

      var theme = _extends$3({}, defaultTheme$1, 'theme' in props ? props.theme : props); // insert variant props before responsive styles, so they can be merged
      // we need to maintain order of the style props, so if a variant is place in the middle
      // of other props, it will extends its props at that same location order.


      var obj = getObjectWithVariants$1(typeof args === 'function' ? args(theme) : args, theme);
      var styles = responsive$1(obj)(theme);
      var result = {};

      for (var key in styles) {
        var x = styles[key];
        var val = typeof x === 'function' ? x(theme) : x;

        if (val && typeof val === 'object') {
          if (hasDefault$1(val)) {
            result[key] = val[THEME_UI_DEFAULT_KEY$1];
            continue;
          } // On type level, val can also be an array here,
          // but we transform all arrays in `responsive` function.


          result[key] = css(val)(theme);
          continue;
        }

        var prop = key in aliases$1 ? aliases$1[key] : key;
        var scaleName = prop in scales$1 ? scales$1[prop] : undefined;
        var scale = scaleName ? theme == null ? void 0 : theme[scaleName] : get$2(theme, prop, {});
        var transform = get$2(transforms$1, prop, get$2);
        var value = transform(scale, val, val);

        if (prop in multiples$1) {
          var dirs = multiples$1[prop];

          for (var i = 0; i < dirs.length; i++) {
            result[dirs[i]] = value;
          }
        } else {
          result[prop] = value;
        }
      }

      return result;
    };
  };

  function _extends$2() {
    _extends$2 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$2.apply(this, arguments);
  }

  var toVarName = function toVarName(key) {
    return "--theme-ui-" + key.replace('-__default', '');
  };

  var toVarValue = function toVarValue(key) {
    return "var(" + toVarName(key) + ")";
  };

  var join = function join() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return args.filter(Boolean).join('-');
  };

  var reservedKeys = new Set(['useCustomProperties', 'initialColorModeName', 'printColorModeName', 'initialColorMode', 'useLocalStorage', 'config']); // convert theme values to custom properties

  var toCustomProperties = function toCustomProperties(obj, parent) {
    var next = Array.isArray(obj) ? [] : {};

    for (var key in obj) {
      var value = obj[key];
      var name = join(parent, key);

      if (value && typeof value === 'object') {
        next[key] = toCustomProperties(value, name);
        continue;
      }

      if (reservedKeys.has(key)) {
        next[key] = value;
        continue;
      }

      next[key] = toVarValue(name);
    }

    return next;
  };
  /**
   * @internal
   * Recursively transforms an object into CSS variables excluding "modes" key.
   */


  var __objectToVars = function __objectToVars(parent, obj) {
    var vars = {};

    for (var key in obj) {
      if (key === 'modes') continue;
      var name = join(parent, key);
      var value = obj[key];

      if (value && typeof value === 'object') {
        vars = _extends$2({}, vars, __objectToVars(name, value));
      } else {
        vars[toVarName(name)] = value;
      }
    }

    return vars;
  };
  /**
   * @internal
   * Creates root styles for color modes.
   * - Transforms color scale into CSS variables.
   * - Sets background and text color.
   */


  var __createColorStyles = function __createColorStyles(theme) {
    if (theme === void 0) {
      theme = {};
    }

    var _ref = theme.config || theme || {},
        useCustomProperties = _ref.useCustomProperties,
        initialColorModeName = _ref.initialColorModeName,
        printColorModeName = _ref.printColorModeName,
        useRootStyles = _ref.useRootStyles;

    var colors = theme.rawColors || theme.colors;
    if (!colors || useRootStyles === false) return {};

    if (useCustomProperties === false) {
      return css$1({
        color: 'text',
        bg: 'background'
      })(theme);
    }

    var modes = colors.modes || {};

    var styles = __createColorProperties(colors, modes);

    if (printColorModeName) {
      var mode = printColorModeName === 'initial' || printColorModeName === initialColorModeName ? colors : modes[printColorModeName];
      styles['@media print'] = __objectToVars('colors', mode);
    }

    var colorToVarValue = function colorToVarValue(color) {
      return toVarValue("colors-" + color);
    };

    return css$1(_extends$2({}, styles, {
      color: colorToVarValue('text'),
      bg: colorToVarValue('background')
    }))(theme);
  };
  /**
   * @internal
   * Returns an object with colors turned into Custom CSS Properties and
   * .theme-ui-<colormode> classes used for no-flash serverside rendering.
   */


  function __createColorProperties(colors, modes) {
    var styles = __objectToVars('colors', colors);

    Object.keys(modes).forEach(function (mode) {
      var className = ".theme-ui-" + mode;
      var key = "&" + className + ", " + className + " &";
      styles[key] = __objectToVars('colors', modes[mode]);
    });
    return styles;
  }

  var STORAGE_KEY = 'theme-ui-color-mode';
  var storage = {
    get: function get() {
      try {
        return window.localStorage.getItem(STORAGE_KEY);
      } catch (err) {
        console.warn('localStorage is disabled and color mode might not work as expected.', 'Please check your Site Settings.', err);
      }
    },
    set: function set(value) {
      try {
        window.localStorage.setItem(STORAGE_KEY, value);
      } catch (err) {
        console.warn('localStorage is disabled and color mode might not work as expected.', 'Please check your Site Settings.', err);
      }
    }
  };

  var getPreferredColorScheme = function getPreferredColorScheme() {
    if (typeof window !== 'undefined' && window.matchMedia) {
      if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        return 'dark';
      }

      if (window.matchMedia('(prefers-color-scheme: light)').matches) {
        return 'light';
      }
    }

    return null;
  };

  var useClientsideEffect = typeof window === 'undefined' ? function () {} : React.useLayoutEffect;

  var TopLevelColorModeProvider = function TopLevelColorModeProvider(_ref) {
    var outerCtx = _ref.outerCtx,
        children = _ref.children;
    var outerTheme = outerCtx.theme || {};

    var _ref2 = outerTheme.config || outerTheme,
        initialColorModeName = _ref2.initialColorModeName,
        useColorSchemeMediaQuery = _ref2.useColorSchemeMediaQuery,
        useLocalStorage = _ref2.useLocalStorage;

    var _useState = React.useState(function () {
      var preferredMode = useColorSchemeMediaQuery !== false && getPreferredColorScheme();
      return preferredMode || initialColorModeName;
    }),
        colorMode = _useState[0],
        setColorMode = _useState[1]; // on first render, we read the color mode from localStorage and
    // clear the class on document element body


    useClientsideEffect(function () {
      var stored = useLocalStorage !== false && storage.get();

      if (typeof document !== 'undefined') {
        document.documentElement.classList.remove('theme-ui-' + stored);
      }

      if (stored && stored !== colorMode) {
        colorMode = stored;
        setColorMode(stored);
      }
    }, []); // when mode changes, we save it to localStorage

    React.useEffect(function () {
      if (colorMode && useLocalStorage !== false) {
        storage.set(colorMode);
      }
    }, [colorMode, useLocalStorage]);

    if (process.env.NODE_ENV !== 'production') {
      var _outerTheme$colors;

      if ((_outerTheme$colors = outerTheme.colors) != null && _outerTheme$colors.modes && initialColorModeName && Object.keys(outerTheme.colors.modes).indexOf(initialColorModeName) > -1) {
        console.warn('[theme-ui] The `initialColorModeName` value should be a unique name' + ' and cannot reference a key in `theme.colors.modes`.');
      }
    }

    var newTheme = useThemeWithAppliedColorMode({
      colorMode: colorMode,
      outerTheme: outerTheme
    });

    var newCtx = _extends$2({}, outerCtx, {
      theme: newTheme,
      colorMode: colorMode,
      setColorMode: setColorMode
    });

    return /*#__PURE__*/React__default["default"].createElement(__ThemeUIInternalBaseThemeProvider, {
      context: newCtx
    }, /*#__PURE__*/React__default["default"].createElement(GlobalColorStyles, {
      theme: newTheme
    }), children);
  };

  function useColorMode() {
    var _useThemeUI = useThemeUI(),
        colorMode = _useThemeUI.colorMode,
        setColorMode = _useThemeUI.setColorMode;

    if (typeof setColorMode !== 'function') {
      throw new Error("[useColorMode] requires the ColorModeProvider component");
    } // We're allowing the user to specify a narrower type for its color mode name.


    return [colorMode, setColorMode];
  }

  var omitModes = function omitModes(colors) {
    var res = _extends$2({}, colors);

    delete res.modes;
    return res;
  };

  function copyRawColors(colors, outerThemeRawColors) {
    for (var _i = 0, _Object$entries = Object.entries(colors); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _Object$entries[_i],
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      if (typeof value === 'string' && !value.startsWith('var(')) {
        outerThemeRawColors[key] = value;
      } else if (typeof value === 'object') {
        var newValue = _extends$2({}, outerThemeRawColors[key]);

        copyRawColors(value, newValue);
        outerThemeRawColors[key] = newValue;
      }
    }
  }

  function useThemeWithAppliedColorMode(_ref3) {
    var outerTheme = _ref3.outerTheme,
        colorMode = _ref3.colorMode;
    var theme = React.useMemo(function () {
      var res = _extends$2({}, outerTheme);

      var modes = get$2(res, 'colors.modes', {});
      var currentColorMode = get$2(modes, colorMode, {});

      if (colorMode) {
        res.colors = _extends$2({}, res.colors, currentColorMode);
      }

      var _ref4 = outerTheme.config || outerTheme,
          useCustomProperties = _ref4.useCustomProperties,
          _ref4$initialColorMod = _ref4.initialColorModeName,
          initialColorModeName = _ref4$initialColorMod === void 0 ? '__default' : _ref4$initialColorMod;

      var outerThemeRawColors = outerTheme.rawColors || outerTheme.colors || {};

      if (useCustomProperties !== false) {
        var alreadyHasRawColors = res.rawColors != null;
        var colors = res.colors || {};

        if (alreadyHasRawColors) {
          outerThemeRawColors = _extends$2({}, outerThemeRawColors);
          copyRawColors(colors, outerThemeRawColors);

          if (outerThemeRawColors.modes) {
            outerThemeRawColors.modes[initialColorModeName] = omitModes(outerThemeRawColors);
          }

          res.rawColors = outerThemeRawColors;
        } else {
          if (!('modes' in outerThemeRawColors)) {
            res.rawColors = colors;
          } else {
            var _extends2;

            var _modes = _extends$2((_extends2 = {}, _extends2[initialColorModeName] = omitModes(outerThemeRawColors), _extends2), outerThemeRawColors.modes);

            res.rawColors = _extends$2({}, colors, {
              modes: _modes
            });
            /* modes doesn't match index signature by design */
          }
        }

        res.colors = toCustomProperties(omitModes(outerThemeRawColors), 'colors');
      }

      return res;
    }, [colorMode, outerTheme]);
    return theme;
  }

  function GlobalColorStyles(_ref5) {
    var theme = _ref5.theme;
    return jsx(react.Global, {
      styles: function styles() {
        return {
          html: __createColorStyles(theme)
        };
      }
    });
  }

  function NestedColorModeProvider(_ref6) {
    var _newTheme$config2;

    var outerCtx = _ref6.outerCtx,
        children = _ref6.children;
    var newTheme = useThemeWithAppliedColorMode({
      outerTheme: outerCtx.theme,
      colorMode: outerCtx.colorMode
    }); // Nested theme providers need to be rerendered after hydration for the correct
    // color mode to apply.

    var _useState2 = React.useState( // Note: we could also check some "ssr-enabled" flag as an optimization for
    // SPAs, as deeply nested theme providers will also pay a performance penalty
    // for this SSR bug fix
    function () {
      var _newTheme$config;

      return ((_newTheme$config = newTheme.config) == null ? void 0 : _newTheme$config.useLocalStorage) !== false;
    }),
        needsRerender = _useState2[0],
        setNeedsRerender = _useState2[1];

    useClientsideEffect(function () {
      return void setNeedsRerender(false);
    }, []);
    var themeColors = newTheme.rawColors || newTheme.colors;
    var useCustomProperties = (_newTheme$config2 = newTheme.config) == null ? void 0 : _newTheme$config2.useCustomProperties;
    var colorVars = React.useMemo(function () {
      if (useCustomProperties === false) {
        return {};
      }

      var colors = themeColors || {};
      return css$1(__createColorProperties(colors, colors.modes || {}))(newTheme);
    }, [newTheme, themeColors, useCustomProperties]);
    return /*#__PURE__*/React__default["default"].createElement(__ThemeUIInternalBaseThemeProvider, {
      context: _extends$2({}, outerCtx, {
        theme: newTheme
      })
    }, jsx('div', {
      'data-themeui-nested-provider': true,
      // the key here ensures that children will be rerendered after color
      // mode is read from localStorage
      key: Number(needsRerender),
      suppressHydrationWarning: true,
      css: colorVars,
      children: children
    }));
  }

  var ColorModeProvider = function ColorModeProvider(_ref7) {
    var children = _ref7.children;
    var outerCtx = useThemeUI();
    var isTopLevelColorModeProvider = typeof outerCtx.setColorMode !== 'function';
    return isTopLevelColorModeProvider ? /*#__PURE__*/React__default["default"].createElement(TopLevelColorModeProvider, {
      outerCtx: outerCtx
    }, children) : /*#__PURE__*/React__default["default"].createElement(NestedColorModeProvider, {
      outerCtx: outerCtx
    }, children);
  };

  var __defProp$$ = Object.defineProperty;
  var __getOwnPropSymbols$$ = Object.getOwnPropertySymbols;
  var __hasOwnProp$$ = Object.prototype.hasOwnProperty;
  var __propIsEnum$$ = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$$ = function __defNormalProp$$(obj, key, value) {
    return key in obj ? __defProp$$(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$$ = function __spreadValues$$(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$$.call(b, prop)) __defNormalProp$$(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$$) {
      var _iterator3 = _createForOfIteratorHelper(__getOwnPropSymbols$$(b)),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var prop = _step3.value;
          if (__propIsEnum$$.call(b, prop)) __defNormalProp$$(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }

    return a;
  };

  var __objRest$K = function __objRest$K(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$$.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$$) {
      var _iterator4 = _createForOfIteratorHelper(__getOwnPropSymbols$$(source)),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var prop = _step4.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$$.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }

    return target;
  };

  var useThemeContext = useThemeUI;

  var ThemeProvider = function ThemeProvider(_a) {
    var _b = _a,
        children = _b.children,
        themeProps = _b.theme,
        props = __objRest$K(_b, ["children", "theme"]);

    var customTheme = Object.assign(defaultTheme$3, themeProps || {});
    return /* @__PURE__ */React__default["default"].createElement(ThemeProvider$1, {
      theme: function theme(_theme) {
        return merge$1(_theme, customTheme);
      }
    }, /* @__PURE__ */React__default["default"].createElement(GlobalStyles, null), /* @__PURE__ */React__default["default"].createElement(styled.ThemeProvider, __spreadValues$$({
      theme: customTheme
    }, props), /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, children)));
  };

  function _extends$1() {
    _extends$1 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$1.apply(this, arguments);
  }

  function memoize$1(fn) {
    var cache = Object.create(null);
    return function (arg) {
      if (cache[arg] === undefined) cache[arg] = fn(arg);
      return cache[arg];
    };
  }

  var reactPropsRegex$1 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

  var isPropValid = /* #__PURE__ */memoize$1(function (prop) {
    return reactPropsRegex$1.test(prop) || prop.charCodeAt(0) === 111
    /* o */
    && prop.charCodeAt(1) === 110
    /* n */
    && prop.charCodeAt(2) < 91;
  }
  /* Z+1 */
  );
  var isBrowser$3 = typeof document !== 'undefined';

  function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (registered[className] !== undefined) {
        registeredStyles.push(registered[className] + ";");
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }

  var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;

    if ( // we only need to add the styles to the registered cache if the
    // class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser$3 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
      cache.registered[className] = serialized.styles;
    }

    if (cache.inserted[serialized.name] === undefined) {
      var stylesForSSR = '';
      var current = serialized;

      do {
        var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

        if (!isBrowser$3 && maybeStyles !== undefined) {
          stylesForSSR += maybeStyles;
        }

        current = current.next;
      } while (current !== undefined);

      if (!isBrowser$3 && stylesForSSR.length !== 0) {
        return stylesForSSR;
      }
    }
  };
  /* eslint-disable */
  // Inspired by https://github.com/garycourt/murmurhash-js
  // Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86


  function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash

    var k,
        i = 0,
        len = str.length;

    for (; len >= 4; ++i, len -= 4) {
      k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
      k =
      /* Math.imul(k, m): */
      (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
      k ^=
      /* k >>> r: */
      k >>> 24;
      h =
      /* Math.imul(k, m): */
      (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array


    switch (len) {
      case 3:
        h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

      case 2:
        h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

      case 1:
        h ^= str.charCodeAt(i) & 0xff;
        h =
        /* Math.imul(h, m): */
        (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.


    h ^= h >>> 13;
    h =
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
  }

  var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
  };
  var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
  var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
  var hyphenateRegex = /[A-Z]|^ms/g;
  var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

  var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
  };

  var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
  };

  var processStyleName = /* #__PURE__ */memoize$1(function (styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
  });

  var processStyleValue = function processStyleValue(key, value) {
    switch (key) {
      case 'animation':
      case 'animationName':
        {
          if (typeof value === 'string') {
            return value.replace(animationRegex, function (match, p1, p2) {
              cursor = {
                name: p1,
                styles: p2,
                next: cursor
              };
              return p1;
            });
          }
        }
    }

    if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
      return value + 'px';
    }

    return value;
  };

  if (process.env.NODE_ENV !== 'production') {
    var contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
    var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
    var oldProcessStyleValue = processStyleValue;
    var msPattern = /^-ms-/;
    var hyphenPattern = /-(.)/g;
    var hyphenatedCache = {};

    processStyleValue = function processStyleValue(key, value) {
      if (key === 'content') {
        if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
          throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
        }
      }

      var processed = oldProcessStyleValue(key, value);

      if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
        hyphenatedCache[key] = true;
        console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
          return _char.toUpperCase();
        }) + "?");
      }

      return processed;
    };
  }

  function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) {
      return '';
    }

    if (interpolation.__emotion_styles !== undefined) {
      if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
        throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
      }

      return interpolation;
    }

    switch (typeof interpolation) {
      case 'boolean':
        {
          return '';
        }

      case 'object':
        {
          if (interpolation.anim === 1) {
            cursor = {
              name: interpolation.name,
              styles: interpolation.styles,
              next: cursor
            };
            return interpolation.name;
          }

          if (interpolation.styles !== undefined) {
            var next = interpolation.next;

            if (next !== undefined) {
              // not the most efficient thing ever but this is a pretty rare case
              // and there will be very few iterations of this generally
              while (next !== undefined) {
                cursor = {
                  name: next.name,
                  styles: next.styles,
                  next: cursor
                };
                next = next.next;
              }
            }

            var styles = interpolation.styles + ";";

            if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
              styles += interpolation.map;
            }

            return styles;
          }

          return createStringFromObject(mergedProps, registered, interpolation);
        }

      case 'function':
        {
          if (mergedProps !== undefined) {
            var previousCursor = cursor;
            var result = interpolation(mergedProps);
            cursor = previousCursor;
            return handleInterpolation(mergedProps, registered, result);
          } else if (process.env.NODE_ENV !== 'production') {
            console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
          }

          break;
        }

      case 'string':
        if (process.env.NODE_ENV !== 'production') {
          var matched = [];
          var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
            var fakeVarName = "animation" + matched.length;
            matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
            return "${" + fakeVarName + "}";
          });

          if (matched.length) {
            console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
          }
        }

        break;
    } // finalize string values (regular strings and functions interpolated into css calls)


    if (registered == null) {
      return interpolation;
    }

    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
  }

  function createStringFromObject(mergedProps, registered, obj) {
    var string = '';

    if (Array.isArray(obj)) {
      for (var i = 0; i < obj.length; i++) {
        string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
      }
    } else {
      for (var _key in obj) {
        var value = obj[_key];

        if (typeof value !== 'object') {
          if (registered != null && registered[value] !== undefined) {
            string += _key + "{" + registered[value] + "}";
          } else if (isProcessableValue(value)) {
            string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
          }
        } else {
          if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
          }

          if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
            for (var _i = 0; _i < value.length; _i++) {
              if (isProcessableValue(value[_i])) {
                string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
              }
            }
          } else {
            var interpolated = handleInterpolation(mergedProps, registered, value);

            switch (_key) {
              case 'animation':
              case 'animationName':
                {
                  string += processStyleName(_key) + ":" + interpolated + ";";
                  break;
                }

              default:
                {
                  if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                    console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                  }

                  string += _key + "{" + interpolated + "}";
                }
            }
          }
        }
      }
    }

    return string;
  }

  var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
  var sourceMapPattern;

  if (process.env.NODE_ENV !== 'production') {
    sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
  } // this is the cursor for keyframes
  // keyframes are stored on the SerializedStyles object as a linked list


  var cursor;

  var serializeStyles = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
      return args[0];
    }

    var stringMode = true;
    var styles = '';
    cursor = undefined;
    var strings = args[0];

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation(mergedProps, registered, strings);
    } else {
      if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
      }

      styles += strings[0];
    } // we start at 1 since we've already handled the first arg


    for (var i = 1; i < args.length; i++) {
      styles += handleInterpolation(mergedProps, registered, args[i]);

      if (stringMode) {
        if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
        }

        styles += strings[i];
      }
    }

    var sourceMap;

    if (process.env.NODE_ENV !== 'production') {
      styles = styles.replace(sourceMapPattern, function (match) {
        sourceMap = match;
        return '';
      });
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time


    labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

    while ((match = labelPattern.exec(styles)) !== null) {
      identifierName += '-' + // $FlowFixMe we know it's not null
      match[1];
    }

    var name = murmur2(styles) + identifierName;

    if (process.env.NODE_ENV !== 'production') {
      // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
      return {
        name: name,
        styles: styles,
        map: sourceMap,
        next: cursor,
        toString: function toString() {
          return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
        }
      };
    }

    return {
      name: name,
      styles: styles,
      next: cursor
    };
  };

  var testOmitPropsOnStringTag = isPropValid;

  var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
  };

  var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
  };

  var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;

    if (options) {
      var optionsShouldForwardProp = options.shouldForwardProp;
      shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
        return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
      } : optionsShouldForwardProp;
    }

    if (typeof shouldForwardProp !== 'function' && isReal) {
      shouldForwardProp = tag.__emotion_forwardProp;
    }

    return shouldForwardProp;
  };

  var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
  var isBrowser$2 = typeof document !== 'undefined';

  var createStyled = function createStyled(tag, options) {
    if (process.env.NODE_ENV !== 'production') {
      if (tag === undefined) {
        throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
      }
    }

    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;

    if (options !== undefined) {
      identifierName = options.label;
      targetClassName = options.target;
    }

    var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function () {
      var args = arguments;
      var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

      if (identifierName !== undefined) {
        styles.push("label:" + identifierName + ";");
      }

      if (args[0] == null || args[0].raw === undefined) {
        styles.push.apply(styles, args);
      } else {
        if (process.env.NODE_ENV !== 'production' && args[0][0] === undefined) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        }

        styles.push(args[0][0]);
        var len = args.length;
        var i = 1;

        for (; i < len; i++) {
          if (process.env.NODE_ENV !== 'production' && args[0][i] === undefined) {
            console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
          }

          styles.push(args[i], args[0][i]);
        }
      } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


      var Styled = react.withEmotionCache(function (props, cache, ref) {
        var finalTag = shouldUseAs && props.as || baseTag;
        var className = '';
        var classInterpolations = [];
        var mergedProps = props;

        if (props.theme == null) {
          mergedProps = {};

          for (var key in props) {
            mergedProps[key] = props[key];
          }

          mergedProps.theme = React.useContext(react.ThemeContext);
        }

        if (typeof props.className === 'string') {
          className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
        } else if (props.className != null) {
          className = props.className + " ";
        }

        var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
        var rules = insertStyles(cache, serialized, typeof finalTag === 'string');
        className += cache.key + "-" + serialized.name;

        if (targetClassName !== undefined) {
          className += " " + targetClassName;
        }

        var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
        var newProps = {};

        for (var _key in props) {
          if (shouldUseAs && _key === 'as') continue;

          if ( // $FlowFixMe
          finalShouldForwardProp(_key)) {
            newProps[_key] = props[_key];
          }
        }

        newProps.className = className;
        newProps.ref = ref;
        var ele = /*#__PURE__*/React.createElement(finalTag, newProps);

        if (!isBrowser$2 && rules !== undefined) {
          var _ref;

          var serializedNames = serialized.name;
          var next = serialized.next;

          while (next !== undefined) {
            serializedNames += ' ' + next.name;
            next = next.next;
          }

          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + " " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
          }, _ref.nonce = cache.sheet.nonce, _ref)), ele);
        }

        return ele;
      });
      Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
      Styled.defaultProps = tag.defaultProps;
      Styled.__emotion_real = Styled;
      Styled.__emotion_base = baseTag;
      Styled.__emotion_styles = styles;
      Styled.__emotion_forwardProp = shouldForwardProp;
      Object.defineProperty(Styled, 'toString', {
        value: function value() {
          if (targetClassName === undefined && process.env.NODE_ENV !== 'production') {
            return 'NO_COMPONENT_SELECTOR';
          } // $FlowFixMe: coerce undefined to string


          return "." + targetClassName;
        }
      });

      Styled.withComponent = function (nextTag, nextOptions) {
        return createStyled(nextTag, _extends$1({}, options, nextOptions, {
          shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
        })).apply(void 0, styles);
      };

      return Styled;
    };
  };

  var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
  'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
  var newStyled = createStyled.bind();
  tags.forEach(function (tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    newStyled[tagName] = newStyled(tagName);
  });
  /**
   * Allows for nested scales with shorthand values
   * @example
   * {
   *   colors: {
   *     primary: { __default: '#00f', light: '#33f' }
   *   }
   * }
   * css({ color: 'primary' }); // { color: '#00f' }
   * css({ color: 'primary.light' }) // { color: '#33f' }
   */

  var THEME_UI_DEFAULT_KEY = '__default';

  var hasDefault = function hasDefault(x) {
    return typeof x === 'object' && x !== null && THEME_UI_DEFAULT_KEY in x;
  };
  /**
   * Extracts value under path from a deeply nested object.
   * Used for Themes, variants and Theme UI style objects.
   * Given a path to object with `__default` key, returns the value under that key.
   *
   * @param obj a theme, variant or style object
   * @param path path separated with dots (`.`)
   * @param fallback default value returned if get(obj, path) is not found
   */


  function get$1(obj, path, fallback, p, undef) {
    var pathArray = path && typeof path === 'string' ? path.split('.') : [path];

    for (p = 0; p < pathArray.length; p++) {
      obj = obj ? obj[pathArray[p]] : undef;
    }

    if (obj === undef) return fallback;
    return hasDefault(obj) ? obj[THEME_UI_DEFAULT_KEY] : obj;
  }

  var getObjectWithVariants = function getObjectWithVariants(obj, theme) {
    if (obj && obj['variant']) {
      var result = {};

      for (var key in obj) {
        var x = obj[key];

        if (key === 'variant') {
          var val = typeof x === 'function' ? x(theme) : x;

          var _variant = getObjectWithVariants(get$1(theme, val), theme);

          result = _objectSpread(_objectSpread({}, result), _variant);
        } else {
          result[key] = x;
        }
      }

      return result;
    }

    return obj;
  };

  var defaultBreakpoints = [40, 52, 64].map(function (n) {
    return n + 'em';
  });
  var defaultTheme = {
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
    fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
  };
  var aliases = {
    bg: 'backgroundColor',
    m: 'margin',
    mt: 'marginTop',
    mr: 'marginRight',
    mb: 'marginBottom',
    ml: 'marginLeft',
    mx: 'marginX',
    my: 'marginY',
    p: 'padding',
    pt: 'paddingTop',
    pr: 'paddingRight',
    pb: 'paddingBottom',
    pl: 'paddingLeft',
    px: 'paddingX',
    py: 'paddingY'
  };
  var multiples = {
    marginX: ['marginLeft', 'marginRight'],
    marginY: ['marginTop', 'marginBottom'],
    paddingX: ['paddingLeft', 'paddingRight'],
    paddingY: ['paddingTop', 'paddingBottom'],
    scrollMarginX: ['scrollMarginLeft', 'scrollMarginRight'],
    scrollMarginY: ['scrollMarginTop', 'scrollMarginBottom'],
    scrollPaddingX: ['scrollPaddingLeft', 'scrollPaddingRight'],
    scrollPaddingY: ['scrollPaddingTop', 'scrollPaddingBottom'],
    size: ['width', 'height']
  };
  var scales = {
    color: 'colors',
    backgroundColor: 'colors',
    borderColor: 'colors',
    caretColor: 'colors',
    columnRuleColor: 'colors',
    textDecorationColor: 'colors',
    opacity: 'opacities',
    transition: 'transitions',
    margin: 'space',
    marginTop: 'space',
    marginRight: 'space',
    marginBottom: 'space',
    marginLeft: 'space',
    marginX: 'space',
    marginY: 'space',
    marginBlock: 'space',
    marginBlockEnd: 'space',
    marginBlockStart: 'space',
    marginInline: 'space',
    marginInlineEnd: 'space',
    marginInlineStart: 'space',
    padding: 'space',
    paddingTop: 'space',
    paddingRight: 'space',
    paddingBottom: 'space',
    paddingLeft: 'space',
    paddingX: 'space',
    paddingY: 'space',
    paddingBlock: 'space',
    paddingBlockEnd: 'space',
    paddingBlockStart: 'space',
    paddingInline: 'space',
    paddingInlineEnd: 'space',
    paddingInlineStart: 'space',
    scrollMargin: 'space',
    scrollMarginTop: 'space',
    scrollMarginRight: 'space',
    scrollMarginBottom: 'space',
    scrollMarginLeft: 'space',
    scrollMarginX: 'space',
    scrollMarginY: 'space',
    scrollPadding: 'space',
    scrollPaddingTop: 'space',
    scrollPaddingRight: 'space',
    scrollPaddingBottom: 'space',
    scrollPaddingLeft: 'space',
    scrollPaddingX: 'space',
    scrollPaddingY: 'space',
    inset: 'space',
    insetBlock: 'space',
    insetBlockEnd: 'space',
    insetBlockStart: 'space',
    insetInline: 'space',
    insetInlineEnd: 'space',
    insetInlineStart: 'space',
    top: 'space',
    right: 'space',
    bottom: 'space',
    left: 'space',
    gridGap: 'space',
    gridColumnGap: 'space',
    gridRowGap: 'space',
    gap: 'space',
    columnGap: 'space',
    rowGap: 'space',
    fontFamily: 'fonts',
    fontSize: 'fontSizes',
    fontWeight: 'fontWeights',
    lineHeight: 'lineHeights',
    letterSpacing: 'letterSpacings',
    border: 'borders',
    borderTop: 'borders',
    borderRight: 'borders',
    borderBottom: 'borders',
    borderLeft: 'borders',
    borderWidth: 'borderWidths',
    borderStyle: 'borderStyles',
    borderRadius: 'radii',
    borderTopRightRadius: 'radii',
    borderTopLeftRadius: 'radii',
    borderBottomRightRadius: 'radii',
    borderBottomLeftRadius: 'radii',
    borderTopWidth: 'borderWidths',
    borderTopColor: 'colors',
    borderTopStyle: 'borderStyles',
    borderBottomWidth: 'borderWidths',
    borderBottomColor: 'colors',
    borderBottomStyle: 'borderStyles',
    borderLeftWidth: 'borderWidths',
    borderLeftColor: 'colors',
    borderLeftStyle: 'borderStyles',
    borderRightWidth: 'borderWidths',
    borderRightColor: 'colors',
    borderRightStyle: 'borderStyles',
    borderBlock: 'borders',
    borderBlockColor: 'colors',
    borderBlockEnd: 'borders',
    borderBlockEndColor: 'colors',
    borderBlockEndStyle: 'borderStyles',
    borderBlockEndWidth: 'borderWidths',
    borderBlockStart: 'borders',
    borderBlockStartColor: 'colors',
    borderBlockStartStyle: 'borderStyles',
    borderBlockStartWidth: 'borderWidths',
    borderBlockStyle: 'borderStyles',
    borderBlockWidth: 'borderWidths',
    borderEndEndRadius: 'radii',
    borderEndStartRadius: 'radii',
    borderInline: 'borders',
    borderInlineColor: 'colors',
    borderInlineEnd: 'borders',
    borderInlineEndColor: 'colors',
    borderInlineEndStyle: 'borderStyles',
    borderInlineEndWidth: 'borderWidths',
    borderInlineStart: 'borders',
    borderInlineStartColor: 'colors',
    borderInlineStartStyle: 'borderStyles',
    borderInlineStartWidth: 'borderWidths',
    borderInlineStyle: 'borderStyles',
    borderInlineWidth: 'borderWidths',
    borderStartEndRadius: 'radii',
    borderStartStartRadius: 'radii',
    columnRuleWidth: 'borderWidths',
    outlineColor: 'colors',
    boxShadow: 'shadows',
    textShadow: 'shadows',
    zIndex: 'zIndices',
    width: 'sizes',
    minWidth: 'sizes',
    maxWidth: 'sizes',
    height: 'sizes',
    minHeight: 'sizes',
    maxHeight: 'sizes',
    flexBasis: 'sizes',
    size: 'sizes',
    blockSize: 'sizes',
    inlineSize: 'sizes',
    maxBlockSize: 'sizes',
    maxInlineSize: 'sizes',
    minBlockSize: 'sizes',
    minInlineSize: 'sizes',
    columnWidth: 'sizes',
    // svg
    fill: 'colors',
    stroke: 'colors'
  };

  var positiveOrNegative = function positiveOrNegative(scale, value) {
    if (typeof value !== 'number' || value >= 0) {
      if (typeof value === 'string' && value.startsWith('-')) {
        var valueWithoutMinus = value.substring(1);

        var _n2 = get$1(scale, valueWithoutMinus, valueWithoutMinus);

        if (typeof _n2 === 'number') {
          return _n2 * -1;
        }

        return "-".concat(_n2);
      }

      return get$1(scale, value, value);
    }

    var absolute = Math.abs(value);
    var n = get$1(scale, absolute, absolute);
    if (typeof n === 'string') return '-' + n;
    return Number(n) * -1;
  };

  var transforms = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginBlock', 'marginBlockEnd', 'marginBlockStart', 'marginInline', 'marginInlineEnd', 'marginInlineStart', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, curr, positiveOrNegative));
  }, {});

  var responsive = function responsive(styles) {
    return function (theme) {
      var next = {};
      var breakpoints = theme && theme.breakpoints || defaultBreakpoints;
      var mediaQueries = [null].concat(_toConsumableArray(breakpoints.map(function (n) {
        return n.includes('@media') ? n : "@media screen and (min-width: ".concat(n, ")");
      })));

      for (var k in styles) {
        var key = k;
        var value = styles[key];

        if (typeof value === 'function') {
          value = value(theme || {});
        }

        if (value === false || value == null) {
          continue;
        }

        if (!Array.isArray(value)) {
          next[key] = value;
          continue;
        }

        for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
          var media = mediaQueries[i];

          if (!media) {
            next[key] = value[i];
            continue;
          }

          next[media] = next[media] || {};
          if (value[i] == null) continue;
          next[media][key] = value[i];
        }
      }

      return next;
    };
  };

  var css = function css() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var theme = _objectSpread(_objectSpread({}, defaultTheme), 'theme' in props ? props.theme : props); // insert variant props before responsive styles, so they can be merged
      // we need to maintain order of the style props, so if a variant is place in the middle
      // of other props, it will extends its props at that same location order.


      var obj = getObjectWithVariants(typeof args === 'function' ? args(theme) : args, theme);
      var styles = responsive(obj)(theme);
      var result = {};

      for (var key in styles) {
        var x = styles[key];
        var val = typeof x === 'function' ? x(theme) : x;

        if (val && typeof val === 'object') {
          if (hasDefault(val)) {
            result[key] = val[THEME_UI_DEFAULT_KEY];
            continue;
          } // On type level, val can also be an array here,
          // but we transform all arrays in `responsive` function.


          result[key] = css(val)(theme);
          continue;
        }

        var prop = key in aliases ? aliases[key] : key;
        var scaleName = prop in scales ? scales[prop] : undefined;
        var scale = scaleName ? theme == null ? void 0 : theme[scaleName] : get$1(theme, prop, {});
        var transform = get$1(transforms, prop, get$1);
        var value = transform(scale, val, val);

        if (prop in multiples) {
          var dirs = multiples[prop];

          for (var i = 0; i < dirs.length; i++) {
            result[dirs[i]] = value;
          }
        } else {
          result[prop] = value;
        }
      }

      return result;
    };
  };

  function memoize(fn) {
    var cache = {};
    return function (arg) {
      if (cache[arg] === undefined) cache[arg] = fn(arg);
      return cache[arg];
    };
  }

  var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

  var index$1 = memoize(function (prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
    /* o */
    && prop.charCodeAt(1) === 110
    /* n */
    && prop.charCodeAt(2) < 91;
  }
  /* Z+1 */
  );
  var all = styledSystem.compose(styledSystem.space, styledSystem.typography, styledSystem.color, styledSystem.layout, styledSystem.flexbox, styledSystem.border, styledSystem.background, styledSystem.position, styledSystem.grid, styledSystem.shadow, styledSystem.buttonStyle, styledSystem.textStyle, styledSystem.colorStyle);
  var props = all.propNames;

  var createShouldForwardProp = function createShouldForwardProp(props) {
    var regex = new RegExp("^(" + props.join('|') + ")$");
    return memoize$1(function (prop) {
      return index$1(prop) && !regex.test(prop);
    });
  };

  createShouldForwardProp(props);
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  /* eslint-disable no-unused-vars */

  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;

  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }

    return Object(val);
  }

  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      } // Detect buggy property enumeration order in older V8 versions.
      // https://bugs.chromium.org/p/v8/issues/detail?id=4118


      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

      test1[5] = 'de';

      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test2 = {};

      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }

      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });

      if (order2.join('') !== '0123456789') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });

      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }

      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }

  var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;

    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);

      for (var key in from) {
        if (hasOwnProperty$1.call(from, key)) {
          to[key] = from[key];
        }
      }

      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);

        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }

    return to;
  };

  var merge = function merge(a, b) {
    var result = objectAssign({}, a, b);

    for (var key in a) {
      var _assign;

      if (!a[key] || typeof b[key] !== 'object') continue;
      objectAssign(result, (_assign = {}, _assign[key] = objectAssign(a[key], b[key]), _assign));
    }

    return result;
  }; // sort object-value responsive styles


  var sort = function sort(obj) {
    var next = {};
    Object.keys(obj).sort(function (a, b) {
      return a.localeCompare(b, undefined, {
        numeric: true,
        sensitivity: 'base'
      });
    }).forEach(function (key) {
      next[key] = obj[key];
    });
    return next;
  };

  var defaults$1 = {
    breakpoints: [40, 52, 64].map(function (n) {
      return n + 'em';
    })
  };

  var createMediaQuery = function createMediaQuery(n) {
    return "@media screen and (min-width: " + n + ")";
  };

  var getValue = function getValue(n, scale) {
    return get(scale, n, n);
  };

  var get = function get(obj, key, def, p, undef) {
    key = key && key.split ? key.split('.') : [key];

    for (p = 0; p < key.length; p++) {
      obj = obj ? obj[key[p]] : undef;
    }

    return obj === undef ? def : obj;
  };

  var createParser = function createParser(config) {
    var cache = {};

    var parse = function parse(props) {
      var styles = {};
      var shouldSort = false;
      var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;

      for (var key in props) {
        if (!config[key]) continue;
        var sx = config[key];
        var raw = props[key];
        var scale = get(props.theme, sx.scale, sx.defaults);

        if (typeof raw === 'object') {
          cache.breakpoints = !isCacheDisabled && cache.breakpoints || get(props.theme, 'breakpoints', defaults$1.breakpoints);

          if (Array.isArray(raw)) {
            cache.media = !isCacheDisabled && cache.media || [null].concat(cache.breakpoints.map(createMediaQuery));
            styles = merge(styles, parseResponsiveStyle(cache.media, sx, scale, raw, props));
            continue;
          }

          if (raw !== null) {
            styles = merge(styles, parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
            shouldSort = true;
          }

          continue;
        }

        objectAssign(styles, sx(raw, scale, props));
      } // sort object-based responsive styles


      if (shouldSort) {
        styles = sort(styles);
      }

      return styles;
    };

    parse.config = config;
    parse.propNames = Object.keys(config);
    parse.cache = cache;
    var keys = Object.keys(config).filter(function (k) {
      return k !== 'config';
    });

    if (keys.length > 1) {
      keys.forEach(function (key) {
        var _createParser;

        parse[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser));
      });
    }

    return parse;
  };

  var parseResponsiveStyle = function parseResponsiveStyle(mediaQueries, sx, scale, raw, _props) {
    var styles = {};
    raw.slice(0, mediaQueries.length).forEach(function (value, i) {
      var media = mediaQueries[i];
      var style = sx(value, scale, _props);

      if (!media) {
        objectAssign(styles, style);
      } else {
        var _assign2;

        objectAssign(styles, (_assign2 = {}, _assign2[media] = objectAssign({}, styles[media], style), _assign2));
      }
    });
    return styles;
  };

  var parseResponsiveObject = function parseResponsiveObject(breakpoints, sx, scale, raw, _props) {
    var styles = {};

    for (var key in raw) {
      var breakpoint = breakpoints[key];
      var value = raw[key];
      var style = sx(value, scale, _props);

      if (!breakpoint) {
        objectAssign(styles, style);
      } else {
        var _assign3;

        var media = createMediaQuery(breakpoint);
        objectAssign(styles, (_assign3 = {}, _assign3[media] = objectAssign({}, styles[media], style), _assign3));
      }
    }

    return styles;
  };

  var createStyleFunction = function createStyleFunction(_ref) {
    var properties = _ref.properties,
        property = _ref.property,
        scale = _ref.scale,
        _ref$transform = _ref.transform,
        transform = _ref$transform === void 0 ? getValue : _ref$transform,
        defaultScale = _ref.defaultScale;
    properties = properties || [property];

    var sx = function sx(value, scale, _props) {
      var result = {};
      var n = transform(value, scale, _props);
      if (n === null) return;
      properties.forEach(function (prop) {
        result[prop] = n;
      });
      return result;
    };

    sx.scale = scale;
    sx.defaults = defaultScale;
    return sx;
  }; // new v5 API


  var system$1 = function system(args) {
    if (args === void 0) {
      args = {};
    }

    var config = {};
    Object.keys(args).forEach(function (key) {
      var conf = args[key];

      if (conf === true) {
        // shortcut definition
        config[key] = createStyleFunction({
          property: key,
          scale: key
        });
        return;
      }

      if (typeof conf === 'function') {
        config[key] = conf;
        return;
      }

      config[key] = createStyleFunction(conf);
    });
    var parser = createParser(config);
    return parser;
  };

  var compose$1 = function compose() {
    var config = {};

    for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
      parsers[_key] = arguments[_key];
    }

    parsers.forEach(function (parser) {
      if (!parser || !parser.config) return;
      objectAssign(config, parser.config);
    });
    var parser = createParser(config);
    return parser;
  };

  var defaults = {
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
  };

  var isNumber = function isNumber(n) {
    return typeof n === 'number' && !isNaN(n);
  };

  var getMargin = function getMargin(n, scale) {
    if (!isNumber(n)) {
      return get(scale, n, n);
    }

    var isNegative = n < 0;
    var absolute = Math.abs(n);
    var value = get(scale, absolute, absolute);

    if (!isNumber(value)) {
      return isNegative ? '-' + value : value;
    }

    return value * (isNegative ? -1 : 1);
  };

  var configs = {};
  configs.margin = {
    margin: {
      property: 'margin',
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    },
    marginTop: {
      property: 'marginTop',
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    },
    marginRight: {
      property: 'marginRight',
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    },
    marginBottom: {
      property: 'marginBottom',
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    },
    marginLeft: {
      property: 'marginLeft',
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    },
    marginX: {
      properties: ['marginLeft', 'marginRight'],
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    },
    marginY: {
      properties: ['marginTop', 'marginBottom'],
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    }
  };
  configs.margin.m = configs.margin.margin;
  configs.margin.mt = configs.margin.marginTop;
  configs.margin.mr = configs.margin.marginRight;
  configs.margin.mb = configs.margin.marginBottom;
  configs.margin.ml = configs.margin.marginLeft;
  configs.margin.mx = configs.margin.marginX;
  configs.margin.my = configs.margin.marginY;
  configs.padding = {
    padding: {
      property: 'padding',
      scale: 'space',
      defaultScale: defaults.space
    },
    paddingTop: {
      property: 'paddingTop',
      scale: 'space',
      defaultScale: defaults.space
    },
    paddingRight: {
      property: 'paddingRight',
      scale: 'space',
      defaultScale: defaults.space
    },
    paddingBottom: {
      property: 'paddingBottom',
      scale: 'space',
      defaultScale: defaults.space
    },
    paddingLeft: {
      property: 'paddingLeft',
      scale: 'space',
      defaultScale: defaults.space
    },
    paddingX: {
      properties: ['paddingLeft', 'paddingRight'],
      scale: 'space',
      defaultScale: defaults.space
    },
    paddingY: {
      properties: ['paddingTop', 'paddingBottom'],
      scale: 'space',
      defaultScale: defaults.space
    }
  };
  configs.padding.p = configs.padding.padding;
  configs.padding.pt = configs.padding.paddingTop;
  configs.padding.pr = configs.padding.paddingRight;
  configs.padding.pb = configs.padding.paddingBottom;
  configs.padding.pl = configs.padding.paddingLeft;
  configs.padding.px = configs.padding.paddingX;
  configs.padding.py = configs.padding.paddingY;
  var margin = system$1(configs.margin);
  var padding = system$1(configs.padding);
  var space = compose$1(margin, padding);
  var config = {
    color: {
      property: 'color',
      scale: 'colors'
    },
    backgroundColor: {
      property: 'backgroundColor',
      scale: 'colors'
    },
    opacity: true
  };
  config.bg = config.backgroundColor;
  var color = system$1(config);
  var boxSystemProps = [].concat(_toConsumableArray(space.propNames), _toConsumableArray(color.propNames));
  var shouldForwardProp = createShouldForwardProp(boxSystemProps);

  var sx = function sx(props) {
    return css(props.sx)(props.theme);
  };

  var base = function base(props) {
    return css(props.__css)(props.theme);
  };

  var variant = function variant(_ref8) {
    var theme = _ref8.theme,
        variant = _ref8.variant,
        _ref8$__themeKey = _ref8.__themeKey,
        __themeKey = _ref8$__themeKey === void 0 ? 'variants' : _ref8$__themeKey;

    return css(get$1(theme, __themeKey + '.' + variant, get$1(theme, variant)));
  };

  var Box$1 = newStyled('div', {
    shouldForwardProp: shouldForwardProp
  })({
    boxSizing: 'border-box',
    margin: 0,
    minWidth: 0
  }, base, variant, space, color, sx, function (props) {
    return props.css;
  });
  Box$1.displayName = 'Box';
  var Flex$1 = newStyled(Box$1)({
    display: 'flex'
  });
  Flex$1.displayName = 'Flex';

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var Image = /*#__PURE__*/React__default["default"].forwardRef(function Image(props, ref) {
    return /*#__PURE__*/React__default["default"].createElement(Box$1, _extends({
      ref: ref,
      as: "img"
    }, props, {
      __themeKey: "images",
      __css: _objectSpread({
        maxWidth: '100%',
        height: 'auto'
      }, props.__css)
    }));
  });
  react.keyframes({
    from: {
      transform: 'rotate(0deg)'
    },
    to: {
      transform: 'rotate(360deg)'
    }
  });
  var __defProp$_ = Object.defineProperty;
  var __getOwnPropSymbols$_ = Object.getOwnPropertySymbols;
  var __hasOwnProp$_ = Object.prototype.hasOwnProperty;
  var __propIsEnum$_ = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$_ = function __defNormalProp$_(obj, key, value) {
    return key in obj ? __defProp$_(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$_ = function __spreadValues$_(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$_.call(b, prop)) __defNormalProp$_(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$_) {
      var _iterator5 = _createForOfIteratorHelper(__getOwnPropSymbols$_(b)),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var prop = _step5.value;
          if (__propIsEnum$_.call(b, prop)) __defNormalProp$_(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }

    return a;
  };

  var getSizeStyle = function getSizeStyle(variant) {
    switch (variant) {
      case "md":
        return {
          height: 48,
          width: 48
        };

      case "sm":
        return {
          height: 32,
          width: 32
        };

      default:
        return {
          height: 56,
          width: 56
        };
    }
  };

  var getContainerStyle$4 = function getContainerStyle$4(variant, brand) {
    return __spreadValues$_({
      borderRadius: "circle",
      borderStyle: "solid",
      borderWidth: "hairline",
      boxSizing: "border-box",
      color: brand ? "typeface.on.brand.pure" : "neutral.30",
      display: "inline-flex",
      justifyContent: "center",
      overflow: "hidden",
      placeItems: "center",
      position: "relative"
    }, getSizeStyle(variant));
  };

  var imageStyle = {
    height: "100%",
    objectFit: "cover",
    position: "relative",
    width: "100%",
    zIndex: "1"
  };
  var initialsStyle = {
    m: "auto",
    position: "absolute"
  };
  var portugueseNameArticles = ["da", "de", "do"];

  var getInitials = function getInitials() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var filteredNames = text.split(/\W+/gi).filter(function (name) {
      return !portugueseNameArticles.includes(name.toLowerCase());
    });
    var leadingName = head(filteredNames);
    var trallingName = head(filteredNames.slice(1, 2));

    if (!filteredNames.length) {
      return "";
    }

    if (filteredNames.length === 1) {
      return "".concat(leadingName && leadingName.slice(0, 2).toUpperCase(), " ");
    }

    return "".concat(leadingName && leadingName.slice(0, 1)).concat(trallingName && trallingName.slice(0, 1)).toUpperCase();
  };

  var getKey = styledSystem__namespace.get,
      compose = styledSystem__namespace.compose,
      system = styledSystem__namespace.system;
  var COMMON = compose(styledSystem__namespace.space, styledSystem__namespace.color, styledSystem__namespace.display);
  var whiteSpace = system({
    whiteSpace: {
      property: "whiteSpace"
    }
  });
  var TYPOGRAPHY = compose(styledSystem__namespace.typography, whiteSpace);
  var BORDER = compose(styledSystem__namespace.border, styledSystem__namespace.shadow);
  var LAYOUT = styledSystem__namespace.layout;
  var FLEX = styledSystem__namespace.flexbox;
  var GRID = styledSystem__namespace.grid;

  var getBoxStyle = function getBoxStyle(_ref9) {
    var fullWidth = _ref9.fullWidth,
        width = _ref9.width;
    return {
      width: fullWidth ? "100%" : width
    };
  };

  var __defProp$Z = Object.defineProperty;
  var __defProps$D = Object.defineProperties;
  var __getOwnPropDescs$D = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$Z = Object.getOwnPropertySymbols;
  var __hasOwnProp$Z = Object.prototype.hasOwnProperty;
  var __propIsEnum$Z = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$Z = function __defNormalProp$Z(obj, key, value) {
    return key in obj ? __defProp$Z(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$Z = function __spreadValues$Z(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$Z.call(b, prop)) __defNormalProp$Z(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$Z) {
      var _iterator6 = _createForOfIteratorHelper(__getOwnPropSymbols$Z(b)),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var prop = _step6.value;
          if (__propIsEnum$Z.call(b, prop)) __defNormalProp$Z(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }

    return a;
  };

  var __spreadProps$D = function __spreadProps$D(a, b) {
    return __defProps$D(a, __getOwnPropDescs$D(b));
  };

  var Wrapper$1 = styled__default["default"](themeUi.Box)(LAYOUT, FLEX, TYPOGRAPHY, COMMON, BORDER, sx$1);
  var Box = React__default["default"].forwardRef(function (props, ref) {
    return /* @__PURE__ */React__default["default"].createElement(Wrapper$1, __spreadProps$D(__spreadValues$Z({
      sx: __spreadValues$Z(__spreadValues$Z({}, getBoxStyle(props)), props.sx)
    }, props), {
      ref: ref
    }));
  });
  var __defProp$Y = Object.defineProperty;
  var __defProps$C = Object.defineProperties;
  var __getOwnPropDescs$C = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$Y = Object.getOwnPropertySymbols;
  var __hasOwnProp$Y = Object.prototype.hasOwnProperty;
  var __propIsEnum$Y = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$Y = function __defNormalProp$Y(obj, key, value) {
    return key in obj ? __defProp$Y(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$Y = function __spreadValues$Y(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$Y.call(b, prop)) __defNormalProp$Y(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$Y) {
      var _iterator7 = _createForOfIteratorHelper(__getOwnPropSymbols$Y(b)),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var prop = _step7.value;
          if (__propIsEnum$Y.call(b, prop)) __defNormalProp$Y(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }

    return a;
  };

  var __spreadProps$C = function __spreadProps$C(a, b) {
    return __defProps$C(a, __getOwnPropDescs$C(b));
  };

  var Wrapper = styled__default["default"](Box)(COMMON, TYPOGRAPHY, sx$1, LAYOUT);
  var Typography = React__default["default"].forwardRef(function (props, ref) {
    return /* @__PURE__ */React__default["default"].createElement(Wrapper, __spreadProps$C(__spreadValues$Y({
      as: "p",
      m: 0,
      p: 0
    }, props), {
      ref: ref
    }));
  });

  var isSmallProp$2 = function isSmallProp$2(variant) {
    return variant === "sm";
  };

  var getColorTypfaceTokenByProp = function getColorTypfaceTokenByProp(_ref10, suffix) {
    var brand = _ref10.brand,
        inverse = _ref10.inverse;
    return "typeface.".concat(inverse ? "inverse." : "").concat(brand ? "on.brand." : "").concat(suffix);
  };

  var __defProp$X = Object.defineProperty;
  var __getOwnPropSymbols$X = Object.getOwnPropertySymbols;
  var __hasOwnProp$X = Object.prototype.hasOwnProperty;
  var __propIsEnum$X = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$X = function __defNormalProp$X(obj, key, value) {
    return key in obj ? __defProp$X(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$X = function __spreadValues$X(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$X.call(b, prop)) __defNormalProp$X(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$X) {
      var _iterator8 = _createForOfIteratorHelper(__getOwnPropSymbols$X(b)),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var prop = _step8.value;
          if (__propIsEnum$X.call(b, prop)) __defNormalProp$X(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }

    return a;
  };

  var __objRest$J = function __objRest$J(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$X.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$X) {
      var _iterator9 = _createForOfIteratorHelper(__getOwnPropSymbols$X(source)),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var prop = _step9.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$X.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }

    return target;
  };

  var Body = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        variant = _b.variant,
        props = __objRest$J(_b, ["variant"]);

    return /* @__PURE__ */React__default["default"].createElement(Typography, __spreadValues$X({
      color: getColorTypfaceTokenByProp(props, "pure"),
      fontFamily: "base",
      fontSize: isSmallProp$2(variant) ? "xxs" : "xs",
      letterSpacing: "standard",
      lineHeight: isSmallProp$2(variant) ? "huge" : "superdistant",
      ref: ref
    }, props));
  });
  Body.defaultProps = {
    brand: false,
    inverse: false,
    variant: "lg"
  };
  var __defProp$W = Object.defineProperty;
  var __defProps$B = Object.defineProperties;
  var __getOwnPropDescs$B = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$W = Object.getOwnPropertySymbols;
  var __hasOwnProp$W = Object.prototype.hasOwnProperty;
  var __propIsEnum$W = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$W = function __defNormalProp$W(obj, key, value) {
    return key in obj ? __defProp$W(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$W = function __spreadValues$W(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$W.call(b, prop)) __defNormalProp$W(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$W) {
      var _iterator10 = _createForOfIteratorHelper(__getOwnPropSymbols$W(b)),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var prop = _step10.value;
          if (__propIsEnum$W.call(b, prop)) __defNormalProp$W(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }

    return a;
  };

  var __spreadProps$B = function __spreadProps$B(a, b) {
    return __defProps$B(a, __getOwnPropDescs$B(b));
  };

  var __objRest$I = function __objRest$I(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$W.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$W) {
      var _iterator11 = _createForOfIteratorHelper(__getOwnPropSymbols$W(source)),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var prop = _step11.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$W.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    }

    return target;
  };

  var AvatarBase = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        name = _b.name,
        imageSrc = _b.imageSrc,
        variant = _b.variant,
        brand = _b.brand,
        sx = _b.sx,
        props = __objRest$I(_b, ["name", "imageSrc", "variant", "brand", "sx"]);

    var initials = getInitials(name);
    var hasSrcImg = !!imageSrc || false;
    var typoSize = variant === "sm" ? "sm" : "lg";

    var _React$useState = React.useState(hasSrcImg),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        showImage = _React$useState2[0],
        handleShowImage = _React$useState2[1];

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$B(__spreadValues$W({
      sx: __spreadValues$W(__spreadValues$W({}, getContainerStyle$4(variant, brand)), sx)
    }, props), {
      ref: ref
    }), showImage ? /* @__PURE__ */React__default["default"].createElement(Image, {
      alt: name,
      as: "img",
      "data-testid": "avatar-image",
      onError: function onError() {
        return handleShowImage(false);
      },
      src: imageSrc,
      sx: imageStyle
    }) : /* @__PURE__ */React__default["default"].createElement(Box, {
      as: "span",
      sx: initialsStyle
    }, /* @__PURE__ */React__default["default"].createElement(Body, {
      color: brand ? "neutral.on.brand.30" : "typeface.pure",
      variant: typoSize
    }, initials)));
  });
  var PersonAvatar = React__default["default"].forwardRef(function (_c, ref) {
    var props = __objRest$I(_c, []);

    return /* @__PURE__ */React__default["default"].createElement(AvatarBase, __spreadProps$B(__spreadValues$W({
      sx: {
        borderRadius: "circle"
      }
    }, props), {
      ref: ref
    }));
  });
  var BrandAvatar = React__default["default"].forwardRef(function (_d, ref) {
    var props = __objRest$I(_d, []);

    return /* @__PURE__ */React__default["default"].createElement(AvatarBase, __spreadProps$B(__spreadValues$W({
      sx: {
        borderRadius: "xs"
      }
    }, props), {
      ref: ref
    }));
  });
  styled__default["default"](PersonAvatar);
  styled__default["default"](BrandAvatar);

  var getIconSize$1 = function getIconSize$1(size) {
    switch (size) {
      case "md":
        return "1.5rem";

      case "lg":
        return "2rem";

      default:
        return "1rem";
    }
  };

  var getIconStyle = function getIconStyle(_ref11) {
    var size = _ref11.size,
        variant = _ref11.variant,
        color = _ref11.color;
    return {
      "& > svg": {
        cursor: "inherit",
        fill: "currentcolor",
        fontSize: getIconSize$1(size)
      },
      border: "none",
      borderRadius: "pill",
      color: variant || color || "inherit",
      cursor: "inherit",
      height: getIconSize$1(size),
      minWidth: "auto",
      width: getIconSize$1(size)
    };
  };

  var __defProp$V = Object.defineProperty;
  var __getOwnPropSymbols$V = Object.getOwnPropertySymbols;
  var __hasOwnProp$V = Object.prototype.hasOwnProperty;
  var __propIsEnum$V = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$V = function __defNormalProp$V(obj, key, value) {
    return key in obj ? __defProp$V(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$V = function __spreadValues$V(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$V.call(b, prop)) __defNormalProp$V(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$V) {
      var _iterator12 = _createForOfIteratorHelper(__getOwnPropSymbols$V(b)),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var prop = _step12.value;
          if (__propIsEnum$V.call(b, prop)) __defNormalProp$V(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
    }

    return a;
  };

  var __objRest$H = function __objRest$H(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$V.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$V) {
      var _iterator13 = _createForOfIteratorHelper(__getOwnPropSymbols$V(source)),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var prop = _step13.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$V.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
    }

    return target;
  };

  var Icon = React.forwardRef(function (_a, ref) {
    var _b = _a,
        _b$sx = _b.sx,
        sx = _b$sx === void 0 ? {} : _b$sx,
        _b$size = _b.size,
        size = _b$size === void 0 ? "md" : _b$size,
        props = __objRest$H(_b, ["sx", "size"]);

    return /* @__PURE__ */React__default["default"].createElement(themeUi.IconButton, __spreadValues$V({
      as: "span",
      ref: ref,
      sx: __spreadValues$V(__spreadValues$V({}, getIconStyle(__spreadValues$V({
        size: size
      }, props))), sx)
    }, props));
  });

  var getSpinnerStyle = function getSpinnerStyle(size, strokeWidth) {
    var loadingSize;

    switch (size) {
      case "lg":
        loadingSize = 32;
        break;

      case "md":
        loadingSize = 24;
        break;

      case "sm":
        loadingSize = 16;
        break;

      default:
        loadingSize = size;
        break;
    }

    return {
      "& div": {
        animation: "spin 1s linear infinite",
        borderBottomColor: "inherit",
        borderLeftColor: "transparent",
        borderRadius: "circle",
        borderRightColor: "inherit",
        borderStyle: "solid",
        borderTopColor: "inherit",
        borderWidth: strokeWidth,
        display: "block",
        height: "100%",
        position: "relative",
        width: "100%"
      },
      "@keyframes spin": {
        "0%": {
          transform: "rotate(0deg)"
        },
        "100%": {
          transform: "rotate(360deg)"
        }
      },
      alignItems: "center",
      display: "flex",
      height: loadingSize,
      justifyContent: "center",
      position: "relative",
      width: loadingSize
    };
  };

  var __defProp$U = Object.defineProperty;
  var __getOwnPropSymbols$U = Object.getOwnPropertySymbols;
  var __hasOwnProp$U = Object.prototype.hasOwnProperty;
  var __propIsEnum$U = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$U = function __defNormalProp$U(obj, key, value) {
    return key in obj ? __defProp$U(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$U = function __spreadValues$U(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$U.call(b, prop)) __defNormalProp$U(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$U) {
      var _iterator14 = _createForOfIteratorHelper(__getOwnPropSymbols$U(b)),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var prop = _step14.value;
          if (__propIsEnum$U.call(b, prop)) __defNormalProp$U(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
    }

    return a;
  };

  var __objRest$G = function __objRest$G(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$U.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$U) {
      var _iterator15 = _createForOfIteratorHelper(__getOwnPropSymbols$U(source)),
          _step15;

      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var prop = _step15.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$U.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
    }

    return target;
  };

  var Spinner = React.forwardRef(function (_a, ref) {
    var _b = _a,
        progress = _b.progress,
        _b$size2 = _b.size,
        size = _b$size2 === void 0 ? "lg" : _b$size2,
        _b$strokeWidth = _b.strokeWidth,
        strokeWidth = _b$strokeWidth === void 0 ? 2 : _b$strokeWidth,
        _b$text = _b.text,
        text = _b$text === void 0 ? "" : _b$text,
        sx = _b.sx,
        props = __objRest$G(_b, ["progress", "size", "strokeWidth", "text", "sx"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadValues$U({
      "aria-describedby": "id",
      "aria-valuemax": 100,
      "aria-valuemin": 0,
      "aria-valuetext": progress ? progress.toString() : text,
      ref: ref,
      role: "progressbar",
      sx: __spreadValues$U(__spreadValues$U({}, getSpinnerStyle(size, strokeWidth)), sx),
      tabIndex: 0
    }, props), /* @__PURE__ */React__default["default"].createElement(Box, null));
  });
  var __defProp$T = Object.defineProperty;
  var __getOwnPropSymbols$T = Object.getOwnPropertySymbols;
  var __hasOwnProp$T = Object.prototype.hasOwnProperty;
  var __propIsEnum$T = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$T = function __defNormalProp$T(obj, key, value) {
    return key in obj ? __defProp$T(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$T = function __spreadValues$T(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$T.call(b, prop)) __defNormalProp$T(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$T) {
      var _iterator16 = _createForOfIteratorHelper(__getOwnPropSymbols$T(b)),
          _step16;

      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var prop = _step16.value;
          if (__propIsEnum$T.call(b, prop)) __defNormalProp$T(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }
    }

    return a;
  };

  var __objRest$F = function __objRest$F(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$T.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$T) {
      var _iterator17 = _createForOfIteratorHelper(__getOwnPropSymbols$T(source)),
          _step17;

      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var prop = _step17.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$T.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
    }

    return target;
  };

  var Action = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        _b$variant = _b.variant,
        variant = _b$variant === void 0 ? "lg" : _b$variant,
        props = __objRest$F(_b, ["variant"]);

    return /* @__PURE__ */React__default["default"].createElement(Typography, __spreadValues$T({
      color: getColorTypfaceTokenByProp(props, "strong"),
      fontFamily: "base",
      fontSize: isSmallProp$2(variant) ? "xxs" : "xs",
      fontWeight: "bold",
      letterSpacing: "standard",
      lineHeight: isSmallProp$2(variant) ? "tiny" : "superdistant",
      ref: ref
    }, props));
  });
  var __defProp$S = Object.defineProperty;
  var __defProps$A = Object.defineProperties;
  var __getOwnPropDescs$A = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$S = Object.getOwnPropertySymbols;
  var __hasOwnProp$S = Object.prototype.hasOwnProperty;
  var __propIsEnum$S = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$S = function __defNormalProp$S(obj, key, value) {
    return key in obj ? __defProp$S(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$S = function __spreadValues$S(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$S.call(b, prop)) __defNormalProp$S(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$S) {
      var _iterator18 = _createForOfIteratorHelper(__getOwnPropSymbols$S(b)),
          _step18;

      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var prop = _step18.value;
          if (__propIsEnum$S.call(b, prop)) __defNormalProp$S(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }
    }

    return a;
  };

  var __spreadProps$A = function __spreadProps$A(a, b) {
    return __defProps$A(a, __getOwnPropDescs$A(b));
  };

  var __objRest$E = function __objRest$E(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$S.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$S) {
      var _iterator19 = _createForOfIteratorHelper(__getOwnPropSymbols$S(source)),
          _step19;

      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var prop = _step19.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$S.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
    }

    return target;
  };

  var getCursorStyle = function getCursorStyle(_ref12) {
    var isLoading = _ref12.isLoading,
        disabled = _ref12.disabled;

    if (isLoading) {
      return "progress";
    } else if (disabled) {
      return "not-allowed";
    }

    return "pointer";
  };

  var getButtonBaseStyle = function getButtonBaseStyle(_ref13) {
    var _ref13$borderRadius = _ref13.borderRadius,
        borderRadius = _ref13$borderRadius === void 0 ? "xs" : _ref13$borderRadius,
        fullWidth = _ref13.fullWidth,
        disabled = _ref13.disabled,
        width = _ref13.width,
        isLoading = _ref13.isLoading;
    return {
      alignItems: "center",
      bg: "transparent",
      border: "2px solid",
      borderColor: "transparent",
      borderRadius: borderRadius,
      boxSizing: "border-box",
      cursor: getCursorStyle({
        disabled: disabled,
        isLoading: isLoading
      }),
      display: "flex",
      justifyContent: "center",
      minWidth: 99,
      transition: "all 0.1s",
      width: fullWidth && "100%" || width || "auto"
    };
  };

  var activeInteractionBaseStyle = {
    borderWidth: "hairline",
    boxShadow: "none"
  };
  var disabledBaseStyle = {
    bg: "transparent",
    borderStyle: "none",
    boxShadow: "none",
    cursor: "auto"
  };
  var buttonShapeStyleSize = {
    lg: {
      height: "48px",
      px: "inline.xxxs"
    },
    sm: {
      height: "32px",
      px: "inline.nano"
    }
  };

  var getButtonsVariantsStyle = function getButtonsVariantsStyle(_ref14) {
    var brand = _ref14.brand,
        variant = _ref14.variant;

    if (brand) {
      return {};
    }

    switch (variant) {
      case "primary":
        return {
          "&:active:enabled": __spreadValues$S({
            bg: "interaction.accent.03"
          }, activeInteractionBaseStyle),
          "&:disabled": __spreadProps$A(__spreadValues$S({}, disabledBaseStyle), {
            bg: "interaction.blend.02",
            color: "typeface.meld"
          }),
          "&:focus:enabled:not(:active)": {
            bg: "interaction.accent.02",
            borderColor: "interaction.accent.02",
            borderStyle: "solid",
            borderWidth: "thin",
            boxShadow: "inset 0 0 0 2px ".concat(defaultTheme$3.colors.neutral["00"]),
            outline: "none"
          },
          "&:hover:enabled:not(:active)": {
            bg: "interaction.accent.02"
          },
          bg: "interaction.accent.01",
          borderWidth: "hairline",
          color: "typeface.inverse.strong"
        };

      case "secondary":
        return {
          "&:active:enabled": __spreadValues$S({
            bg: "interaction.subtle.02",
            borderColor: "interaction.accent.03",
            color: "interaction.accent.03"
          }, activeInteractionBaseStyle),
          "&:disabled": __spreadProps$A(__spreadValues$S({}, disabledBaseStyle), {
            borderColor: "interaction.blend.04",
            borderStyle: "solid",
            color: "typeface.meld"
          }),
          "&:focus:enabled:not(:active)": {
            bg: "interaction.subtle.01",
            borderColor: "interaction.accent.02",
            borderWidth: "thin",
            boxShadow: "inset 0 0 0 2px ".concat(defaultTheme$3.colors.neutral["00"]),
            color: "interaction.accent.02"
          },
          "&:hover:enabled:not(:active)": {
            bg: "interaction.subtle.01",
            borderColor: "interaction.accent.02",
            color: "interaction.accent.02"
          },
          borderColor: "interaction.accent.01",
          borderStyle: "solid",
          borderWidth: "hairline",
          color: "interaction.accent.01"
        };

      case "tertiary":
        return {
          "&:active:enabled": __spreadValues$S({
            bg: "interaction.subtle.02",
            color: "interaction.accent.03"
          }, activeInteractionBaseStyle),
          "&:disabled": __spreadProps$A(__spreadValues$S({}, disabledBaseStyle), {
            color: "typeface.meld"
          }),
          "&:focus:enabled:not(:active)": {
            bg: "interaction.subtle.01",
            borderColor: "interaction.accent.02",
            borderWidth: "thin",
            boxShadow: "inset 0 0 0 2px ".concat(defaultTheme$3.colors.neutral["00"])
          },
          "&:hover:enabled:not(:active)": {
            bg: "interaction.subtle.01",
            color: "interaction.accent.02"
          },
          borderWidth: "hairline",
          color: "interaction.accent.01"
        };

      default:
        return {};
    }
  };

  var getBrandButtonTheme = function getBrandButtonTheme(_ref15) {
    var brand = _ref15.brand,
        variant = _ref15.variant;

    if (!brand) {
      return {};
    }

    switch (variant) {
      case "primary":
        return {
          "&:active": __spreadValues$S({
            bg: "interaction.on.brand.accent.03",
            borderColor: "transparent",
            color: "interaction.accent.03"
          }, activeInteractionBaseStyle),
          "&:disabled": __spreadProps$A(__spreadValues$S({}, disabledBaseStyle), {
            bg: "interaction.on.brand.blend.02",
            color: "typeface.on.brand.meld"
          }),
          "&:focus:not(:active)": {
            bg: "interaction.on.brand.accent.02",
            borderColor: "interaction.on.brand.accent.02",
            borderWidth: "thin",
            boxShadow: "inset 0 0 0 2px ".concat(defaultTheme$3.colors.interaction.accent["02"]),
            color: "interaction.accent.02",
            outline: "none"
          },
          "&:hover:enabled:not(:active)": {
            bg: "interaction.on.brand.accent.02",
            color: "interaction.accent.02"
          },
          bg: "interaction.on.brand.accent.01",
          borderWidth: "hairline",
          color: "interaction.accent.01"
        };

      case "secondary":
      case "tertiary":
        return {
          "&:active": __spreadValues$S({
            bg: "interaction.on.brand.subtle.02"
          }, activeInteractionBaseStyle),
          "&:disabled": __spreadProps$A(__spreadValues$S({}, disabledBaseStyle), {
            borderColor: "interaction.on.brand.blend.04",
            borderStyle: "solid",
            color: "typeface.on.brand.meld"
          }),
          "&:focus:not(:active)": {
            bg: "interaction.on.brand.subtle.01",
            borderWidth: "thin",
            boxShadow: "inset 0 0 0 2px ".concat(defaultTheme$3.colors.interaction.inverse.on.brand.blend["04"]),
            outline: "none"
          },
          "&:hover:not(:active)": {
            bg: "interaction.on.brand.subtle.01"
          },
          borderColor: "interaction.on.brand.accent.01",
          borderWidth: "hairline",
          color: "interaction.on.brand.accent.01"
        };

      default:
        return {};
    }
  };

  var getButtonStyle = function getButtonStyle(_a) {
    var _b = _a,
        _b$size3 = _b.size,
        size = _b$size3 === void 0 ? "lg" : _b$size3,
        width = _b.width,
        props = __objRest$E(_b, ["size", "width"]);

    return __spreadValues$S(__spreadValues$S(__spreadValues$S(__spreadValues$S({}, buttonShapeStyleSize[size]), getButtonBaseStyle(__spreadValues$S({
      width: width
    }, props))), getButtonsVariantsStyle(props)), getBrandButtonTheme(props));
  };

  var getIsSmallSize = function getIsSmallSize(_ref16) {
    var size = _ref16.size;
    return size === "sm";
  };

  var getIconSize = function getIconSize(_ref17) {
    var size = _ref17.size;
    return getIsSmallSize({
      size: size
    }) ? 16 : 20;
  };

  var getIconSpacing = function getIconSpacing(_ref18) {
    var size = _ref18.size;
    return size && getIsSmallSize({
      size: size
    }) ? "inline.quark" : "inline.nano";
  };

  var getSpinnerStrokeSize = function getSpinnerStrokeSize(_ref19) {
    var size = _ref19.size;
    return size && getIsSmallSize({
      size: size
    }) ? 2 : 3;
  };

  var __defProp$R = Object.defineProperty;
  var __defProps$z = Object.defineProperties;
  var __getOwnPropDescs$z = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$R = Object.getOwnPropertySymbols;
  var __hasOwnProp$R = Object.prototype.hasOwnProperty;
  var __propIsEnum$R = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$R = function __defNormalProp$R(obj, key, value) {
    return key in obj ? __defProp$R(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$R = function __spreadValues$R(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$R.call(b, prop)) __defNormalProp$R(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$R) {
      var _iterator20 = _createForOfIteratorHelper(__getOwnPropSymbols$R(b)),
          _step20;

      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var prop = _step20.value;
          if (__propIsEnum$R.call(b, prop)) __defNormalProp$R(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }
    }

    return a;
  };

  var __spreadProps$z = function __spreadProps$z(a, b) {
    return __defProps$z(a, __getOwnPropDescs$z(b));
  };

  var __objRest$D = function __objRest$D(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$R.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$R) {
      var _iterator21 = _createForOfIteratorHelper(__getOwnPropSymbols$R(source)),
          _step21;

      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var prop = _step21.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$R.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
    }

    return target;
  };

  var Button = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        _b$variant2 = _b.variant,
        variant = _b$variant2 === void 0 ? "primary" : _b$variant2,
        _b$brand = _b.brand,
        brand = _b$brand === void 0 ? false : _b$brand,
        _b$disabled = _b.disabled,
        disabled = _b$disabled === void 0 ? false : _b$disabled,
        _b$size4 = _b.size,
        size = _b$size4 === void 0 ? "lg" : _b$size4,
        sx = _b.sx,
        iconOnly = _b.iconOnly,
        children = _b.children,
        isLoading = _b.isLoading,
        props = __objRest$D(_b, ["variant", "brand", "disabled", "size", "sx", "iconOnly", "children", "isLoading"]);

    var buttonSimilarProps = __spreadProps$z(__spreadValues$R({}, props), {
      brand: brand,
      disabled: disabled,
      isLoading: isLoading,
      size: size,
      variant: variant
    });

    var leadingIcon = props.leadingIcon,
        trailingIcon = props.trailingIcon;

    var renderLeadingIcon = function renderLeadingIcon() {
      return /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, leadingIcon && /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */React__default["default"].createElement(Icon, null, leadingIcon), /* @__PURE__ */React__default["default"].createElement(Box, {
        mr: iconOnly ? 0 : getIconSpacing({
          size: size
        })
      })));
    };

    var renderLoading = function renderLoading() {
      return /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, isLoading ? /* @__PURE__ */React__default["default"].createElement(Spinner, {
        ml: iconOnly ? 0 : getIconSpacing({
          size: size
        }),
        size: getIconSize({
          size: size
        }),
        strokeWidth: getSpinnerStrokeSize({
          size: size
        })
      }) : "");
    };

    var renderButtonContent = function renderButtonContent() {
      if (iconOnly) {
        return /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, !isLoading && renderLeadingIcon(), renderLoading());
      }

      return /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, renderLeadingIcon(), !iconOnly && /* @__PURE__ */React__default["default"].createElement(Action, {
        color: "inherit",
        sx: {
          pointerEvents: "none"
        },
        variant: size
      }, children), !isLoading && trailingIcon && /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */React__default["default"].createElement(Box, {
        ml: getIconSpacing({
          size: size
        })
      }), trailingIcon), renderLoading());
    };

    return /* @__PURE__ */React__default["default"].createElement(themeUi.Button, __spreadProps$z(__spreadValues$R({
      "aria-disabled": disabled,
      "data-loading": isLoading,
      sx: __spreadValues$R(__spreadValues$R({}, getButtonStyle(buttonSimilarProps)), sx),
      tabIndex: 0
    }, buttonSimilarProps), {
      disabled: disabled,
      ref: ref
    }), renderButtonContent());
  });

  var getIconOnlyStyle = function getIconOnlyStyle(floating, size, brand, disabled, color) {
    var iconSize;

    switch (size) {
      case "lg":
        iconSize = 48;
        break;

      case "sm":
        iconSize = floating ? 48 : 32;
        break;

      default:
        iconSize = 48;
        break;
    }

    var iconColor = function iconColor() {
      if (color) {
        return color;
      } else if (floating) {
        if (disabled) {
          return brand ? "typeface.on.brand.meld" : "typeface.meld";
        }

        return brand ? "interaction.accent.01" : "interaction.on.brand.08";
      }

      return brand ? "interaction.on.brand.blend.07" : "interaction.blend.07";
    };

    var fillColor = function fillColor() {
      if (color) {
        return color;
      } else if (floating) {
        if (disabled) {
          return brand ? "typeface.on.brand.meld" : "typeface.meld";
        }

        return brand ? "interaction.accent.01" : "interaction.on.brand.08";
      }

      return brand ? "interaction.on.brand.blend.08" : "interaction.blend.08";
    };

    var backgroundColor = function backgroundColor() {
      if (floating) {
        if (disabled) {
          return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
        }

        return brand ? "interaction.on.brand.blend.08" : "interaction.accent.01";
      }

      return "transparent";
    };

    var hoverBackgroundColor = function hoverBackgroundColor() {
      if (floating) {
        return brand ? "interaction.inverse.accent.03" : "interaction.accent.02";
      }

      return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
    };

    var focusBackgroundColor = function focusBackgroundColor() {
      if (floating) {
        return brand ? "interaction.inverse.accent.03" : "interaction.accent.02";
      }

      return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
    };

    var focusBorderColor = function focusBorderColor() {
      if (floating) {
        return brand ? "interaction.inverse.accent.03" : "interaction.accent.02";
      }

      return brand ? "interaction.on.brand.blend.08" : "interaction.blend.08";
    };

    var focusBoxshadowColor = function focusBoxshadowColor() {
      if (floating) {
        return brand ? defaultTheme$3.colors.interaction.accent["02"] : defaultTheme$3.colors.neutral["00"];
      }

      return brand ? defaultTheme$3.colors.interaction.inverse.on.brand.blend["04"] : defaultTheme$3.colors.neutral["00"];
    };

    var activeBackgroundColor = function activeBackgroundColor() {
      if (floating) {
        return brand ? "interaction.inverse.accent.01" : "interaction.accent.03";
      }

      return brand ? "interaction.on.brand.blend.03" : "interaction.blend.03";
    };

    return {
      "& span > svg > path": {
        fill: iconColor()
      },
      "&:active:enabled": {
        "& span > svg > path": {
          fill: fillColor()
        },
        backgroundColor: activeBackgroundColor()
      },
      "&:disabled": {
        "& span > svg": {
          cursor: "not-allowed",
          fill: brand ? "interaction.on.brand.blend.05" : "interaction.blend.05"
        },
        "& span > svg > path": {
          cursor: "not-allowed",
          fill: brand ? "interaction.on.brand.blend.05" : "interaction.blend.05"
        },
        cursor: "not-allowed"
      },
      "&:disabled:enabled": {
        "& span > svg > path": {
          fill: brand ? "interaction.on.brand.blend.05" : "interaction.blend.05"
        },
        cursor: "not-allowed"
      },
      "&:focus:enabled:not(:active)": {
        "& span > svg > path": {
          fill: fillColor()
        },
        backgroundColor: focusBackgroundColor(),
        borderColor: focusBorderColor(),
        borderStyle: "solid",
        borderWidth: "thin",
        boxShadow: "inset 0 0 0 2px ".concat(focusBoxshadowColor())
      },
      "&:hover:enabled:not(:active)": {
        "& span > svg > path": {
          fill: fillColor()
        },
        backgroundColor: hoverBackgroundColor()
      },
      alignItems: "center",
      backgroundColor: backgroundColor(),
      borderColor: "transparent",
      borderRadius: floating ? "circle" : "xs",
      borderStyle: "solid",
      borderWidth: "thin",
      boxShadow: floating ? defaultTheme$3.shadows["03"] : void 0,
      color: iconColor(),
      cursor: disabled ? "not-allowed" : "pointer",
      display: "flex",
      height: iconSize,
      justifyContent: "center",
      minWidth: "min-content",
      px: 0,
      transition: "all 0.1s",
      width: iconSize
    };
  };

  var __defProp$Q = Object.defineProperty;
  var __getOwnPropSymbols$Q = Object.getOwnPropertySymbols;
  var __hasOwnProp$Q = Object.prototype.hasOwnProperty;
  var __propIsEnum$Q = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$Q = function __defNormalProp$Q(obj, key, value) {
    return key in obj ? __defProp$Q(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$Q = function __spreadValues$Q(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$Q.call(b, prop)) __defNormalProp$Q(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$Q) {
      var _iterator22 = _createForOfIteratorHelper(__getOwnPropSymbols$Q(b)),
          _step22;

      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var prop = _step22.value;
          if (__propIsEnum$Q.call(b, prop)) __defNormalProp$Q(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }
    }

    return a;
  };

  var __objRest$C = function __objRest$C(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$Q.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$Q) {
      var _iterator23 = _createForOfIteratorHelper(__getOwnPropSymbols$Q(source)),
          _step23;

      try {
        for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
          var prop = _step23.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$Q.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator23.e(err);
      } finally {
        _iterator23.f();
      }
    }

    return target;
  };

  var ButtonIcon = function ButtonIcon(_a) {
    var _b = _a,
        brand = _b.brand,
        floating = _b.floating,
        _b$size5 = _b.size,
        size = _b$size5 === void 0 ? "lg" : _b$size5,
        sx = _b.sx,
        disabled = _b.disabled,
        props = __objRest$C(_b, ["brand", "floating", "size", "sx", "disabled"]);

    return /* @__PURE__ */React__default["default"].createElement(Button, __spreadValues$Q({
      disabled: disabled,
      iconOnly: true,
      sx: __spreadValues$Q(__spreadValues$Q({}, getIconOnlyStyle(floating, size, brand, disabled, props.color)), sx),
      tabIndex: 0
    }, props));
  };

  var __defProp$P = Object.defineProperty;
  var __getOwnPropSymbols$P = Object.getOwnPropertySymbols;
  var __hasOwnProp$P = Object.prototype.hasOwnProperty;
  var __propIsEnum$P = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$P = function __defNormalProp$P(obj, key, value) {
    return key in obj ? __defProp$P(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$P = function __spreadValues$P(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$P.call(b, prop)) __defNormalProp$P(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$P) {
      var _iterator24 = _createForOfIteratorHelper(__getOwnPropSymbols$P(b)),
          _step24;

      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var prop = _step24.value;
          if (__propIsEnum$P.call(b, prop)) __defNormalProp$P(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
    }

    return a;
  };

  var ButtonFloating = function ButtonFloating(props) {
    return /* @__PURE__ */React__default["default"].createElement(ButtonIcon, __spreadValues$P({
      floating: true
    }, props));
  };

  var __defProp$O = Object.defineProperty;
  var __defProps$y = Object.defineProperties;
  var __getOwnPropDescs$y = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$O = Object.getOwnPropertySymbols;
  var __hasOwnProp$O = Object.prototype.hasOwnProperty;
  var __propIsEnum$O = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$O = function __defNormalProp$O(obj, key, value) {
    return key in obj ? __defProp$O(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$O = function __spreadValues$O(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$O.call(b, prop)) __defNormalProp$O(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$O) {
      var _iterator25 = _createForOfIteratorHelper(__getOwnPropSymbols$O(b)),
          _step25;

      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var prop = _step25.value;
          if (__propIsEnum$O.call(b, prop)) __defNormalProp$O(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }
    }

    return a;
  };

  var __spreadProps$y = function __spreadProps$y(a, b) {
    return __defProps$y(a, __getOwnPropDescs$y(b));
  };

  var baseStyle = {
    alignItems: "center",
    display: "flex",
    justifyContent: "center"
  };
  var axisStyle = {
    both: __spreadProps$y(__spreadValues$O({}, baseStyle), {
      insetStart: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)"
    }),
    default: __spreadValues$O({}, baseStyle),
    horizontal: __spreadProps$y(__spreadValues$O({}, baseStyle), {
      insetStart: "50%",
      transform: "translateX(-50%)"
    }),
    vertical: __spreadProps$y(__spreadValues$O({}, baseStyle), {
      top: "50%",
      transform: "translateY(-50%)"
    })
  };
  var __defProp$N = Object.defineProperty;
  var __defProps$x = Object.defineProperties;
  var __getOwnPropDescs$x = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$N = Object.getOwnPropertySymbols;
  var __hasOwnProp$N = Object.prototype.hasOwnProperty;
  var __propIsEnum$N = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$N = function __defNormalProp$N(obj, key, value) {
    return key in obj ? __defProp$N(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$N = function __spreadValues$N(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$N.call(b, prop)) __defNormalProp$N(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$N) {
      var _iterator26 = _createForOfIteratorHelper(__getOwnPropSymbols$N(b)),
          _step26;

      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var prop = _step26.value;
          if (__propIsEnum$N.call(b, prop)) __defNormalProp$N(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
    }

    return a;
  };

  var __spreadProps$x = function __spreadProps$x(a, b) {
    return __defProps$x(a, __getOwnPropDescs$x(b));
  };

  var __objRest$B = function __objRest$B(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$N.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$N) {
      var _iterator27 = _createForOfIteratorHelper(__getOwnPropSymbols$N(source)),
          _step27;

      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var prop = _step27.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$N.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }
    }

    return target;
  };

  var Center = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        _b$axis = _b.axis,
        axis = _b$axis === void 0 ? "default" : _b$axis,
        sx = _b.sx,
        props = __objRest$B(_b, ["axis", "sx"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$x(__spreadValues$N({
      sx: __spreadValues$N(__spreadValues$N({}, axisStyle[axis]), sx)
    }, props), {
      ref: ref
    }));
  });

  var getCheckBoxStyle = function getCheckBoxStyle(brand, disabled, hover, focus, active) {
    var getSpanBackgroundColor = function getSpanBackgroundColor() {
      if (active) {
        return brand ? "interaction.on.brand.blend.03" : "interaction.blend.03";
      } else if (hover || focus) {
        return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
      }

      return "transparent";
    };

    var getSpanBorderColor = function getSpanBorderColor() {
      if (focus) {
        return brand ? "interaction.on.brand.blend.05" : "interaction.blend.05";
      }

      return "transparent";
    };

    var getInputColor = function getInputColor() {
      if (disabled) {
        return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
      }

      return brand ? "interaction.on.brand.select.focus" : "interaction.select.focus";
    };

    var getCheckedInputColor = function getCheckedInputColor() {
      if (disabled) {
        return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
      }

      return brand ? "interaction.on.brand.select.active" : "interaction.select.active";
    };

    return {
      alignItems: "center",
      input: {
        ":checked": {
          "~ svg": {
            color: getCheckedInputColor()
          }
        },
        ":not(:checked)": {
          "~ svg": {
            color: getInputColor()
          }
        },
        "~ svg": {
          backgroundColor: "transparent !important",
          color: getInputColor(),
          position: "relative",
          zIndex: 10
        }
      },
      span: {
        bg: getSpanBackgroundColor(),
        borderColor: getSpanBorderColor(),
        borderRadius: "circle",
        borderStyle: "solid",
        borderWidth: "thin",
        boxSizing: "border-box",
        display: "block",
        height: "40px",
        position: "absolute",
        transform: "translateX(-8px)",
        width: "40px",
        zIndex: 1
      }
    };
  };

  var __defProp$M = Object.defineProperty;
  var __defProps$w = Object.defineProperties;
  var __getOwnPropDescs$w = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$M = Object.getOwnPropertySymbols;
  var __hasOwnProp$M = Object.prototype.hasOwnProperty;
  var __propIsEnum$M = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$M = function __defNormalProp$M(obj, key, value) {
    return key in obj ? __defProp$M(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$M = function __spreadValues$M(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$M.call(b, prop)) __defNormalProp$M(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$M) {
      var _iterator28 = _createForOfIteratorHelper(__getOwnPropSymbols$M(b)),
          _step28;

      try {
        for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
          var prop = _step28.value;
          if (__propIsEnum$M.call(b, prop)) __defNormalProp$M(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator28.e(err);
      } finally {
        _iterator28.f();
      }
    }

    return a;
  };

  var __spreadProps$w = function __spreadProps$w(a, b) {
    return __defProps$w(a, __getOwnPropDescs$w(b));
  };

  var __objRest$A = function __objRest$A(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$M.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$M) {
      var _iterator29 = _createForOfIteratorHelper(__getOwnPropSymbols$M(source)),
          _step29;

      try {
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
          var prop = _step29.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$M.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }
    }

    return target;
  };

  var CheckBox = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        label = _b.label,
        brand = _b.brand,
        sx = _b.sx,
        props = __objRest$A(_b, ["label", "brand", "sx"]);

    var _React$useState3 = React.useState(false),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        hover = _React$useState4[0],
        setHover = _React$useState4[1];

    var _React$useState5 = React.useState(false),
        _React$useState6 = _slicedToArray(_React$useState5, 2),
        focus = _React$useState6[0],
        setFocus = _React$useState6[1];

    var _React$useState7 = React.useState(false),
        _React$useState8 = _slicedToArray(_React$useState7, 2),
        active = _React$useState8[0],
        setActive = _React$useState8[1];

    var getLabelColor = function getLabelColor() {
      if (props.disabled) {
        return brand ? "typeface.on.brand.meld" : "typeface.meld";
      }

      return brand ? "typeface.on.brand.pure" : "typeface.pure";
    };

    return /* @__PURE__ */React__default["default"].createElement(themeUi.Label, {
      onBlur: function onBlur() {
        return setFocus(false);
      },
      onFocus: function onFocus() {
        return !props.disabled && setFocus(true);
      },
      onMouseDown: function onMouseDown() {
        return !props.disabled && setActive(true);
      },
      onMouseEnter: function onMouseEnter() {
        return !props.disabled && setHover(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setHover(false);
      },
      onMouseUp: function onMouseUp(evt) {
        evt.currentTarget.blur();
        setActive(false);
      },
      sx: __spreadValues$M(__spreadValues$M({}, getCheckBoxStyle(brand, props.disabled, hover, focus, active)), sx)
    }, /* @__PURE__ */React__default["default"].createElement(Box, {
      as: "span"
    }), /* @__PURE__ */React__default["default"].createElement(themeUi.Checkbox, __spreadProps$w(__spreadValues$M({}, props), {
      ref: ref
    })), label && /* @__PURE__ */React__default["default"].createElement(Body, {
      brand: brand,
      color: getLabelColor(),
      ml: "inline.nano",
      variant: "lg"
    }, label));
  });
  var __defProp$L = Object.defineProperty;
  var __getOwnPropSymbols$L = Object.getOwnPropertySymbols;
  var __hasOwnProp$L = Object.prototype.hasOwnProperty;
  var __propIsEnum$L = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$L = function __defNormalProp$L(obj, key, value) {
    return key in obj ? __defProp$L(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$L = function __spreadValues$L(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$L.call(b, prop)) __defNormalProp$L(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$L) {
      var _iterator30 = _createForOfIteratorHelper(__getOwnPropSymbols$L(b)),
          _step30;

      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          var prop = _step30.value;
          if (__propIsEnum$L.call(b, prop)) __defNormalProp$L(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }
    }

    return a;
  };

  var getDividerStyle = function getDividerStyle(brand, variant) {
    var customStyle = {};

    if (variant === "horizontal") {
      customStyle["width"] = "100%";
      customStyle["height"] = 1;
    } else {
      customStyle["width"] = 1;
      customStyle["height"] = "100%";
    }

    return __spreadValues$L({
      backgroundColor: brand ? "neutral.on.brand.30" : "neutral.30",
      border: "none",
      margin: 0,
      position: "relative"
    }, customStyle);
  };

  var __defProp$K = Object.defineProperty;
  var __defProps$v = Object.defineProperties;
  var __getOwnPropDescs$v = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$K = Object.getOwnPropertySymbols;
  var __hasOwnProp$K = Object.prototype.hasOwnProperty;
  var __propIsEnum$K = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$K = function __defNormalProp$K(obj, key, value) {
    return key in obj ? __defProp$K(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$K = function __spreadValues$K(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$K.call(b, prop)) __defNormalProp$K(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$K) {
      var _iterator31 = _createForOfIteratorHelper(__getOwnPropSymbols$K(b)),
          _step31;

      try {
        for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
          var prop = _step31.value;
          if (__propIsEnum$K.call(b, prop)) __defNormalProp$K(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator31.e(err);
      } finally {
        _iterator31.f();
      }
    }

    return a;
  };

  var __spreadProps$v = function __spreadProps$v(a, b) {
    return __defProps$v(a, __getOwnPropDescs$v(b));
  };

  var __objRest$z = function __objRest$z(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$K.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$K) {
      var _iterator32 = _createForOfIteratorHelper(__getOwnPropSymbols$K(source)),
          _step32;

      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var prop = _step32.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$K.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }
    }

    return target;
  };

  var Divider = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        sx = _b.sx,
        _b$variant3 = _b.variant,
        variant = _b$variant3 === void 0 ? "horizontal" : _b$variant3,
        props = __objRest$z(_b, ["brand", "sx", "variant"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$v(__spreadValues$K({
      sx: __spreadValues$K(__spreadValues$K({}, getDividerStyle(brand, variant)), sx)
    }, props), {
      ref: ref
    }));
  });
  var __defProp$J = Object.defineProperty;
  var __getOwnPropSymbols$J = Object.getOwnPropertySymbols;
  var __hasOwnProp$J = Object.prototype.hasOwnProperty;
  var __propIsEnum$J = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$J = function __defNormalProp$J(obj, key, value) {
    return key in obj ? __defProp$J(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$J = function __spreadValues$J(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$J.call(b, prop)) __defNormalProp$J(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$J) {
      var _iterator33 = _createForOfIteratorHelper(__getOwnPropSymbols$J(b)),
          _step33;

      try {
        for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
          var prop = _step33.value;
          if (__propIsEnum$J.call(b, prop)) __defNormalProp$J(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator33.e(err);
      } finally {
        _iterator33.f();
      }
    }

    return a;
  };

  var Spacer = function Spacer(props) {
    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadValues$J({
      mx: "auto",
      p: 0
    }, props));
  };

  function _isPlaceholder(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
  }
  /**
   * Optimized internal one-arity curry function.
   *
   * @private
   * @category Function
   * @param {Function} fn The function to curry.
   * @return {Function} The curried function.
   */


  function _curry1(fn) {
    return function f1(a) {
      if (arguments.length === 0 || _isPlaceholder(a)) {
        return f1;
      } else {
        return fn.apply(this, arguments);
      }
    };
  }
  /**
   * Optimized internal two-arity curry function.
   *
   * @private
   * @category Function
   * @param {Function} fn The function to curry.
   * @return {Function} The curried function.
   */


  function _curry2(fn) {
    return function f2(a, b) {
      switch (arguments.length) {
        case 0:
          return f2;

        case 1:
          return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
            return fn(a, _b);
          });

        default:
          return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
            return fn(_a, b);
          }) : _isPlaceholder(b) ? _curry1(function (_b) {
            return fn(a, _b);
          }) : fn(a, b);
      }
    };
  }

  function _arity(n, fn) {
    /* eslint-disable no-unused-vars */
    switch (n) {
      case 0:
        return function () {
          return fn.apply(this, arguments);
        };

      case 1:
        return function (a0) {
          return fn.apply(this, arguments);
        };

      case 2:
        return function (a0, a1) {
          return fn.apply(this, arguments);
        };

      case 3:
        return function (a0, a1, a2) {
          return fn.apply(this, arguments);
        };

      case 4:
        return function (a0, a1, a2, a3) {
          return fn.apply(this, arguments);
        };

      case 5:
        return function (a0, a1, a2, a3, a4) {
          return fn.apply(this, arguments);
        };

      case 6:
        return function (a0, a1, a2, a3, a4, a5) {
          return fn.apply(this, arguments);
        };

      case 7:
        return function (a0, a1, a2, a3, a4, a5, a6) {
          return fn.apply(this, arguments);
        };

      case 8:
        return function (a0, a1, a2, a3, a4, a5, a6, a7) {
          return fn.apply(this, arguments);
        };

      case 9:
        return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
          return fn.apply(this, arguments);
        };

      case 10:
        return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
          return fn.apply(this, arguments);
        };

      default:
        throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
  }
  /**
   * Optimized internal three-arity curry function.
   *
   * @private
   * @category Function
   * @param {Function} fn The function to curry.
   * @return {Function} The curried function.
   */


  function _curry3(fn) {
    return function f3(a, b, c) {
      switch (arguments.length) {
        case 0:
          return f3;

        case 1:
          return _isPlaceholder(a) ? f3 : _curry2(function (_b, _c) {
            return fn(a, _b, _c);
          });

        case 2:
          return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function (_a, _c) {
            return fn(_a, b, _c);
          }) : _isPlaceholder(b) ? _curry2(function (_b, _c) {
            return fn(a, _b, _c);
          }) : _curry1(function (_c) {
            return fn(a, b, _c);
          });

        default:
          return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function (_a, _b) {
            return fn(_a, _b, c);
          }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function (_a, _c) {
            return fn(_a, b, _c);
          }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function (_b, _c) {
            return fn(a, _b, _c);
          }) : _isPlaceholder(a) ? _curry1(function (_a) {
            return fn(_a, b, c);
          }) : _isPlaceholder(b) ? _curry1(function (_b) {
            return fn(a, _b, c);
          }) : _isPlaceholder(c) ? _curry1(function (_c) {
            return fn(a, b, _c);
          }) : fn(a, b, c);
      }
    };
  }
  /**
   * Tests whether or not an object is an array.
   *
   * @private
   * @param {*} val The object to test.
   * @return {Boolean} `true` if `val` is an array, `false` otherwise.
   * @example
   *
   *      _isArray([]); //=> true
   *      _isArray(null); //=> false
   *      _isArray({}); //=> false
   */


  var _isArray = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
  };

  function _isString(x) {
    return Object.prototype.toString.call(x) === '[object String]';
  }
  /**
   * Tests whether or not an object is similar to an array.
   *
   * @private
   * @category Type
   * @category List
   * @sig * -> Boolean
   * @param {*} x The object to test.
   * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
   * @example
   *
   *      _isArrayLike([]); //=> true
   *      _isArrayLike(true); //=> false
   *      _isArrayLike({}); //=> false
   *      _isArrayLike({length: 10}); //=> false
   *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
   */


  var _isArrayLike = /*#__PURE__*/_curry1(function isArrayLike(x) {
    if (_isArray(x)) {
      return true;
    }

    if (!x) {
      return false;
    }

    if (typeof x !== 'object') {
      return false;
    }

    if (_isString(x)) {
      return false;
    }

    if (x.nodeType === 1) {
      return !!x.length;
    }

    if (x.length === 0) {
      return true;
    }

    if (x.length > 0) {
      return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    }

    return false;
  });

  var _isArrayLike$1 = _isArrayLike;

  var XWrap = /*#__PURE__*/function () {
    function XWrap(fn) {
      this.f = fn;
    }

    XWrap.prototype['@@transducer/init'] = function () {
      throw new Error('init not implemented on XWrap');
    };

    XWrap.prototype['@@transducer/result'] = function (acc) {
      return acc;
    };

    XWrap.prototype['@@transducer/step'] = function (acc, x) {
      return this.f(acc, x);
    };

    return XWrap;
  }();

  function _xwrap(fn) {
    return new XWrap(fn);
  }
  /**
   * Creates a function that is bound to a context.
   * Note: `R.bind` does not provide the additional argument-binding capabilities of
   * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
   *
   * @func
   * @memberOf R
   * @since v0.6.0
   * @category Function
   * @category Object
   * @sig (* -> *) -> {*} -> (* -> *)
   * @param {Function} fn The function to bind to context
   * @param {Object} thisObj The context to bind `fn` to
   * @return {Function} A function that will execute in the context of `thisObj`.
   * @see R.partial
   * @example
   *
   *      const log = R.bind(console.log, console);
   *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
   *      // logs {a: 2}
   * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
   */


  var bind = /*#__PURE__*/_curry2(function bind(fn, thisObj) {
    return _arity(fn.length, function () {
      return fn.apply(thisObj, arguments);
    });
  });

  var bind$1 = bind;

  function _arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;

    while (idx < len) {
      acc = xf['@@transducer/step'](acc, list[idx]);

      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }

      idx += 1;
    }

    return xf['@@transducer/result'](acc);
  }

  function _iterableReduce(xf, acc, iter) {
    var step = iter.next();

    while (!step.done) {
      acc = xf['@@transducer/step'](acc, step.value);

      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }

      step = iter.next();
    }

    return xf['@@transducer/result'](acc);
  }

  function _methodReduce(xf, acc, obj, methodName) {
    return xf['@@transducer/result'](obj[methodName](bind$1(xf['@@transducer/step'], xf), acc));
  }

  var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';

  function _reduce(fn, acc, list) {
    if (typeof fn === 'function') {
      fn = _xwrap(fn);
    }

    if (_isArrayLike$1(list)) {
      return _arrayReduce(fn, acc, list);
    }

    if (typeof list['fantasy-land/reduce'] === 'function') {
      return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
    }

    if (list[symIterator] != null) {
      return _iterableReduce(fn, acc, list[symIterator]());
    }

    if (typeof list.next === 'function') {
      return _iterableReduce(fn, acc, list);
    }

    if (typeof list.reduce === 'function') {
      return _methodReduce(fn, acc, list, 'reduce');
    }

    throw new TypeError('reduce: list must be array or iterable');
  }
  /**
   * Returns a single item by iterating through the list, successively calling
   * the iterator function and passing it an accumulator value and the current
   * value from the array, and then passing the result to the next call.
   *
   * The iterator function receives two values: *(acc, value)*. It may use
   * [`R.reduced`](#reduced) to shortcut the iteration.
   *
   * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
   * is *(value, acc)*.
   *
   * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
   * arrays), unlike the native `Array.prototype.reduce` method. For more details
   * on this behavior, see:
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
   *
   * Dispatches to the `reduce` method of the third argument, if present. When
   * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
   * shortcuting, as this is not implemented by `reduce`.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig ((a, b) -> a) -> a -> [b] -> a
   * @param {Function} fn The iterator function. Receives two values, the accumulator and the
   *        current element from the array.
   * @param {*} acc The accumulator value.
   * @param {Array} list The list to iterate over.
   * @return {*} The final, accumulated value.
   * @see R.reduced, R.addIndex, R.reduceRight
   * @example
   *
   *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
   *      //          -               -10
   *      //         / \              / \
   *      //        -   4           -6   4
   *      //       / \              / \
   *      //      -   3   ==>     -3   3
   *      //     / \              / \
   *      //    -   2           -1   2
   *      //   / \              / \
   *      //  0   1            0   1
   *
   * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
   */


  var reduce = /*#__PURE__*/_curry3(_reduce);

  var reduce$1 = reduce;

  function _pipe(f, g) {
    return function () {
      return g.call(this, f.apply(this, arguments));
    };
  }
  /**
   * This checks whether a function has a [methodname] function. If it isn't an
   * array it will execute that function otherwise it will default to the ramda
   * implementation.
   *
   * @private
   * @param {Function} fn ramda implemtation
   * @param {String} methodname property to check for a custom implementation
   * @return {Object} Whatever the return value of the method is.
   */


  function _checkForMethod(methodname, fn) {
    return function () {
      var length = arguments.length;

      if (length === 0) {
        return fn();
      }

      var obj = arguments[length - 1];
      return _isArray(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
  }
  /**
   * Returns the elements of the given list or string (or object with a `slice`
   * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
   *
   * Dispatches to the `slice` method of the third argument, if present.
   *
   * @func
   * @memberOf R
   * @since v0.1.4
   * @category List
   * @sig Number -> Number -> [a] -> [a]
   * @sig Number -> Number -> String -> String
   * @param {Number} fromIndex The start index (inclusive).
   * @param {Number} toIndex The end index (exclusive).
   * @param {*} list
   * @return {*}
   * @example
   *
   *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
   *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
   *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
   *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
   *      R.slice(0, 3, 'ramda');                     //=> 'ram'
   */


  var slice = /*#__PURE__*/_curry3( /*#__PURE__*/_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
  }));

  var slice$1 = slice;
  /**
   * Returns all but the first element of the given list or string (or object
   * with a `tail` method).
   *
   * Dispatches to the `slice` method of the first argument, if present.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig [a] -> [a]
   * @sig String -> String
   * @param {*} list
   * @return {*}
   * @see R.head, R.init, R.last
   * @example
   *
   *      R.tail([1, 2, 3]);  //=> [2, 3]
   *      R.tail([1, 2]);     //=> [2]
   *      R.tail([1]);        //=> []
   *      R.tail([]);         //=> []
   *
   *      R.tail('abc');  //=> 'bc'
   *      R.tail('ab');   //=> 'b'
   *      R.tail('a');    //=> ''
   *      R.tail('');     //=> ''
   */

  var tail = /*#__PURE__*/_curry1( /*#__PURE__*/_checkForMethod('tail', /*#__PURE__*/slice$1(1, Infinity)));

  var tail$1 = tail;
  /**
   * Performs left-to-right function composition. The first argument may have
   * any arity; the remaining arguments must be unary.
   *
   * In some libraries this function is named `sequence`.
   *
   * **Note:** The result of pipe is not automatically curried.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Function
   * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
   * @param {...Function} functions
   * @return {Function}
   * @see R.compose
   * @example
   *
   *      const f = R.pipe(Math.pow, R.negate, R.inc);
   *
   *      f(3, 4); // -(3^4) + 1
   * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
   */

  function pipe() {
    if (arguments.length === 0) {
      throw new Error('pipe requires at least one argument');
    }

    return _arity(arguments[0].length, reduce$1(_pipe, arguments[0], tail$1(arguments)));
  }

  var getIconColor$1 = function getIconColor$1(_ref20) {
    var variant = _ref20.variant,
        brand = _ref20.brand,
        disabled = _ref20.disabled;
    var blnd07 = "interaction.inverse.blend.07";

    if (disabled) {
      return brand ? blnd07 : "interaction.blend.06";
    }

    switch (variant) {
      case "invalid":
        return brand ? blnd07 : "feedback.error.shape";

      case "valid":
        return brand ? "interaction.inverse.blend.08" : "feedback.success.shape";

      default:
        return brand ? blnd07 : "neutral.inverse.10";
    }
  };

  var getTextColor = function getTextColor(_ref21) {
    var variant = _ref21.variant,
        brand = _ref21.brand,
        disabled = _ref21.disabled;

    if (brand) {
      return "interaction.inverse.blend.07";
    }

    if (disabled) {
      return "interaction.blend.06";
    }

    switch (variant) {
      case "invalid":
        return "feedback.error.text";

      case "valid":
        return "feedback.success.text";

      default:
        return "typeface.smooth";
    }
  };

  var __defProp$I = Object.defineProperty;
  var __getOwnPropSymbols$I = Object.getOwnPropertySymbols;
  var __hasOwnProp$I = Object.prototype.hasOwnProperty;
  var __propIsEnum$I = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$I = function __defNormalProp$I(obj, key, value) {
    return key in obj ? __defProp$I(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$I = function __spreadValues$I(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$I.call(b, prop)) __defNormalProp$I(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$I) {
      var _iterator34 = _createForOfIteratorHelper(__getOwnPropSymbols$I(b)),
          _step34;

      try {
        for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
          var prop = _step34.value;
          if (__propIsEnum$I.call(b, prop)) __defNormalProp$I(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator34.e(err);
      } finally {
        _iterator34.f();
      }
    }

    return a;
  };

  var __objRest$y = function __objRest$y(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$I.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$I) {
      var _iterator35 = _createForOfIteratorHelper(__getOwnPropSymbols$I(source)),
          _step35;

      try {
        for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
          var prop = _step35.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$I.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator35.e(err);
      } finally {
        _iterator35.f();
      }
    }

    return target;
  };

  var Caption = React__default["default"].forwardRef(function (_a, ref) {
    var props = __objRest$y(_a, []);

    return /* @__PURE__ */React__default["default"].createElement(Typography, __spreadValues$I({
      color: getColorTypfaceTokenByProp(props, "pure"),
      fontFamily: "base",
      fontSize: "xxxs",
      letterSpacing: "standard",
      lineHeight: "distant",
      ref: ref
    }, props));
  });

  var getFlexStyle = function getFlexStyle(_ref22) {
    var fullWidth = _ref22.fullWidth,
        width = _ref22.width,
        align = _ref22.align,
        basis = _ref22.basis,
        direction = _ref22.direction,
        grow = _ref22.grow,
        justify = _ref22.justify,
        shrink = _ref22.shrink,
        wrap = _ref22.wrap;
    return {
      alignItems: align,
      display: "flex",
      flexBasis: basis,
      flexDirection: direction,
      flexGrow: grow,
      flexShrink: shrink,
      flexWrap: wrap,
      justifyContent: justify,
      width: fullWidth ? "100%" : width
    };
  };

  var __defProp$H = Object.defineProperty;
  var __defProps$u = Object.defineProperties;
  var __getOwnPropDescs$u = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$H = Object.getOwnPropertySymbols;
  var __hasOwnProp$H = Object.prototype.hasOwnProperty;
  var __propIsEnum$H = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$H = function __defNormalProp$H(obj, key, value) {
    return key in obj ? __defProp$H(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$H = function __spreadValues$H(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$H.call(b, prop)) __defNormalProp$H(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$H) {
      var _iterator36 = _createForOfIteratorHelper(__getOwnPropSymbols$H(b)),
          _step36;

      try {
        for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
          var prop = _step36.value;
          if (__propIsEnum$H.call(b, prop)) __defNormalProp$H(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator36.e(err);
      } finally {
        _iterator36.f();
      }
    }

    return a;
  };

  var __spreadProps$u = function __spreadProps$u(a, b) {
    return __defProps$u(a, __getOwnPropDescs$u(b));
  };

  var __objRest$x = function __objRest$x(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$H.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$H) {
      var _iterator37 = _createForOfIteratorHelper(__getOwnPropSymbols$H(source)),
          _step37;

      try {
        for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
          var prop = _step37.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$H.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator37.e(err);
      } finally {
        _iterator37.f();
      }
    }

    return target;
  };

  var Flex = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        sx = _b.sx,
        props = __objRest$x(_b, ["sx"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$u(__spreadValues$H({
      display: "flex",
      flex: "none",
      sx: __spreadValues$H(__spreadValues$H({}, getFlexStyle(props)), sx)
    }, props), {
      ref: ref
    }));
  });
  var __defProp$G = Object.defineProperty;
  var __defProps$t = Object.defineProperties;
  var __getOwnPropDescs$t = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$G = Object.getOwnPropertySymbols;
  var __hasOwnProp$G = Object.prototype.hasOwnProperty;
  var __propIsEnum$G = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$G = function __defNormalProp$G(obj, key, value) {
    return key in obj ? __defProp$G(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$G = function __spreadValues$G(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$G.call(b, prop)) __defNormalProp$G(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$G) {
      var _iterator38 = _createForOfIteratorHelper(__getOwnPropSymbols$G(b)),
          _step38;

      try {
        for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
          var prop = _step38.value;
          if (__propIsEnum$G.call(b, prop)) __defNormalProp$G(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator38.e(err);
      } finally {
        _iterator38.f();
      }
    }

    return a;
  };

  var __spreadProps$t = function __spreadProps$t(a, b) {
    return __defProps$t(a, __getOwnPropDescs$t(b));
  };

  var renderIcon = function renderIcon(props) {
    var disabled = props.disabled,
        variant = props.variant,
        icon = props.icon;
    var iconToRender = null;

    if (disabled) {
      iconToRender = /* @__PURE__ */React__default["default"].createElement(almaIcons.LockBold, null);
    } else {
      switch (variant) {
        case "valid":
          iconToRender = /* @__PURE__ */React__default["default"].createElement(almaIcons.CheckroundBold, null);
          break;

        case "invalid":
          iconToRender = /* @__PURE__ */React__default["default"].createElement(almaIcons.WarningBold, null);
          break;

        case "custom":
          if (icon) {
            iconToRender = icon;
          }

          break;
      }
    }

    if (iconToRender) {
      return /* @__PURE__ */React__default["default"].createElement(Icon, {
        color: getIconColor$1(props),
        size: "sm"
      }, iconToRender);
    }

    return null;
  };

  var SupportMessage = function SupportMessage(props) {
    var value = props.value,
        brand = props.brand,
        disabled = props.disabled;
    return /* @__PURE__ */React__default["default"].createElement(Flex, __spreadProps$t(__spreadValues$G({
      "aria-disabled": disabled,
      minHeight: "1em",
      tabIndex: 0
    }, props), {
      alignItems: "center"
    }), renderIcon(props), /* @__PURE__ */React__default["default"].createElement(Caption, {
      brand: brand,
      color: getTextColor(props),
      pl: "inline.quark"
    }, value));
  };

  var __defProp$F = Object.defineProperty;
  var __defProps$s = Object.defineProperties;
  var __getOwnPropDescs$s = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$F = Object.getOwnPropertySymbols;
  var __hasOwnProp$F = Object.prototype.hasOwnProperty;
  var __propIsEnum$F = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$F = function __defNormalProp$F(obj, key, value) {
    return key in obj ? __defProp$F(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$F = function __spreadValues$F(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$F.call(b, prop)) __defNormalProp$F(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$F) {
      var _iterator39 = _createForOfIteratorHelper(__getOwnPropSymbols$F(b)),
          _step39;

      try {
        for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
          var prop = _step39.value;
          if (__propIsEnum$F.call(b, prop)) __defNormalProp$F(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator39.e(err);
      } finally {
        _iterator39.f();
      }
    }

    return a;
  };

  var __spreadProps$s = function __spreadProps$s(a, b) {
    return __defProps$s(a, __getOwnPropDescs$s(b));
  };

  var __objRest$w = function __objRest$w(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$F.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$F) {
      var _iterator40 = _createForOfIteratorHelper(__getOwnPropSymbols$F(source)),
          _step40;

      try {
        for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
          var prop = _step40.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$F.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator40.e(err);
      } finally {
        _iterator40.f();
      }
    }

    return target;
  };

  var StyledContainer = function StyledContainer(props) {
    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadValues$F({
      sx: {
        height: "auto",
        minWidth: 320,
        position: "relative"
      }
    }, props));
  };

  var activeLabelStyle = {
    "& > p": {
      fontSize: "xxxs"
    },
    mt: "inline.xxxs",
    overflow: "hidden",
    pt: 0,
    transform: "translateY(-0.625rem)",
    width: "auto"
  };
  var StyledLabel = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        color = _b.color,
        isActive = _b.isActive,
        label = _b.label,
        variant = _b.variant,
        variantSize = _b.variantSize,
        leadingIcon = _b.leadingIcon,
        props = __objRest$w(_b, ["color", "isActive", "label", "variant", "variantSize", "leadingIcon"]);

    var activeStyle = isActive && variantSize === "lg" ? activeLabelStyle : "";
    var isSmall = variantSize === "sm";

    var labelPaddingLeft = function labelPaddingLeft() {
      if (isSmall) {
        if (leadingIcon) {
          return "inline.sm";
        }

        return "inline.nano";
      }

      return "";
    };

    return /* @__PURE__ */React__default["default"].createElement(themeUi.Label, __spreadProps$s(__spreadValues$F({
      color: color,
      pt: "inline.xxxs",
      sx: __spreadValues$F({
        "&:disabled": {
          color: "typeface.meld"
        },
        alignItems: "center",
        flex: "none",
        left: leadingIcon ? "inline.lg" : "inline.xxxs",
        pl: labelPaddingLeft(),
        pointerEvents: "none",
        position: isSmall ? "static" : "absolute",
        pt: isSmall ? 0 : "",
        transition: "all 200ms",
        whiteSpace: "nowrap"
      }, activeStyle)
    }, props), {
      ref: ref
    }), /* @__PURE__ */React__default["default"].createElement(Body, {
      color: "inherit",
      variant: variantSize
    }, label));
  });
  var StyledInput = React__default["default"].forwardRef(function (_c, ref) {
    var _d = _c,
        name = _d.name,
        trailingIcon = _d.trailingIcon,
        leadingIcon = _d.leadingIcon,
        variantSize = _d.variantSize,
        brand = _d.brand,
        props = __objRest$w(_d, ["name", "trailingIcon", "leadingIcon", "variantSize", "brand"]);

    var isSmall = variantSize === "sm";

    var paddingRightInput = function paddingRightInput() {
      if (trailingIcon) {
        if (isSmall) {
          return "inline.sm";
        }

        return "inline.xxxs";
      }

      if (trailingIcon) {
        return "inline.lg";
      }

      return "inline.xxxs";
    };

    var paddingLeftInput = function paddingLeftInput() {
      if (leadingIcon) {
        if (isSmall) {
          return "inline.xxxs";
        }

        return "inline.lg";
      }

      return "inline.xxxs";
    };

    return /* @__PURE__ */React__default["default"].createElement(themeUi.Input, __spreadProps$s(__spreadValues$F({
      name: name,
      sx: {
        "&:disabled": {
          color: "typeface.meld",
          cursor: "not-allowed"
        },
        '&[type="password"]': {
          font: "small-caption",
          fontSize: "xs"
        },
        border: "none",
        color: brand ? "typeface.on.brand.pure" : "typeface.smooth",
        fontFamily: "base",
        height: variantSize === "lg" ? 56 : 32,
        minWidth: "72px",
        pl: paddingLeftInput(),
        pr: paddingRightInput(),
        pt: variantSize === "sm" ? "" : "inline.xxs",
        transition: "all 0.25s ease-in"
      }
    }, props), {
      ref: ref
    }));
  });

  var StyledInputLabelContainer = function StyledInputLabelContainer(_ref23) {
    var color = _ref23.color,
        children = _ref23.children,
        variantSize = _ref23.variantSize,
        focused = _ref23.focused,
        brand = _ref23.brand;
    return /* @__PURE__ */React__default["default"].createElement(Flex, {
      flex: "none",
      sx: {
        "&:disabled": {
          color: "typeface.meld",
          cursor: "not-allowed"
        },
        "&:focus:visible": {
          outline: "none"
        },
        ":hover": {
          bg: brand ? "interaction.on.brand.blend.02" : "interaction.blend.02"
        },
        bg: brand ? "interaction.on.brand.blend.01" : "interaction.blend.01",
        border: "none",
        borderBottomColor: "".concat(color),
        borderBottomLeftRadius: "none",
        borderBottomRightRadius: "none",
        borderBottomStyle: "solid",
        borderBottomWidth: focused ? "thin" : "hairline",
        borderTopLeftRadius: "xs",
        borderTopRightRadius: "xs",
        height: variantSize === "lg" ? 56 : 32
      }
    }, children);
  };

  var getColorInputToken = function getColorInputToken(type, variant) {
    return "feedback.".concat(variant, ".").concat(type);
  };

  var getInputColors = function getInputColors(_ref24) {
    var variant = _ref24.variant,
        disabled = _ref24.disabled,
        active = _ref24.active,
        brand = _ref24.brand;
    var isNotDefaultVariant = variant !== "default";
    var defaultToken = "interaction.select.default";
    var activeColor = !disabled && active && "interaction.select.active";
    var disabledTypoToken = disabled && "typeface.meld";
    var brandShapeColor = brand ? "interaction.on.brand.select.default" : "";
    var brandLabelColor = brand ? "typeface.on.brand.pure" : "";
    var variantColorShape = isNotDefaultVariant && getColorInputToken("shape", variant);
    var variantColorLabel = isNotDefaultVariant && getColorInputToken("text", variant);
    var colorShape = brandShapeColor || disabledTypoToken || variantColorShape || activeColor || defaultToken;
    var colorLabel = brandLabelColor || disabledTypoToken || variantColorLabel || activeColor || defaultToken;
    return {
      colorLabel: colorLabel,
      colorShape: colorShape
    };
  };

  var getWrapStyle = function getWrapStyle(_ref25) {
    var spacing = _ref25.spacing;
    return {
      "& > *:not(style)": {
        margin: spacing
      },
      flexWrap: "wrap"
    };
  };

  var wrapItemStyle = {
    alignItems: "flex-start",
    display: "flex",
    flexWrap: "wrap"
  };
  var __defProp$E = Object.defineProperty;
  var __defProps$r = Object.defineProperties;
  var __getOwnPropDescs$r = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$E = Object.getOwnPropertySymbols;
  var __hasOwnProp$E = Object.prototype.hasOwnProperty;
  var __propIsEnum$E = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$E = function __defNormalProp$E(obj, key, value) {
    return key in obj ? __defProp$E(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$E = function __spreadValues$E(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$E.call(b, prop)) __defNormalProp$E(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$E) {
      var _iterator41 = _createForOfIteratorHelper(__getOwnPropSymbols$E(b)),
          _step41;

      try {
        for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
          var prop = _step41.value;
          if (__propIsEnum$E.call(b, prop)) __defNormalProp$E(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator41.e(err);
      } finally {
        _iterator41.f();
      }
    }

    return a;
  };

  var __spreadProps$r = function __spreadProps$r(a, b) {
    return __defProps$r(a, __getOwnPropDescs$r(b));
  };

  var __objRest$v = function __objRest$v(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$E.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$E) {
      var _iterator42 = _createForOfIteratorHelper(__getOwnPropSymbols$E(source)),
          _step42;

      try {
        for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
          var prop = _step42.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$E.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator42.e(err);
      } finally {
        _iterator42.f();
      }
    }

    return target;
  };

  var Wrap = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        _b$spacing = _b.spacing,
        spacing = _b$spacing === void 0 ? 10 : _b$spacing,
        props = __objRest$v(_b, ["spacing"]);

    return /* @__PURE__ */React__default["default"].createElement(Flex, __spreadProps$r(__spreadValues$E({
      as: "ul",
      flexWrap: "wrap",
      sx: getWrapStyle(__spreadProps$r(__spreadValues$E({}, props), {
        spacing: spacing
      }))
    }, props), {
      ref: ref
    }));
  });
  var WrapItem = React__default["default"].forwardRef(function (props, ref) {
    return /* @__PURE__ */React__default["default"].createElement(Wrap, __spreadProps$r(__spreadValues$E({
      as: "li",
      sx: wrapItemStyle
    }, props), {
      ref: ref
    }));
  });

  var StyledIcon = function StyledIcon(_ref26) {
    var _sx;

    var children = _ref26.children,
        disabled = _ref26.disabled,
        variantSize = _ref26.variantSize,
        _ref26$direction = _ref26.direction,
        direction = _ref26$direction === void 0 ? "left" : _ref26$direction;
    return /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: (_sx = {
        cursor: disabled ? "not-allowed" : "pointer"
      }, _defineProperty(_sx, direction, "inline.nano"), _defineProperty(_sx, "mx", variantSize === "lg" ? "inline.nano" : "inline.quark"), _defineProperty(_sx, "pointerEvents", "none"), _defineProperty(_sx, "position", "absolute"), _defineProperty(_sx, "top", variantSize === "lg" ? "inline.xxxs" : "inline.nano"), _sx)
    }, children);
  };

  var __defProp$D = Object.defineProperty;
  var __defProps$q = Object.defineProperties;
  var __getOwnPropDescs$q = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$D = Object.getOwnPropertySymbols;
  var __hasOwnProp$D = Object.prototype.hasOwnProperty;
  var __propIsEnum$D = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$D = function __defNormalProp$D(obj, key, value) {
    return key in obj ? __defProp$D(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$D = function __spreadValues$D(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$D.call(b, prop)) __defNormalProp$D(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$D) {
      var _iterator43 = _createForOfIteratorHelper(__getOwnPropSymbols$D(b)),
          _step43;

      try {
        for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
          var prop = _step43.value;
          if (__propIsEnum$D.call(b, prop)) __defNormalProp$D(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator43.e(err);
      } finally {
        _iterator43.f();
      }
    }

    return a;
  };

  var __spreadProps$q = function __spreadProps$q(a, b) {
    return __defProps$q(a, __getOwnPropDescs$q(b));
  };

  var __objRest$u = function __objRest$u(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$D.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$D) {
      var _iterator44 = _createForOfIteratorHelper(__getOwnPropSymbols$D(source)),
          _step44;

      try {
        for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
          var prop = _step44.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$D.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator44.e(err);
      } finally {
        _iterator44.f();
      }
    }

    return target;
  };

  var Spacing = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        _b$size6 = _b.size,
        size = _b$size6 === void 0 ? "quark" : _b$size6,
        sx = _b.sx,
        _b$variant4 = _b.variant,
        variant = _b$variant4 === void 0 ? "horizontal" : _b$variant4,
        props = __objRest$u(_b, ["size", "sx", "variant"]);

    var getSpacingValue = function getSpacingValue(type) {
      if (type === "bottom") {
        if (variant === "horizontal") {
          return "stack.".concat(size);
        }

        return "0";
      } else if (type === "right") {
        if (variant === "vertical") {
          return "inline.".concat(size);
        }

        return "0";
      }

      return "0";
    };

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$q(__spreadValues$D({}, props), {
      ref: ref,
      sx: __spreadValues$D(__spreadValues$D({}, {
        paddingBottom: getSpacingValue("bottom"),
        paddingRight: getSpacingValue("right"),
        position: "relative"
      }), sx)
    }));
  });
  var __defProp$C = Object.defineProperty;
  var __getOwnPropSymbols$C = Object.getOwnPropertySymbols;
  var __hasOwnProp$C = Object.prototype.hasOwnProperty;
  var __propIsEnum$C = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$C = function __defNormalProp$C(obj, key, value) {
    return key in obj ? __defProp$C(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$C = function __spreadValues$C(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$C.call(b, prop)) __defNormalProp$C(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$C) {
      var _iterator45 = _createForOfIteratorHelper(__getOwnPropSymbols$C(b)),
          _step45;

      try {
        for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
          var prop = _step45.value;
          if (__propIsEnum$C.call(b, prop)) __defNormalProp$C(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator45.e(err);
      } finally {
        _iterator45.f();
      }
    }

    return a;
  };

  var __objRest$t = function __objRest$t(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$C.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$C) {
      var _iterator46 = _createForOfIteratorHelper(__getOwnPropSymbols$C(source)),
          _step46;

      try {
        for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
          var prop = _step46.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$C.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator46.e(err);
      } finally {
        _iterator46.f();
      }
    }

    return target;
  };

  var InputIcon = function InputIcon(_a) {
    var _b = _a,
        iconClick = _b.iconClick,
        leadingIcon = _b.leadingIcon,
        trailingIcon = _b.trailingIcon,
        variantSize = _b.variantSize,
        color = _b.color,
        disabled = _b.disabled,
        brand = _b.brand,
        props = __objRest$t(_b, ["iconClick", "leadingIcon", "trailingIcon", "variantSize", "color", "disabled", "brand"]);

    return iconClick && trailingIcon ? /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */React__default["default"].createElement(ButtonIcon, {
      brand: brand,
      color: color,
      disabled: disabled,
      leadingIcon: trailingIcon,
      onClick: iconClick,
      size: variantSize,
      sx: {
        alignSelf: "center"
      }
    }), /* @__PURE__ */React__default["default"].createElement(Spacing, {
      size: "quark",
      variant: "vertical"
    })) : /* @__PURE__ */React__default["default"].createElement(StyledIcon, __spreadValues$C({
      direction: leadingIcon ? "left" : "right",
      disabled: disabled,
      variantSize: variantSize
    }, props), /* @__PURE__ */React__default["default"].createElement(Icon, {
      color: color,
      size: variantSize === "sm" ? "xs" : "md",
      sx: {
        pointerEvents: "none"
      }
    }, trailingIcon || leadingIcon));
  };

  var __defProp$B = Object.defineProperty;
  var __defProps$p = Object.defineProperties;
  var __getOwnPropDescs$p = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$B = Object.getOwnPropertySymbols;
  var __hasOwnProp$B = Object.prototype.hasOwnProperty;
  var __propIsEnum$B = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$B = function __defNormalProp$B(obj, key, value) {
    return key in obj ? __defProp$B(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$B = function __spreadValues$B(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$B.call(b, prop)) __defNormalProp$B(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$B) {
      var _iterator47 = _createForOfIteratorHelper(__getOwnPropSymbols$B(b)),
          _step47;

      try {
        for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
          var prop = _step47.value;
          if (__propIsEnum$B.call(b, prop)) __defNormalProp$B(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator47.e(err);
      } finally {
        _iterator47.f();
      }
    }

    return a;
  };

  var __spreadProps$p = function __spreadProps$p(a, b) {
    return __defProps$p(a, __getOwnPropDescs$p(b));
  };

  var __objRest$s = function __objRest$s(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$B.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$B) {
      var _iterator48 = _createForOfIteratorHelper(__getOwnPropSymbols$B(source)),
          _step48;

      try {
        for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
          var prop = _step48.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$B.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator48.e(err);
      } finally {
        _iterator48.f();
      }
    }

    return target;
  };

  var Input = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        onChange = _b.onChange,
        _b$variantSize = _b.variantSize,
        variantSize = _b$variantSize === void 0 ? "lg" : _b$variantSize,
        _onFocus = _b.onFocus,
        _onBlur = _b.onBlur,
        defaultValue = _b.defaultValue,
        rest = __objRest$s(_b, ["onChange", "variantSize", "onFocus", "onBlur", "defaultValue"]);

    var label = rest.label,
        disabled = rest.disabled,
        value = rest.value,
        supportMessage = rest.supportMessage,
        _rest$variant = rest.variant,
        variant = _rest$variant === void 0 ? "default" : _rest$variant,
        leadingIcon = rest.leadingIcon,
        trailingIcon = rest.trailingIcon,
        placeholder = rest.placeholder,
        id = rest.id,
        width = rest.width,
        height = rest.height,
        iconColor = rest.iconColor,
        triggerActive = rest.triggerFocus,
        brand = rest.brand,
        iconClick = rest.iconClick,
        right = rest.right;

    var _React$useState9 = React.useState(false),
        _React$useState10 = _slicedToArray(_React$useState9, 2),
        active = _React$useState10[0],
        setActive = _React$useState10[1];

    var _React$useState11 = React.useState(defaultValue || value),
        _React$useState12 = _slicedToArray(_React$useState11, 2),
        controlValue = _React$useState12[0],
        setControlValue = _React$useState12[1];

    var previousValueRef = React.useRef(controlValue);
    React.useEffect(function () {
      if (defaultValue) {
        setControlValue(defaultValue);
      } else if (previousValueRef.current !== value) {
        setControlValue(value);
        previousValueRef.current = value;
      }
    }, [value, defaultValue]);

    var handleChange = function handleChange(e) {
      setControlValue(e.target.value);

      if (onChange) {
        onChange(e);
      }

      e.preventDefault();
    };

    var hasValue = controlValue || controlValue && defaultValue;
    var isActiveLabel = triggerActive || active || !!hasValue || !!placeholder;
    var supportVariants = {
      error: "invalid",
      success: "valid"
    };
    var inputColors = getInputColors({
      active: active,
      brand: brand,
      disabled: disabled,
      variant: variant
    });
    return /* @__PURE__ */React__default["default"].createElement(StyledContainer, {
      height: height,
      width: width
    }, /* @__PURE__ */React__default["default"].createElement(StyledInputLabelContainer, {
      brand: brand,
      color: inputColors.colorShape,
      focused: active,
      variantSize: variantSize
    }, /* @__PURE__ */React__default["default"].createElement(InputIcon, {
      color: iconColor || inputColors.colorShape,
      disabled: disabled,
      iconClick: iconClick,
      leadingIcon: leadingIcon,
      variant: variant,
      variantSize: variantSize
    }), /* @__PURE__ */React__default["default"].createElement(StyledLabel, {
      color: inputColors.colorLabel,
      htmlFor: id,
      isActive: isActiveLabel,
      label: label,
      leadingIcon: leadingIcon,
      variant: variant,
      variantSize: variantSize
    }), /* @__PURE__ */React__default["default"].createElement(StyledInput, __spreadProps$p(__spreadValues$B({
      "aria-disabled": disabled,
      "aria-invalid": variant === "error",
      "aria-placeholder": placeholder,
      "aria-readonly": "true",
      autoCapitalize: "none",
      autoComplete: "off",
      color: inputColors.colorShape,
      disabled: disabled,
      id: id,
      role: "textbox",
      type: "text",
      value: controlValue || "",
      variant: variant,
      variantSize: variantSize
    }, rest), {
      onBlur: function onBlur(e) {
        return pipe(function () {
          return setActive(false);
        }, function () {
          return _onBlur && _onBlur(e);
        })();
      },
      onChange: handleChange,
      onFocus: function onFocus(e) {
        return pipe(function () {
          return setActive(true);
        }, function () {
          return _onFocus && _onFocus(e);
        })();
      },
      ref: ref
    })), right && !trailingIcon ? right : /* @__PURE__ */React__default["default"].createElement(InputIcon, {
      brand: brand,
      color: iconColor || inputColors.colorShape,
      disabled: disabled,
      iconClick: iconClick,
      trailingIcon: trailingIcon,
      variant: variant,
      variantSize: variantSize
    })), /* @__PURE__ */React__default["default"].createElement(Wrap, null, typeof supportMessage === "string" ? /* @__PURE__ */React__default["default"].createElement(SupportMessage, {
      brand: brand,
      disabled: disabled,
      value: supportMessage,
      variant: supportVariants[variant]
    }) : supportMessage == null ? void 0 : supportMessage.map(function (suptMsg, i) {
      return /* @__PURE__ */React__default["default"].createElement(WrapItem, {
        key: i,
        mb: "inline.quark",
        mr: "inline.nano"
      }, /* @__PURE__ */React__default["default"].createElement(SupportMessage, {
        brand: brand,
        disabled: disabled,
        tabIndex: i,
        value: suptMsg,
        variant: supportVariants[variant]
      }));
    })));
  });
  var __defProp$A = Object.defineProperty;
  var __getOwnPropSymbols$A = Object.getOwnPropertySymbols;
  var __hasOwnProp$A = Object.prototype.hasOwnProperty;
  var __propIsEnum$A = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$A = function __defNormalProp$A(obj, key, value) {
    return key in obj ? __defProp$A(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$A = function __spreadValues$A(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$A.call(b, prop)) __defNormalProp$A(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$A) {
      var _iterator49 = _createForOfIteratorHelper(__getOwnPropSymbols$A(b)),
          _step49;

      try {
        for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
          var prop = _step49.value;
          if (__propIsEnum$A.call(b, prop)) __defNormalProp$A(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator49.e(err);
      } finally {
        _iterator49.f();
      }
    }

    return a;
  };

  var __objRest$r = function __objRest$r(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$A.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$A) {
      var _iterator50 = _createForOfIteratorHelper(__getOwnPropSymbols$A(source)),
          _step50;

      try {
        for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
          var prop = _step50.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$A.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator50.e(err);
      } finally {
        _iterator50.f();
      }
    }

    return target;
  };

  var InputPassword = function InputPassword(_a) {
    var _b = _a,
        variantSize = _b.variantSize,
        disabled = _b.disabled,
        brand = _b.brand,
        props = __objRest$r(_b, ["variantSize", "disabled", "brand"]);

    var _React$useState13 = React.useState(true),
        _React$useState14 = _slicedToArray(_React$useState13, 2),
        passwordShown = _React$useState14[0],
        setPasswordShown = _React$useState14[1];

    function toggleVisibility() {
      setPasswordShown(!passwordShown);
    }

    function renderIcon(showPassword) {
      if (showPassword) {
        return /* @__PURE__ */React__default["default"].createElement(almaIcons.ViewonBold, null);
      }

      return /* @__PURE__ */React__default["default"].createElement(almaIcons.ViewoffBold, null);
    }

    function getInputType(showPassword) {
      if (showPassword) {
        return "password";
      }

      return "text";
    }

    function getInputRole(showPassword) {
      if (showPassword) {
        return void 0;
      }

      return "textbox";
    }

    return /* @__PURE__ */React__default["default"].createElement(Input, __spreadValues$A({
      brand: brand,
      disabled: disabled,
      right: /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */React__default["default"].createElement(ButtonIcon, {
        brand: brand,
        disabled: disabled,
        leadingIcon: renderIcon(passwordShown),
        onClick: toggleVisibility,
        size: variantSize,
        sx: {
          alignSelf: "center"
        }
      }), /* @__PURE__ */React__default["default"].createElement(Spacing, {
        size: "quark",
        variant: "vertical"
      })),
      role: getInputRole(passwordShown),
      type: getInputType(passwordShown),
      variantSize: variantSize
    }, props));
  };

  var __defProp$z = Object.defineProperty;
  var __defProps$o = Object.defineProperties;
  var __getOwnPropDescs$o = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$z = Object.getOwnPropertySymbols;
  var __hasOwnProp$z = Object.prototype.hasOwnProperty;
  var __propIsEnum$z = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$z = function __defNormalProp$z(obj, key, value) {
    return key in obj ? __defProp$z(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$z = function __spreadValues$z(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$z.call(b, prop)) __defNormalProp$z(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$z) {
      var _iterator51 = _createForOfIteratorHelper(__getOwnPropSymbols$z(b)),
          _step51;

      try {
        for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
          var prop = _step51.value;
          if (__propIsEnum$z.call(b, prop)) __defNormalProp$z(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator51.e(err);
      } finally {
        _iterator51.f();
      }
    }

    return a;
  };

  var __spreadProps$o = function __spreadProps$o(a, b) {
    return __defProps$o(a, __getOwnPropDescs$o(b));
  };

  var __objRest$q = function __objRest$q(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$z.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$z) {
      var _iterator52 = _createForOfIteratorHelper(__getOwnPropSymbols$z(source)),
          _step52;

      try {
        for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
          var prop = _step52.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$z.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator52.e(err);
      } finally {
        _iterator52.f();
      }
    }

    return target;
  };

  var interactionAcessibleElementBaseStyle = {
    bg: "interaction.blend.02",
    display: "block",
    height: "40px",
    position: "absolute",
    transform: "translateX(-8px)",
    width: "40px",
    zIndex: 1,
    borderRadius: "circle",
    transition: "background-color 0.12s ease-in"
  };
  var radioStyle = {
    alignItems: "center",
    "&:hover": {
      span: __spreadValues$z({}, interactionAcessibleElementBaseStyle)
    },
    "&:focus, &:focus-visible": {
      span: __spreadProps$o(__spreadValues$z({}, interactionAcessibleElementBaseStyle), {
        bg: "interaction.blend.02",
        borderColor: "interaction.blend.05",
        borderStyle: "solid",
        borderWidth: "thin"
      })
    },
    "&:active": {
      span: __spreadProps$o(__spreadValues$z({}, interactionAcessibleElementBaseStyle), {
        bg: "interaction.blend.03",
        borderStyle: "none"
      })
    },
    input: {
      "&:disabled": {
        "~ svg": {
          color: "interaction.blend.05"
        }
      },
      "&:focus": {
        "~ svg": {
          bg: "transparent"
        }
      },
      "~ svg": {
        color: "interaction.select.default"
      }
    }
  };
  var Radio = React__default["default"].forwardRef(function (props, ref) {
    var _a = props,
        label = _a.label,
        value = _a.value,
        disabled = _a.disabled,
        rest = __objRest$q(_a, ["label", "value", "disabled"]);

    return /* @__PURE__ */React__default["default"].createElement(themeUi.Label, {
      css: css$4(__spreadValues$z({}, radioStyle))
    }, /* @__PURE__ */React__default["default"].createElement(Box, {
      as: "span"
    }), /* @__PURE__ */React__default["default"].createElement(themeUi.Radio, __spreadProps$o(__spreadValues$z({
      disabled: disabled,
      value: value,
      width: 24
    }, rest), {
      ref: ref
    })), /* @__PURE__ */React__default["default"].createElement(Body, {
      ml: "inline.nano"
    }, label));
  });
  var __defProp$y = Object.defineProperty;
  var __defProps$n = Object.defineProperties;
  var __getOwnPropDescs$n = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$y = Object.getOwnPropertySymbols;
  var __hasOwnProp$y = Object.prototype.hasOwnProperty;
  var __propIsEnum$y = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$y = function __defNormalProp$y(obj, key, value) {
    return key in obj ? __defProp$y(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$y = function __spreadValues$y(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$y.call(b, prop)) __defNormalProp$y(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$y) {
      var _iterator53 = _createForOfIteratorHelper(__getOwnPropSymbols$y(b)),
          _step53;

      try {
        for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
          var prop = _step53.value;
          if (__propIsEnum$y.call(b, prop)) __defNormalProp$y(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator53.e(err);
      } finally {
        _iterator53.f();
      }
    }

    return a;
  };

  var __spreadProps$n = function __spreadProps$n(a, b) {
    return __defProps$n(a, __getOwnPropDescs$n(b));
  };

  var getInputBoxStyle = function getInputBoxStyle(brand) {
    return {
      "::-webkit-search-decoration, ::-webkit-search-cancel-button, ::-webkit-search-results-button, ::-webkit-search-results-decoration": {
        "-moz-appearance": "none",
        "-webkit-appearance": "none",
        appearance: "none",
        display: "none"
      },
      ":disabled": {
        cursor: "not-allowed"
      },
      ":focus": {
        backgroundColor: brand ? "interaction.inverse.blend.03" : "interaction.blend.02",
        borderBottomWidth: "thin",
        borderColor: brand ? "interaction.inverse.blend.08" : "interaction.select.active",
        borderLeftWidth: "none",
        borderRightWidth: "none",
        borderTopWidth: "none"
      },
      ":hover:enabled": {
        backgroundColor: brand ? "interaction.inverse.blend.03" : "interaction.blend.02"
      },
      backgroundColor: brand ? "interaction.inverse.blend.02" : "interaction.blend.01",
      borderBottomLeftRadius: "none",
      borderBottomRightRadius: "none",
      borderBottomWidth: "hairline",
      borderColor: brand ? "interaction.inverse.blend.07" : "interaction.select.default",
      borderLeftWidth: "none",
      borderRightWidth: "none",
      borderStyle: "solid",
      borderTopLeftRadius: "xs",
      borderTopRightRadius: "xs",
      borderTopWidth: "none",
      width: "100%"
    };
  };

  var getMagnifierIconSize = function getMagnifierIconSize(variantSize) {
    switch (variantSize) {
      case "lg":
        return 26;

      case "sm":
        return 20;

      default:
        return 0;
    }
  };

  var getClearIconSize = function getClearIconSize(variantSize) {
    switch (variantSize) {
      case "lg":
        return 18;

      case "sm":
        return 18;

      default:
        return 0;
    }
  };

  var getCustomStyle = function getCustomStyle(variantSize) {
    var baseObject = {
      padding: getVerticalSpacing(variantSize).string,
      paddingLeft: "".concat(parseInt(getVerticalSpacing(variantSize).themeUi, 10) * 2 + getMagnifierIconSize(variantSize), "px"),
      paddingRight: "".concat(parseInt(getVerticalSpacing(variantSize).themeUi, 10) * 2 + getClearIconSize(variantSize), "px")
    };

    switch (variantSize) {
      case "lg":
        baseObject["height"] = "56px";
        break;

      case "sm":
        baseObject["height"] = "32px";
        break;
    }

    return baseObject;
  };

  var getVerticalSpacing = function getVerticalSpacing(variantSize) {
    switch (variantSize) {
      case "lg":
        return {
          string: "xxxs",
          themeUi: defaultTheme$3.space.inline.xxxs
        };

      case "sm":
        return {
          string: "nano",
          themeUi: defaultTheme$3.space.inline.nano
        };

      default:
        return {
          string: "",
          themeUi: "0"
        };
    }
  };

  var getFontStyle = function getFontStyle(_ref27) {
    var variantSize = _ref27.variantSize,
        brand = _ref27.brand;
    var fontStyleObject = {
      "::placeholder": {
        color: brand ? "typeface.on.brand.pure" : "typeface.smooth"
      },
      "::selection": {
        backgroundColor: brand ? "interaction.inverse.blend.03" : "interaction.subtle.02"
      },
      color: brand ? "typeface.on.brand.pure" : "typeface.smooth",
      fontFamily: "base",
      fontStyle: "normal",
      fontWeight: "normal"
    };

    switch (variantSize) {
      case "lg":
        return __spreadProps$n(__spreadValues$y({}, fontStyleObject), {
          fontSize: "xs"
        });

      case "sm":
        return __spreadProps$n(__spreadValues$y({}, fontStyleObject), {
          fontSize: "xxs"
        });

      default:
        return fontStyleObject;
    }
  };

  var getSearchStyle = function getSearchStyle(_ref28) {
    var variantSize = _ref28.variantSize,
        brand = _ref28.brand;
    return __spreadValues$y(__spreadValues$y(__spreadValues$y({}, getInputBoxStyle(brand)), getFontStyle({
      brand: brand,
      variantSize: variantSize
    })), getCustomStyle(variantSize));
  };

  var getMagnifierIconStyle = function getMagnifierIconStyle(_ref29) {
    var variantSize = _ref29.variantSize,
        focused = _ref29.focused,
        hovered = _ref29.hovered,
        brand = _ref29.brand;
    var iconColor;

    if (focused) {
      iconColor = {
        "& > svg > path": {
          fill: brand ? "interaction.inverse.blend.08" : "interaction.select.active"
        }
      };
    } else if (hovered) {
      iconColor = {
        "& > svg > path": {
          fill: brand ? "interaction.inverse.blend.07" : "interaction.select.focus"
        }
      };
    } else {
      iconColor = {
        "& > svg > path": {
          fill: brand ? "interaction.inverse.blend.07" : "interaction.select.default"
        }
      };
    }

    return __spreadValues$y({
      "& > svg": {
        height: "100%",
        width: "100%"
      },
      height: "".concat(getMagnifierIconSize(variantSize), "px"),
      left: getVerticalSpacing(variantSize).themeUi,
      pointerEvents: "none",
      position: "absolute",
      top: "calc(50% - ".concat(getMagnifierIconSize(variantSize) / 2, "px)"),
      width: "".concat(getMagnifierIconSize(variantSize), "px")
    }, iconColor);
  };

  var getClearIconStyle = function getClearIconStyle(_ref30) {
    var brand = _ref30.brand,
        variantSize = _ref30.variantSize;
    return {
      cursor: "pointer",
      position: "absolute",
      right: getVerticalSpacing(variantSize).themeUi
    };
  };

  var __defProp$x = Object.defineProperty;
  var __defProps$m = Object.defineProperties;
  var __getOwnPropDescs$m = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$x = Object.getOwnPropertySymbols;
  var __hasOwnProp$x = Object.prototype.hasOwnProperty;
  var __propIsEnum$x = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$x = function __defNormalProp$x(obj, key, value) {
    return key in obj ? __defProp$x(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$x = function __spreadValues$x(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$x.call(b, prop)) __defNormalProp$x(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$x) {
      var _iterator54 = _createForOfIteratorHelper(__getOwnPropSymbols$x(b)),
          _step54;

      try {
        for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
          var prop = _step54.value;
          if (__propIsEnum$x.call(b, prop)) __defNormalProp$x(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator54.e(err);
      } finally {
        _iterator54.f();
      }
    }

    return a;
  };

  var __spreadProps$m = function __spreadProps$m(a, b) {
    return __defProps$m(a, __getOwnPropDescs$m(b));
  };

  var __objRest$p = function __objRest$p(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$x.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$x) {
      var _iterator55 = _createForOfIteratorHelper(__getOwnPropSymbols$x(source)),
          _step55;

      try {
        for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
          var prop = _step55.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$x.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator55.e(err);
      } finally {
        _iterator55.f();
      }
    }

    return target;
  };

  var Search = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        value = _b.value,
        defaultValue = _b.defaultValue,
        disabled = _b.disabled,
        placeholder = _b.placeholder,
        _b$variantSize2 = _b.variantSize,
        variantSize = _b$variantSize2 === void 0 ? "lg" : _b$variantSize2,
        _onBlur2 = _b.onBlur,
        _onFocus2 = _b.onFocus,
        _onChange = _b.onChange,
        _onMouseEnter = _b.onMouseEnter,
        _onMouseLeave = _b.onMouseLeave,
        onClear = _b.onClear,
        sx = _b.sx,
        otherProps = __objRest$p(_b, ["brand", "value", "defaultValue", "disabled", "placeholder", "variantSize", "onBlur", "onFocus", "onChange", "onMouseEnter", "onMouseLeave", "onClear", "sx"]);

    var _React$useState15 = React.useState(false),
        _React$useState16 = _slicedToArray(_React$useState15, 2),
        focused = _React$useState16[0],
        setFocused = _React$useState16[1];

    var _React$useState17 = React.useState(false),
        _React$useState18 = _slicedToArray(_React$useState17, 2),
        hovered = _React$useState18[0],
        setHovered = _React$useState18[1];

    var _React$useState19 = React.useState(value),
        _React$useState20 = _slicedToArray(_React$useState19, 2),
        controlValue = _React$useState20[0],
        setValue = _React$useState20[1];

    React.useEffect(function () {
      if (defaultValue) {
        setValue(defaultValue);
      }
    }, [defaultValue]);
    return /* @__PURE__ */React__default["default"].createElement(Center, {
      sx: __spreadValues$x(__spreadValues$x({}, {
        opacity: disabled ? defaultTheme$3.opacities["07"] : 1,
        position: "relative"
      }), sx)
    }, /* @__PURE__ */React__default["default"].createElement(Icon, {
      css: css$4(getMagnifierIconStyle({
        brand: brand,
        focused: focused,
        hovered: hovered,
        variantSize: variantSize
      }))
    }, /* @__PURE__ */React__default["default"].createElement(almaIcons.SearchBold, null)), /* @__PURE__ */React__default["default"].createElement(themeUi.Input, __spreadProps$m(__spreadValues$x({
      autoComplete: "off",
      css: css$4(getSearchStyle({
        brand: brand,
        variantSize: variantSize
      })),
      dir: "auto",
      disabled: disabled,
      placeholder: placeholder,
      role: "combobox",
      spellCheck: "false",
      type: "search",
      value: controlValue || ""
    }, otherProps), {
      onBlur: function onBlur(e) {
        if (!disabled) {
          setFocused(false);
        }

        if (_onBlur2) {
          _onBlur2(e);
        }
      },
      onChange: function onChange(e) {
        setValue(e.target.value);

        if (_onChange) {
          _onChange(e);
        }
      },
      onFocus: function onFocus(e) {
        if (!disabled) {
          setFocused(true);
        }

        if (_onFocus2) {
          _onFocus2(e);
        }
      },
      onMouseEnter: function onMouseEnter(e) {
        if (!disabled) {
          setHovered(true);
        }

        if (_onMouseEnter) {
          _onMouseEnter(e);
        }
      },
      onMouseLeave: function onMouseLeave(e) {
        if (!disabled) {
          setHovered(false);
        }

        if (_onMouseLeave) {
          _onMouseLeave(e);
        }
      },
      ref: ref
    })), !disabled && controlValue && /* @__PURE__ */React__default["default"].createElement(ButtonIcon, {
      leadingIcon: /* @__PURE__ */React__default["default"].createElement(almaIcons.CloseBold, null),
      onClick: function onClick() {
        setValue("");

        if (onClear) {
          onClear();
        }
      },
      size: "sm",
      sx: getClearIconStyle({
        brand: brand,
        focused: focused,
        hovered: hovered,
        variantSize: variantSize
      })
    }));
  });
  var titleStyle = {
    color: "typeface.strong",
    fontFamily: "base",
    fontSize: "xs",
    fontWeight: "bold",
    letterSpacing: "standard",
    lineHeight: "superdistant",
    padding: "inset.quark",
    width: "calc(100% - ".concat(parseInt(defaultTheme$3.space.inset.md, 10), "px)")
  };

  var getMessageStyle$1 = function getMessageStyle$1(linkProps) {
    var baseObject = {
      margin: 0,
      paddingLeft: "inset.quark",
      paddingRight: "inset.quark",
      width: "calc(100% - ".concat(parseInt(defaultTheme$3.space.inset.md, 10), "px)")
    };

    if (linkProps) {
      baseObject["marginBottom"] = "stack.nano";
    }

    return baseObject;
  };

  var linkStyle = {
    alignItems: "center",
    display: "flex",
    marginTop: "stack.nano",
    paddingLeft: "inset.quark",
    paddingRight: "inset.quark",
    textDecoration: "none",
    width: "calc(100% - ".concat(parseInt(defaultTheme$3.space.inset.md, 10), "px)")
  };
  var iconTypeStyle$1 = {
    height: "inset.md",
    left: "inset.xs",
    position: "absolute",
    top: "inset.xs",
    width: "inset.md"
  };
  var closeButtonStyle = {
    position: "absolute",
    right: "inset.xs",
    top: "inset.xs"
  };

  var getContainerStyle$3 = function getContainerStyle$3(variant) {
    var containerStyle = {
      alignItems: "flex-start",
      backgroundColor: "neutral.00",
      borderColor: "neutral.30",
      borderRadius: "xs",
      borderStyle: "solid",
      borderWidth: "hairline",
      boxShadow: defaultTheme$3.shadows["02"],
      flexDirection: "column",
      padding: "inset.xs",
      position: "relative",
      width: "320px"
    };

    if (variant !== "simple") {
      containerStyle["paddingLeft"] = "".concat(parseInt(defaultTheme$3.space.inset.xs, 10) + parseInt(defaultTheme$3.space.inset.md, 10), "px");
    }

    return containerStyle;
  };

  var __defProp$w = Object.defineProperty;
  var __defProps$l = Object.defineProperties;
  var __getOwnPropDescs$l = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$w = Object.getOwnPropertySymbols;
  var __hasOwnProp$w = Object.prototype.hasOwnProperty;
  var __propIsEnum$w = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$w = function __defNormalProp$w(obj, key, value) {
    return key in obj ? __defProp$w(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$w = function __spreadValues$w(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$w.call(b, prop)) __defNormalProp$w(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$w) {
      var _iterator56 = _createForOfIteratorHelper(__getOwnPropSymbols$w(b)),
          _step56;

      try {
        for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
          var prop = _step56.value;
          if (__propIsEnum$w.call(b, prop)) __defNormalProp$w(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator56.e(err);
      } finally {
        _iterator56.f();
      }
    }

    return a;
  };

  var __spreadProps$l = function __spreadProps$l(a, b) {
    return __defProps$l(a, __getOwnPropDescs$l(b));
  };

  var __objRest$o = function __objRest$o(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$w.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$w) {
      var _iterator57 = _createForOfIteratorHelper(__getOwnPropSymbols$w(source)),
          _step57;

      try {
        for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
          var prop = _step57.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$w.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator57.e(err);
      } finally {
        _iterator57.f();
      }
    }

    return target;
  };

  var isSmallProp$1 = function isSmallProp$1(variant) {
    return variant === "sm";
  };

  var LinkInline = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        _b$variant5 = _b.variant,
        variant = _b$variant5 === void 0 ? "lg" : _b$variant5,
        props = __objRest$o(_b, ["variant"]);

    return /* @__PURE__ */React__default["default"].createElement(Typography, __spreadProps$l(__spreadValues$w({
      as: "a",
      color: getColorTypfaceTokenByProp(props, "pure"),
      css: {
        textDecoration: "underline"
      },
      fontFamily: "base",
      fontSize: isSmallProp$1(variant) ? "xxs" : "xs",
      letterSpacing: "standard",
      lineHeight: isSmallProp$1(variant) ? "huge" : "superdistant"
    }, props), {
      ref: ref
    }));
  });
  var __defProp$v = Object.defineProperty;
  var __getOwnPropSymbols$v = Object.getOwnPropertySymbols;
  var __hasOwnProp$v = Object.prototype.hasOwnProperty;
  var __propIsEnum$v = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$v = function __defNormalProp$v(obj, key, value) {
    return key in obj ? __defProp$v(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$v = function __spreadValues$v(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$v.call(b, prop)) __defNormalProp$v(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$v) {
      var _iterator58 = _createForOfIteratorHelper(__getOwnPropSymbols$v(b)),
          _step58;

      try {
        for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
          var prop = _step58.value;
          if (__propIsEnum$v.call(b, prop)) __defNormalProp$v(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator58.e(err);
      } finally {
        _iterator58.f();
      }
    }

    return a;
  };

  var getCustomAttributes = function getCustomAttributes(variant) {
    var customAttributes = {};

    switch (variant) {
      case "lg":
        customAttributes["fontSize"] = "xs";
        customAttributes["height"] = "32px";
        customAttributes["lineHeight"] = "medium";
        break;

      case "sm":
        customAttributes["fontSize"] = "xxs";
        customAttributes["height"] = "24px";
        customAttributes["lineHeight"] = "standard";
        break;
    }

    return customAttributes;
  };

  var getContainerStyle$2 = function getContainerStyle$2(brand, variant) {
    var getInteractionAttributes = function getInteractionAttributes(defaultColor, brandColor) {
      return {
        "& > p": {
          borderBottomColor: brand ? brandColor : defaultColor,
          borderBottomStyle: "solid",
          borderBottomWidth: "thin",
          color: "inherit"
        }
      };
    };

    return __spreadValues$v({
      "& > p": {
        borderBottomColor: "transparent",
        borderBottomStyle: "solid",
        borderBottomWidth: "thin",
        color: "inherit",
        fontSize: "inherit",
        lineHeight: "inherit",
        paddingTop: "1px"
      },
      ":active": __spreadValues$v({
        color: brand ? "interaction.inverse.blend.08" : "interaction.select.active"
      }, getInteractionAttributes("interaction.select.active", "interaction.inverse.blend.08")),
      ":focus:not(:active)": __spreadValues$v({
        borderColor: brand ? "interaction.inverse.blend.08" : "interaction.select.focus",
        borderStyle: "solid",
        borderWidth: "thin",
        color: brand ? "interaction.inverse.blend.08" : "interaction.select.focus"
      }, getInteractionAttributes("interaction.select.focus", "interaction.inverse.blend.08")),
      ":hover:not(:active)": __spreadValues$v({
        color: brand ? "interaction.inverse.blend.08" : "interaction.select.focus"
      }, getInteractionAttributes("interaction.select.focus", "interaction.inverse.blend.08")),
      alignItems: "center",
      borderColor: "transparent",
      borderStyle: "solid",
      borderWidth: "thin",
      color: brand ? "interaction.inverse.blend.07" : "interaction.select.default",
      display: "inline-flex",
      margin: 0,
      padding: "inline.quark",
      textDecoration: "none"
    }, getCustomAttributes(variant));
  };

  var getDisabledContainerStyle = function getDisabledContainerStyle(brand, variant) {
    return __spreadValues$v({
      "& > p": {
        borderBottomColor: "transparent",
        borderBottomStyle: "solid",
        borderBottomWidth: "thin",
        color: "inherit",
        fontSize: "inherit",
        lineHeight: "inherit",
        paddingTop: "1px"
      },
      alignItems: "center",
      color: brand ? "interaction.inverse.blend.05" : "typeface.meld",
      display: "inline-flex",
      margin: 0,
      padding: "inline.quark",
      textDecoration: "none"
    }, getCustomAttributes(variant));
  };

  var __defProp$u = Object.defineProperty;
  var __defProps$k = Object.defineProperties;
  var __getOwnPropDescs$k = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$u = Object.getOwnPropertySymbols;
  var __hasOwnProp$u = Object.prototype.hasOwnProperty;
  var __propIsEnum$u = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$u = function __defNormalProp$u(obj, key, value) {
    return key in obj ? __defProp$u(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$u = function __spreadValues$u(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$u.call(b, prop)) __defNormalProp$u(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$u) {
      var _iterator59 = _createForOfIteratorHelper(__getOwnPropSymbols$u(b)),
          _step59;

      try {
        for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
          var prop = _step59.value;
          if (__propIsEnum$u.call(b, prop)) __defNormalProp$u(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator59.e(err);
      } finally {
        _iterator59.f();
      }
    }

    return a;
  };

  var __spreadProps$k = function __spreadProps$k(a, b) {
    return __defProps$k(a, __getOwnPropDescs$k(b));
  };

  var __objRest$n = function __objRest$n(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$u.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$u) {
      var _iterator60 = _createForOfIteratorHelper(__getOwnPropSymbols$u(source)),
          _step60;

      try {
        for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
          var prop = _step60.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$u.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator60.e(err);
      } finally {
        _iterator60.f();
      }
    }

    return target;
  };

  var LinkStandalone = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        disabled = _b.disabled,
        href = _b.href,
        trailingIcon = _b.trailingIcon,
        label = _b.label,
        target = _b.target,
        variant = _b.variant,
        props = __objRest$n(_b, ["brand", "disabled", "href", "trailingIcon", "label", "target", "variant"]);

    var getIconSize = function getIconSize() {
      switch (variant) {
        case "lg":
          return "md";

        case "sm":
          return "xs";

        default:
          return "md";
      }
    };

    if (disabled) {
      return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$k(__spreadValues$u({}, props), {
        ref: ref,
        sx: getDisabledContainerStyle(brand, variant),
        tabIndex: 0
      }), /* @__PURE__ */React__default["default"].createElement(Body, null, label), trailingIcon && /* @__PURE__ */React__default["default"].createElement(Icon, {
        size: getIconSize(),
        sx: {
          marginLeft: "10px"
        }
      }, trailingIcon));
    }

    return /* @__PURE__ */React__default["default"].createElement(LinkInline, __spreadProps$k(__spreadValues$u({}, props), {
      href: href,
      onMouseUp: function onMouseUp(evt) {
        evt.currentTarget.blur();

        if (props.onMouseUp) {
          props.onMouseUp(evt);
        }
      },
      ref: ref,
      sx: getContainerStyle$2(brand, variant),
      tabIndex: 0,
      target: target,
      variant: variant
    }), /* @__PURE__ */React__default["default"].createElement(Body, null, label), trailingIcon && /* @__PURE__ */React__default["default"].createElement(Icon, {
      size: getIconSize(),
      sx: {
        marginLeft: "10px"
      }
    }, trailingIcon));
  });
  var __defProp$t = Object.defineProperty;
  var __defProps$j = Object.defineProperties;
  var __getOwnPropDescs$j = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$t = Object.getOwnPropertySymbols;
  var __hasOwnProp$t = Object.prototype.hasOwnProperty;
  var __propIsEnum$t = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$t = function __defNormalProp$t(obj, key, value) {
    return key in obj ? __defProp$t(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$t = function __spreadValues$t(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$t.call(b, prop)) __defNormalProp$t(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$t) {
      var _iterator61 = _createForOfIteratorHelper(__getOwnPropSymbols$t(b)),
          _step61;

      try {
        for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
          var prop = _step61.value;
          if (__propIsEnum$t.call(b, prop)) __defNormalProp$t(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator61.e(err);
      } finally {
        _iterator61.f();
      }
    }

    return a;
  };

  var __spreadProps$j = function __spreadProps$j(a, b) {
    return __defProps$j(a, __getOwnPropDescs$j(b));
  };

  var __objRest$m = function __objRest$m(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$t.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$t) {
      var _iterator62 = _createForOfIteratorHelper(__getOwnPropSymbols$t(source)),
          _step62;

      try {
        for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
          var prop = _step62.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$t.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator62.e(err);
      } finally {
        _iterator62.f();
      }
    }

    return target;
  };

  var Toast = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        onClose = _b.onClose,
        _b$variant6 = _b.variant,
        variant = _b$variant6 === void 0 ? "simple" : _b$variant6,
        supportIcon = _b.supportIcon,
        linkProps = _b.linkProps,
        message = _b.message,
        sx = _b.sx,
        title = _b.title,
        props = __objRest$m(_b, ["onClose", "variant", "supportIcon", "linkProps", "message", "sx", "title"]);

    var renderToastTypeIcon = function renderToastTypeIcon() {
      var iconColor = "";
      var IconToRender = null;

      switch (variant) {
        case "success":
          iconColor = "feedback.success.shape";
          IconToRender = /* @__PURE__ */React__default["default"].createElement(almaIcons.CheckroundBold, null);
          break;

        case "error":
          iconColor = "feedback.error.shape";
          IconToRender = /* @__PURE__ */React__default["default"].createElement(almaIcons.WarningBold, null);
          break;

        case "custom":
          IconToRender = supportIcon ? supportIcon : /* @__PURE__ */React__default["default"].createElement(almaIcons.AppBold, null);
          break;
      }

      if (IconToRender) {
        return /* @__PURE__ */React__default["default"].createElement(Icon, {
          color: iconColor,
          size: "md",
          sx: iconTypeStyle$1
        }, IconToRender);
      }

      return null;
    };

    return /* @__PURE__ */React__default["default"].createElement(Center, __spreadProps$j(__spreadValues$t({}, props), {
      ref: ref,
      sx: __spreadValues$t(__spreadValues$t({}, getContainerStyle$3(variant)), sx)
    }), renderToastTypeIcon(), title && /* @__PURE__ */React__default["default"].createElement(themeUi.Heading, {
      as: "h3",
      css: css$4(titleStyle)
    }, title), message && /* @__PURE__ */React__default["default"].createElement(Body, {
      sx: getMessageStyle$1(linkProps),
      variant: "sm"
    }, message), /* @__PURE__ */React__default["default"].createElement(ButtonIcon, {
      leadingIcon: /* @__PURE__ */React__default["default"].createElement(almaIcons.CloseBold, null),
      onClick: function onClick() {
        return onClose && onClose();
      },
      size: "sm",
      sx: closeButtonStyle
    }), linkProps && /* @__PURE__ */React__default["default"].createElement(LinkStandalone, {
      href: linkProps.href,
      label: linkProps.label,
      sx: linkStyle,
      target: linkProps.target,
      trailingIcon: linkProps.icon,
      variant: "sm"
    }));
  });

  var getMessageStyle = function getMessageStyle(actionButton) {
    var baseObject = {
      margin: 0,
      maxHeight: "96px",
      overflow: "auto",
      paddingY: "stack.quark",
      position: "relative"
    };

    if (actionButton) {
      baseObject["marginRight"] = "inline.xxxs";
    }

    return baseObject;
  };

  var iconTypeStyle = {
    marginRight: "inline.xxxs"
  };

  var getContentStyle = function getContentStyle(open, bottomDistance) {
    return {
      alignItems: "center",
      backgroundColor: "neutral.00",
      borderColor: "neutral.30",
      borderRadius: "xs",
      borderStyle: "solid",
      borderWidth: "hairline",
      bottom: open ? bottomDistance : -100,
      boxShadow: defaultTheme$3.shadows["02"],
      display: "flex",
      padding: "squish.nano",
      pointerEvents: "auto",
      position: "relative",
      transition: "bottom 0.3s ease-in"
    };
  };

  var getContainerStyle$1 = function getContainerStyle$1(zIndex) {
    return {
      "&.show": {
        visibility: "visible"
      },
      alignItems: "flex-end",
      bottom: 0,
      display: "flex",
      height: "100%",
      justifyContent: "center",
      left: 0,
      overflow: "hidden",
      pointerEvents: "none",
      position: "absolute",
      visibility: "hidden",
      width: "100%",
      zIndex: zIndex
    };
  };

  var __defProp$s = Object.defineProperty;
  var __defProps$i = Object.defineProperties;
  var __getOwnPropDescs$i = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$s = Object.getOwnPropertySymbols;
  var __hasOwnProp$s = Object.prototype.hasOwnProperty;
  var __propIsEnum$s = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$s = function __defNormalProp$s(obj, key, value) {
    return key in obj ? __defProp$s(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$s = function __spreadValues$s(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$s.call(b, prop)) __defNormalProp$s(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$s) {
      var _iterator63 = _createForOfIteratorHelper(__getOwnPropSymbols$s(b)),
          _step63;

      try {
        for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
          var prop = _step63.value;
          if (__propIsEnum$s.call(b, prop)) __defNormalProp$s(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator63.e(err);
      } finally {
        _iterator63.f();
      }
    }

    return a;
  };

  var __spreadProps$i = function __spreadProps$i(a, b) {
    return __defProps$i(a, __getOwnPropDescs$i(b));
  };

  var __objRest$l = function __objRest$l(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$s.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$s) {
      var _iterator64 = _createForOfIteratorHelper(__getOwnPropSymbols$s(source)),
          _step64;

      try {
        for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
          var prop = _step64.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$s.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator64.e(err);
      } finally {
        _iterator64.f();
      }
    }

    return target;
  };

  var Snackbar = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        actionButton = _b.actionButton,
        _b$bottomDistance = _b.bottomDistance,
        bottomDistance = _b$bottomDistance === void 0 ? 100 : _b$bottomDistance,
        _b$duration = _b.duration,
        duration = _b$duration === void 0 ? 3e3 : _b$duration,
        message = _b.message,
        onClose = _b.onClose,
        open = _b.open,
        sx = _b.sx,
        _b$variant7 = _b.variant,
        variant = _b$variant7 === void 0 ? "simple" : _b$variant7,
        supportIcon = _b.supportIcon,
        zIndex = _b.zIndex,
        otherProps = __objRest$l(_b, ["actionButton", "bottomDistance", "duration", "message", "onClose", "open", "sx", "variant", "supportIcon", "zIndex"]);

    var renderSnackbarTypeIcon = function renderSnackbarTypeIcon() {
      var iconColor = "";
      var IconToRender = null;

      switch (variant) {
        case "success":
          iconColor = "feedback.success.shape";
          IconToRender = /* @__PURE__ */React__default["default"].createElement(almaIcons.CheckroundBold, null);
          break;

        case "error":
          iconColor = "feedback.error.shape";
          IconToRender = /* @__PURE__ */React__default["default"].createElement(almaIcons.WarningBold, null);
          break;

        case "custom":
          IconToRender = supportIcon ? supportIcon : /* @__PURE__ */React__default["default"].createElement(almaIcons.AppBold, null);
          break;
      }

      if (IconToRender) {
        return /* @__PURE__ */React__default["default"].createElement(Icon, {
          color: iconColor,
          sx: iconTypeStyle
        }, IconToRender);
      }

      return null;
    };

    var openRef = React.useRef(false);
    React.useEffect(function () {
      var openTimeout;

      if (!openRef.current && open) {
        openTimeout = window.setTimeout(function () {
          onClose && onClose(false);
        }, duration);
      }

      if (openRef.current !== open) {
        openRef.current = open;
      }

      return function () {
        return clearTimeout(openTimeout);
      };
    });
    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$i(__spreadValues$s({
      sx: __spreadValues$s(__spreadValues$s({}, getContainerStyle$1(zIndex)), sx)
    }, otherProps), {
      className: open ? "show" : "",
      ref: ref
    }), /* @__PURE__ */React__default["default"].createElement(Center, {
      sx: getContentStyle(open, bottomDistance)
    }, renderSnackbarTypeIcon(), /* @__PURE__ */React__default["default"].createElement(Body, {
      sx: getMessageStyle(actionButton),
      variant: "sm"
    }, message), actionButton && /* @__PURE__ */React__default["default"].createElement(Button, {
      onClick: function onClick() {
        return actionButton.onClick && actionButton.onClick();
      },
      size: "sm",
      variant: "tertiary"
    }, actionButton.label)));
  });
  var __defProp$r = Object.defineProperty;
  var __defProps$h = Object.defineProperties;
  var __getOwnPropDescs$h = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$r = Object.getOwnPropertySymbols;
  var __hasOwnProp$r = Object.prototype.hasOwnProperty;
  var __propIsEnum$r = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$r = function __defNormalProp$r(obj, key, value) {
    return key in obj ? __defProp$r(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$r = function __spreadValues$r(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$r.call(b, prop)) __defNormalProp$r(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$r) {
      var _iterator65 = _createForOfIteratorHelper(__getOwnPropSymbols$r(b)),
          _step65;

      try {
        for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
          var prop = _step65.value;
          if (__propIsEnum$r.call(b, prop)) __defNormalProp$r(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator65.e(err);
      } finally {
        _iterator65.f();
      }
    }

    return a;
  };

  var __spreadProps$h = function __spreadProps$h(a, b) {
    return __defProps$h(a, __getOwnPropDescs$h(b));
  };

  var __objRest$k = function __objRest$k(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$r.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$r) {
      var _iterator66 = _createForOfIteratorHelper(__getOwnPropSymbols$r(source)),
          _step66;

      try {
        for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
          var prop = _step66.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$r.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator66.e(err);
      } finally {
        _iterator66.f();
      }
    }

    return target;
  };

  var headingVariantStyle = {
    lg: {
      fontSize: "xs"
    },
    md: {
      fontSize: "xxs",
      lineHeight: "tiny"
    },
    sm: {
      fontSize: "xxxs",
      letterSpacing: "standard",
      lineHeight: "distant"
    }
  };
  var TextInteraction = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        _b$variant8 = _b.variant,
        variant = _b$variant8 === void 0 ? "lg" : _b$variant8,
        props = __objRest$k(_b, ["brand", "variant"]);

    return /* @__PURE__ */React__default["default"].createElement(Typography, __spreadProps$h(__spreadValues$r({
      color: brand ? "interaction.inverse.blend.07" : "interaction.select.default",
      fontFamily: "base",
      fontWeight: "medium",
      letterSpacing: "standard",
      lineHeight: "superdistant",
      ref: ref
    }, props), {
      sx: __spreadValues$r(__spreadValues$r({}, headingVariantStyle[variant]), props.sx)
    }));
  });
  var __defProp$q = Object.defineProperty;
  var __getOwnPropSymbols$q = Object.getOwnPropertySymbols;
  var __hasOwnProp$q = Object.prototype.hasOwnProperty;
  var __propIsEnum$q = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$q = function __defNormalProp$q(obj, key, value) {
    return key in obj ? __defProp$q(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$q = function __spreadValues$q(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$q.call(b, prop)) __defNormalProp$q(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$q) {
      var _iterator67 = _createForOfIteratorHelper(__getOwnPropSymbols$q(b)),
          _step67;

      try {
        for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
          var prop = _step67.value;
          if (__propIsEnum$q.call(b, prop)) __defNormalProp$q(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator67.e(err);
      } finally {
        _iterator67.f();
      }
    }

    return a;
  };

  var getTabStyle = function getTabStyle(brand, disabled, active) {
    var getActiveStyle = function getActiveStyle(isActive) {
      if (isActive) {
        return {
          borderBottomColor: brand ? "interaction.on.brand.select.active" : "interaction.select.active",
          borderBottomWidth: "thin",
          color: brand ? "interaction.on.brand.select.active" : "interaction.select.active"
        };
      }

      return {};
    };

    var getDisabledStyle = function getDisabledStyle() {
      if (disabled) {
        return {
          borderBottomColor: "transparent",
          borderBottomStyle: "solid",
          borderBottomWidth: "thin",
          borderTopColor: "transparent",
          borderTopStyle: "solid",
          borderTopWidth: "thin",
          color: brand ? "typeface.on.brand.meld" : "typeface.meld",
          cursor: "not-allowed"
        };
      }

      return {
        ":active": __spreadValues$q({}, getActiveStyle(true)),
        ":focus:not(:active)": {
          borderColor: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
          borderStyle: "solid",
          borderWidth: "thin",
          color: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
          margin: -2
        },
        ":hover:not(:active)": {
          borderBottomColor: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
          borderBottomWidth: "thin",
          color: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus"
        }
      };
    };

    return __spreadValues$q(__spreadValues$q({
      borderBottomColor: brand ? "interaction.on.brand.blend.04" : "interaction.blend.04",
      borderBottomStyle: "solid",
      borderBottomWidth: "hairline",
      borderTopColor: "transparent",
      borderTopStyle: "solid",
      borderTopWidth: "thin",
      color: brand ? "interaction.on.brand.select.default" : "interaction.select.default",
      cursor: "pointer",
      display: "inline-block",
      margin: 0,
      padding: "inset.xs",
      textAlign: "center"
    }, getActiveStyle(active)), getDisabledStyle());
  };

  var getTabContained = function getTabContained(brand, disabled, active) {
    var getActiveStyle = function getActiveStyle(isActive) {
      if (isActive) {
        return {
          backgroundColor: "transparent",
          borderTopColor: brand ? "interaction.on.brand.select.active" : "interaction.select.active",
          borderTopWidth: "thin",
          color: brand ? "interaction.on.brand.select.active" : "interaction.select.active"
        };
      }

      return {};
    };

    var getDisabledStyle = function getDisabledStyle() {
      if (disabled) {
        return {
          backgroundColor: brand ? "interaction.on.brand.blend.01" : "interaction.blend.01",
          borderBottomColor: "transparent",
          borderBottomStyle: "solid",
          borderBottomWidth: "thin",
          borderTopColor: "transparent",
          borderTopStyle: "solid",
          borderTopWidth: "thin",
          color: brand ? "interaction.inverse.blend.05" : "typeface.meld",
          cursor: "not-allowed"
        };
      }

      return {
        ":active": __spreadValues$q({}, getActiveStyle(true)),
        ":focus:not(:active)": {
          backgroundColor: brand ? "interaction.on.brand.blend.02" : "interaction.blend.02",
          borderColor: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
          borderStyle: "solid",
          borderWidth: "thin",
          color: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
          margin: -2
        },
        ":hover:not(:active)": {
          backgroundColor: brand ? "interaction.on.brand.blend.02" : "interaction.blend.02",
          borderTopColor: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
          color: brand ? "interaction.inverse.blend.08" : "interaction.select.focus"
        }
      };
    };

    return __spreadValues$q(__spreadValues$q({
      backgroundColor: brand ? "interaction.on.brand.blend.01" : "interaction.blend.01",
      borderBottomColor: "transparent",
      borderBottomStyle: "solid",
      borderBottomWidth: "thin",
      borderTopColor: "transparent",
      borderTopStyle: "solid",
      borderTopWidth: "thin",
      color: brand ? "interaction.on.brand.select.default" : "interaction.select.default",
      cursor: "pointer",
      display: "inline-block",
      margin: 0,
      padding: "inset.xs",
      textAlign: "center"
    }, getActiveStyle(active)), getDisabledStyle());
  };

  var getTabContainerStyle = function getTabContainerStyle(position) {
    var getPosition = function getPosition() {
      switch (position) {
        case "left":
          return "flex-start";

        case "right":
          return "flex-end";

        case "center":
          return "center";

        default:
          return "center";
      }
    };

    return {
      alignItems: "center",
      display: "flex",
      justifyContent: getPosition()
    };
  };

  var __defProp$p = Object.defineProperty;
  var __defProps$g = Object.defineProperties;
  var __getOwnPropDescs$g = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$p = Object.getOwnPropertySymbols;
  var __hasOwnProp$p = Object.prototype.hasOwnProperty;
  var __propIsEnum$p = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$p = function __defNormalProp$p(obj, key, value) {
    return key in obj ? __defProp$p(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$p = function __spreadValues$p(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$p.call(b, prop)) __defNormalProp$p(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$p) {
      var _iterator68 = _createForOfIteratorHelper(__getOwnPropSymbols$p(b)),
          _step68;

      try {
        for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
          var prop = _step68.value;
          if (__propIsEnum$p.call(b, prop)) __defNormalProp$p(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator68.e(err);
      } finally {
        _iterator68.f();
      }
    }

    return a;
  };

  var __spreadProps$g = function __spreadProps$g(a, b) {
    return __defProps$g(a, __getOwnPropDescs$g(b));
  };

  var __objRest$j = function __objRest$j(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$p.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$p) {
      var _iterator69 = _createForOfIteratorHelper(__getOwnPropSymbols$p(source)),
          _step69;

      try {
        for (_iterator69.s(); !(_step69 = _iterator69.n()).done;) {
          var prop = _step69.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$p.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator69.e(err);
      } finally {
        _iterator69.f();
      }
    }

    return target;
  };

  var Tab = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        active = _b.active,
        brand = _b.brand,
        contained = _b.contained,
        sx = _b.sx,
        disabled = _b.disabled,
        label = _b.label,
        handleClick = _b.handleClick,
        tabName = _b.tabName,
        props = __objRest$j(_b, ["active", "brand", "contained", "sx", "disabled", "label", "handleClick", "tabName"]);

    var tabStyle = contained ? __spreadValues$p({}, getTabContained(brand, disabled, active)) : __spreadValues$p({}, getTabStyle(brand, disabled, active));

    var setActive = function setActive(evt) {
      evt.preventDefault();

      if (tabName && handleClick && !disabled) {
        handleClick(tabName, evt);
        return evt.currentTarget.blur();
      }
    };

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$g(__spreadValues$p({}, props), {
      ref: ref
    }), /* @__PURE__ */React__default["default"].createElement(TextInteraction, {
      "aria-controls": String(tabName),
      "aria-selected": active,
      brand: brand,
      onClick: setActive,
      sx: __spreadValues$p(__spreadValues$p({}, tabStyle), sx),
      tabIndex: 0,
      variant: "md"
    }, label));
  });
  var TabContainer = React__default["default"].forwardRef(function (_c, ref) {
    var _d = _c,
        position = _d.position,
        props = __objRest$j(_d, ["position"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$g(__spreadValues$p({}, props), {
      ref: ref,
      sx: getTabContainerStyle(position)
    }));
  });
  var TabPanesContainer = React__default["default"].forwardRef(function (_ref31, ref) {
    var _ref31$activeTab = _ref31.activeTab,
        activeTab = _ref31$activeTab === void 0 ? "" : _ref31$activeTab,
        children = _ref31.children;
    var childWithProps = React__default["default"].Children.map(children, function (child) {
      var _a;

      if (!React__default["default"].isValidElement(child)) {
        return child;
      }

      var isTabSelected = Boolean(activeTab) && activeTab === ((_a = child == null ? void 0 : child.props) == null ? void 0 : _a.tabName);
      return React__default["default"].cloneElement(child, {
        ref: ref,
        selected: isTabSelected
      });
    });
    return /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, childWithProps);
  });
  var TabPane = React__default["default"].forwardRef(function (_e, ref) {
    var _f = _e,
        _f$selected = _f.selected,
        selected = _f$selected === void 0 ? false : _f$selected,
        _f$forceRerender = _f.forceRerender,
        forceRerender = _f$forceRerender === void 0 ? false : _f$forceRerender,
        _f$tabName = _f.tabName,
        tabName = _f$tabName === void 0 ? "" : _f$tabName,
        props = __objRest$j(_f, ["selected", "forceRerender", "tabName"]);

    var _React$useState21 = React.useState(false),
        _React$useState22 = _slicedToArray(_React$useState21, 2),
        wasSelected = _React$useState22[0],
        setSelectedSituation = _React$useState22[1];

    React.useLayoutEffect(function () {
      if (!wasSelected && selected) {
        setSelectedSituation(selected);
      }
    }, [wasSelected, selected, forceRerender]);
    var shouldRender = forceRerender ? selected : wasSelected;

    if (!shouldRender) {
      return null;
    }

    return selected ? /* @__PURE__ */React__default["default"].createElement(Box, __spreadValues$p({
      "aria-labelledby": tabName,
      ref: ref,
      role: "tabpanel",
      tabIndex: 0
    }, props)) : null;
  });

  var getIconColor = function getIconColor(_ref32, suffix) {
    var brand = _ref32.brand,
        disabled = _ref32.disabled;

    if (disabled) {
      return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
    }

    return brand ? "support.on.brand.".concat(suffix) : "support.".concat(suffix);
  };

  var getContainerStyle = function getContainerStyle(props) {
    var brand = props.brand,
        disabled = props.disabled;
    return {
      "& > *": {
        cursor: disabled ? "not-allowed" : "auto"
      },
      "&:active": {
        bg: brand ? "interaction.on.brand.blend.02" : "interaction.blend.02"
      },
      "&:focus:not(:active)": {
        bg: brand ? "interaction.on.brand.blend.01" : "interaction.blend.01",
        borderColor: brand ? "interaction.on.brand.blend.02" : "interaction.blend.08",
        borderStyle: "solid",
        borderWidth: "thin"
      },
      "&:hover:not(:active)": {
        bg: brand ? "interaction.on.brand.blend.01" : "interaction.blend.01",
        "div span > svg": {
          color: getIconColor(props, "02")
        }
      },
      display: "flex",
      "div span > svg": {
        color: getIconColor(props, "01")
      },
      flexDirection: "column",
      maxWidth: 360,
      minWidth: 320,
      transition: "all 300ms ease-in-out"
    };
  };

  var wrapperStyle = {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    lineHeight: "20%",
    width: "100%"
  };

  var getTextDisabledColor = function getTextDisabledColor(_ref33) {
    var brand = _ref33.brand,
        disabled = _ref33.disabled;

    if (disabled) {
      return {
        color: brand ? "typeface.on.brand.meld" : "typeface.meld"
      };
    }

    return {
      color: ""
    };
  };

  var __defProp$o = Object.defineProperty;
  var __getOwnPropSymbols$o = Object.getOwnPropertySymbols;
  var __hasOwnProp$o = Object.prototype.hasOwnProperty;
  var __propIsEnum$o = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$o = function __defNormalProp$o(obj, key, value) {
    return key in obj ? __defProp$o(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$o = function __spreadValues$o(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$o.call(b, prop)) __defNormalProp$o(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$o) {
      var _iterator70 = _createForOfIteratorHelper(__getOwnPropSymbols$o(b)),
          _step70;

      try {
        for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
          var prop = _step70.value;
          if (__propIsEnum$o.call(b, prop)) __defNormalProp$o(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator70.e(err);
      } finally {
        _iterator70.f();
      }
    }

    return a;
  };

  var __objRest$i = function __objRest$i(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$o.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$o) {
      var _iterator71 = _createForOfIteratorHelper(__getOwnPropSymbols$o(source)),
          _step71;

      try {
        for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
          var prop = _step71.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$o.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator71.e(err);
      } finally {
        _iterator71.f();
      }
    }

    return target;
  };

  var renderLabel = function renderLabel(props) {
    var brand = props.brand,
        center = props.center,
        children = props.children,
        labelText = props.labelText;
    return /* @__PURE__ */React__default["default"].createElement(Action, {
      brand: brand,
      fontWeight: "medium",
      lineHeight: "superdistant",
      sx: getTextDisabledColor(props)
    }, center || children, labelText);
  };

  var renderDate = function renderDate(props) {
    var brand = props.brand,
        dateText = props.dateText;
    return dateText ? /* @__PURE__ */React__default["default"].createElement(Body, {
      brand: brand,
      lineHeight: 0,
      sx: getTextDisabledColor(props),
      variant: "sm"
    }, dateText) : null;
  };

  var renderBodyText = function renderBodyText(props) {
    var brand = props.brand,
        bodyText = props.bodyText,
        leadingIcon = props.leadingIcon;
    return bodyText ? /* @__PURE__ */React__default["default"].createElement(Box, {
      p: 0,
      pl: leadingIcon ? "inline.xs" : "",
      pt: "inline.nano"
    }, /* @__PURE__ */React__default["default"].createElement(Body, {
      brand: brand,
      sx: getTextDisabledColor(props),
      variant: "sm"
    }, bodyText)) : null;
  };

  var ListItem = React__default["default"].forwardRef(function (props, ref) {
    var _a = props,
        children = _a.children,
        center = _a.center,
        dividerColor = _a.dividerColor,
        left = _a.left,
        leadingIcon = _a.leadingIcon,
        bodyText = _a.bodyText,
        brand = _a.brand,
        labelText = _a.labelText,
        dateText = _a.dateText,
        noDivider = _a.noDivider,
        _a$insetSpace = _a.insetSpace,
        insetSpace = _a$insetSpace === void 0 ? "inset.xs" : _a$insetSpace,
        disabled = _a.disabled,
        rest = __objRest$i(_a, ["children", "center", "dividerColor", "left", "leadingIcon", "bodyText", "brand", "labelText", "dateText", "noDivider", "insetSpace", "disabled"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadValues$o({
      as: "li",
      p: 0,
      sx: getContainerStyle(props)
    }, rest), /* @__PURE__ */React__default["default"].createElement(Box, {
      p: insetSpace,
      ref: ref
    }, /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: wrapperStyle
    }, left || leadingIcon && /* @__PURE__ */React__default["default"].createElement(Icon, {
      mr: "inline.nano"
    }, leadingIcon), renderLabel(props), /* @__PURE__ */React__default["default"].createElement(Spacer, null), renderDate(props)), renderBodyText(props)), !noDivider && /* @__PURE__ */React__default["default"].createElement(Divider, {
      brand: brand,
      sx: dividerColor ? {
        bg: dividerColor
      } : void 0
    }));
  });
  var __defProp$n = Object.defineProperty;
  var __getOwnPropSymbols$n = Object.getOwnPropertySymbols;
  var __hasOwnProp$n = Object.prototype.hasOwnProperty;
  var __propIsEnum$n = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$n = function __defNormalProp$n(obj, key, value) {
    return key in obj ? __defProp$n(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$n = function __spreadValues$n(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$n.call(b, prop)) __defNormalProp$n(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$n) {
      var _iterator72 = _createForOfIteratorHelper(__getOwnPropSymbols$n(b)),
          _step72;

      try {
        for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
          var prop = _step72.value;
          if (__propIsEnum$n.call(b, prop)) __defNormalProp$n(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator72.e(err);
      } finally {
        _iterator72.f();
      }
    }

    return a;
  };

  var getLabelStyle = function getLabelStyle(brand, disabled) {
    var getFontColor = function getFontColor() {
      if (disabled) {
        return brand ? "typeface.on.brand.meld" : "typeface.meld";
      }

      return "";
    };

    return {
      color: getFontColor(),
      margin: 0,
      paddingLeft: "inline.nano",
      textAlign: "left"
    };
  };

  var getCheckboxStyle = function getCheckboxStyle(brand, checked, disabled) {
    var getBackgroundColor = function getBackgroundColor() {
      if (disabled) {
        return brand ? "interaction.inverse.blend.04" : "interaction.blend.03";
      } else if (checked) {
        return brand ? "interaction.inverse.blend.07" : "interaction.select.active";
      }

      return brand ? "interaction.inverse.blend.07" : "interaction.select.default";
    };

    var getStateBackgroundColor = function getStateBackgroundColor() {
      if (checked) {
        return brand ? "interaction.inverse.blend.08" : "interaction.select.active";
      }

      return brand ? "interaction.inverse.blend.08" : "interaction.select.focus";
    };

    return {
      ":active:not(:disabled), :focus:not(:disabled), :hover:not(:disabled)": {
        backgroundColor: getStateBackgroundColor()
      },
      backgroundColor: getBackgroundColor(),
      border: "none",
      borderRadius: "pill",
      height: "100%",
      position: "relative",
      width: "100%"
    };
  };

  var getSliderStyle = function getSliderStyle(brand, checked, hovered, focused, active, disabled) {
    var getPositionStyle = function getPositionStyle() {
      if (checked) {
        return {
          left: "auto",
          right: "inset.quark"
        };
      }

      return {
        left: "inset.quark",
        right: "auto"
      };
    };

    var getStatusStyle = function getStatusStyle() {
      if (active) {
        return {
          backgroundColor: brand ? "interaction.inverse.blend.04" : "interaction.blend.03"
        };
      } else if (focused) {
        return {
          borderColor: brand ? "interaction.inverse.blend.05" : "interaction.blend.05"
        };
      }

      return {};
    };

    var getBackgroundColor = function getBackgroundColor() {
      if (disabled) {
        return brand ? "neutral.inverse.on.brand.30" : "interaction.inverse.blend.07";
      }

      return brand ? "interaction.accent.01" : "neutral.00";
    };

    return __spreadValues$n({
      "::before": __spreadValues$n({
        backgroundColor: brand ? "interaction.inverse.blend.03" : "interaction.blend.02",
        borderColor: "transparent",
        borderRadius: "circle",
        borderStyle: "solid",
        borderWidth: "thin",
        content: hovered || focused ? "''" : void 0,
        height: 40,
        left: "calc(50% - 22px)",
        position: "absolute",
        top: "calc(50% - 22px)",
        width: 40,
        zIndex: -1
      }, getStatusStyle()),
      backgroundColor: getBackgroundColor(),
      borderRadius: "circle",
      bottom: "inset.quark",
      boxShadow: "01",
      height: 16,
      pointerEvents: "none",
      position: "absolute",
      top: "inset.quark",
      width: 16
    }, getPositionStyle());
  };

  var __defProp$m = Object.defineProperty;
  var __defProps$f = Object.defineProperties;
  var __getOwnPropDescs$f = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$m = Object.getOwnPropertySymbols;
  var __hasOwnProp$m = Object.prototype.hasOwnProperty;
  var __propIsEnum$m = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$m = function __defNormalProp$m(obj, key, value) {
    return key in obj ? __defProp$m(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$m = function __spreadValues$m(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$m.call(b, prop)) __defNormalProp$m(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$m) {
      var _iterator73 = _createForOfIteratorHelper(__getOwnPropSymbols$m(b)),
          _step73;

      try {
        for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
          var prop = _step73.value;
          if (__propIsEnum$m.call(b, prop)) __defNormalProp$m(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator73.e(err);
      } finally {
        _iterator73.f();
      }
    }

    return a;
  };

  var __spreadProps$f = function __spreadProps$f(a, b) {
    return __defProps$f(a, __getOwnPropDescs$f(b));
  };

  var __objRest$h = function __objRest$h(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$m.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$m) {
      var _iterator74 = _createForOfIteratorHelper(__getOwnPropSymbols$m(source)),
          _step74;

      try {
        for (_iterator74.s(); !(_step74 = _iterator74.n()).done;) {
          var prop = _step74.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$m.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator74.e(err);
      } finally {
        _iterator74.f();
      }
    }

    return target;
  };

  var Switch = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        _b$defaultChecked = _b.defaultChecked,
        defaultChecked = _b$defaultChecked === void 0 ? false : _b$defaultChecked,
        _b$disabled2 = _b.disabled,
        disabled = _b$disabled2 === void 0 ? false : _b$disabled2,
        id = _b.id,
        _b$label = _b.label,
        label = _b$label === void 0 ? "" : _b$label,
        props = __objRest$h(_b, ["brand", "defaultChecked", "disabled", "id", "label"]);

    var _React$useState23 = React.useState(defaultChecked),
        _React$useState24 = _slicedToArray(_React$useState23, 2),
        checked = _React$useState24[0],
        setChecked = _React$useState24[1];

    var _React$useState25 = React.useState(false),
        _React$useState26 = _slicedToArray(_React$useState25, 2),
        hovered = _React$useState26[0],
        setHovered = _React$useState26[1];

    var _React$useState27 = React.useState(false),
        _React$useState28 = _slicedToArray(_React$useState27, 2),
        focused = _React$useState28[0],
        setFocused = _React$useState28[1];

    var _React$useState29 = React.useState(false),
        _React$useState30 = _slicedToArray(_React$useState29, 2),
        active = _React$useState30[0],
        setActive = _React$useState30[1];

    var handleOnClick = function handleOnClick(evt) {
      evt.preventDefault();

      if (!disabled) {
        setChecked(!checked);
        evt.currentTarget.blur();
      }
    };

    return /* @__PURE__ */React__default["default"].createElement(themeUi.Label, {
      htmlFor: id,
      onMouseDown: function onMouseDown() {
        return !disabled && setActive(true);
      },
      onMouseEnter: function onMouseEnter() {
        return !disabled && setHovered(true);
      },
      onMouseLeave: function onMouseLeave() {
        return !disabled && setHovered(false);
      },
      onMouseUp: function onMouseUp() {
        return !disabled && setActive(false);
      },
      sx: {
        display: "flex"
      },
      tabIndex: -1
    }, /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: {
        height: 24,
        position: "relative",
        width: 48
      }
    }, /* @__PURE__ */React__default["default"].createElement(themeUi.Input, __spreadProps$f(__spreadValues$m({}, props), {
      "aria-checked": checked,
      "aria-readonly": disabled,
      defaultChecked: checked,
      disabled: disabled,
      id: id,
      onBlur: function onBlur() {
        return !disabled && setFocused(false);
      },
      onClick: handleOnClick,
      onFocus: function onFocus() {
        return !disabled && setFocused(true);
      },
      ref: ref,
      role: "switch",
      sx: getCheckboxStyle(brand, checked, disabled),
      tabIndex: 0,
      type: "checkbox"
    })), /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: getSliderStyle(brand, checked, hovered, focused, active, disabled)
    })), /* @__PURE__ */React__default["default"].createElement(Body, {
      inverse: brand,
      sx: getLabelStyle(brand, disabled),
      variant: "lg"
    }, label));
  });

  function objectFilter(object, fn) {
    var result = {};
    Object.keys(object).forEach(function (key) {
      var value = object[key];
      var shouldPass = fn(value, key, object);

      if (shouldPass) {
        result[key] = value;
      }
    });
    return result;
  }

  var filterUndefined = function filterUndefined(object) {
    return objectFilter(object, function (val) {
      return val !== null && val !== void 0;
    });
  };

  var getGridStyle = function getGridStyle() {
    return {
      height: "100%",
      position: "relative",
      width: "100%"
    };
  };

  var mapResponsive = function mapResponsive(prop, mapperFn) {
    if (Array.isArray(prop)) {
      return prop.map(function (item) {
        if (item === null) {
          return null;
        }

        return mapperFn(item);
      });
    } else if (prop) {
      return mapperFn(prop);
    }

    return null;
  };

  var getSpan = function getSpan(value) {
    return mapResponsive(value, function (prop) {
      return prop === "auto" ? "auto" : "span ".concat(prop, "/span ").concat(prop);
    });
  };

  var getGridItemStyle = function getGridItemStyle(props) {
    return filterUndefined({
      gridColumn: getSpan(props.colSpan),
      gridColumnEnd: props.colEnd,
      gridColumnStart: props.colStart,
      gridRow: getSpan(props.rowSpan),
      gridRowEnd: props.rowEnd,
      gridRowStart: props.rowStart
    });
  };

  var __defProp$l = Object.defineProperty;
  var __defProps$e = Object.defineProperties;
  var __getOwnPropDescs$e = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$l = Object.getOwnPropertySymbols;
  var __hasOwnProp$l = Object.prototype.hasOwnProperty;
  var __propIsEnum$l = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$l = function __defNormalProp$l(obj, key, value) {
    return key in obj ? __defProp$l(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$l = function __spreadValues$l(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$l.call(b, prop)) __defNormalProp$l(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$l) {
      var _iterator75 = _createForOfIteratorHelper(__getOwnPropSymbols$l(b)),
          _step75;

      try {
        for (_iterator75.s(); !(_step75 = _iterator75.n()).done;) {
          var prop = _step75.value;
          if (__propIsEnum$l.call(b, prop)) __defNormalProp$l(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator75.e(err);
      } finally {
        _iterator75.f();
      }
    }

    return a;
  };

  var __spreadProps$e = function __spreadProps$e(a, b) {
    return __defProps$e(a, __getOwnPropDescs$e(b));
  };

  var __objRest$g = function __objRest$g(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$l.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$l) {
      var _iterator76 = _createForOfIteratorHelper(__getOwnPropSymbols$l(source)),
          _step76;

      try {
        for (_iterator76.s(); !(_step76 = _iterator76.n()).done;) {
          var prop = _step76.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$l.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator76.e(err);
      } finally {
        _iterator76.f();
      }
    }

    return target;
  };

  var StyledGrid = styled__default["default"](themeUi.Grid)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n"])), GRID);
  var Grid = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        children = _b.children,
        props = __objRest$g(_b, ["children"]);

    return /* @__PURE__ */React__default["default"].createElement(StyledGrid, __spreadProps$e(__spreadValues$l({
      columns: [6, 8, 8, 12],
      gap: ["inline.nano", "inline.xxxs", "inline.xxs", "inline.xxs"],
      paddingX: ["inline.xxxs", "inline.xxxs", "inline.xxs", "inline.xxs"]
    }, props), {
      ref: ref,
      sx: __spreadValues$l(__spreadValues$l({}, getGridStyle()), props.sx)
    }), children);
  });
  var GridItem = React__default["default"].forwardRef(function (_c, ref) {
    var _d = _c,
        colSpan = _d.colSpan,
        rowSpan = _d.rowSpan,
        colStart = _d.colStart,
        colEnd = _d.colEnd,
        rowStart = _d.rowStart,
        rowEnd = _d.rowEnd,
        children = _d.children,
        props = __objRest$g(_d, ["colSpan", "rowSpan", "colStart", "colEnd", "rowStart", "rowEnd", "children"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$e(__spreadValues$l({}, props), {
      ref: ref,
      sx: __spreadValues$l(__spreadValues$l({}, getGridItemStyle({
        colEnd: colEnd,
        colSpan: colSpan,
        colStart: colStart,
        rowEnd: rowEnd,
        rowSpan: rowSpan,
        rowStart: rowStart
      })), props.sx)
    }), children);
  });

  var getBreadcrumbStyle = function getBreadcrumbStyle(onClick) {
    return {
      cursor: onClick ? "pointer" : "default",
      margin: 0,
      padding: "inset.quark"
    };
  };

  var __defProp$k = Object.defineProperty;
  var __defProps$d = Object.defineProperties;
  var __getOwnPropDescs$d = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$k = Object.getOwnPropertySymbols;
  var __hasOwnProp$k = Object.prototype.hasOwnProperty;
  var __propIsEnum$k = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$k = function __defNormalProp$k(obj, key, value) {
    return key in obj ? __defProp$k(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$k = function __spreadValues$k(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$k.call(b, prop)) __defNormalProp$k(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$k) {
      var _iterator77 = _createForOfIteratorHelper(__getOwnPropSymbols$k(b)),
          _step77;

      try {
        for (_iterator77.s(); !(_step77 = _iterator77.n()).done;) {
          var prop = _step77.value;
          if (__propIsEnum$k.call(b, prop)) __defNormalProp$k(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator77.e(err);
      } finally {
        _iterator77.f();
      }
    }

    return a;
  };

  var __spreadProps$d = function __spreadProps$d(a, b) {
    return __defProps$d(a, __getOwnPropDescs$d(b));
  };

  var __objRest$f = function __objRest$f(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$k.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$k) {
      var _iterator78 = _createForOfIteratorHelper(__getOwnPropSymbols$k(source)),
          _step78;

      try {
        for (_iterator78.s(); !(_step78 = _iterator78.n()).done;) {
          var prop = _step78.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$k.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator78.e(err);
      } finally {
        _iterator78.f();
      }
    }

    return target;
  };

  var Breadcrumb = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        index = _b.index,
        isCurrentIndex = _b.isCurrentIndex,
        label = _b.label,
        handleClick = _b.handleClick,
        sx = _b.sx,
        props = __objRest$f(_b, ["brand", "index", "isCurrentIndex", "label", "handleClick", "sx"]);

    var setActive = function setActive() {
      handleClick && handleClick(index);
    };

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadValues$k({
      onClick: function onClick(e) {
        setActive();

        if (props.onClick) {
          props.onClick(e);
        }
      },
      sx: __spreadValues$k(__spreadValues$k({}, getBreadcrumbStyle(!!handleClick)), sx)
    }, props), /* @__PURE__ */React__default["default"].createElement(LinkStandalone, {
      "aria-current": isCurrentIndex,
      "aria-label": label,
      brand: brand,
      label: label,
      ref: ref,
      variant: "sm"
    }));
  });
  var BreadcrumbContainer = React__default["default"].forwardRef(function (_c, ref) {
    var _d = _c,
        activeIndex = _d.activeIndex,
        brand = _d.brand,
        children = _d.children,
        props = __objRest$f(_d, ["activeIndex", "brand", "children"]);

    var renderChildrens = function renderChildrens() {
      if (Array.isArray(children)) {
        var renderSeparator = function renderSeparator(canRender, idx) {
          return canRender && /* @__PURE__ */React__default["default"].createElement(Box, {
            height: 16,
            key: "".concat(idx, "-s"),
            ml: "inline.nano",
            mr: "inline.nano"
          }, /* @__PURE__ */React__default["default"].createElement(Divider, {
            brand: brand,
            variant: "vertical"
          }));
        };

        return children.map(function (ChildrenItem, idx) {
          if (idx > activeIndex) {
            return null;
          }

          return [renderSeparator(idx > 0, idx), ChildrenItem];
        });
      }

      return children;
    };

    return /* @__PURE__ */React__default["default"].createElement(Flex, __spreadProps$d(__spreadValues$k({
      alignItems: "center",
      justifyContent: "center",
      tabIndex: 0
    }, props), {
      ref: ref
    }), renderChildrens());
  });

  var getStepperStyle = function getStepperStyle(active, brand) {
    var getBackgroundColor = function getBackgroundColor() {
      if (active) {
        return brand ? "interaction.on.brand.accent.01" : "interaction.accent.01";
      }

      return brand ? "interaction.on.brand.blend.06" : "interaction.blend.06";
    };

    return {
      backgroundColor: getBackgroundColor(),
      borderRadius: active ? "pill" : "circle",
      cursor: active ? "default" : "pointer",
      height: 8,
      transition: "width 0.2s ease-in, border-radius 0.2s ease-in",
      width: active ? 24 : 8
    };
  };

  var __defProp$j = Object.defineProperty;
  var __defProps$c = Object.defineProperties;
  var __getOwnPropDescs$c = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$j = Object.getOwnPropertySymbols;
  var __hasOwnProp$j = Object.prototype.hasOwnProperty;
  var __propIsEnum$j = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$j = function __defNormalProp$j(obj, key, value) {
    return key in obj ? __defProp$j(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$j = function __spreadValues$j(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$j.call(b, prop)) __defNormalProp$j(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$j) {
      var _iterator79 = _createForOfIteratorHelper(__getOwnPropSymbols$j(b)),
          _step79;

      try {
        for (_iterator79.s(); !(_step79 = _iterator79.n()).done;) {
          var prop = _step79.value;
          if (__propIsEnum$j.call(b, prop)) __defNormalProp$j(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator79.e(err);
      } finally {
        _iterator79.f();
      }
    }

    return a;
  };

  var __spreadProps$c = function __spreadProps$c(a, b) {
    return __defProps$c(a, __getOwnPropDescs$c(b));
  };

  var __objRest$e = function __objRest$e(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$j.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$j) {
      var _iterator80 = _createForOfIteratorHelper(__getOwnPropSymbols$j(source)),
          _step80;

      try {
        for (_iterator80.s(); !(_step80 = _iterator80.n()).done;) {
          var prop = _step80.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$j.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator80.e(err);
      } finally {
        _iterator80.f();
      }
    }

    return target;
  };

  var Stepper = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        active = _b.active,
        brand = _b.brand,
        index = _b.index,
        sx = _b.sx,
        props = __objRest$e(_b, ["active", "brand", "index", "sx"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$c(__spreadValues$j({}, props), {
      "aria-expanded": active,
      ref: ref,
      sx: __spreadValues$j({
        cursor: active ? "default" : "pointer",
        padding: "inline.quark"
      }, sx)
    }), /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: __spreadValues$j(__spreadValues$j({}, getStepperStyle(active, brand)), sx)
    }));
  });
  var StepperContainer = React__default["default"].forwardRef(function (_ref34, ref) {
    var children = _ref34.children;
    return /* @__PURE__ */React__default["default"].createElement(Flex, {
      alignItems: "center",
      justifyContent: "center",
      ref: ref
    }, children);
  });

  var getOverlayStyle = function getOverlayStyle(variant, zIndex) {
    return {
      backgroundColor: "interaction.blend.05",
      height: variant === "screen" ? "100vh" : "100%",
      left: 0,
      position: variant === "screen" ? "fixed" : "absolute",
      top: 0,
      width: variant === "screen" ? "100vw" : "100%",
      zIndex: zIndex
    };
  };

  var __defProp$i = Object.defineProperty;
  var __defProps$b = Object.defineProperties;
  var __getOwnPropDescs$b = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$i = Object.getOwnPropertySymbols;
  var __hasOwnProp$i = Object.prototype.hasOwnProperty;
  var __propIsEnum$i = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$i = function __defNormalProp$i(obj, key, value) {
    return key in obj ? __defProp$i(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$i = function __spreadValues$i(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$i.call(b, prop)) __defNormalProp$i(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$i) {
      var _iterator81 = _createForOfIteratorHelper(__getOwnPropSymbols$i(b)),
          _step81;

      try {
        for (_iterator81.s(); !(_step81 = _iterator81.n()).done;) {
          var prop = _step81.value;
          if (__propIsEnum$i.call(b, prop)) __defNormalProp$i(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator81.e(err);
      } finally {
        _iterator81.f();
      }
    }

    return a;
  };

  var __spreadProps$b = function __spreadProps$b(a, b) {
    return __defProps$b(a, __getOwnPropDescs$b(b));
  };

  var __objRest$d = function __objRest$d(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$i.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$i) {
      var _iterator82 = _createForOfIteratorHelper(__getOwnPropSymbols$i(source)),
          _step82;

      try {
        for (_iterator82.s(); !(_step82 = _iterator82.n()).done;) {
          var prop = _step82.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$i.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator82.e(err);
      } finally {
        _iterator82.f();
      }
    }

    return target;
  };

  var Overlay = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        _b$variant9 = _b.variant,
        variant = _b$variant9 === void 0 ? "screen" : _b$variant9,
        _b$zIndex = _b.zIndex,
        zIndex = _b$zIndex === void 0 ? 1 : _b$zIndex,
        props = __objRest$d(_b, ["variant", "zIndex"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$b(__spreadValues$i({}, props), {
      ref: ref,
      sx: __spreadValues$i(__spreadValues$i({}, getOverlayStyle(variant, zIndex)), props.sx)
    }));
  });

  var getBasicChipStyle = function getBasicChipStyle(variant) {
    return {
      alignItems: "center",
      borderRadius: "pill",
      borderStyle: "solid",
      cursor: "pointer",
      display: "flex",
      height: variant === "lg" ? 32 : 24,
      paddingLeft: "inline.nano",
      position: "relative",
      width: "max-content"
    };
  };

  var getChipTextStyle = function getChipTextStyle(staticText) {
    return {
      color: "inherit",
      paddingBottom: staticText ? "inline.quark" : "stack.nano",
      paddingLeft: staticText ? void 0 : "inline.quark",
      paddingRight: staticText ? void 0 : "inline.quark",
      paddingTop: staticText ? "inline.quark" : "stack.nano"
    };
  };

  var __defProp$h = Object.defineProperty;
  var __defProps$a = Object.defineProperties;
  var __getOwnPropDescs$a = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$h = Object.getOwnPropertySymbols;
  var __hasOwnProp$h = Object.prototype.hasOwnProperty;
  var __propIsEnum$h = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$h = function __defNormalProp$h(obj, key, value) {
    return key in obj ? __defProp$h(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$h = function __spreadValues$h(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$h.call(b, prop)) __defNormalProp$h(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$h) {
      var _iterator83 = _createForOfIteratorHelper(__getOwnPropSymbols$h(b)),
          _step83;

      try {
        for (_iterator83.s(); !(_step83 = _iterator83.n()).done;) {
          var prop = _step83.value;
          if (__propIsEnum$h.call(b, prop)) __defNormalProp$h(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator83.e(err);
      } finally {
        _iterator83.f();
      }
    }

    return a;
  };

  var __spreadProps$a = function __spreadProps$a(a, b) {
    return __defProps$a(a, __getOwnPropDescs$a(b));
  };

  var getChipInputContainerStyle = function getChipInputContainerStyle(brand, variant, hover, focus, active, trailingFocus) {
    var getBackgroundColor = function getBackgroundColor() {
      if (active) {
        return brand ? "interaction.on.brand.blend.03" : "interaction.blend.03";
      } else if (hover || focus) {
        return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
      }

      return brand ? "interaction.on.brand.blend.01" : "interaction.blend.01";
    };

    var getColor = function getColor() {
      if (hover || focus || trailingFocus) {
        return brand ? "typeface.on.brand.strong" : "typeface.strong";
      }

      return brand ? "typeface.on.brand.pure" : "typeface.pure";
    };

    return __spreadProps$a(__spreadValues$h({}, getBasicChipStyle(variant)), {
      backgroundColor: getBackgroundColor(),
      borderColor: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
      borderWidth: focus ? "thin" : void 0,
      color: getColor()
    });
  };

  var getChipTrailingStyle = function getChipTrailingStyle(brand, variant, hover, focus, active) {
    var getBackgroundColor = function getBackgroundColor() {
      if (active) {
        return brand ? "interaction.on.brand.blend.03" : "interaction.blend.03";
      } else if (hover) {
        return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
      }

      return "transparent";
    };

    var getBorderColor = function getBorderColor() {
      if (focus) {
        return brand ? "interaction.on.brand.select.focus" : "interaction.select.focus";
      }

      return "transparent";
    };

    return {
      backgroundColor: getBackgroundColor(),
      borderColor: getBorderColor(),
      borderRadius: "circle",
      borderStyle: "solid",
      borderWidth: "thin",
      height: variant === "lg" ? 32 : 24,
      margin: 0,
      width: variant === "lg" ? 32 : 24
    };
  };

  var __defProp$g = Object.defineProperty;
  var __defProps$9 = Object.defineProperties;
  var __getOwnPropDescs$9 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$g = Object.getOwnPropertySymbols;
  var __hasOwnProp$g = Object.prototype.hasOwnProperty;
  var __propIsEnum$g = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$g = function __defNormalProp$g(obj, key, value) {
    return key in obj ? __defProp$g(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$g = function __spreadValues$g(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$g.call(b, prop)) __defNormalProp$g(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$g) {
      var _iterator84 = _createForOfIteratorHelper(__getOwnPropSymbols$g(b)),
          _step84;

      try {
        for (_iterator84.s(); !(_step84 = _iterator84.n()).done;) {
          var prop = _step84.value;
          if (__propIsEnum$g.call(b, prop)) __defNormalProp$g(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator84.e(err);
      } finally {
        _iterator84.f();
      }
    }

    return a;
  };

  var __spreadProps$9 = function __spreadProps$9(a, b) {
    return __defProps$9(a, __getOwnPropDescs$9(b));
  };

  var __objRest$c = function __objRest$c(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$g.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$g) {
      var _iterator85 = _createForOfIteratorHelper(__getOwnPropSymbols$g(source)),
          _step85;

      try {
        for (_iterator85.s(); !(_step85 = _iterator85.n()).done;) {
          var prop = _step85.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$g.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator85.e(err);
      } finally {
        _iterator85.f();
      }
    }

    return target;
  };

  var ChipInput = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        leadingIcon = _b.leadingIcon,
        label = _b.label,
        onClose = _b.onClose,
        _b$variant10 = _b.variant,
        variant = _b$variant10 === void 0 ? "lg" : _b$variant10,
        tabIndex = _b.tabIndex,
        props = __objRest$c(_b, ["brand", "leadingIcon", "label", "onClose", "variant", "tabIndex"]);

    var _React$useState31 = React.useState(false),
        _React$useState32 = _slicedToArray(_React$useState31, 2),
        containerHover = _React$useState32[0],
        setContainerHover = _React$useState32[1];

    var _React$useState33 = React.useState(false),
        _React$useState34 = _slicedToArray(_React$useState33, 2),
        trailingHover = _React$useState34[0],
        setTrailingHover = _React$useState34[1];

    var _React$useState35 = React.useState(false),
        _React$useState36 = _slicedToArray(_React$useState35, 2),
        containerFocus = _React$useState36[0],
        setContainerFocus = _React$useState36[1];

    var _React$useState37 = React.useState(false),
        _React$useState38 = _slicedToArray(_React$useState37, 2),
        trailingFocus = _React$useState38[0],
        setTrailingFocus = _React$useState38[1];

    var _React$useState39 = React.useState(false),
        _React$useState40 = _slicedToArray(_React$useState39, 2),
        containerActive = _React$useState40[0],
        setContainerActive = _React$useState40[1];

    var _React$useState41 = React.useState(false),
        _React$useState42 = _slicedToArray(_React$useState41, 2),
        trailingActive = _React$useState42[0],
        setTrailingActive = _React$useState42[1];

    var getIconColor = function getIconColor() {
      if (containerHover || containerFocus) {
        return brand ? "interaction.on.brand.blend.08" : "interaction.blend.08";
      }

      return brand ? "interaction.on.brand.blend.07" : "interaction.blend.07";
    };

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$9(__spreadValues$g({
      "aria-label": "Deletar ".concat(label),
      role: "button"
    }, props), {
      onBlur: function onBlur(evt) {
        setContainerFocus(false);

        if (props.onBlur) {
          props.onBlur(evt);
        }
      },
      onFocus: function onFocus(evt) {
        if (!trailingFocus && !trailingActive && !containerActive) {
          setContainerFocus(true);
        }

        if (props.onFocus) {
          props.onFocus(evt);
        }
      },
      onMouseDown: function onMouseDown() {
        return !trailingActive && setContainerActive(true);
      },
      onMouseEnter: function onMouseEnter(evt) {
        setContainerHover(true);

        if (props.onMouseEnter) {
          props.onMouseEnter(evt);
        }
      },
      onMouseLeave: function onMouseLeave(evt) {
        setContainerHover(false);

        if (props.onMouseLeave) {
          props.onMouseLeave(evt);
        }
      },
      onMouseUp: function onMouseUp() {
        setContainerFocus(false);
        setTrailingFocus(false);
        setContainerActive(false);
      },
      ref: ref,
      sx: __spreadValues$g(__spreadValues$g({}, getChipInputContainerStyle(brand, variant, containerHover && !trailingHover, containerFocus && !trailingFocus, containerActive && !trailingActive, trailingFocus)), props.sx),
      tabIndex: tabIndex
    }), leadingIcon && /* @__PURE__ */React__default["default"].createElement(Icon, {
      color: getIconColor(),
      size: variant === "lg" ? "md" : "xs",
      sx: {
        margin: 0,
        marginBottom: "stack.quark",
        marginTop: "stack.quark",
        padding: 0
      }
    }, leadingIcon), /* @__PURE__ */React__default["default"].createElement(TextInteraction, {
      sx: getChipTextStyle(),
      variant: variant === "lg" ? "md" : "sm"
    }, label), /* @__PURE__ */React__default["default"].createElement(Icon, {
      color: getIconColor(),
      onBlur: function onBlur() {
        return setTrailingFocus(false);
      },
      onFocus: function onFocus() {
        if (!trailingActive) {
          setContainerFocus(false);
          setTrailingFocus(true);
        }
      },
      onMouseDown: function onMouseDown() {
        return setTrailingActive(true);
      },
      onMouseEnter: function onMouseEnter() {
        return setTrailingHover(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setTrailingHover(false);
      },
      onMouseUp: function onMouseUp(evt) {
        setContainerFocus(false);
        setTrailingFocus(false);
        setTrailingActive(false);

        if (onClose) {
          onClose(evt);
        }
      },
      size: variant === "lg" ? "md" : "xs",
      sx: getChipTrailingStyle(brand, variant, trailingHover, trailingFocus, trailingActive),
      tabIndex: tabIndex
    }, /* @__PURE__ */React__default["default"].createElement(almaIcons.CloseBold, null)));
  });
  var __defProp$f = Object.defineProperty;
  var __defProps$8 = Object.defineProperties;
  var __getOwnPropDescs$8 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$f = Object.getOwnPropertySymbols;
  var __hasOwnProp$f = Object.prototype.hasOwnProperty;
  var __propIsEnum$f = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$f = function __defNormalProp$f(obj, key, value) {
    return key in obj ? __defProp$f(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$f = function __spreadValues$f(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$f.call(b, prop)) __defNormalProp$f(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$f) {
      var _iterator86 = _createForOfIteratorHelper(__getOwnPropSymbols$f(b)),
          _step86;

      try {
        for (_iterator86.s(); !(_step86 = _iterator86.n()).done;) {
          var prop = _step86.value;
          if (__propIsEnum$f.call(b, prop)) __defNormalProp$f(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator86.e(err);
      } finally {
        _iterator86.f();
      }
    }

    return a;
  };

  var __spreadProps$8 = function __spreadProps$8(a, b) {
    return __defProps$8(a, __getOwnPropDescs$8(b));
  };

  var getChipToggleStyle = function getChipToggleStyle(_ref35) {
    var active = _ref35.active,
        brand = _ref35.brand,
        disabled = _ref35.disabled,
        focus = _ref35.focus,
        hover = _ref35.hover,
        selected = _ref35.selected,
        variant = _ref35.variant;

    var getBackgroundColor = function getBackgroundColor() {
      if (selected) {
        if (disabled) {
          return brand ? "interaction.on.brand.blend.01" : "interaction.blend.01";
        } else if (active) {
          return brand ? "interaction.on.brand.subtle.03" : "interaction.subtle.03";
        } else if (hover || focus) {
          return brand ? "interaction.on.brand.subtle.02" : "interaction.subtle.02";
        }

        return brand ? "interaction.on.brand.subtle.01" : "interaction.subtle.01";
      }

      if (active) {
        return brand ? "interaction.on.brand.blend.03" : "interaction.blend.03";
      } else if (hover || focus) {
        return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
      }

      return "transparent";
    };

    var getBorderColor = function getBorderColor() {
      if (selected) {
        if (disabled) {
          return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
        }

        return brand ? "interaction.on.brand.select.active" : "interaction.select.active";
      } else if (disabled) {
        return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
      }

      return brand ? "interaction.on.brand.select.default" : "interaction.select.default";
    };

    var getColor = function getColor() {
      if (selected) {
        if (disabled) {
          return brand ? "typeface.on.brand.meld" : "typeface.meld";
        }

        return brand ? "interaction.on.brand.select.default" : "interaction.select.active";
      } else if (disabled) {
        return brand ? "typeface.on.brand.meld" : "typeface.meld";
      } else if (hover || focus) {
        return brand ? "typeface.on.brand.strong" : "typeface.strong";
      }

      return brand ? "typeface.on.brand.pure" : "typeface.pure";
    };

    return __spreadProps$8(__spreadValues$f({}, getBasicChipStyle(variant)), {
      backgroundColor: getBackgroundColor(),
      borderColor: getBorderColor(),
      borderWidth: focus ? "thin" : "hairline",
      color: getColor(),
      paddingRight: "inline.nano"
    });
  };

  var __defProp$e = Object.defineProperty;
  var __defProps$7 = Object.defineProperties;
  var __getOwnPropDescs$7 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$e = Object.getOwnPropertySymbols;
  var __hasOwnProp$e = Object.prototype.hasOwnProperty;
  var __propIsEnum$e = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$e = function __defNormalProp$e(obj, key, value) {
    return key in obj ? __defProp$e(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$e = function __spreadValues$e(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$e.call(b, prop)) __defNormalProp$e(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$e) {
      var _iterator87 = _createForOfIteratorHelper(__getOwnPropSymbols$e(b)),
          _step87;

      try {
        for (_iterator87.s(); !(_step87 = _iterator87.n()).done;) {
          var prop = _step87.value;
          if (__propIsEnum$e.call(b, prop)) __defNormalProp$e(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator87.e(err);
      } finally {
        _iterator87.f();
      }
    }

    return a;
  };

  var __spreadProps$7 = function __spreadProps$7(a, b) {
    return __defProps$7(a, __getOwnPropDescs$7(b));
  };

  var __objRest$b = function __objRest$b(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$e.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$e) {
      var _iterator88 = _createForOfIteratorHelper(__getOwnPropSymbols$e(source)),
          _step88;

      try {
        for (_iterator88.s(); !(_step88 = _iterator88.n()).done;) {
          var prop = _step88.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$e.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator88.e(err);
      } finally {
        _iterator88.f();
      }
    }

    return target;
  };

  var ChipToggle = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        disabled = _b.disabled,
        label = _b.label,
        selected = _b.selected,
        _b$variant11 = _b.variant,
        variant = _b$variant11 === void 0 ? "lg" : _b$variant11,
        props = __objRest$b(_b, ["brand", "disabled", "label", "selected", "variant"]);

    var _React$useState43 = React.useState(false),
        _React$useState44 = _slicedToArray(_React$useState43, 2),
        hover = _React$useState44[0],
        setHover = _React$useState44[1];

    var _React$useState45 = React.useState(false),
        _React$useState46 = _slicedToArray(_React$useState45, 2),
        focus = _React$useState46[0],
        setFocus = _React$useState46[1];

    var _React$useState47 = React.useState(false),
        _React$useState48 = _slicedToArray(_React$useState47, 2),
        active = _React$useState48[0],
        setActive = _React$useState48[1];

    var getIconColor = function getIconColor() {
      if (selected) {
        if (disabled) {
          return brand ? "typeface.on.brand.meld" : "typeface.meld";
        }

        return brand ? "interaction.on.brand.select.default" : "interaction.select.active";
      } else if (hover || focus) {
        return brand ? "interaction.on.brand.blend.08" : "interaction.blend.08";
      }

      return brand ? "interaction.on.brand.blend.07" : "interaction.blend.07";
    };

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$7(__spreadValues$e({
      "aria-disabled": disabled,
      "aria-label": label,
      role: "button"
    }, props), {
      onBlur: function onBlur(evt) {
        !disabled && setFocus(false);

        if (props.onBlur) {
          props.onBlur(evt);
        }
      },
      onFocus: function onFocus(evt) {
        if (!active) {
          !disabled && setFocus(true);
        }

        if (props.onFocus) {
          props.onFocus(evt);
        }
      },
      onMouseDown: function onMouseDown() {
        return !disabled && setActive(true);
      },
      onMouseEnter: function onMouseEnter(evt) {
        !disabled && setHover(true);

        if (props.onMouseEnter) {
          props.onMouseEnter(evt);
        }
      },
      onMouseLeave: function onMouseLeave(evt) {
        !disabled && setHover(false);

        if (props.onMouseLeave) {
          props.onMouseLeave(evt);
        }
      },
      onMouseUp: function onMouseUp() {
        !disabled && setFocus(false);
        !disabled && setActive(false);
      },
      ref: ref,
      sx: __spreadValues$e(__spreadValues$e({}, getChipToggleStyle({
        active: active,
        brand: brand,
        disabled: disabled,
        focus: focus,
        hover: hover,
        selected: selected,
        variant: variant
      })), props.sx)
    }), selected && /* @__PURE__ */React__default["default"].createElement(Icon, {
      color: getIconColor(),
      size: variant === "lg" ? "md" : "xs",
      sx: {
        margin: 0,
        marginBottom: "stack.quark",
        marginTop: "stack.quark",
        padding: 0
      }
    }, /* @__PURE__ */React__default["default"].createElement(almaIcons.CheckBold, null)), /* @__PURE__ */React__default["default"].createElement(TextInteraction, {
      sx: getChipTextStyle(),
      variant: variant === "lg" ? "md" : "sm"
    }, label));
  });
  var __defProp$d = Object.defineProperty;
  var __defProps$6 = Object.defineProperties;
  var __getOwnPropDescs$6 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
  var __hasOwnProp$d = Object.prototype.hasOwnProperty;
  var __propIsEnum$d = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$d = function __defNormalProp$d(obj, key, value) {
    return key in obj ? __defProp$d(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$d = function __spreadValues$d(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$d.call(b, prop)) __defNormalProp$d(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$d) {
      var _iterator89 = _createForOfIteratorHelper(__getOwnPropSymbols$d(b)),
          _step89;

      try {
        for (_iterator89.s(); !(_step89 = _iterator89.n()).done;) {
          var prop = _step89.value;
          if (__propIsEnum$d.call(b, prop)) __defNormalProp$d(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator89.e(err);
      } finally {
        _iterator89.f();
      }
    }

    return a;
  };

  var __spreadProps$6 = function __spreadProps$6(a, b) {
    return __defProps$6(a, __getOwnPropDescs$6(b));
  };

  var getChipStaticStyle = function getChipStaticStyle(brand) {
    return __spreadProps$6(__spreadValues$d({}, getBasicChipStyle("sm")), {
      backgroundColor: brand ? "interaction.on.brand.blend.02" : "interaction.blend.02",
      color: brand ? "typeface.on.brand.pure" : "typeface.pure",
      cursor: "default",
      paddingRight: "inline.nano"
    });
  };

  var __defProp$c = Object.defineProperty;
  var __defProps$5 = Object.defineProperties;
  var __getOwnPropDescs$5 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
  var __hasOwnProp$c = Object.prototype.hasOwnProperty;
  var __propIsEnum$c = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$c = function __defNormalProp$c(obj, key, value) {
    return key in obj ? __defProp$c(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$c = function __spreadValues$c(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$c.call(b, prop)) __defNormalProp$c(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$c) {
      var _iterator90 = _createForOfIteratorHelper(__getOwnPropSymbols$c(b)),
          _step90;

      try {
        for (_iterator90.s(); !(_step90 = _iterator90.n()).done;) {
          var prop = _step90.value;
          if (__propIsEnum$c.call(b, prop)) __defNormalProp$c(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator90.e(err);
      } finally {
        _iterator90.f();
      }
    }

    return a;
  };

  var __spreadProps$5 = function __spreadProps$5(a, b) {
    return __defProps$5(a, __getOwnPropDescs$5(b));
  };

  var __objRest$a = function __objRest$a(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$c.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$c) {
      var _iterator91 = _createForOfIteratorHelper(__getOwnPropSymbols$c(source)),
          _step91;

      try {
        for (_iterator91.s(); !(_step91 = _iterator91.n()).done;) {
          var prop = _step91.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$c.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator91.e(err);
      } finally {
        _iterator91.f();
      }
    }

    return target;
  };

  var ChipStatic = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        label = _b.label,
        props = __objRest$a(_b, ["brand", "label"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$5(__spreadValues$c({
      "aria-label": label,
      role: "button"
    }, props), {
      ref: ref,
      sx: __spreadValues$c(__spreadValues$c({}, getChipStaticStyle(brand)), props.sx)
    }), /* @__PURE__ */React__default["default"].createElement(Caption, {
      sx: getChipTextStyle(true)
    }, label));
  });
  var __defProp$b = Object.defineProperty;
  var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
  var __hasOwnProp$b = Object.prototype.hasOwnProperty;
  var __propIsEnum$b = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$b = function __defNormalProp$b(obj, key, value) {
    return key in obj ? __defProp$b(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$b = function __spreadValues$b(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$b.call(b, prop)) __defNormalProp$b(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$b) {
      var _iterator92 = _createForOfIteratorHelper(__getOwnPropSymbols$b(b)),
          _step92;

      try {
        for (_iterator92.s(); !(_step92 = _iterator92.n()).done;) {
          var prop = _step92.value;
          if (__propIsEnum$b.call(b, prop)) __defNormalProp$b(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator92.e(err);
      } finally {
        _iterator92.f();
      }
    }

    return a;
  };

  var transitionParams = {
    transitionDuration: "0.3s",
    transitionTimingFunction: "ease-in"
  };

  var getAccordionContainerStyle = function getAccordionContainerStyle(brand, open, hover, focus, active) {
    var getBackgroundColor = function getBackgroundColor() {
      if (active) {
        return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
      } else if (hover || focus) {
        return brand ? "interaction.on.brand.blend.01" : "interaction.blend.01";
      }

      return "transparent";
    };

    var getBorderColor = function getBorderColor() {
      if (focus) {
        return brand ? "interaction.on.brand.select.focus" : "interaction.select.focus";
      }

      return "transparent";
    };

    return __spreadValues$b({
      backgroundColor: getBackgroundColor(),
      borderColor: getBorderColor(),
      borderStyle: "solid",
      borderWidth: "thin",
      maxHeight: open ? "100vh" : 56,
      overflow: "hidden",
      transitionProperty: "max-height"
    }, transitionParams);
  };

  var accordionLabelContainerStyle = {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    position: "relative",
    width: "100%"
  };
  var accordionLabelStyle = {
    alignItems: "center",
    display: "flex",
    paddingRight: "inline.nano",
    position: "relative"
  };

  var getAccordionTrailingIconStyle = function getAccordionTrailingIconStyle(open) {
    return __spreadValues$b({
      transform: open ? "rotate(180deg)" : "rotate(0)",
      transitionProperty: "transform"
    }, transitionParams);
  };

  var getAccordionTextStyle = function getAccordionTextStyle(open, leadingIcon) {
    return __spreadValues$b({
      opacity: open ? 1 : 0,
      paddingLeft: leadingIcon ? "inline.xs" : void 0,
      paddingTop: "stack.nano",
      transitionProperty: "opacity"
    }, transitionParams);
  };

  var __defProp$a = Object.defineProperty;
  var __defProps$4 = Object.defineProperties;
  var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
  var __hasOwnProp$a = Object.prototype.hasOwnProperty;
  var __propIsEnum$a = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$a = function __defNormalProp$a(obj, key, value) {
    return key in obj ? __defProp$a(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$a = function __spreadValues$a(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$a.call(b, prop)) __defNormalProp$a(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$a) {
      var _iterator93 = _createForOfIteratorHelper(__getOwnPropSymbols$a(b)),
          _step93;

      try {
        for (_iterator93.s(); !(_step93 = _iterator93.n()).done;) {
          var prop = _step93.value;
          if (__propIsEnum$a.call(b, prop)) __defNormalProp$a(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator93.e(err);
      } finally {
        _iterator93.f();
      }
    }

    return a;
  };

  var __spreadProps$4 = function __spreadProps$4(a, b) {
    return __defProps$4(a, __getOwnPropDescs$4(b));
  };

  var __objRest$9 = function __objRest$9(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$a.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$a) {
      var _iterator94 = _createForOfIteratorHelper(__getOwnPropSymbols$a(source)),
          _step94;

      try {
        for (_iterator94.s(); !(_step94 = _iterator94.n()).done;) {
          var prop = _step94.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$a.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator94.e(err);
      } finally {
        _iterator94.f();
      }
    }

    return target;
  };

  var Accordion = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        disabled = _b.disabled,
        _b$label2 = _b.label,
        label = _b$label2 === void 0 ? "" : _b$label2,
        leadingIcon = _b.leadingIcon,
        _b$text2 = _b.text,
        text = _b$text2 === void 0 ? "" : _b$text2,
        props = __objRest$9(_b, ["brand", "disabled", "label", "leadingIcon", "text"]);

    var _React$useState49 = React.useState(false),
        _React$useState50 = _slicedToArray(_React$useState49, 2),
        open = _React$useState50[0],
        setOpen = _React$useState50[1];

    var _React$useState51 = React.useState(false),
        _React$useState52 = _slicedToArray(_React$useState51, 2),
        hover = _React$useState52[0],
        setHover = _React$useState52[1];

    var _React$useState53 = React.useState(false),
        _React$useState54 = _slicedToArray(_React$useState53, 2),
        focus = _React$useState54[0],
        setFocus = _React$useState54[1];

    var _React$useState55 = React.useState(false),
        _React$useState56 = _slicedToArray(_React$useState55, 2),
        active = _React$useState56[0],
        setActive = _React$useState56[1];

    var getLeadingIconColor = function getLeadingIconColor() {
      if (disabled) {
        return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
      } else if (hover || focus || active) {
        return brand ? "support.on.brand.02" : "support.02";
      }

      return brand ? "support.on.brand.01" : "support.01";
    };

    var getTrailingIconColor = function getTrailingIconColor() {
      if (disabled) {
        return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
      }

      return brand ? "interaction.on.brand.blend.07" : "interaction.blend.07";
    };

    var getLabelColor = function getLabelColor() {
      if (disabled) {
        return brand ? "typeface.on.brand.meld" : "typeface.meld";
      }

      return brand ? "typeface.on.brand.strong" : "typeface.pure";
    };

    var getTextColor = function getTextColor() {
      if (disabled) {
        return brand ? "typeface.on.brand.meld" : "typeface.meld";
      }

      return brand ? "typeface.on.brand.pure" : "typeface.smooth";
    };

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$4(__spreadValues$a({}, props), {
      "aria-disabled": disabled,
      "aria-expanded": open,
      onBlur: function onBlur(evt) {
        !disabled && setFocus(false);

        if (props.onBlur) {
          props.onBlur(evt);
        }
      },
      onClick: function onClick(evt) {
        !disabled && setOpen(!open);

        if (props.onClick) {
          props.onClick(evt);
        }
      },
      onFocus: function onFocus(evt) {
        if (!active) {
          !disabled && setFocus(true);
        }

        if (props.onFocus) {
          props.onFocus(evt);
        }
      },
      onMouseDown: function onMouseDown() {
        return !disabled && setActive(true);
      },
      onMouseEnter: function onMouseEnter(evt) {
        !disabled && setHover(true);

        if (props.onMouseEnter) {
          props.onMouseEnter(evt);
        }
      },
      onMouseLeave: function onMouseLeave(evt) {
        !disabled && setHover(false);

        if (props.onMouseLeave) {
          props.onMouseLeave(evt);
        }
      },
      onMouseUp: function onMouseUp() {
        !disabled && setFocus(false);
        !disabled && setActive(false);
      },
      ref: ref,
      sx: __spreadValues$a({
        cursor: disabled ? "default" : "pointer",
        position: "relative",
        width: "100%"
      }, props.sx)
    }), /* @__PURE__ */React__default["default"].createElement(Box, {
      p: "inset.xs",
      sx: getAccordionContainerStyle(brand, open, hover, focus, active),
      tabIndex: disabled ? -1 : 0
    }, /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: accordionLabelContainerStyle
    }, /* @__PURE__ */React__default["default"].createElement(TextInteraction, {
      color: getLabelColor(),
      sx: accordionLabelStyle,
      variant: "lg"
    }, leadingIcon && /* @__PURE__ */React__default["default"].createElement(Icon, {
      color: getLeadingIconColor(),
      mr: "inline.nano",
      size: "md"
    }, leadingIcon), label), /* @__PURE__ */React__default["default"].createElement(Icon, {
      color: getTrailingIconColor(),
      size: "md",
      sx: getAccordionTrailingIconStyle(open)
    }, /* @__PURE__ */React__default["default"].createElement(almaIcons.ChevrondownsmBold, null))), /* @__PURE__ */React__default["default"].createElement(Body, {
      color: getTextColor(),
      sx: getAccordionTextStyle(open, leadingIcon),
      variant: "sm"
    }, text)), /* @__PURE__ */React__default["default"].createElement(Divider, {
      brand: brand,
      variant: "horizontal"
    }));
  });
  styled__default["default"](Accordion);
  var __defProp$9 = Object.defineProperty;
  var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
  var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
  var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$9 = function __defNormalProp$9(obj, key, value) {
    return key in obj ? __defProp$9(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$9 = function __spreadValues$9(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$9.call(b, prop)) __defNormalProp$9(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$9) {
      var _iterator95 = _createForOfIteratorHelper(__getOwnPropSymbols$9(b)),
          _step95;

      try {
        for (_iterator95.s(); !(_step95 = _iterator95.n()).done;) {
          var prop = _step95.value;
          if (__propIsEnum$9.call(b, prop)) __defNormalProp$9(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator95.e(err);
      } finally {
        _iterator95.f();
      }
    }

    return a;
  };

  var getBannerStyle = function getBannerStyle(variant, zIndex, open) {
    var getPositionStyle = function getPositionStyle() {
      if (variant === "top") {
        return {
          borderBottomColor: "interaction.blend.02",
          borderBottomWidth: "hairline",
          top: open ? 0 : -150
        };
      }

      return {
        borderTopColor: "interaction.blend.02",
        borderTopWidth: "hairline",
        bottom: open ? 0 : -150
      };
    };

    return __spreadValues$9({
      alignItems: "center",
      backgroundColor: "neutral.00",
      borderStyle: "solid",
      display: "flex",
      justifyContent: "space-between",
      left: 0,
      maxHeight: 128,
      minHeight: 64,
      paddingBottom: "stack.xxxs",
      paddingLeft: "inline.xxs",
      paddingRight: "inline.xxs",
      paddingTop: "stack.xxxs",
      position: "absolute",
      transition: "all 300ms ease-in-out",
      width: "100%",
      zIndex: zIndex
    }, getPositionStyle());
  };

  var bannerMessageStyle = {
    maxHeight: "calc(128px - ".concat(parseInt(defaultTheme$3.space.stack.xxxs, 10) * 2, "px)"),
    overflow: "auto",
    paddingBottom: "stack.quark",
    paddingRight: "inline.xxxs",
    paddingTop: "stack.quark",
    position: "relative"
  };
  var bannerButtonsContainerStyle = {
    alignItems: "center",
    display: "flex",
    minWidth: "min-content"
  };
  var __defProp$8 = Object.defineProperty;
  var __defProps$3 = Object.defineProperties;
  var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
  var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
  var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$8 = function __defNormalProp$8(obj, key, value) {
    return key in obj ? __defProp$8(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$8 = function __spreadValues$8(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$8.call(b, prop)) __defNormalProp$8(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$8) {
      var _iterator96 = _createForOfIteratorHelper(__getOwnPropSymbols$8(b)),
          _step96;

      try {
        for (_iterator96.s(); !(_step96 = _iterator96.n()).done;) {
          var prop = _step96.value;
          if (__propIsEnum$8.call(b, prop)) __defNormalProp$8(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator96.e(err);
      } finally {
        _iterator96.f();
      }
    }

    return a;
  };

  var __spreadProps$3 = function __spreadProps$3(a, b) {
    return __defProps$3(a, __getOwnPropDescs$3(b));
  };

  var __objRest$8 = function __objRest$8(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$8.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$8) {
      var _iterator97 = _createForOfIteratorHelper(__getOwnPropSymbols$8(source)),
          _step97;

      try {
        for (_iterator97.s(); !(_step97 = _iterator97.n()).done;) {
          var prop = _step97.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$8.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator97.e(err);
      } finally {
        _iterator97.f();
      }
    }

    return target;
  };

  var Banner = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        actionButton = _b.actionButton,
        children = _b.children,
        onClose = _b.onClose,
        _b$open = _b.open,
        open = _b$open === void 0 ? false : _b$open,
        sx = _b.sx,
        _b$variant12 = _b.variant,
        variant = _b$variant12 === void 0 ? "bottom" : _b$variant12,
        _b$zIndex2 = _b.zIndex,
        zIndex = _b$zIndex2 === void 0 ? 1 : _b$zIndex2,
        props = __objRest$8(_b, ["actionButton", "children", "onClose", "open", "sx", "variant", "zIndex"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: {
        height: "100%",
        overflow: "hidden",
        position: "relative",
        width: "100%"
      }
    }, /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$3(__spreadValues$8({
      sx: __spreadValues$8(__spreadValues$8({}, getBannerStyle(variant, zIndex, open)), sx)
    }, props), {
      ref: ref,
      tabIndex: 0
    }), /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: bannerMessageStyle
    }, children), /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: bannerButtonsContainerStyle
    }, actionButton && /* @__PURE__ */React__default["default"].createElement(Button, {
      ml: "inline.nano",
      mr: "inline.nano",
      onClick: function onClick() {
        return actionButton.onClick && actionButton.onClick();
      },
      size: "sm",
      variant: "primary"
    }, actionButton.label), /* @__PURE__ */React__default["default"].createElement(ButtonIcon, {
      leadingIcon: /* @__PURE__ */React__default["default"].createElement(almaIcons.CloseBold, null),
      onClick: function onClick() {
        return onClose && onClose();
      },
      size: "sm"
    }))));
  });
  styled__default["default"](Banner);
  var top = 'top';
  var bottom = 'bottom';
  var right = 'right';
  var left = 'left';
  var auto = 'auto';
  var basePlacements = [top, bottom, right, left];
  var start = 'start';
  var end = 'end';
  var clippingParents = 'clippingParents';
  var viewport = 'viewport';
  var popper = 'popper';
  var reference = 'reference';
  var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
    return acc.concat([placement + "-" + start, placement + "-" + end]);
  }, []);
  var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
    return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
  }, []); // modifiers that need to read the DOM

  var beforeRead = 'beforeRead';
  var read = 'read';
  var afterRead = 'afterRead'; // pure-logic modifiers

  var beforeMain = 'beforeMain';
  var main = 'main';
  var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

  var beforeWrite = 'beforeWrite';
  var write = 'write';
  var afterWrite = 'afterWrite';
  var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

  function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
  }

  function getWindow(node) {
    if (node == null) {
      return window;
    }

    if (node.toString() !== '[object Window]') {
      var ownerDocument = node.ownerDocument;
      return ownerDocument ? ownerDocument.defaultView || window : window;
    }

    return node;
  }

  function isElement$1(node) {
    var OwnElement = getWindow(node).Element;
    return node instanceof OwnElement || node instanceof Element;
  }

  function isHTMLElement(node) {
    var OwnElement = getWindow(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
  }

  function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') {
      return false;
    }

    var OwnElement = getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
  } // and applies them to the HTMLElements such as popper and arrow


  function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function (name) {
      var style = state.styles[name] || {};
      var attributes = state.attributes[name] || {};
      var element = state.elements[name]; // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      } // Flow doesn't support to extend this property, but it's the most
      // effective way to apply styles to an HTMLElement
      // $FlowFixMe[cannot-write]


      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (name) {
        var value = attributes[name];

        if (value === false) {
          element.removeAttribute(name);
        } else {
          element.setAttribute(name, value === true ? '' : value);
        }
      });
    });
  }

  function effect$2(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: '0',
        top: '0',
        margin: '0'
      },
      arrow: {
        position: 'absolute'
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;

    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    }

    return function () {
      Object.keys(state.elements).forEach(function (name) {
        var element = state.elements[name];
        var attributes = state.attributes[name] || {};
        var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

        var style = styleProperties.reduce(function (style, property) {
          style[property] = '';
          return style;
        }, {}); // arrow is optional + virtual elements

        if (!isHTMLElement(element) || !getNodeName(element)) {
          return;
        }

        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function (attribute) {
          element.removeAttribute(attribute);
        });
      });
    };
  } // eslint-disable-next-line import/no-unused-modules


  var applyStyles$1 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: applyStyles,
    effect: effect$2,
    requires: ['computeStyles']
  };

  function getBasePlacement$1(placement) {
    return placement.split('-')[0];
  } // import { isHTMLElement } from './instanceOf';


  function getBoundingClientRect(element, // eslint-disable-next-line unused-imports/no-unused-vars
  includeScale) {
    var rect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1; // FIXME:
    // `offsetWidth` returns an integer while `getBoundingClientRect`
    // returns a float. This results in `scaleX` or `scaleY` being
    // non-1 when it should be for elements that aren't a full pixel in
    // width or height.
    // if (isHTMLElement(element) && includeScale) {
    //   const offsetHeight = element.offsetHeight;
    //   const offsetWidth = element.offsetWidth;
    //   // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
    //   // Fallback to 1 in case both values are `0`
    //   if (offsetWidth > 0) {
    //     scaleX = rect.width / offsetWidth || 1;
    //   }
    //   if (offsetHeight > 0) {
    //     scaleY = rect.height / offsetHeight || 1;
    //   }
    // }

    return {
      width: rect.width / scaleX,
      height: rect.height / scaleY,
      top: rect.top / scaleY,
      right: rect.right / scaleX,
      bottom: rect.bottom / scaleY,
      left: rect.left / scaleX,
      x: rect.left / scaleX,
      y: rect.top / scaleY
    };
  } // means it doesn't take into account transforms.


  function getLayoutRect(element) {
    var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223

    var width = element.offsetWidth;
    var height = element.offsetHeight;

    if (Math.abs(clientRect.width - width) <= 1) {
      width = clientRect.width;
    }

    if (Math.abs(clientRect.height - height) <= 1) {
      height = clientRect.height;
    }

    return {
      x: element.offsetLeft,
      y: element.offsetTop,
      width: width,
      height: height
    };
  }

  function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

    if (parent.contains(child)) {
      return true;
    } // then fallback to custom implementation with Shadow DOM support
    else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


    return false;
  }

  function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
  }

  function isTableElement(element) {
    return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
  }

  function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return ((isElement$1(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
    element.document) || window.document).documentElement;
  }

  function getParentNode(element) {
    if (getNodeName(element) === 'html') {
      return element;
    }

    return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
      // $FlowFixMe[incompatible-return]
      // $FlowFixMe[prop-missing]
      element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
      element.parentNode || ( // DOM Element detected
      isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
      // $FlowFixMe[incompatible-call]: HTMLElement is a Node
      getDocumentElement(element) // fallback

    );
  }

  function getTrueOffsetParent(element) {
    if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
    getComputedStyle(element).position === 'fixed') {
      return null;
    }

    return element.offsetParent;
  } // `.offsetParent` reports `null` for fixed elements, while absolute elements
  // return the containing block


  function getContainingBlock(element) {
    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
    var isIE = navigator.userAgent.indexOf('Trident') !== -1;

    if (isIE && isHTMLElement(element)) {
      // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
      var elementCss = getComputedStyle(element);

      if (elementCss.position === 'fixed') {
        return null;
      }
    }

    var currentNode = getParentNode(element);

    while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
      var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
      // create a containing block.
      // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

      if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
        return currentNode;
      } else {
        currentNode = currentNode.parentNode;
      }
    }

    return null;
  } // Gets the closest ancestor positioned element. Handles some edge cases,
  // such as table ancestors and cross browser bugs.


  function getOffsetParent(element) {
    var window = getWindow(element);
    var offsetParent = getTrueOffsetParent(element);

    while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
      offsetParent = getTrueOffsetParent(offsetParent);
    }

    if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
      return window;
    }

    return offsetParent || getContainingBlock(element) || window;
  }

  function getMainAxisFromPlacement(placement) {
    return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
  }

  var max = Math.max;
  var min = Math.min;
  var round = Math.round;

  function within(min$1, value, max$1) {
    return max(min$1, min(value, max$1));
  }

  function getFreshSideObject() {
    return {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
  }

  function mergePaddingObject(paddingObject) {
    return Object.assign({}, getFreshSideObject(), paddingObject);
  }

  function expandToHashMap(value, keys) {
    return keys.reduce(function (hashMap, key) {
      hashMap[key] = value;
      return hashMap;
    }, {});
  }

  var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
      placement: state.placement
    })) : padding;
    return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  };

  function arrow(_ref) {
    var _state$modifiersData$;

    var state = _ref.state,
        name = _ref.name,
        options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = getBasePlacement$1(state.placement);
    var axis = getMainAxisFromPlacement(basePlacement);
    var isVertical = [left, right].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';

    if (!arrowElement || !popperOffsets) {
      return;
    }

    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = getLayoutRect(arrowElement);
    var minProp = axis === 'y' ? top : left;
    var maxProp = axis === 'y' ? bottom : right;
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = getOffsetParent(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds

    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = within(min, center, max); // Prevents breaking syntax highlighting...

    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
  }

  function effect$1(_ref2) {
    var state = _ref2.state,
        options = _ref2.options;
    var _options$element = options.element,
        arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

    if (arrowElement == null) {
      return;
    } // CSS selector


    if (typeof arrowElement === 'string') {
      arrowElement = state.elements.popper.querySelector(arrowElement);

      if (!arrowElement) {
        return;
      }
    }

    if (process.env.NODE_ENV !== "production") {
      if (!isHTMLElement(arrowElement)) {
        console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
      }
    }

    if (!contains(state.elements.popper, arrowElement)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
      }

      return;
    }

    state.elements.arrow = arrowElement;
  } // eslint-disable-next-line import/no-unused-modules


  var arrow$1 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect$1,
    requires: ['popperOffsets'],
    requiresIfExists: ['preventOverflow']
  };

  function getVariation(placement) {
    return placement.split('-')[1];
  }

  var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
  }; // Round the offsets to the nearest suitable subpixel based on the DPR.
  // Zooming can change the DPR, but it seems to report a value that will
  // cleanly divide the values into the appropriate subpixels.

  function roundOffsetsByDPR(_ref) {
    var x = _ref.x,
        y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
      x: round(round(x * dpr) / dpr) || 0,
      y: round(round(y * dpr) / dpr) || 0
    };
  }

  function mapToStyles(_ref2) {
    var _Object$assign2;

    var popper = _ref2.popper,
        popperRect = _ref2.popperRect,
        placement = _ref2.placement,
        variation = _ref2.variation,
        offsets = _ref2.offsets,
        position = _ref2.position,
        gpuAcceleration = _ref2.gpuAcceleration,
        adaptive = _ref2.adaptive,
        roundOffsets = _ref2.roundOffsets;

    var _ref3 = roundOffsets === true ? roundOffsetsByDPR(offsets) : typeof roundOffsets === 'function' ? roundOffsets(offsets) : offsets,
        _ref3$x = _ref3.x,
        x = _ref3$x === void 0 ? 0 : _ref3$x,
        _ref3$y = _ref3.y,
        y = _ref3$y === void 0 ? 0 : _ref3$y;

    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = left;
    var sideY = top;
    var win = window;

    if (adaptive) {
      var offsetParent = getOffsetParent(popper);
      var heightProp = 'clientHeight';
      var widthProp = 'clientWidth';

      if (offsetParent === getWindow(popper)) {
        offsetParent = getDocumentElement(popper);

        if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
          heightProp = 'scrollHeight';
          widthProp = 'scrollWidth';
        }
      } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


      offsetParent = offsetParent;

      if (placement === top || (placement === left || placement === right) && variation === end) {
        sideY = bottom; // $FlowFixMe[prop-missing]

        y -= offsetParent[heightProp] - popperRect.height;
        y *= gpuAcceleration ? 1 : -1;
      }

      if (placement === left || (placement === top || placement === bottom) && variation === end) {
        sideX = right; // $FlowFixMe[prop-missing]

        x -= offsetParent[widthProp] - popperRect.width;
        x *= gpuAcceleration ? 1 : -1;
      }
    }

    var commonStyles = Object.assign({
      position: position
    }, adaptive && unsetSides);

    if (gpuAcceleration) {
      var _Object$assign;

      return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }

    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
  }

  function computeStyles(_ref4) {
    var state = _ref4.state,
        options = _ref4.options;
    var _options$gpuAccelerat = options.gpuAcceleration,
        gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
        _options$adaptive = options.adaptive,
        adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
        _options$roundOffsets = options.roundOffsets,
        roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

    if (process.env.NODE_ENV !== "production") {
      var transitionProperty = getComputedStyle(state.elements.popper).transitionProperty || '';

      if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
        return transitionProperty.indexOf(property) >= 0;
      })) {
        console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
      }
    }

    var commonStyles = {
      placement: getBasePlacement$1(state.placement),
      variation: getVariation(state.placement),
      popper: state.elements.popper,
      popperRect: state.rects.popper,
      gpuAcceleration: gpuAcceleration
    };

    if (state.modifiersData.popperOffsets != null) {
      state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
      })));
    }

    if (state.modifiersData.arrow != null) {
      state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
      })));
    }

    state.attributes.popper = Object.assign({}, state.attributes.popper, {
      'data-popper-placement': state.placement
    });
  } // eslint-disable-next-line import/no-unused-modules


  var computeStyles$1 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
  };
  var passive = {
    passive: true
  };

  function effect(_ref) {
    var state = _ref.state,
        instance = _ref.instance,
        options = _ref.options;
    var _options$scroll = options.scroll,
        scroll = _options$scroll === void 0 ? true : _options$scroll,
        _options$resize = options.resize,
        resize = _options$resize === void 0 ? true : _options$resize;
    var window = getWindow(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.addEventListener('resize', instance.update, passive);
    }

    return function () {
      if (scroll) {
        scrollParents.forEach(function (scrollParent) {
          scrollParent.removeEventListener('scroll', instance.update, passive);
        });
      }

      if (resize) {
        window.removeEventListener('resize', instance.update, passive);
      }
    };
  } // eslint-disable-next-line import/no-unused-modules


  var eventListeners = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect,
    data: {}
  };
  var hash$1 = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
  };

  function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function (matched) {
      return hash$1[matched];
    });
  }

  var hash = {
    start: 'end',
    end: 'start'
  };

  function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function (matched) {
      return hash[matched];
    });
  }

  function getWindowScroll(node) {
    var win = getWindow(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
      scrollLeft: scrollLeft,
      scrollTop: scrollTop
    };
  }

  function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
  }

  function getViewportRect(element) {
    var win = getWindow(element);
    var html = getDocumentElement(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
    // can be obscured underneath it.
    // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
    // if it isn't open, so if this isn't available, the popper will be detected
    // to overflow the bottom of the screen too early.

    if (visualViewport) {
      width = visualViewport.width;
      height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
      // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
      // errors due to floating point numbers, so we need to check precision.
      // Safari returns a number <= 0, usually < -1 when pinch-zoomed
      // Feature detection fails in mobile emulation mode in Chrome.
      // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
      // 0.001
      // Fallback here: "Not Safari" userAgent

      if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        x = visualViewport.offsetLeft;
        y = visualViewport.offsetTop;
      }
    }

    return {
      width: width,
      height: height,
      x: x + getWindowScrollBarX(element),
      y: y
    };
  } // of the `<html>` and `<body>` rect bounds if horizontally scrollable


  function getDocumentRect(element) {
    var _element$ownerDocumen;

    var html = getDocumentElement(element);
    var winScroll = getWindowScroll(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
    var y = -winScroll.scrollTop;

    if (getComputedStyle(body || html).direction === 'rtl') {
      x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
    }

    return {
      width: width,
      height: height,
      x: x,
      y: y
    };
  }

  function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = getComputedStyle(element),
        overflow = _getComputedStyle.overflow,
        overflowX = _getComputedStyle.overflowX,
        overflowY = _getComputedStyle.overflowY;

    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
  }

  function getScrollParent(node) {
    if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
      // $FlowFixMe[incompatible-return]: assume body is always available
      return node.ownerDocument.body;
    }

    if (isHTMLElement(node) && isScrollParent(node)) {
      return node;
    }

    return getScrollParent(getParentNode(node));
  }
  /*
  given a DOM element, return the list of all scroll parents, up the list of ancesors
  until we get to the top window object. This list is what we attach scroll listeners
  to, because if any of these parent elements scroll, we'll need to re-calculate the
  reference element's position.
  */


  function listScrollParents(element, list) {
    var _element$ownerDocumen;

    if (list === void 0) {
      list = [];
    }

    var scrollParent = getScrollParent(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = getWindow(scrollParent);
    var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    updatedList.concat(listScrollParents(getParentNode(target)));
  }

  function rectToClientRect(rect) {
    return Object.assign({}, rect, {
      left: rect.x,
      top: rect.y,
      right: rect.x + rect.width,
      bottom: rect.y + rect.height
    });
  }

  function getInnerBoundingClientRect(element) {
    var rect = getBoundingClientRect(element);
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
  }

  function getClientRectFromMixedType(element, clippingParent) {
    return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isHTMLElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
  } // A "clipping parent" is an overflowable container with the characteristic of
  // clipping (or hiding) overflowing elements with a position different from
  // `initial`


  function getClippingParents(element) {
    var clippingParents = listScrollParents(getParentNode(element));
    var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
    var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

    if (!isElement$1(clipperElement)) {
      return [];
    } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


    return clippingParents.filter(function (clippingParent) {
      return isElement$1(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
    });
  } // Gets the maximum area that the element is visible in due to any number of
  // clipping parents


  function getClippingRect(element, boundary, rootBoundary) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
      var rect = getClientRectFromMixedType(element, clippingParent);
      accRect.top = max(rect.top, accRect.top);
      accRect.right = min(rect.right, accRect.right);
      accRect.bottom = min(rect.bottom, accRect.bottom);
      accRect.left = max(rect.left, accRect.left);
      return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
  }

  function computeOffsets(_ref) {
    var reference = _ref.reference,
        element = _ref.element,
        placement = _ref.placement;
    var basePlacement = placement ? getBasePlacement$1(placement) : null;
    var variation = placement ? getVariation(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;

    switch (basePlacement) {
      case top:
        offsets = {
          x: commonX,
          y: reference.y - element.height
        };
        break;

      case bottom:
        offsets = {
          x: commonX,
          y: reference.y + reference.height
        };
        break;

      case right:
        offsets = {
          x: reference.x + reference.width,
          y: commonY
        };
        break;

      case left:
        offsets = {
          x: reference.x - element.width,
          y: commonY
        };
        break;

      default:
        offsets = {
          x: reference.x,
          y: reference.y
        };
    }

    var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

    if (mainAxis != null) {
      var len = mainAxis === 'y' ? 'height' : 'width';

      switch (variation) {
        case start:
          offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
          break;

        case end:
          offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
          break;
      }
    }

    return offsets;
  }

  function detectOverflow(state, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        _options$placement = _options.placement,
        placement = _options$placement === void 0 ? state.placement : _options$placement,
        _options$boundary = _options.boundary,
        boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
        _options$rootBoundary = _options.rootBoundary,
        rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
        _options$elementConte = _options.elementContext,
        elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
        _options$altBoundary = _options.altBoundary,
        altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
        _options$padding = _options.padding,
        padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
    var altContext = elementContext === popper ? reference : popper;
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = getClippingRect(isElement$1(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
    var referenceClientRect = getBoundingClientRect(state.elements.reference);
    var popperOffsets = computeOffsets({
      reference: referenceClientRect,
      element: popperRect,
      strategy: 'absolute',
      placement: placement
    });
    var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect

    var overflowOffsets = {
      top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
      bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
      left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
      right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

    if (elementContext === popper && offsetData) {
      var offset = offsetData[placement];
      Object.keys(overflowOffsets).forEach(function (key) {
        var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
        var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
        overflowOffsets[key] += offset[axis] * multiply;
      });
    }

    return overflowOffsets;
  }

  function computeAutoPlacement(state, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        placement = _options.placement,
        boundary = _options.boundary,
        rootBoundary = _options.rootBoundary,
        padding = _options.padding,
        flipVariations = _options.flipVariations,
        _options$allowedAutoP = _options.allowedAutoPlacements,
        allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
    var variation = getVariation(placement);
    var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
      return getVariation(placement) === variation;
    }) : basePlacements;
    var allowedPlacements = placements$1.filter(function (placement) {
      return allowedAutoPlacements.indexOf(placement) >= 0;
    });

    if (allowedPlacements.length === 0) {
      allowedPlacements = placements$1;

      if (process.env.NODE_ENV !== "production") {
        console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
      }
    } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


    var overflows = allowedPlacements.reduce(function (acc, placement) {
      acc[placement] = detectOverflow(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding
      })[getBasePlacement$1(placement)];
      return acc;
    }, {});
    return Object.keys(overflows).sort(function (a, b) {
      return overflows[a] - overflows[b];
    });
  }

  function getExpandedFallbackPlacements(placement) {
    if (getBasePlacement$1(placement) === auto) {
      return [];
    }

    var oppositePlacement = getOppositePlacement(placement);
    return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
  }

  function flip(_ref) {
    var state = _ref.state,
        options = _ref.options,
        name = _ref.name;

    if (state.modifiersData[name]._skip) {
      return;
    }

    var _options$mainAxis = options.mainAxis,
        checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
        _options$altAxis = options.altAxis,
        checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
        specifiedFallbackPlacements = options.fallbackPlacements,
        padding = options.padding,
        boundary = options.boundary,
        rootBoundary = options.rootBoundary,
        altBoundary = options.altBoundary,
        _options$flipVariatio = options.flipVariations,
        flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
        allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = getBasePlacement$1(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
      return acc.concat(getBasePlacement$1(placement) === auto ? computeAutoPlacement(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        flipVariations: flipVariations,
        allowedAutoPlacements: allowedAutoPlacements
      }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];

    for (var i = 0; i < placements.length; i++) {
      var placement = placements[i];

      var _basePlacement = getBasePlacement$1(placement);

      var isStartVariation = getVariation(placement) === start;
      var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
      var len = isVertical ? 'width' : 'height';
      var overflow = detectOverflow(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        altBoundary: altBoundary,
        padding: padding
      });
      var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

      if (referenceRect[len] > popperRect[len]) {
        mainVariationSide = getOppositePlacement(mainVariationSide);
      }

      var altVariationSide = getOppositePlacement(mainVariationSide);
      var checks = [];

      if (checkMainAxis) {
        checks.push(overflow[_basePlacement] <= 0);
      }

      if (checkAltAxis) {
        checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
      }

      if (checks.every(function (check) {
        return check;
      })) {
        firstFittingPlacement = placement;
        makeFallbackChecks = false;
        break;
      }

      checksMap.set(placement, checks);
    }

    if (makeFallbackChecks) {
      // `2` may be desired in some cases – research later
      var numberOfChecks = flipVariations ? 3 : 1;

      var _loop = function _loop(_i) {
        var fittingPlacement = placements.find(function (placement) {
          var checks = checksMap.get(placement);

          if (checks) {
            return checks.slice(0, _i).every(function (check) {
              return check;
            });
          }
        });

        if (fittingPlacement) {
          firstFittingPlacement = fittingPlacement;
          return "break";
        }
      };

      for (var _i = numberOfChecks; _i > 0; _i--) {
        var _ret = _loop(_i);

        if (_ret === "break") break;
      }
    }

    if (state.placement !== firstFittingPlacement) {
      state.modifiersData[name]._skip = true;
      state.placement = firstFittingPlacement;
      state.reset = true;
    }
  } // eslint-disable-next-line import/no-unused-modules


  var flip$1 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: ['offset'],
    data: {
      _skip: false
    }
  };

  function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) {
      preventedOffsets = {
        x: 0,
        y: 0
      };
    }

    return {
      top: overflow.top - rect.height - preventedOffsets.y,
      right: overflow.right - rect.width + preventedOffsets.x,
      bottom: overflow.bottom - rect.height + preventedOffsets.y,
      left: overflow.left - rect.width - preventedOffsets.x
    };
  }

  function isAnySideFullyClipped(overflow) {
    return [top, right, bottom, left].some(function (side) {
      return overflow[side] >= 0;
    });
  }

  function hide(_ref) {
    var state = _ref.state,
        name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = detectOverflow(state, {
      elementContext: 'reference'
    });
    var popperAltOverflow = detectOverflow(state, {
      altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
      referenceClippingOffsets: referenceClippingOffsets,
      popperEscapeOffsets: popperEscapeOffsets,
      isReferenceHidden: isReferenceHidden,
      hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
      'data-popper-reference-hidden': isReferenceHidden,
      'data-popper-escaped': hasPopperEscaped
    });
  } // eslint-disable-next-line import/no-unused-modules


  var hide$1 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: ['preventOverflow'],
    fn: hide
  };

  function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = getBasePlacement$1(placement);
    var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
      placement: placement
    })) : offset,
        skidding = _ref[0],
        distance = _ref[1];

    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [left, right].indexOf(basePlacement) >= 0 ? {
      x: distance,
      y: skidding
    } : {
      x: skidding,
      y: distance
    };
  }

  function offset(_ref2) {
    var state = _ref2.state,
        options = _ref2.options,
        name = _ref2.name;
    var _options$offset = options.offset,
        offset = _options$offset === void 0 ? [0, 0] : _options$offset;
    var data = placements.reduce(function (acc, placement) {
      acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
      return acc;
    }, {});
    var _data$state$placement = data[state.placement],
        x = _data$state$placement.x,
        y = _data$state$placement.y;

    if (state.modifiersData.popperOffsets != null) {
      state.modifiersData.popperOffsets.x += x;
      state.modifiersData.popperOffsets.y += y;
    }

    state.modifiersData[name] = data;
  } // eslint-disable-next-line import/no-unused-modules


  var offset$1 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: ['popperOffsets'],
    fn: offset
  };

  function popperOffsets(_ref) {
    var state = _ref.state,
        name = _ref.name; // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step

    state.modifiersData[name] = computeOffsets({
      reference: state.rects.reference,
      element: state.rects.popper,
      strategy: 'absolute',
      placement: state.placement
    });
  } // eslint-disable-next-line import/no-unused-modules


  var popperOffsets$1 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
  };

  function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
  }

  function preventOverflow(_ref) {
    var state = _ref.state,
        options = _ref.options,
        name = _ref.name;
    var _options$mainAxis = options.mainAxis,
        checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
        _options$altAxis = options.altAxis,
        checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
        boundary = options.boundary,
        rootBoundary = options.rootBoundary,
        altBoundary = options.altBoundary,
        padding = options.padding,
        _options$tether = options.tether,
        tether = _options$tether === void 0 ? true : _options$tether,
        _options$tetherOffset = options.tetherOffset,
        tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = detectOverflow(state, {
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      altBoundary: altBoundary
    });
    var basePlacement = getBasePlacement$1(state.placement);
    var variation = getVariation(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = getMainAxisFromPlacement(basePlacement);
    var altAxis = getAltAxis(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
      placement: state.placement
    })) : tetherOffset;
    var data = {
      x: 0,
      y: 0
    };

    if (!popperOffsets) {
      return;
    }

    if (checkMainAxis || checkAltAxis) {
      var mainSide = mainAxis === 'y' ? top : left;
      var altSide = mainAxis === 'y' ? bottom : right;
      var len = mainAxis === 'y' ? 'height' : 'width';
      var offset = popperOffsets[mainAxis];
      var min$1 = popperOffsets[mainAxis] + overflow[mainSide];
      var max$1 = popperOffsets[mainAxis] - overflow[altSide];
      var additive = tether ? -popperRect[len] / 2 : 0;
      var minLen = variation === start ? referenceRect[len] : popperRect[len];
      var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
      // outside the reference bounds

      var arrowElement = state.elements.arrow;
      var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
        width: 0,
        height: 0
      };
      var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
      var arrowPaddingMin = arrowPaddingObject[mainSide];
      var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
      // to include its full size in the calculation. If the reference is small
      // and near the edge of a boundary, the popper can overflow even if the
      // reference is not overflowing as well (e.g. virtual elements with no
      // width or height)

      var arrowLen = within(0, referenceRect[len], arrowRect[len]);
      var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - tetherOffsetValue : minLen - arrowLen - arrowPaddingMin - tetherOffsetValue;
      var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + tetherOffsetValue : maxLen + arrowLen + arrowPaddingMax + tetherOffsetValue;
      var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
      var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
      var offsetModifierValue = state.modifiersData.offset ? state.modifiersData.offset[state.placement][mainAxis] : 0;
      var tetherMin = popperOffsets[mainAxis] + minOffset - offsetModifierValue - clientOffset;
      var tetherMax = popperOffsets[mainAxis] + maxOffset - offsetModifierValue;

      if (checkMainAxis) {
        var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
      }

      if (checkAltAxis) {
        var _mainSide = mainAxis === 'x' ? top : left;

        var _altSide = mainAxis === 'x' ? bottom : right;

        var _offset = popperOffsets[altAxis];

        var _min = _offset + overflow[_mainSide];

        var _max = _offset - overflow[_altSide];

        var _preventedOffset = within(tether ? min(_min, tetherMin) : _min, _offset, tether ? max(_max, tetherMax) : _max);

        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
      }
    }

    state.modifiersData[name] = data;
  } // eslint-disable-next-line import/no-unused-modules


  var preventOverflow$1 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: ['offset']
  };

  function getHTMLElementScroll(element) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }

  function getNodeScroll(node) {
    if (node === getWindow(node) || !isHTMLElement(node)) {
      return getWindowScroll(node);
    } else {
      return getHTMLElementScroll(node);
    }
  }

  function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = rect.width / element.offsetWidth || 1;
    var scaleY = rect.height / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
  } // Returns the composite rect of an element relative to its offsetParent.
  // Composite means it takes into account transforms as well as layout.


  function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) {
      isFixed = false;
    }

    var isOffsetParentAnElement = isHTMLElement(offsetParent);
    isHTMLElement(offsetParent) && isElementScaled(offsetParent);
    var documentElement = getDocumentElement(offsetParent);
    var rect = getBoundingClientRect(elementOrVirtualElement);
    var scroll = {
      scrollLeft: 0,
      scrollTop: 0
    };
    var offsets = {
      x: 0,
      y: 0
    };

    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
      if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
      isScrollParent(documentElement)) {
        scroll = getNodeScroll(offsetParent);
      }

      if (isHTMLElement(offsetParent)) {
        offsets = getBoundingClientRect(offsetParent);
        offsets.x += offsetParent.clientLeft;
        offsets.y += offsetParent.clientTop;
      } else if (documentElement) {
        offsets.x = getWindowScrollBarX(documentElement);
      }
    }

    return {
      x: rect.left + scroll.scrollLeft - offsets.x,
      y: rect.top + scroll.scrollTop - offsets.y,
      width: rect.width,
      height: rect.height
    };
  }

  function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function (modifier) {
      map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively

    function sort(modifier) {
      visited.add(modifier.name);
      var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
      requires.forEach(function (dep) {
        if (!visited.has(dep)) {
          var depModifier = map.get(dep);

          if (depModifier) {
            sort(depModifier);
          }
        }
      });
      result.push(modifier);
    }

    modifiers.forEach(function (modifier) {
      if (!visited.has(modifier.name)) {
        // check for visited object
        sort(modifier);
      }
    });
    return result;
  }

  function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase

    return modifierPhases.reduce(function (acc, phase) {
      return acc.concat(orderedModifiers.filter(function (modifier) {
        return modifier.phase === phase;
      }));
    }, []);
  }

  function debounce$1(fn) {
    var pending;
    return function () {
      if (!pending) {
        pending = new Promise(function (resolve) {
          Promise.resolve().then(function () {
            pending = undefined;
            resolve(fn());
          });
        });
      }

      return pending;
    };
  }

  function format(str) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return [].concat(args).reduce(function (p, c) {
      return p.replace(/%s/, c);
    }, str);
  }

  var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
  var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
  var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];

  function validateModifiers(modifiers) {
    modifiers.forEach(function (modifier) {
      [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
      .filter(function (value, index, self) {
        return self.indexOf(value) === index;
      }).forEach(function (key) {
        switch (key) {
          case 'name':
            if (typeof modifier.name !== 'string') {
              console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
            }

            break;

          case 'enabled':
            if (typeof modifier.enabled !== 'boolean') {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
            }

            break;

          case 'phase':
            if (modifierPhases.indexOf(modifier.phase) < 0) {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
            }

            break;

          case 'fn':
            if (typeof modifier.fn !== 'function') {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
            }

            break;

          case 'effect':
            if (modifier.effect != null && typeof modifier.effect !== 'function') {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
            }

            break;

          case 'requires':
            if (modifier.requires != null && !Array.isArray(modifier.requires)) {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
            }

            break;

          case 'requiresIfExists':
            if (!Array.isArray(modifier.requiresIfExists)) {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
            }

            break;

          case 'options':
          case 'data':
            break;

          default:
            console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
              return "\"" + s + "\"";
            }).join(', ') + "; but \"" + key + "\" was provided.");
        }

        modifier.requires && modifier.requires.forEach(function (requirement) {
          if (modifiers.find(function (mod) {
            return mod.name === requirement;
          }) == null) {
            console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
          }
        });
      });
    });
  }

  function uniqueBy(arr, fn) {
    var identifiers = new Set();
    return arr.filter(function (item) {
      var identifier = fn(item);

      if (!identifiers.has(identifier)) {
        identifiers.add(identifier);
        return true;
      }
    });
  }

  function mergeByName(modifiers) {
    var merged = modifiers.reduce(function (merged, current) {
      var existing = merged[current.name];
      merged[current.name] = existing ? Object.assign({}, existing, current, {
        options: Object.assign({}, existing.options, current.options),
        data: Object.assign({}, existing.data, current.data)
      }) : current;
      return merged;
    }, {}); // IE11 does not support Object.values

    return Object.keys(merged).map(function (key) {
      return merged[key];
    });
  }

  var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
  var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
  var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
  };

  function areValidElements() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return !args.some(function (element) {
      return !(element && typeof element.getBoundingClientRect === 'function');
    });
  }

  function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) {
      generatorOptions = {};
    }

    var _generatorOptions = generatorOptions,
        _generatorOptions$def = _generatorOptions.defaultModifiers,
        defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
        _generatorOptions$def2 = _generatorOptions.defaultOptions,
        defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var state = {
        placement: 'bottom',
        orderedModifiers: [],
        options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
        modifiersData: {},
        elements: {
          reference: reference,
          popper: popper
        },
        attributes: {},
        styles: {}
      };
      var effectCleanupFns = [];
      var isDestroyed = false;
      var instance = {
        state: state,
        setOptions: function setOptions(setOptionsAction) {
          var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
          cleanupModifierEffects();
          state.options = Object.assign({}, defaultOptions, state.options, options);
          state.scrollParents = {
            reference: isElement$1(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
            popper: listScrollParents(popper)
          }; // Orders the modifiers based on their dependencies and `phase`
          // properties

          var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

          state.orderedModifiers = orderedModifiers.filter(function (m) {
            return m.enabled;
          }); // Validate the provided modifiers so that the consumer will get warned
          // if one of the modifiers is invalid for any reason

          if (process.env.NODE_ENV !== "production") {
            var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
              var name = _ref.name;
              return name;
            });
            validateModifiers(modifiers);

            if (getBasePlacement$1(state.options.placement) === auto) {
              var flipModifier = state.orderedModifiers.find(function (_ref2) {
                var name = _ref2.name;
                return name === 'flip';
              });

              if (!flipModifier) {
                console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
              }
            }

            var _getComputedStyle = getComputedStyle(popper),
                marginTop = _getComputedStyle.marginTop,
                marginRight = _getComputedStyle.marginRight,
                marginBottom = _getComputedStyle.marginBottom,
                marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
            // cause bugs with positioning, so we'll warn the consumer


            if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
              return parseFloat(margin);
            })) {
              console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
            }
          }

          runModifierEffects();
          return instance.update();
        },
        // Sync update – it will always be executed, even if not necessary. This
        // is useful for low frequency updates where sync behavior simplifies the
        // logic.
        // For high frequency updates (e.g. `resize` and `scroll` events), always
        // prefer the async Popper#update method
        forceUpdate: function forceUpdate() {
          if (isDestroyed) {
            return;
          }

          var _state$elements = state.elements,
              reference = _state$elements.reference,
              popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
          // anymore

          if (!areValidElements(reference, popper)) {
            if (process.env.NODE_ENV !== "production") {
              console.error(INVALID_ELEMENT_ERROR);
            }

            return;
          } // Store the reference and popper rects to be read by modifiers


          state.rects = {
            reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
            popper: getLayoutRect(popper)
          }; // Modifiers have the ability to reset the current update cycle. The
          // most common use case for this is the `flip` modifier changing the
          // placement, which then needs to re-run all the modifiers, because the
          // logic was previously ran for the previous placement and is therefore
          // stale/incorrect

          state.reset = false;
          state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
          // is filled with the initial data specified by the modifier. This means
          // it doesn't persist and is fresh on each update.
          // To ensure persistent data, use `${name}#persistent`

          state.orderedModifiers.forEach(function (modifier) {
            return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
          });
          var __debug_loops__ = 0;

          for (var index = 0; index < state.orderedModifiers.length; index++) {
            if (process.env.NODE_ENV !== "production") {
              __debug_loops__ += 1;

              if (__debug_loops__ > 100) {
                console.error(INFINITE_LOOP_ERROR);
                break;
              }
            }

            if (state.reset === true) {
              state.reset = false;
              index = -1;
              continue;
            }

            var _state$orderedModifie = state.orderedModifiers[index],
                fn = _state$orderedModifie.fn,
                _state$orderedModifie2 = _state$orderedModifie.options,
                _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
                name = _state$orderedModifie.name;

            if (typeof fn === 'function') {
              state = fn({
                state: state,
                options: _options,
                name: name,
                instance: instance
              }) || state;
            }
          }
        },
        // Async and optimistically optimized update – it will not be executed if
        // not necessary (debounced to run at most once-per-tick)
        update: debounce$1(function () {
          return new Promise(function (resolve) {
            instance.forceUpdate();
            resolve(state);
          });
        }),
        destroy: function destroy() {
          cleanupModifierEffects();
          isDestroyed = true;
        }
      };

      if (!areValidElements(reference, popper)) {
        if (process.env.NODE_ENV !== "production") {
          console.error(INVALID_ELEMENT_ERROR);
        }

        return instance;
      }

      instance.setOptions(options).then(function (state) {
        if (!isDestroyed && options.onFirstUpdate) {
          options.onFirstUpdate(state);
        }
      }); // Modifiers have the ability to execute arbitrary code before the first
      // update cycle runs. They will be executed in the same order as the update
      // cycle. This is useful when a modifier adds some persistent data that
      // other modifiers need to use, but the modifier is run after the dependent
      // one.

      function runModifierEffects() {
        state.orderedModifiers.forEach(function (_ref3) {
          var name = _ref3.name,
              _ref3$options = _ref3.options,
              options = _ref3$options === void 0 ? {} : _ref3$options,
              effect = _ref3.effect;

          if (typeof effect === 'function') {
            var cleanupFn = effect({
              state: state,
              name: name,
              instance: instance,
              options: options
            });

            var noopFn = function noopFn() {};

            effectCleanupFns.push(cleanupFn || noopFn);
          }
        });
      }

      function cleanupModifierEffects() {
        effectCleanupFns.forEach(function (fn) {
          return fn();
        });
        effectCleanupFns = [];
      }

      return instance;
    };
  }

  var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
  var createPopper = /*#__PURE__*/popperGenerator({
    defaultModifiers: defaultModifiers
  }); // eslint-disable-next-line import/no-unused-modules

  /**!
  * tippy.js v6.3.2
  * (c) 2017-2021 atomiks
  * MIT License
  */

  var BOX_CLASS = "tippy-box";
  var CONTENT_CLASS = "tippy-content";
  var BACKDROP_CLASS = "tippy-backdrop";
  var ARROW_CLASS = "tippy-arrow";
  var SVG_ARROW_CLASS = "tippy-svg-arrow";
  var TOUCH_OPTIONS = {
    passive: true,
    capture: true
  };

  var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
  };

  function hasOwnProperty(obj, key) {
    return {}.hasOwnProperty.call(obj, key);
  }

  function getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
      var v = value[index];
      return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }

    return value;
  }

  function isType(value, type) {
    var str = {}.toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
  }

  function invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
  }

  function debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) {
      return fn;
    }

    var timeout;
    return function (arg) {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn(arg);
      }, ms);
    };
  }

  function removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function (key) {
      delete clone[key];
    });
    return clone;
  }

  function splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
  }

  function normalizeToArray(value) {
    return [].concat(value);
  }

  function pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) {
      arr.push(value);
    }
  }

  function unique(arr) {
    return arr.filter(function (item, index) {
      return arr.indexOf(item) === index;
    });
  }

  function getBasePlacement(placement) {
    return placement.split('-')[0];
  }

  function arrayFrom(value) {
    return [].slice.call(value);
  }

  function removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function (acc, key) {
      if (obj[key] !== undefined) {
        acc[key] = obj[key];
      }

      return acc;
    }, {});
  }

  function div() {
    return document.createElement('div');
  }

  function isElement(value) {
    return ['Element', 'Fragment'].some(function (type) {
      return isType(value, type);
    });
  }

  function isNodeList(value) {
    return isType(value, 'NodeList');
  }

  function isMouseEvent(value) {
    return isType(value, 'MouseEvent');
  }

  function isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
  }

  function getArrayOfElements(value) {
    if (isElement(value)) {
      return [value];
    }

    if (isNodeList(value)) {
      return arrayFrom(value);
    }

    if (Array.isArray(value)) {
      return value;
    }

    return arrayFrom(document.querySelectorAll(value));
  }

  function setTransitionDuration(els, value) {
    els.forEach(function (el) {
      if (el) {
        el.style.transitionDuration = value + "ms";
      }
    });
  }

  function setVisibilityState(els, state) {
    els.forEach(function (el) {
      if (el) {
        el.setAttribute('data-state', state);
      }
    });
  }

  function getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;

    var _normalizeToArray = normalizeToArray(elementOrElements),
        element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body


    return (element == null ? void 0 : (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body) ? element.ownerDocument : document;
  }

  function isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX,
        clientY = event.clientY;
    return popperTreeData.every(function (_ref) {
      var popperRect = _ref.popperRect,
          popperState = _ref.popperState,
          props = _ref.props;
      var interactiveBorder = props.interactiveBorder;
      var basePlacement = getBasePlacement(popperState.placement);
      var offsetData = popperState.modifiersData.offset;

      if (!offsetData) {
        return true;
      }

      var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
      var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
      var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
      var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
      var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
      var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
      var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
      var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
      return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
  }

  function updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...

    ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
      box[method](event, listener);
    });
  }
  /**
   * Compared to xxx.contains, this function works for dom structures with shadow
   * dom
   */


  function actualContains(parent, child) {
    var target = child;

    while (target) {
      var _ref2;

      if (parent.contains(target)) {
        return true;
      }

      target = (_ref2 = target.getRootNode == null ? void 0 : target.getRootNode()) == null ? void 0 : _ref2.host;
    }

    return false;
  }

  var currentInput = {
    isTouch: false
  };
  var lastMouseMoveTime = 0;
  /**
   * When a `touchstart` event is fired, it's assumed the user is using touch
   * input. We'll bind a `mousemove` event listener to listen for mouse input in
   * the future. This way, the `isTouch` property is fully dynamic and will handle
   * hybrid devices that use a mix of touch + mouse input.
   */

  function onDocumentTouchStart() {
    if (currentInput.isTouch) {
      return;
    }

    currentInput.isTouch = true;

    if (window.performance) {
      document.addEventListener('mousemove', onDocumentMouseMove);
    }
  }
  /**
   * When two `mousemove` event are fired consecutively within 20ms, it's assumed
   * the user is using mouse input again. `mousemove` can fire on touch devices as
   * well, but very rarely that quickly.
   */


  function onDocumentMouseMove() {
    var now = performance.now();

    if (now - lastMouseMoveTime < 20) {
      currentInput.isTouch = false;
      document.removeEventListener('mousemove', onDocumentMouseMove);
    }

    lastMouseMoveTime = now;
  }
  /**
   * When an element is in focus and has a tippy, leaving the tab/window and
   * returning causes it to show again. For mouse users this is unexpected, but
   * for keyboard use it makes sense.
   * TODO: find a better technique to solve this problem
   */


  function onWindowBlur() {
    var activeElement = document.activeElement;

    if (isReferenceElement(activeElement)) {
      var instance = activeElement._tippy;

      if (activeElement.blur && !instance.state.isVisible) {
        activeElement.blur();
      }
    }
  }

  function bindGlobalEventListeners() {
    document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
    window.addEventListener('blur', onWindowBlur);
  }

  var isBrowser$1 = typeof window !== 'undefined' && typeof document !== 'undefined';
  var isIE11 = isBrowser$1 ? // @ts-ignore
  !!window.msCrypto : false;

  function createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [method + "() was called on a" + txt + "destroyed instance. This is a no-op but", 'indicates a potential memory leak.'].join(' ');
  }

  function clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
  }

  function getDevMessage(message) {
    return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
  }

  function getFormattedMessage(message) {
    return [getDevMessage(message), // title
    'color: #00C584; font-size: 1.3em; font-weight: bold;', // message
    'line-height: 1.5', // footer
    'color: #a6a095;'];
  } // Assume warnings and errors never have the same message


  var visitedMessages;

  if (process.env.NODE_ENV !== "production") {
    resetVisitedMessages();
  }

  function resetVisitedMessages() {
    visitedMessages = new Set();
  }

  function warnWhen(condition, message) {
    if (condition && !visitedMessages.has(message)) {
      var _console;

      visitedMessages.add(message);

      (_console = console).warn.apply(_console, getFormattedMessage(message));
    }
  }

  function errorWhen(condition, message) {
    if (condition && !visitedMessages.has(message)) {
      var _console2;

      visitedMessages.add(message);

      (_console2 = console).error.apply(_console2, getFormattedMessage(message));
    }
  }

  function validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    errorWhen(didPassFalsyValue, ['tippy() was passed', '`' + String(targets) + '`', 'as its targets (first) argument. Valid types are: String, Element,', 'Element[], or NodeList.'].join(' '));
    errorWhen(didPassPlainObject, ['tippy() was passed a plain object which is not supported as an argument', 'for virtual positioning. Use props.getReferenceClientRect instead.'].join(' '));
  }

  var pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
  };
  var renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
  };
  var defaultProps = Object.assign({
    appendTo: TIPPY_DEFAULT_APPEND_TO,
    aria: {
      content: 'auto',
      expanded: 'auto'
    },
    delay: 0,
    duration: [300, 250],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [0, 10],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
  }, pluginProps, {}, renderProps);
  var defaultKeys = Object.keys(defaultProps);

  var setDefaultProps = function setDefaultProps(partialProps) {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      validateProps(partialProps, []);
    }

    var keys = Object.keys(partialProps);
    keys.forEach(function (key) {
      defaultProps[key] = partialProps[key];
    });
  };

  function getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function (acc, plugin) {
      var name = plugin.name,
          defaultValue = plugin.defaultValue;

      if (name) {
        var _name;

        acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
      }

      return acc;
    }, {});
    return Object.assign({}, passedProps, {}, pluginProps);
  }

  function getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
      plugins: plugins
    }))) : defaultKeys;
    var props = propKeys.reduce(function (acc, key) {
      var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();

      if (!valueAsString) {
        return acc;
      }

      if (key === 'content') {
        acc[key] = valueAsString;
      } else {
        try {
          acc[key] = JSON.parse(valueAsString);
        } catch (e) {
          acc[key] = valueAsString;
        }
      }

      return acc;
    }, {});
    return props;
  }

  function evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
      content: invokeWithArgsOrReturn(props.content, [reference])
    }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, defaultProps.aria, {}, out.aria);
    out.aria = {
      expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
      content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
  }

  function validateProps(partialProps, plugins) {
    if (partialProps === void 0) {
      partialProps = {};
    }

    if (plugins === void 0) {
      plugins = [];
    }

    var keys = Object.keys(partialProps);
    keys.forEach(function (prop) {
      var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
      var didPassUnknownProp = !hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`

      if (didPassUnknownProp) {
        didPassUnknownProp = plugins.filter(function (plugin) {
          return plugin.name === prop;
        }).length === 0;
      }

      warnWhen(didPassUnknownProp, ["`" + prop + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", 'a plugin, forgot to pass it in an array as props.plugins.', '\n\n', 'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n', 'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'].join(' '));
    });
  }

  var innerHTML = function innerHTML() {
    return 'innerHTML';
  };

  function dangerouslySetInnerHTML(element, html) {
    element[innerHTML()] = html;
  }

  function createArrowElement(value) {
    var arrow = div();

    if (value === true) {
      arrow.className = ARROW_CLASS;
    } else {
      arrow.className = SVG_ARROW_CLASS;

      if (isElement(value)) {
        arrow.appendChild(value);
      } else {
        dangerouslySetInnerHTML(arrow, value);
      }
    }

    return arrow;
  }

  function setContent(content, props) {
    if (isElement(props.content)) {
      dangerouslySetInnerHTML(content, '');
      content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
      if (props.allowHTML) {
        dangerouslySetInnerHTML(content, props.content);
      } else {
        content.textContent = props.content;
      }
    }
  }

  function getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = arrayFrom(box.children);
    return {
      box: box,
      content: boxChildren.find(function (node) {
        return node.classList.contains(CONTENT_CLASS);
      }),
      arrow: boxChildren.find(function (node) {
        return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
      }),
      backdrop: boxChildren.find(function (node) {
        return node.classList.contains(BACKDROP_CLASS);
      })
    };
  }

  function render(instance) {
    var popper = div();
    var box = div();
    box.className = BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = div();
    content.className = CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);

    function onUpdate(prevProps, nextProps) {
      var _getChildren = getChildren(popper),
          box = _getChildren.box,
          content = _getChildren.content,
          arrow = _getChildren.arrow;

      if (nextProps.theme) {
        box.setAttribute('data-theme', nextProps.theme);
      } else {
        box.removeAttribute('data-theme');
      }

      if (typeof nextProps.animation === 'string') {
        box.setAttribute('data-animation', nextProps.animation);
      } else {
        box.removeAttribute('data-animation');
      }

      if (nextProps.inertia) {
        box.setAttribute('data-inertia', '');
      } else {
        box.removeAttribute('data-inertia');
      }

      box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;

      if (nextProps.role) {
        box.setAttribute('role', nextProps.role);
      } else {
        box.removeAttribute('role');
      }

      if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
        setContent(content, instance.props);
      }

      if (nextProps.arrow) {
        if (!arrow) {
          box.appendChild(createArrowElement(nextProps.arrow));
        } else if (prevProps.arrow !== nextProps.arrow) {
          box.removeChild(arrow);
          box.appendChild(createArrowElement(nextProps.arrow));
        }
      } else if (arrow) {
        box.removeChild(arrow);
      }
    }

    return {
      popper: popper,
      onUpdate: onUpdate
    };
  } // Runtime check to identify if the render function is the default one; this
  // way we can apply default CSS transitions logic and it can be tree-shaken away


  render.$$tippy = true;
  var idCounter = 1;
  var mouseMoveListeners = []; // Used by `hideAll()`

  var mountedInstances = [];

  function createTippy(reference, passedProps) {
    var props = evaluateProps(reference, Object.assign({}, defaultProps, {}, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================

    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================

    var id = idCounter++;
    var popperInstance = null;
    var plugins = unique(props.plugins);
    var state = {
      // Is the instance currently enabled?
      isEnabled: true,
      // Is the tippy currently showing and not transitioning out?
      isVisible: false,
      // Has the instance been destroyed?
      isDestroyed: false,
      // Is the tippy currently mounted to the DOM?
      isMounted: false,
      // Has the tippy finished transitioning in?
      isShown: false
    };
    var instance = {
      // properties
      id: id,
      reference: reference,
      popper: div(),
      popperInstance: popperInstance,
      props: props,
      state: state,
      plugins: plugins,
      // methods
      clearDelayTimeouts: clearDelayTimeouts,
      setProps: setProps,
      setContent: setContent,
      show: show,
      hide: hide,
      hideWithInteractivity: hideWithInteractivity,
      enable: enable,
      disable: disable,
      unmount: unmount,
      destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser

    /* istanbul ignore if */

    if (!props.render) {
      if (process.env.NODE_ENV !== "production") {
        errorWhen(true, 'render() function has not been supplied.');
      }

      return instance;
    } // ===========================================================================
    // Initial mutations
    // ===========================================================================


    var _props$render = props.render(instance),
        popper = _props$render.popper,
        onUpdate = _props$render.onUpdate;

    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function (plugin) {
      return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [instance]);

    if (props.showOnCreate) {
      scheduleShow();
    } // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding


    popper.addEventListener('mouseenter', function () {
      if (instance.props.interactive && instance.state.isVisible) {
        instance.clearDelayTimeouts();
      }
    });
    popper.addEventListener('mouseleave', function (event) {
      if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        debouncedOnMouseMove(event);
      }
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================

    function getNormalizedTouchSettings() {
      var touch = instance.props.touch;
      return Array.isArray(touch) ? touch : [touch, 0];
    }

    function getIsCustomTouchBehavior() {
      return getNormalizedTouchSettings()[0] === 'hold';
    }

    function getIsDefaultRenderFn() {
      var _instance$props$rende; // @ts-ignore


      return !!((_instance$props$rende = instance.props.render) == null ? void 0 : _instance$props$rende.$$tippy);
    }

    function getCurrentTarget() {
      return currentTarget || reference;
    }

    function getDocument() {
      var parent = getCurrentTarget().parentNode;
      return parent ? getOwnerDocument(parent) : document;
    }

    function getDefaultTemplateChildren() {
      return getChildren(popper);
    }

    function getDelay(isShow) {
      // For touch or keyboard input, force `0` delay for UX reasons
      // Also if the instance is mounted but not visible (transitioning out),
      // ignore delay
      if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') {
        return 0;
      }

      return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
    }

    function handleStyles() {
      popper.style.pointerEvents = instance.props.interactive && instance.state.isVisible ? '' : 'none';
      popper.style.zIndex = "" + instance.props.zIndex;
    }

    function invokeHook(hook, args, shouldInvokePropsHook) {
      if (shouldInvokePropsHook === void 0) {
        shouldInvokePropsHook = true;
      }

      pluginsHooks.forEach(function (pluginHooks) {
        if (pluginHooks[hook]) {
          pluginHooks[hook].apply(void 0, args);
        }
      });

      if (shouldInvokePropsHook) {
        var _instance$props;

        (_instance$props = instance.props)[hook].apply(_instance$props, args);
      }
    }

    function handleAriaContentAttribute() {
      var aria = instance.props.aria;

      if (!aria.content) {
        return;
      }

      var attr = "aria-" + aria.content;
      var id = popper.id;
      var nodes = normalizeToArray(instance.props.triggerTarget || reference);
      nodes.forEach(function (node) {
        var currentValue = node.getAttribute(attr);

        if (instance.state.isVisible) {
          node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
        } else {
          var nextValue = currentValue && currentValue.replace(id, '').trim();

          if (nextValue) {
            node.setAttribute(attr, nextValue);
          } else {
            node.removeAttribute(attr);
          }
        }
      });
    }

    function handleAriaExpandedAttribute() {
      if (hasAriaExpanded || !instance.props.aria.expanded) {
        return;
      }

      var nodes = normalizeToArray(instance.props.triggerTarget || reference);
      nodes.forEach(function (node) {
        if (instance.props.interactive) {
          node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
        } else {
          node.removeAttribute('aria-expanded');
        }
      });
    }

    function cleanupInteractiveMouseListeners() {
      getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
      mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
        return listener !== debouncedOnMouseMove;
      });
    }

    function onDocumentPress(event) {
      // Moved finger to scroll instead of an intentional tap outside
      if (currentInput.isTouch) {
        if (didTouchMove || event.type === 'mousedown') {
          return;
        }
      }

      var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper

      if (instance.props.interactive && actualContains(popper, actualTarget)) {
        return;
      } // Clicked on the event listeners target


      if (actualContains(getCurrentTarget(), actualTarget)) {
        if (currentInput.isTouch) {
          return;
        }

        if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) {
          return;
        }
      } else {
        invokeHook('onClickOutside', [instance, event]);
      }

      if (instance.props.hideOnClick === true) {
        instance.clearDelayTimeouts();
        instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
        // currentTarget. This lets a tippy with `focus` trigger know that it
        // should not show

        didHideDueToDocumentMouseDown = true;
        setTimeout(function () {
          didHideDueToDocumentMouseDown = false;
        }); // The listener gets added in `scheduleShow()`, but this may be hiding it
        // before it shows, and hide()'s early bail-out behavior can prevent it
        // from being cleaned up

        if (!instance.state.isMounted) {
          removeDocumentPress();
        }
      }
    }

    function onTouchMove() {
      didTouchMove = true;
    }

    function onTouchStart() {
      didTouchMove = false;
    }

    function addDocumentPress() {
      var doc = getDocument();
      doc.addEventListener('mousedown', onDocumentPress, true);
      doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
      doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
      doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
    }

    function removeDocumentPress() {
      var doc = getDocument();
      doc.removeEventListener('mousedown', onDocumentPress, true);
      doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
      doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
      doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
    }

    function onTransitionedOut(duration, callback) {
      onTransitionEnd(duration, function () {
        if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) {
          callback();
        }
      });
    }

    function onTransitionedIn(duration, callback) {
      onTransitionEnd(duration, callback);
    }

    function onTransitionEnd(duration, callback) {
      var box = getDefaultTemplateChildren().box;

      function listener(event) {
        if (event.target === box) {
          updateTransitionEndListener(box, 'remove', listener);
          callback();
        }
      } // Make callback synchronous if duration is 0
      // `transitionend` won't fire otherwise


      if (duration === 0) {
        return callback();
      }

      updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
      updateTransitionEndListener(box, 'add', listener);
      currentTransitionEndListener = listener;
    }

    function on(eventType, handler, options) {
      if (options === void 0) {
        options = false;
      }

      var nodes = normalizeToArray(instance.props.triggerTarget || reference);
      nodes.forEach(function (node) {
        node.addEventListener(eventType, handler, options);
        listeners.push({
          node: node,
          eventType: eventType,
          handler: handler,
          options: options
        });
      });
    }

    function addListeners() {
      if (getIsCustomTouchBehavior()) {
        on('touchstart', onTrigger, {
          passive: true
        });
        on('touchend', onMouseLeave, {
          passive: true
        });
      }

      splitBySpaces(instance.props.trigger).forEach(function (eventType) {
        if (eventType === 'manual') {
          return;
        }

        on(eventType, onTrigger);

        switch (eventType) {
          case 'mouseenter':
            on('mouseleave', onMouseLeave);
            break;

          case 'focus':
            on(isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
            break;

          case 'focusin':
            on('focusout', onBlurOrFocusOut);
            break;
        }
      });
    }

    function removeListeners() {
      listeners.forEach(function (_ref) {
        var node = _ref.node,
            eventType = _ref.eventType,
            handler = _ref.handler,
            options = _ref.options;
        node.removeEventListener(eventType, handler, options);
      });
      listeners = [];
    }

    function onTrigger(event) {
      var _lastTriggerEvent;

      var shouldScheduleClickHide = false;

      if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
        return;
      }

      var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
      lastTriggerEvent = event;
      currentTarget = event.currentTarget;
      handleAriaExpandedAttribute();

      if (!instance.state.isVisible && isMouseEvent(event)) {
        // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        mouseMoveListeners.forEach(function (listener) {
          return listener(event);
        });
      } // Toggle show/hide when clicking click-triggered tooltips


      if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
        shouldScheduleClickHide = true;
      } else {
        scheduleShow(event);
      }

      if (event.type === 'click') {
        isVisibleFromClick = !shouldScheduleClickHide;
      }

      if (shouldScheduleClickHide && !wasFocused) {
        scheduleHide(event);
      }
    }

    function onMouseMove(event) {
      var target = event.target;
      var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);

      if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) {
        return;
      }

      var popperTreeData = getNestedPopperTree().concat(popper).map(function (popper) {
        var _instance$popperInsta;

        var instance = popper._tippy;
        var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;

        if (state) {
          return {
            popperRect: popper.getBoundingClientRect(),
            popperState: state,
            props: props
          };
        }

        return null;
      }).filter(Boolean);

      if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
        cleanupInteractiveMouseListeners();
        scheduleHide(event);
      }
    }

    function onMouseLeave(event) {
      var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;

      if (shouldBail) {
        return;
      }

      if (instance.props.interactive) {
        instance.hideWithInteractivity(event);
        return;
      }

      scheduleHide(event);
    }

    function onBlurOrFocusOut(event) {
      if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) {
        return;
      } // If focus was moved to within the popper


      if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
        return;
      }

      scheduleHide(event);
    }

    function isEventListenerStopped(event) {
      return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }

    function createPopperInstance() {
      destroyPopperInstance();
      var _instance$props2 = instance.props,
          popperOptions = _instance$props2.popperOptions,
          placement = _instance$props2.placement,
          offset = _instance$props2.offset,
          getReferenceClientRect = _instance$props2.getReferenceClientRect,
          moveTransition = _instance$props2.moveTransition;
      var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
      var computedReference = getReferenceClientRect ? {
        getBoundingClientRect: getReferenceClientRect,
        contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
      } : reference;
      var tippyModifier = {
        name: '$$tippy',
        enabled: true,
        phase: 'beforeWrite',
        requires: ['computeStyles'],
        fn: function fn(_ref2) {
          var state = _ref2.state;

          if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh = getDefaultTemplateChildren(),
                box = _getDefaultTemplateCh.box;

            ['placement', 'reference-hidden', 'escaped'].forEach(function (attr) {
              if (attr === 'placement') {
                box.setAttribute('data-placement', state.placement);
              } else {
                if (state.attributes.popper["data-popper-" + attr]) {
                  box.setAttribute("data-" + attr, '');
                } else {
                  box.removeAttribute("data-" + attr);
                }
              }
            });
            state.attributes.popper = {};
          }
        }
      };
      var modifiers = [{
        name: 'offset',
        options: {
          offset: offset
        }
      }, {
        name: 'preventOverflow',
        options: {
          padding: {
            top: 2,
            bottom: 2,
            left: 5,
            right: 5
          }
        }
      }, {
        name: 'flip',
        options: {
          padding: 5
        }
      }, {
        name: 'computeStyles',
        options: {
          adaptive: !moveTransition
        }
      }, tippyModifier];

      if (getIsDefaultRenderFn() && arrow) {
        modifiers.push({
          name: 'arrow',
          options: {
            element: arrow,
            padding: 3
          }
        });
      }

      modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
      instance.popperInstance = createPopper(computedReference, popper, Object.assign({}, popperOptions, {
        placement: placement,
        onFirstUpdate: onFirstUpdate,
        modifiers: modifiers
      }));
    }

    function destroyPopperInstance() {
      if (instance.popperInstance) {
        instance.popperInstance.destroy();
        instance.popperInstance = null;
      }
    }

    function mount() {
      var appendTo = instance.props.appendTo;
      var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
      // it's directly after the reference element so the elements inside the
      // tippy can be tabbed to
      // If there are clipping issues, the user can specify a different appendTo
      // and ensure focus management is handled correctly manually

      var node = getCurrentTarget();

      if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') {
        parentNode = node.parentNode;
      } else {
        parentNode = invokeWithArgsOrReturn(appendTo, [node]);
      } // The popper element needs to exist on the DOM before its position can be
      // updated as Popper needs to read its dimensions


      if (!parentNode.contains(popper)) {
        parentNode.appendChild(popper);
      }

      createPopperInstance();
      /* istanbul ignore else */

      if (process.env.NODE_ENV !== "production") {
        // Accessibility check
        warnWhen(instance.props.interactive && appendTo === defaultProps.appendTo && node.nextElementSibling !== popper, ['Interactive tippy element may not be accessible via keyboard', 'navigation because it is not directly after the reference element', 'in the DOM source order.', '\n\n', 'Using a wrapper <div> or <span> tag around the reference element', 'solves this by creating a new parentNode context.', '\n\n', 'Specifying `appendTo: document.body` silences this warning, but it', 'assumes you are using a focus management solution to handle', 'keyboard navigation.', '\n\n', 'See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity'].join(' '));
      }
    }

    function getNestedPopperTree() {
      return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }

    function scheduleShow(event) {
      instance.clearDelayTimeouts();

      if (event) {
        invokeHook('onTrigger', [instance, event]);
      }

      addDocumentPress();
      var delay = getDelay(true);

      var _getNormalizedTouchSe = getNormalizedTouchSettings(),
          touchValue = _getNormalizedTouchSe[0],
          touchDelay = _getNormalizedTouchSe[1];

      if (currentInput.isTouch && touchValue === 'hold' && touchDelay) {
        delay = touchDelay;
      }

      if (delay) {
        showTimeout = setTimeout(function () {
          instance.show();
        }, delay);
      } else {
        instance.show();
      }
    }

    function scheduleHide(event) {
      instance.clearDelayTimeouts();
      invokeHook('onUntrigger', [instance, event]);

      if (!instance.state.isVisible) {
        removeDocumentPress();
        return;
      } // For interactive tippies, scheduleHide is added to a document.body handler
      // from onMouseLeave so must intercept scheduled hides from mousemove/leave
      // events when trigger contains mouseenter and click, and the tip is
      // currently shown as a result of a click.


      if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && ['mouseleave', 'mousemove'].indexOf(event.type) >= 0 && isVisibleFromClick) {
        return;
      }

      var delay = getDelay(false);

      if (delay) {
        hideTimeout = setTimeout(function () {
          if (instance.state.isVisible) {
            instance.hide();
          }
        }, delay);
      } else {
        // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function () {
          instance.hide();
        });
      }
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================


    function enable() {
      instance.state.isEnabled = true;
    }

    function disable() {
      // Disabling the instance should also hide it
      // https://github.com/atomiks/tippy.js-react/issues/106
      instance.hide();
      instance.state.isEnabled = false;
    }

    function clearDelayTimeouts() {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
      cancelAnimationFrame(scheduleHideAnimationFrame);
    }

    function setProps(partialProps) {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== "production") {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('setProps'));
      }

      if (instance.state.isDestroyed) {
        return;
      }

      invokeHook('onBeforeUpdate', [instance, partialProps]);
      removeListeners();
      var prevProps = instance.props;
      var nextProps = evaluateProps(reference, Object.assign({}, instance.props, {}, partialProps, {
        ignoreAttributes: true
      }));
      instance.props = nextProps;
      addListeners();

      if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
        cleanupInteractiveMouseListeners();
        debouncedOnMouseMove = debounce(onMouseMove, nextProps.interactiveDebounce);
      } // Ensure stale aria-expanded attributes are removed


      if (prevProps.triggerTarget && !nextProps.triggerTarget) {
        normalizeToArray(prevProps.triggerTarget).forEach(function (node) {
          node.removeAttribute('aria-expanded');
        });
      } else if (nextProps.triggerTarget) {
        reference.removeAttribute('aria-expanded');
      }

      handleAriaExpandedAttribute();
      handleStyles();

      if (onUpdate) {
        onUpdate(prevProps, nextProps);
      }

      if (instance.popperInstance) {
        createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
        // and the nested ones get re-rendered first.
        // https://github.com/atomiks/tippyjs-react/issues/177
        // TODO: find a cleaner / more efficient solution(!)

        getNestedPopperTree().forEach(function (nestedPopper) {
          // React (and other UI libs likely) requires a rAF wrapper as it flushes
          // its work in one
          requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
        });
      }

      invokeHook('onAfterUpdate', [instance, partialProps]);
    }

    function setContent(content) {
      instance.setProps({
        content: content
      });
    }

    function show() {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== "production") {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('show'));
      } // Early bail-out


      var isAlreadyVisible = instance.state.isVisible;
      var isDestroyed = instance.state.isDestroyed;
      var isDisabled = !instance.state.isEnabled;
      var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
      var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);

      if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
        return;
      } // Normalize `disabled` behavior across browsers.
      // Firefox allows events on disabled elements, but Chrome doesn't.
      // Using a wrapper element (i.e. <span>) is recommended.


      if (getCurrentTarget().hasAttribute('disabled')) {
        return;
      }

      invokeHook('onShow', [instance], false);

      if (instance.props.onShow(instance) === false) {
        return;
      }

      instance.state.isVisible = true;

      if (getIsDefaultRenderFn()) {
        popper.style.visibility = 'visible';
      }

      handleStyles();
      addDocumentPress();

      if (!instance.state.isMounted) {
        popper.style.transition = 'none';
      } // If flipping to the opposite side after hiding at least once, the
      // animation will use the wrong placement without resetting the duration


      if (getIsDefaultRenderFn()) {
        var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
            box = _getDefaultTemplateCh2.box,
            content = _getDefaultTemplateCh2.content;

        setTransitionDuration([box, content], 0);
      }

      onFirstUpdate = function onFirstUpdate() {
        var _instance$popperInsta2;

        if (!instance.state.isVisible || ignoreOnFirstUpdate) {
          return;
        }

        ignoreOnFirstUpdate = true; // reflow

        void popper.offsetHeight;
        popper.style.transition = instance.props.moveTransition;

        if (getIsDefaultRenderFn() && instance.props.animation) {
          var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
              _box = _getDefaultTemplateCh3.box,
              _content = _getDefaultTemplateCh3.content;

          setTransitionDuration([_box, _content], duration);
          setVisibilityState([_box, _content], 'visible');
        }

        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
        // popper has been positioned for the first time

        (_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
        instance.state.isMounted = true;
        invokeHook('onMount', [instance]);

        if (instance.props.animation && getIsDefaultRenderFn()) {
          onTransitionedIn(duration, function () {
            instance.state.isShown = true;
            invokeHook('onShown', [instance]);
          });
        }
      };

      mount();
    }

    function hide() {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== "production") {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hide'));
      } // Early bail-out


      var isAlreadyHidden = !instance.state.isVisible;
      var isDestroyed = instance.state.isDestroyed;
      var isDisabled = !instance.state.isEnabled;
      var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);

      if (isAlreadyHidden || isDestroyed || isDisabled) {
        return;
      }

      invokeHook('onHide', [instance], false);

      if (instance.props.onHide(instance) === false) {
        return;
      }

      instance.state.isVisible = false;
      instance.state.isShown = false;
      ignoreOnFirstUpdate = false;
      isVisibleFromClick = false;

      if (getIsDefaultRenderFn()) {
        popper.style.visibility = 'hidden';
      }

      cleanupInteractiveMouseListeners();
      removeDocumentPress();
      handleStyles();

      if (getIsDefaultRenderFn()) {
        var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
            box = _getDefaultTemplateCh4.box,
            content = _getDefaultTemplateCh4.content;

        if (instance.props.animation) {
          setTransitionDuration([box, content], duration);
          setVisibilityState([box, content], 'hidden');
        }
      }

      handleAriaContentAttribute();
      handleAriaExpandedAttribute();

      if (instance.props.animation) {
        if (getIsDefaultRenderFn()) {
          onTransitionedOut(duration, instance.unmount);
        }
      } else {
        instance.unmount();
      }
    }

    function hideWithInteractivity(event) {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== "production") {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hideWithInteractivity'));
      }

      getDocument().addEventListener('mousemove', debouncedOnMouseMove);
      pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
      debouncedOnMouseMove(event);
    }

    function unmount() {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== "production") {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('unmount'));
      }

      if (instance.state.isVisible) {
        instance.hide();
      }

      if (!instance.state.isMounted) {
        return;
      }

      destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
      // tree by default. This seems mainly for interactive tippies, but we should
      // find a workaround if possible

      getNestedPopperTree().forEach(function (nestedPopper) {
        nestedPopper._tippy.unmount();
      });

      if (popper.parentNode) {
        popper.parentNode.removeChild(popper);
      }

      mountedInstances = mountedInstances.filter(function (i) {
        return i !== instance;
      });
      instance.state.isMounted = false;
      invokeHook('onHidden', [instance]);
    }

    function destroy() {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== "production") {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('destroy'));
      }

      if (instance.state.isDestroyed) {
        return;
      }

      instance.clearDelayTimeouts();
      instance.unmount();
      removeListeners();
      delete reference._tippy;
      instance.state.isDestroyed = true;
      invokeHook('onDestroy', [instance]);
    }
  }

  function tippy(targets, optionalProps) {
    if (optionalProps === void 0) {
      optionalProps = {};
    }

    var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
    /* istanbul ignore else */

    if (process.env.NODE_ENV !== "production") {
      validateTargets(targets);
      validateProps(optionalProps, plugins);
    }

    bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
      plugins: plugins
    });
    var elements = getArrayOfElements(targets);
    /* istanbul ignore else */

    if (process.env.NODE_ENV !== "production") {
      var isSingleContentElement = isElement(passedProps.content);
      var isMoreThanOneReferenceElement = elements.length > 1;
      warnWhen(isSingleContentElement && isMoreThanOneReferenceElement, ['tippy() was passed an Element as the `content` prop, but more than', 'one tippy instance was created by this invocation. This means the', 'content element will only be appended to the last tippy instance.', '\n\n', 'Instead, pass the .innerHTML of the element, or use a function that', 'returns a cloned version of the element instead.', '\n\n', '1) content: element.innerHTML\n', '2) content: () => element.cloneNode(true)'].join(' '));
    }

    var instances = elements.reduce(function (acc, reference) {
      var instance = reference && createTippy(reference, passedProps);

      if (instance) {
        acc.push(instance);
      }

      return acc;
    }, []);
    return isElement(targets) ? instances[0] : instances;
  }

  tippy.defaultProps = defaultProps;
  tippy.setDefaultProps = setDefaultProps;
  tippy.currentInput = currentInput; // every time the popper is destroyed (i.e. a new target), removing the styles
  // and causing transitions to break for singletons when the console is open, but
  // most notably for non-transform styles being used, `gpuAcceleration: false`.

  Object.assign({}, applyStyles$1, {
    effect: function effect(_ref) {
      var state = _ref.state;
      var initialStyles = {
        popper: {
          position: state.options.strategy,
          left: '0',
          top: '0',
          margin: '0'
        },
        arrow: {
          position: 'absolute'
        },
        reference: {}
      };
      Object.assign(state.elements.popper.style, initialStyles.popper);
      state.styles = initialStyles;

      if (state.elements.arrow) {
        Object.assign(state.elements.arrow.style, initialStyles.arrow);
      } // intentionally return no cleanup function
      // return () => { ... }

    }
  });
  tippy.setDefaultProps({
    render: render
  });

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

  function preserveRef(ref, node) {
    if (ref) {
      if (typeof ref === 'function') {
        ref(node);
      }

      if ({}.hasOwnProperty.call(ref, 'current')) {
        ref.current = node;
      }
    }
  }

  function ssrSafeCreateDiv() {
    return isBrowser && document.createElement('div');
  }

  function toDataAttributes(attrs) {
    var dataAttrs = {
      'data-placement': attrs.placement
    };

    if (attrs.referenceHidden) {
      dataAttrs['data-reference-hidden'] = '';
    }

    if (attrs.escaped) {
      dataAttrs['data-escaped'] = '';
    }

    return dataAttrs;
  }

  function deepEqual(x, y) {
    if (x === y) {
      return true;
    } else if (typeof x === 'object' && x != null && typeof y === 'object' && y != null) {
      if (Object.keys(x).length !== Object.keys(y).length) {
        return false;
      }

      for (var prop in x) {
        if (y.hasOwnProperty(prop)) {
          if (!deepEqual(x[prop], y[prop])) {
            return false;
          }
        } else {
          return false;
        }
      }

      return true;
    } else {
      return false;
    }
  }

  function uniqueByShape(arr) {
    var output = [];
    arr.forEach(function (item) {
      if (!output.find(function (outputItem) {
        return deepEqual(item, outputItem);
      })) {
        output.push(item);
      }
    });
    return output;
  }

  function deepPreserveProps(instanceProps, componentProps) {
    var _instanceProps$popper, _componentProps$poppe;

    return Object.assign({}, componentProps, {
      popperOptions: Object.assign({}, instanceProps.popperOptions, componentProps.popperOptions, {
        modifiers: uniqueByShape([].concat(((_instanceProps$popper = instanceProps.popperOptions) == null ? void 0 : _instanceProps$popper.modifiers) || [], ((_componentProps$poppe = componentProps.popperOptions) == null ? void 0 : _componentProps$poppe.modifiers) || []))
      })
    });
  }

  var useIsomorphicLayoutEffect = isBrowser ? React.useLayoutEffect : React.useEffect;

  function useMutableBox(initialValue) {
    // Using refs instead of state as it's recommended to not store imperative
    // values in state due to memory problems in React(?)
    var ref = React.useRef();

    if (!ref.current) {
      ref.current = typeof initialValue === 'function' ? initialValue() : initialValue;
    }

    return ref.current;
  }

  function updateClassName(box, action, classNames) {
    classNames.split(/\s+/).forEach(function (name) {
      if (name) {
        box.classList[action](name);
      }
    });
  }

  var classNamePlugin = {
    name: 'className',
    defaultValue: '',
    fn: function fn(instance) {
      var box = instance.popper.firstElementChild;

      var isDefaultRenderFn = function isDefaultRenderFn() {
        var _instance$props$rende;

        return !!((_instance$props$rende = instance.props.render) == null ? void 0 : _instance$props$rende.$$tippy);
      };

      function add() {
        if (instance.props.className && !isDefaultRenderFn()) {
          if (process.env.NODE_ENV !== 'production') {
            console.warn(['@tippyjs/react: Cannot use `className` prop in conjunction with', '`render` prop. Place the className on the element you are', 'rendering.'].join(' '));
          }

          return;
        }

        updateClassName(box, 'add', instance.props.className);
      }

      function remove() {
        if (isDefaultRenderFn()) {
          updateClassName(box, 'remove', instance.props.className);
        }
      }

      return {
        onCreate: add,
        onBeforeUpdate: remove,
        onAfterUpdate: add
      };
    }
  };

  function TippyGenerator(tippy) {
    function Tippy(_ref) {
      var children = _ref.children,
          content = _ref.content,
          visible = _ref.visible,
          singleton = _ref.singleton,
          render = _ref.render,
          reference = _ref.reference,
          _ref$disabled = _ref.disabled,
          disabled = _ref$disabled === void 0 ? false : _ref$disabled,
          _ref$ignoreAttributes = _ref.ignoreAttributes,
          ignoreAttributes = _ref$ignoreAttributes === void 0 ? true : _ref$ignoreAttributes;
      _ref.__source;
      _ref.__self;

      var restOfNativeProps = _objectWithoutPropertiesLoose(_ref, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]);

      var isControlledMode = visible !== undefined;
      var isSingletonMode = singleton !== undefined;

      var _useState = React.useState(false),
          mounted = _useState[0],
          setMounted = _useState[1];

      var _useState2 = React.useState({}),
          attrs = _useState2[0],
          setAttrs = _useState2[1];

      var _useState3 = React.useState(),
          singletonContent = _useState3[0],
          setSingletonContent = _useState3[1];

      var mutableBox = useMutableBox(function () {
        return {
          container: ssrSafeCreateDiv(),
          renders: 1
        };
      });
      var props = Object.assign({
        ignoreAttributes: ignoreAttributes
      }, restOfNativeProps, {
        content: mutableBox.container
      });

      if (isControlledMode) {
        if (process.env.NODE_ENV !== 'production') {
          ['trigger', 'hideOnClick', 'showOnCreate'].forEach(function (nativeStateProp) {
            if (props[nativeStateProp] !== undefined) {
              console.warn(["@tippyjs/react: Cannot specify `" + nativeStateProp + "` prop in", "controlled mode (`visible` prop)"].join(' '));
            }
          });
        }

        props.trigger = 'manual';
        props.hideOnClick = false;
      }

      if (isSingletonMode) {
        disabled = true;
      }

      var computedProps = props;
      var plugins = props.plugins || [];

      if (render) {
        computedProps = Object.assign({}, props, {
          plugins: isSingletonMode ? [].concat(plugins, [{
            fn: function fn() {
              return {
                onTrigger: function onTrigger(_, event) {
                  var _singleton$data$child = singleton.data.children.find(function (_ref2) {
                    var instance = _ref2.instance;
                    return instance.reference === event.currentTarget;
                  }),
                      content = _singleton$data$child.content;

                  setSingletonContent(content);
                }
              };
            }
          }]) : plugins,
          render: function render() {
            return {
              popper: mutableBox.container
            };
          }
        });
      }

      var deps = [reference].concat(children ? [children.type] : []); // CREATE

      useIsomorphicLayoutEffect(function () {
        var element = reference;

        if (reference && reference.hasOwnProperty('current')) {
          element = reference.current;
        }

        var instance = tippy(element || mutableBox.ref || ssrSafeCreateDiv(), Object.assign({}, computedProps, {
          plugins: [classNamePlugin].concat(props.plugins || [])
        }));
        mutableBox.instance = instance;

        if (disabled) {
          instance.disable();
        }

        if (visible) {
          instance.show();
        }

        if (isSingletonMode) {
          singleton.hook({
            instance: instance,
            content: content,
            props: computedProps
          });
        }

        setMounted(true);
        return function () {
          instance.destroy();
          singleton == null ? void 0 : singleton.cleanup(instance);
        };
      }, deps); // UPDATE

      useIsomorphicLayoutEffect(function () {
        var _instance$popperInsta; // Prevent this effect from running on 1st render


        if (mutableBox.renders === 1) {
          mutableBox.renders++;
          return;
        }

        var instance = mutableBox.instance;
        instance.setProps(deepPreserveProps(instance.props, computedProps)); // Fixes #264

        (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.forceUpdate();

        if (disabled) {
          instance.disable();
        } else {
          instance.enable();
        }

        if (isControlledMode) {
          if (visible) {
            instance.show();
          } else {
            instance.hide();
          }
        }

        if (isSingletonMode) {
          singleton.hook({
            instance: instance,
            content: content,
            props: computedProps
          });
        }
      });
      useIsomorphicLayoutEffect(function () {
        var _instance$props$poppe;

        if (!render) {
          return;
        }

        var instance = mutableBox.instance;
        instance.setProps({
          popperOptions: Object.assign({}, instance.props.popperOptions, {
            modifiers: [].concat((((_instance$props$poppe = instance.props.popperOptions) == null ? void 0 : _instance$props$poppe.modifiers) || []).filter(function (_ref3) {
              var name = _ref3.name;
              return name !== '$$tippyReact';
            }), [{
              name: '$$tippyReact',
              enabled: true,
              phase: 'beforeWrite',
              requires: ['computeStyles'],
              fn: function fn(_ref4) {
                var _state$modifiersData;

                var state = _ref4.state;
                var hideData = (_state$modifiersData = state.modifiersData) == null ? void 0 : _state$modifiersData.hide; // WARNING: this is a high-risk path that can cause an infinite
                // loop. This expression _must_ evaluate to false when required

                if (attrs.placement !== state.placement || attrs.referenceHidden !== (hideData == null ? void 0 : hideData.isReferenceHidden) || attrs.escaped !== (hideData == null ? void 0 : hideData.hasPopperEscaped)) {
                  setAttrs({
                    placement: state.placement,
                    referenceHidden: hideData == null ? void 0 : hideData.isReferenceHidden,
                    escaped: hideData == null ? void 0 : hideData.hasPopperEscaped
                  });
                }

                state.attributes.popper = {};
              }
            }])
          })
        });
      }, [attrs.placement, attrs.referenceHidden, attrs.escaped].concat(deps));
      return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children ? /*#__PURE__*/React.cloneElement(children, {
        ref: function ref(node) {
          mutableBox.ref = node;
          preserveRef(children.ref, node);
        }
      }) : null, mounted && /*#__PURE__*/reactDom.createPortal(render ? render(toDataAttributes(attrs), singletonContent, mutableBox.instance) : content, mutableBox.container));
    }

    return Tippy;
  }

  var forwardRef = function forwardRef(Tippy, defaultProps) {
    return /*#__PURE__*/React.forwardRef(function TippyWrapper(_ref, _ref2) {
      var children = _ref.children,
          props = _objectWithoutPropertiesLoose(_ref, ["children"]);

      return (
        /*#__PURE__*/
        // If I spread them separately here, Babel adds the _extends ponyfill for
        // some reason
        React__default["default"].createElement(Tippy, Object.assign({}, defaultProps, props), children ? /*#__PURE__*/React.cloneElement(children, {
          ref: function ref(node) {
            preserveRef(_ref2, node);
            preserveRef(children.ref, node);
          }
        }) : null)
      );
    });
  };

  var index = /*#__PURE__*/forwardRef( /*#__PURE__*/TippyGenerator(tippy));
  var Tippy = index;
  var tooltipContainerStyle = {
    ".tippy-box": {
      "> .tippy-content": {
        padding: 0
      },
      backgroundColor: "neutral.inverse.00",
      borderColor: "neutral.inverse.00",
      borderRadius: "xs",
      borderStyle: "solid",
      borderWidth: "hairline",
      boxShadow: "01",
      maxWidth: 240,
      padding: "inset.nano"
    }
  };
  var tooltipContentStyle = {
    color: "typeface.inverse.strong",
    fontSize: "xxxs",
    fontWeight: "bold",
    letterSpacing: "standard",
    lineHeight: "distant",
    paddingBottom: "stack.quark"
  };
  var __defProp$7 = Object.defineProperty;
  var __defProps$2 = Object.defineProperties;
  var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
  var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
  var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$7 = function __defNormalProp$7(obj, key, value) {
    return key in obj ? __defProp$7(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$7 = function __spreadValues$7(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$7.call(b, prop)) __defNormalProp$7(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$7) {
      var _iterator98 = _createForOfIteratorHelper(__getOwnPropSymbols$7(b)),
          _step98;

      try {
        for (_iterator98.s(); !(_step98 = _iterator98.n()).done;) {
          var prop = _step98.value;
          if (__propIsEnum$7.call(b, prop)) __defNormalProp$7(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator98.e(err);
      } finally {
        _iterator98.f();
      }
    }

    return a;
  };

  var __spreadProps$2 = function __spreadProps$2(a, b) {
    return __defProps$2(a, __getOwnPropDescs$2(b));
  };

  var __objRest$7 = function __objRest$7(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$7.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$7) {
      var _iterator99 = _createForOfIteratorHelper(__getOwnPropSymbols$7(source)),
          _step99;

      try {
        for (_iterator99.s(); !(_step99 = _iterator99.n()).done;) {
          var prop = _step99.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$7.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator99.e(err);
      } finally {
        _iterator99.f();
      }
    }

    return target;
  };

  var Tooltip = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        children = _b.children,
        message = _b.message,
        _b$offset = _b.offset,
        offset = _b$offset === void 0 ? 10 : _b$offset,
        title = _b.title,
        _b$zIndex3 = _b.zIndex,
        zIndex = _b$zIndex3 === void 0 ? 9999 : _b$zIndex3,
        props = __objRest$7(_b, ["children", "message", "offset", "title", "zIndex"]);

    var renderContent = function renderContent() {
      return /* @__PURE__ */React__default["default"].createElement(Box, null, title && /* @__PURE__ */React__default["default"].createElement(Body, {
        sx: tooltipContentStyle
      }, title), /* @__PURE__ */React__default["default"].createElement(Caption, {
        inverse: true
      }, message));
    };

    var renderArrow = function renderArrow() {
      return "\n            <svg width=\"16\" height=\"6\" viewBox=\"0 0 8 4\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                <path d=\"M4 0L8 4H0L4 0Z\" fill=\"".concat(defaultTheme$3.colors.neutral.inverse["00"], "\"/>\n            </svg>\n        ");
    };

    return /* @__PURE__ */React__default["default"].createElement(Box, {
      ref: ref,
      sx: tooltipContainerStyle
    }, /* @__PURE__ */React__default["default"].createElement(Tippy, __spreadProps$2(__spreadValues$7({}, props), {
      allowHTML: true,
      arrow: renderArrow(),
      content: renderContent(),
      interactive: true,
      maxWidth: 240,
      offset: [0, offset]
    }), children));
  });
  var getPackStyle = {
    height: "100%",
    position: "relative",
    width: "100%"
  };
  var __defProp$6 = Object.defineProperty;
  var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
  var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
  var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$6 = function __defNormalProp$6(obj, key, value) {
    return key in obj ? __defProp$6(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$6 = function __spreadValues$6(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$6.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$6) {
      var _iterator100 = _createForOfIteratorHelper(__getOwnPropSymbols$6(b)),
          _step100;

      try {
        for (_iterator100.s(); !(_step100 = _iterator100.n()).done;) {
          var prop = _step100.value;
          if (__propIsEnum$6.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator100.e(err);
      } finally {
        _iterator100.f();
      }
    }

    return a;
  };

  var __objRest$6 = function __objRest$6(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$6.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$6) {
      var _iterator101 = _createForOfIteratorHelper(__getOwnPropSymbols$6(source)),
          _step101;

      try {
        for (_iterator101.s(); !(_step101 = _iterator101.n()).done;) {
          var prop = _step101.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$6.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator101.e(err);
      } finally {
        _iterator101.f();
      }
    }

    return target;
  };

  var Pack = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        children = _b.children,
        divider = _b.divider,
        spacing = _b.spacing,
        sx = _b.sx,
        props = __objRest$6(_b, ["children", "divider", "spacing", "sx"]);

    var renderChildrens = function renderChildrens() {
      var childrenCount = React__default["default"].Children.count(children);
      var childWithProps = React__default["default"].Children.map(children, function (child, index) {
        if (!React__default["default"].isValidElement(child)) {
          return child;
        }

        var isLastChild = index === childrenCount - 1;

        var getMarginLocation = function getMarginLocation() {
          switch (props.direction) {
            case "row":
            case "row-reverse":
              return {
                marginInline: spacing
              };

            case "column":
            case "column-reverse":
              return {
                marginBlock: spacing
              };

            default:
              return null;
          }
        };

        var renderDivider = function renderDivider() {
          var direction = props.direction ? props.direction : "column";

          if (divider && typeof divider === "boolean" && !isLastChild) {
            return /* @__PURE__ */React__default["default"].createElement(Divider, {
              variant: direction.indexOf("row") >= 0 ? "vertical" : "horizontal"
            });
          } else if (divider && typeof divider !== "boolean" && !isLastChild) {
            return divider;
          }

          return null;
        };

        return [React__default["default"].cloneElement(child, {
          sx: getMarginLocation()
        }), renderDivider()];
      });
      return /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, childWithProps);
    };

    return /* @__PURE__ */React__default["default"].createElement(Flex, __spreadValues$6({
      ref: ref,
      sx: __spreadValues$6(__spreadValues$6({}, getPackStyle), sx)
    }, props), renderChildrens());
  });

  var getDropdownBaseStyle = function getDropdownBaseStyle(hover, focus, active, disabled) {
    var getBackgroundColor = function getBackgroundColor() {
      if (!disabled && active) {
        return "interaction.blend.02";
      } else if (!disabled && (hover || focus)) {
        return "interaction.blend.01";
      }

      return "transparent";
    };

    return {
      alignItems: "center",
      backgroundColor: getBackgroundColor(),
      borderColor: !disabled && !active && focus ? "interaction.select.focus" : "transparent",
      borderStyle: "solid",
      borderWidth: "thin",
      cursor: disabled ? "default" : "pointer",
      display: "flex",
      justifyContent: "space-between",
      minHeight: 40,
      outline: "none",
      padding: "squish.nano",
      width: "100%"
    };
  };

  var __defProp$5 = Object.defineProperty;
  var __defProps$1 = Object.defineProperties;
  var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
  var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
  var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$5 = function __defNormalProp$5(obj, key, value) {
    return key in obj ? __defProp$5(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$5 = function __spreadValues$5(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$5) {
      var _iterator102 = _createForOfIteratorHelper(__getOwnPropSymbols$5(b)),
          _step102;

      try {
        for (_iterator102.s(); !(_step102 = _iterator102.n()).done;) {
          var prop = _step102.value;
          if (__propIsEnum$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator102.e(err);
      } finally {
        _iterator102.f();
      }
    }

    return a;
  };

  var __spreadProps$1 = function __spreadProps$1(a, b) {
    return __defProps$1(a, __getOwnPropDescs$1(b));
  };

  var __objRest$5 = function __objRest$5(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$5.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$5) {
      var _iterator103 = _createForOfIteratorHelper(__getOwnPropSymbols$5(source)),
          _step103;

      try {
        for (_iterator103.s(); !(_step103 = _iterator103.n()).done;) {
          var prop = _step103.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$5.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator103.e(err);
      } finally {
        _iterator103.f();
      }
    }

    return target;
  };

  var DropdownModuleBase = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        children = _b.children,
        disabled = _b.disabled,
        selected = _b.selected,
        sx = _b.sx,
        props = __objRest$5(_b, ["children", "disabled", "selected", "sx"]);

    var _React$useState57 = React.useState(false),
        _React$useState58 = _slicedToArray(_React$useState57, 2),
        active = _React$useState58[0],
        setActive = _React$useState58[1];

    var _React$useState59 = React.useState(false),
        _React$useState60 = _slicedToArray(_React$useState59, 2),
        focus = _React$useState60[0],
        setFocus = _React$useState60[1];

    var _React$useState61 = React.useState(false),
        _React$useState62 = _slicedToArray(_React$useState61, 2),
        hover = _React$useState62[0],
        setHover = _React$useState62[1];

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$1(__spreadValues$5({}, props), {
      "aria-selected": selected,
      onBlur: function onBlur() {
        return setFocus(false);
      },
      onFocus: function onFocus() {
        return setFocus(true);
      },
      onMouseDown: function onMouseDown() {
        return setActive(true);
      },
      onMouseEnter: function onMouseEnter() {
        return setHover(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setHover(false);
      },
      onMouseUp: function onMouseUp() {
        return setActive(false);
      },
      ref: ref,
      role: "option",
      sx: __spreadProps$1(__spreadValues$5({}, getDropdownBaseStyle(hover, focus, active, disabled)), {
        sx: sx
      })
    }), children);
  });
  var dropdownModuleSingleLeftStyle = {
    alignItems: "center",
    display: "flex",
    pointerEvents: "none"
  };
  var __defProp$4 = Object.defineProperty;
  var __defProps = Object.defineProperties;
  var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
  var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
  var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$4 = function __defNormalProp$4(obj, key, value) {
    return key in obj ? __defProp$4(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$4 = function __spreadValues$4(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$4) {
      var _iterator104 = _createForOfIteratorHelper(__getOwnPropSymbols$4(b)),
          _step104;

      try {
        for (_iterator104.s(); !(_step104 = _iterator104.n()).done;) {
          var prop = _step104.value;
          if (__propIsEnum$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator104.e(err);
      } finally {
        _iterator104.f();
      }
    }

    return a;
  };

  var __spreadProps = function __spreadProps(a, b) {
    return __defProps(a, __getOwnPropDescs(b));
  };

  var __objRest$4 = function __objRest$4(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$4.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$4) {
      var _iterator105 = _createForOfIteratorHelper(__getOwnPropSymbols$4(source)),
          _step105;

      try {
        for (_iterator105.s(); !(_step105 = _iterator105.n()).done;) {
          var prop = _step105.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$4.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator105.e(err);
      } finally {
        _iterator105.f();
      }
    }

    return target;
  };

  var DropdownModuleSingle = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        disabled = _b.disabled,
        label = _b.label,
        leadingIcon = _b.leadingIcon,
        selected = _b.selected,
        sx = _b.sx,
        props = __objRest$4(_b, ["disabled", "label", "leadingIcon", "selected", "sx"]);

    return /* @__PURE__ */React__default["default"].createElement(DropdownModuleBase, __spreadProps(__spreadValues$4({}, props), {
      disabled: disabled,
      ref: ref,
      selected: selected
    }), /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: dropdownModuleSingleLeftStyle
    }, leadingIcon && /* @__PURE__ */React__default["default"].createElement(Icon, {
      color: disabled ? "interaction.blend.04" : "support.01",
      mr: "inline.nano",
      size: "md"
    }, leadingIcon), selected ? /* @__PURE__ */React__default["default"].createElement(TextInteraction, {
      color: disabled ? "typeface.meld" : "typeface.pure",
      pb: "stack.quark",
      pr: "stack.nano",
      pt: "stack.quark",
      variant: "md"
    }, label) : /* @__PURE__ */React__default["default"].createElement(Body, {
      color: disabled ? "typeface.meld" : "typeface.pure",
      variant: "sm"
    }, label)), selected && /* @__PURE__ */React__default["default"].createElement(Icon, {
      color: disabled ? "interaction.blend.04" : "interaction.blend.07",
      size: "md"
    }, /* @__PURE__ */React__default["default"].createElement(almaIcons.CheckBold, null)));
  });
  var DropdownModuleMultiple = React__default["default"].forwardRef(function (_c, ref) {
    var _d = _c,
        checked = _d.checked,
        disabled = _d.disabled,
        label = _d.label,
        sx = _d.sx,
        props = __objRest$4(_d, ["checked", "disabled", "label", "sx"]);

    return /* @__PURE__ */React__default["default"].createElement(DropdownModuleBase, __spreadProps(__spreadValues$4({}, props), {
      disabled: disabled,
      ref: ref,
      selected: checked
    }), /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: dropdownModuleSingleLeftStyle
    }, /* @__PURE__ */React__default["default"].createElement(CheckBox, {
      checked: checked,
      disabled: disabled,
      readOnly: true
    }), checked ? /* @__PURE__ */React__default["default"].createElement(TextInteraction, {
      color: disabled ? "typeface.meld" : "typeface.pure",
      ml: "inline.nano",
      pb: "stack.quark",
      pr: "stack.nano",
      pt: "stack.quark",
      variant: "md"
    }, label) : /* @__PURE__ */React__default["default"].createElement(Body, {
      color: disabled ? "typeface.meld" : "typeface.pure",
      ml: "inline.nano",
      variant: "sm"
    }, label)));
  });
  var __defProp$3 = Object.defineProperty;
  var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
  var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
  var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$3 = function __defNormalProp$3(obj, key, value) {
    return key in obj ? __defProp$3(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$3 = function __spreadValues$3(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$3) {
      var _iterator106 = _createForOfIteratorHelper(__getOwnPropSymbols$3(b)),
          _step106;

      try {
        for (_iterator106.s(); !(_step106 = _iterator106.n()).done;) {
          var prop = _step106.value;
          if (__propIsEnum$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator106.e(err);
      } finally {
        _iterator106.f();
      }
    }

    return a;
  };

  var __objRest$3 = function __objRest$3(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$3.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$3) {
      var _iterator107 = _createForOfIteratorHelper(__getOwnPropSymbols$3(source)),
          _step107;

      try {
        for (_iterator107.s(); !(_step107 = _iterator107.n()).done;) {
          var prop = _step107.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$3.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator107.e(err);
      } finally {
        _iterator107.f();
      }
    }

    return target;
  };

  var headingSxVariantStyle = {
    lg: {
      fontSize: "lg"
    },
    md: {
      fontSize: "md",
      letterSpacing: "standard"
    },
    sm: {
      fontSize: "sm",
      letterSpacing: "standard",
      lineHeight: "distant"
    },
    xl: {
      fontSize: "xl",
      lineHeight: "medium"
    },
    xxl: {
      fontSize: "xxl",
      lineHeight: "large"
    },
    xxxl: {
      fontSize: "xxxl",
      lineHeight: "large"
    }
  };
  var Heading = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        _b$variant13 = _b.variant,
        variant = _b$variant13 === void 0 ? "lg" : _b$variant13,
        props = __objRest$3(_b, ["variant"]);

    return /* @__PURE__ */React__default["default"].createElement(Typography, __spreadValues$3({
      as: "h1",
      color: getColorTypfaceTokenByProp(props, "strong"),
      fontFamily: "base",
      fontWeight: "bold",
      letterSpacing: "small",
      lineHeight: "large",
      ref: ref,
      sx: __spreadValues$3({}, headingSxVariantStyle[variant])
    }, props));
  });
  var __defProp$2 = Object.defineProperty;
  var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
  var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
  var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$2 = function __defNormalProp$2(obj, key, value) {
    return key in obj ? __defProp$2(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$2 = function __spreadValues$2(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$2) {
      var _iterator108 = _createForOfIteratorHelper(__getOwnPropSymbols$2(b)),
          _step108;

      try {
        for (_iterator108.s(); !(_step108 = _iterator108.n()).done;) {
          var prop = _step108.value;
          if (__propIsEnum$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator108.e(err);
      } finally {
        _iterator108.f();
      }
    }

    return a;
  };

  var __objRest$2 = function __objRest$2(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$2) {
      var _iterator109 = _createForOfIteratorHelper(__getOwnPropSymbols$2(source)),
          _step109;

      try {
        for (_iterator109.s(); !(_step109 = _iterator109.n()).done;) {
          var prop = _step109.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$2.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator109.e(err);
      } finally {
        _iterator109.f();
      }
    }

    return target;
  };

  var Overline = React__default["default"].forwardRef(function (_a, ref) {
    var props = __objRest$2(_a, []);

    return /* @__PURE__ */React__default["default"].createElement(Typography, __spreadValues$2({
      color: getColorTypfaceTokenByProp(props, "smooth"),
      fontFamily: "base",
      fontSize: "xxxs",
      fontWeight: "bold",
      letterSpacing: "medium",
      lineHeight: "distant",
      ref: ref,
      sx: {
        textTransform: "uppercase"
      }
    }, props));
  });
  var __defProp$1 = Object.defineProperty;
  var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
  var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
  var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$1 = function __defNormalProp$1(obj, key, value) {
    return key in obj ? __defProp$1(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$1 = function __spreadValues$1(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$1) {
      var _iterator110 = _createForOfIteratorHelper(__getOwnPropSymbols$1(b)),
          _step110;

      try {
        for (_iterator110.s(); !(_step110 = _iterator110.n()).done;) {
          var prop = _step110.value;
          if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator110.e(err);
      } finally {
        _iterator110.f();
      }
    }

    return a;
  };

  var __objRest$1 = function __objRest$1(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$1) {
      var _iterator111 = _createForOfIteratorHelper(__getOwnPropSymbols$1(source)),
          _step111;

      try {
        for (_iterator111.s(); !(_step111 = _iterator111.n()).done;) {
          var prop = _step111.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator111.e(err);
      } finally {
        _iterator111.f();
      }
    }

    return target;
  };

  var isSmallProp = function isSmallProp(variant) {
    return variant === "sm";
  };

  var Subtitle = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        variant = _b.variant,
        props = __objRest$1(_b, ["variant"]);

    return /* @__PURE__ */React__default["default"].createElement(Typography, __spreadValues$1({
      color: getColorTypfaceTokenByProp(props, "pure"),
      fontFamily: "base",
      fontSize: isSmallProp(variant) ? "md" : "lg",
      letterSpacing: isSmallProp(variant) ? "standard" : "small",
      lineHeight: isSmallProp(variant) ? "distant" : "large",
      ref: ref
    }, props));
  });
  Subtitle.defaultProps = {
    variant: "lg"
  };
  var __defProp = Object.defineProperty;
  var __getOwnPropSymbols = Object.getOwnPropertySymbols;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __propIsEnum = Object.prototype.propertyIsEnumerable;

  var __defNormalProp = function __defNormalProp(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues = function __spreadValues(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols) {
      var _iterator112 = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
          _step112;

      try {
        for (_iterator112.s(); !(_step112 = _iterator112.n()).done;) {
          var prop = _step112.value;
          if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator112.e(err);
      } finally {
        _iterator112.f();
      }
    }

    return a;
  };

  var __objRest = function __objRest(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols) {
      var _iterator113 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
          _step113;

      try {
        for (_iterator113.s(); !(_step113 = _iterator113.n()).done;) {
          var prop = _step113.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator113.e(err);
      } finally {
        _iterator113.f();
      }
    }

    return target;
  };

  var TextAction = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        variant = _b.variant,
        props = __objRest(_b, ["variant"]);

    return /* @__PURE__ */React__default["default"].createElement(Typography, __spreadValues({
      color: getColorTypfaceTokenByProp(props, "strong"),
      fontFamily: "base",
      fontSize: isSmallProp$2(variant) ? "xxs" : "xs",
      fontWeight: "bold",
      letterSpacing: "standard",
      lineHeight: isSmallProp$2(variant) ? "tiny" : "superdistant",
      ref: ref
    }, props));
  });
  TextAction.defaultProps = {
    variant: "lg"
  };
  exports.Accordion = Accordion;
  exports.Action = Action;
  exports.Banner = Banner;
  exports.Body = Body;
  exports.Box = Box;
  exports.BrandAvatar = BrandAvatar;
  exports.Breadcrumb = Breadcrumb;
  exports.BreadcrumbContainer = BreadcrumbContainer;
  exports.Button = Button;
  exports.ButtonFloating = ButtonFloating;
  exports.ButtonIcon = ButtonIcon;
  exports.Caption = Caption;
  exports.Center = Center;
  exports.CheckBox = CheckBox;
  exports.ChipInput = ChipInput;
  exports.ChipStatic = ChipStatic;
  exports.ChipToggle = ChipToggle;
  exports.ColorModeProvider = ColorModeProvider;
  exports.Divider = Divider;
  exports.DropdownModuleMultiple = DropdownModuleMultiple;
  exports.DropdownModuleSingle = DropdownModuleSingle;
  exports.Flex = Flex;
  exports.Grid = Grid;
  exports.GridItem = GridItem;
  exports.Heading = Heading;
  exports.Icon = Icon;
  exports.Input = Input;
  exports.InputPassword = InputPassword;
  exports.LinkInline = LinkInline;
  exports.LinkStandalone = LinkStandalone;
  exports.ListItem = ListItem;
  exports.Overlay = Overlay;
  exports.Overline = Overline;
  exports.Pack = Pack;
  exports.PersonAvatar = PersonAvatar;
  exports.Radio = Radio;
  exports.Search = Search;
  exports.Snackbar = Snackbar;
  exports.Spacer = Spacer;
  exports.Spacing = Spacing;
  exports.Spinner = Spinner;
  exports.Stepper = Stepper;
  exports.StepperContainer = StepperContainer;
  exports.Subtitle = Subtitle;
  exports.SupportMessage = SupportMessage;
  exports.Switch = Switch;
  exports.Tab = Tab;
  exports.TabContainer = TabContainer;
  exports.TabPane = TabPane;
  exports.TabPanesContainer = TabPanesContainer;
  exports.TextAction = TextAction;
  exports.TextInteraction = TextInteraction;
  exports.ThemeProvider = ThemeProvider;
  exports.Toast = Toast;
  exports.Tooltip = Tooltip;
  exports.Wrap = Wrap;
  exports.colors = defaultColors;
  exports.getCustomTheme = getCustomTheme;
  exports.getStorybookArgSize = getStorybookArgSize;
  exports.getStorybookArgVariant = getStorybookArgVariant;
  exports.getStorybookArgVariantSize = getStorybookArgVariantSize;
  exports.getStorybookArgZIndex = getStorybookArgZIndex;
  exports.head = head;
  exports.storybookArgSX = storybookArgSX;
  exports.storybookArgTypes = storybookArgTypes;
  exports.tail = tail$2;
  exports.theme = defaultTheme$3;
  exports.useColorMode = useColorMode;
  exports.useThemeContext = useThemeContext;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});